import _ from "lodash";
const subdistricts = [
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "01",
    name: "พระบรมมหาราชวัง",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "02",
    name: "วังบูรพาภิรมย์",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "03",
    name: "วัดราชบพิธ",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "04",
    name: "สำราญราษฎร์",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "05",
    name: "ศาลเจ้าพ่อเสือ",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "06",
    name: "เสาชิงช้า",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "07",
    name: "บวรนิเวศ",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "08",
    name: "ตลาดยอด",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "09",
    name: "ชนะสงคราม",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "10",
    name: "บ้านพานถม",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "11",
    name: "บางขุนพรหม",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "01",
    tumbon_code: "12",
    name: "วัดสามพระยา",
    zipcode: "10200",
  },
  {
    jw_code: "10",
    amph_code: "02",
    tumbon_code: "01",
    name: "ดุสิต",
    zipcode: "10300",
  },
  {
    jw_code: "10",
    amph_code: "02",
    tumbon_code: "02",
    name: "วชิรพยาบาล",
    zipcode: "10300",
  },
  {
    jw_code: "10",
    amph_code: "02",
    tumbon_code: "03",
    name: "สวนจิตรลดา",
    zipcode: "10303",
  },
  {
    jw_code: "10",
    amph_code: "02",
    tumbon_code: "04",
    name: "สี่แยกมหานาค",
    zipcode: "10300",
  },
  {
    jw_code: "10",
    amph_code: "02",
    tumbon_code: "06",
    name: "ถนนนครไชยศรี",
    zipcode: "10300",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "01",
    name: "กระทุ่มราย",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "02",
    name: "หนองจอก",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "03",
    name: "คลองสิบ",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "04",
    name: "คลองสิบสอง",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "05",
    name: "โคกแฝด",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "06",
    name: "คู้ฝั่งเหนือ",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "07",
    name: "ลำผักชี",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "03",
    tumbon_code: "08",
    name: "ลำต้อยติ่ง",
    zipcode: "10530",
  },
  {
    jw_code: "10",
    amph_code: "04",
    tumbon_code: "01",
    name: "มหาพฤฒาราม",
    zipcode: "10500",
  },
  {
    jw_code: "10",
    amph_code: "04",
    tumbon_code: "02",
    name: "สีลม",
    zipcode: "10500",
  },
  {
    jw_code: "10",
    amph_code: "04",
    tumbon_code: "03",
    name: "สุริยวงศ์",
    zipcode: "10500",
  },
  {
    jw_code: "10",
    amph_code: "04",
    tumbon_code: "04",
    name: "บางรัก",
    zipcode: "10500",
  },
  {
    jw_code: "10",
    amph_code: "04",
    tumbon_code: "05",
    name: "สี่พระยา",
    zipcode: "10500",
  },
  {
    jw_code: "10",
    amph_code: "05",
    tumbon_code: "02",
    name: "อนุสาวรีย์",
    zipcode: "10220",
  },
  {
    jw_code: "10",
    amph_code: "05",
    tumbon_code: "08",
    name: "ท่าแร้ง",
    zipcode: "10230",
  },
  {
    jw_code: "10",
    amph_code: "06",
    tumbon_code: "01",
    name: "คลองจั่น",
    zipcode: "10240",
  },
  {
    jw_code: "10",
    amph_code: "06",
    tumbon_code: "08",
    name: "หัวหมาก",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "07",
    tumbon_code: "01",
    name: "รองเมือง",
    zipcode: "10330",
  },
  {
    jw_code: "10",
    amph_code: "07",
    tumbon_code: "02",
    name: "วังใหม่",
    zipcode: "10330",
  },
  {
    jw_code: "10",
    amph_code: "07",
    tumbon_code: "03",
    name: "ปทุมวัน",
    zipcode: "10330",
  },
  {
    jw_code: "10",
    amph_code: "07",
    tumbon_code: "04",
    name: "ลุมพินี",
    zipcode: "10330",
  },
  {
    jw_code: "10",
    amph_code: "08",
    tumbon_code: "01",
    name: "ป้อมปราบ",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "08",
    tumbon_code: "02",
    name: "วัดเทพศิรินทร์",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "08",
    tumbon_code: "03",
    name: "คลองมหานาค",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "08",
    tumbon_code: "04",
    name: "บ้านบาตร",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "08",
    tumbon_code: "05",
    name: "วัดโสมนัส",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "09",
    tumbon_code: "02",
    name: "พระโขนงใต้",
    zipcode: "10260",
  },
  {
    jw_code: "10",
    amph_code: "09",
    tumbon_code: "05",
    name: "บางจาก",
    zipcode: "10260",
  },
  {
    jw_code: "10",
    amph_code: "10",
    tumbon_code: "01",
    name: "มีนบุรี",
    zipcode: "10510",
  },
  {
    jw_code: "10",
    amph_code: "10",
    tumbon_code: "02",
    name: "แสนแสบ",
    zipcode: "10510",
  },
  {
    jw_code: "10",
    amph_code: "11",
    tumbon_code: "01",
    name: "ลาดกระบัง",
    zipcode: "10520",
  },
  {
    jw_code: "10",
    amph_code: "11",
    tumbon_code: "02",
    name: "คลองสองต้นนุ่น",
    zipcode: "10520",
  },
  {
    jw_code: "10",
    amph_code: "11",
    tumbon_code: "03",
    name: "คลองสามประเวศ",
    zipcode: "10520",
  },
  {
    jw_code: "10",
    amph_code: "11",
    tumbon_code: "04",
    name: "ลำปลาทิว",
    zipcode: "10520",
  },
  {
    jw_code: "10",
    amph_code: "11",
    tumbon_code: "05",
    name: "ทับยาว",
    zipcode: "10520",
  },
  {
    jw_code: "10",
    amph_code: "11",
    tumbon_code: "06",
    name: "ขุมทอง",
    zipcode: "10520",
  },
  {
    jw_code: "10",
    amph_code: "12",
    tumbon_code: "03",
    name: "ช่องนนทรี",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "12",
    tumbon_code: "04",
    name: "บางโพงพาง",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "13",
    tumbon_code: "01",
    name: "จักรวรรดิ",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "13",
    tumbon_code: "02",
    name: "สัมพันธวงศ์",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "13",
    tumbon_code: "03",
    name: "ตลาดน้อย",
    zipcode: "10100",
  },
  {
    jw_code: "10",
    amph_code: "14",
    tumbon_code: "01",
    name: "สามเสนใน",
    zipcode: "10400",
  },
  {
    jw_code: "10",
    amph_code: "15",
    tumbon_code: "01",
    name: "วัดกัลยาณ์",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "15",
    tumbon_code: "02",
    name: "หิรัญรูจี",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "15",
    tumbon_code: "03",
    name: "บางยี่เรือ",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "15",
    tumbon_code: "04",
    name: "บุคคโล",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "15",
    tumbon_code: "05",
    name: "ตลาดพลู",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "15",
    tumbon_code: "06",
    name: "ดาวคะนอง",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "15",
    tumbon_code: "07",
    name: "สำเหร่",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "16",
    tumbon_code: "01",
    name: "วัดอรุณ",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "16",
    tumbon_code: "02",
    name: "วัดท่าพระ",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "17",
    tumbon_code: "01",
    name: "ห้วยขวาง",
    zipcode: "10310",
  },
  {
    jw_code: "10",
    amph_code: "17",
    tumbon_code: "02",
    name: "บางกะปิ",
    zipcode: "10310",
  },
  {
    jw_code: "10",
    amph_code: "17",
    tumbon_code: "04",
    name: "สามเสนนอก",
    zipcode: "10310",
  },
  {
    jw_code: "10",
    amph_code: "18",
    tumbon_code: "01",
    name: "สมเด็จเจ้าพระยา",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "18",
    tumbon_code: "02",
    name: "คลองสาน",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "18",
    tumbon_code: "03",
    name: "บางลำภูล่าง",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "18",
    tumbon_code: "04",
    name: "คลองต้นไทร",
    zipcode: "10600",
  },
  {
    jw_code: "10",
    amph_code: "19",
    tumbon_code: "01",
    name: "คลองชักพระ",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "19",
    tumbon_code: "02",
    name: "ตลิ่งชัน",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "19",
    tumbon_code: "03",
    name: "ฉิมพลี",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "19",
    tumbon_code: "04",
    name: "บางพรม",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "19",
    tumbon_code: "05",
    name: "บางระมาด",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "19",
    tumbon_code: "07",
    name: "บางเชือกหนัง",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "20",
    tumbon_code: "04",
    name: "ศิริราช",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "20",
    tumbon_code: "05",
    name: "บ้านช่างหล่อ",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "20",
    tumbon_code: "06",
    name: "บางขุนนนท์",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "20",
    tumbon_code: "07",
    name: "บางขุนศรี",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "20",
    tumbon_code: "09",
    name: "อรุณอมรินทร์",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "21",
    tumbon_code: "05",
    name: "ท่าข้าม",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "21",
    tumbon_code: "07",
    name: "แสมดำ",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "01",
    name: "บางหว้า",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "02",
    name: "บางด้วน",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "03",
    name: "บางแค",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "04",
    name: "บางแคเหนือ",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "05",
    name: "บางไผ่",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "06",
    name: "บางจาก",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "07",
    name: "บางแวก",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "08",
    name: "คลองขวาง",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "09",
    name: "ปากคลองภาษีเจริญ",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "22",
    tumbon_code: "10",
    name: "คูหาสวรรค์",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "23",
    tumbon_code: "02",
    name: "หนองแขม",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "23",
    tumbon_code: "03",
    name: "หนองค้างพลู",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "24",
    tumbon_code: "01",
    name: "ราษฎร์บูรณะ",
    zipcode: "10140",
  },
  {
    jw_code: "10",
    amph_code: "24",
    tumbon_code: "02",
    name: "บางปะกอก",
    zipcode: "10140",
  },
  {
    jw_code: "10",
    amph_code: "25",
    tumbon_code: "01",
    name: "บางพลัด",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "25",
    tumbon_code: "02",
    name: "บางอ้อ",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "25",
    tumbon_code: "03",
    name: "บางบำหรุ",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "25",
    tumbon_code: "04",
    name: "บางยี่ขัน",
    zipcode: "10700",
  },
  {
    jw_code: "10",
    amph_code: "26",
    tumbon_code: "01",
    name: "ดินแดง",
    zipcode: "10400",
  },
  {
    jw_code: "10",
    amph_code: "27",
    tumbon_code: "01",
    name: "คลองกุ่ม",
    zipcode: "10230",
  },
  {
    jw_code: "10",
    amph_code: "27",
    tumbon_code: "02",
    name: "สะพานสูง",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "27",
    tumbon_code: "03",
    name: "คันนายาว",
    zipcode: "10240",
  },
  {
    jw_code: "10",
    amph_code: "27",
    tumbon_code: "04",
    name: "นวมินทร์",
    zipcode: "10240",
  },
  {
    jw_code: "10",
    amph_code: "27",
    tumbon_code: "05",
    name: "นวลจันทร์",
    zipcode: "10240",
  },
  {
    jw_code: "10",
    amph_code: "28",
    tumbon_code: "01",
    name: "ทุ่งวัดดอน",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "28",
    tumbon_code: "02",
    name: "ยานนาวา",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "28",
    tumbon_code: "03",
    name: "ทุ่งมหาเมฆ",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "29",
    tumbon_code: "01",
    name: "บางซื่อ",
    zipcode: "10800",
  },
  {
    jw_code: "10",
    amph_code: "29",
    tumbon_code: "02",
    name: "วงศ์สว่าง",
    zipcode: "10800",
  },
  {
    jw_code: "10",
    amph_code: "30",
    tumbon_code: "01",
    name: "ลาดยาว",
    zipcode: "10900",
  },
  {
    jw_code: "10",
    amph_code: "30",
    tumbon_code: "02",
    name: "เสนานิคม",
    zipcode: "10900",
  },
  {
    jw_code: "10",
    amph_code: "30",
    tumbon_code: "03",
    name: "จันทรเกษม",
    zipcode: "10900",
  },
  {
    jw_code: "10",
    amph_code: "30",
    tumbon_code: "04",
    name: "จอมพล",
    zipcode: "10900",
  },
  {
    jw_code: "10",
    amph_code: "30",
    tumbon_code: "05",
    name: "จตุจักร",
    zipcode: "10900",
  },
  {
    jw_code: "10",
    amph_code: "31",
    tumbon_code: "01",
    name: "บางคอแหลม",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "31",
    tumbon_code: "02",
    name: "วัดพระยาไกร",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "31",
    tumbon_code: "03",
    name: "บางโคล่",
    zipcode: "10120",
  },
  {
    jw_code: "10",
    amph_code: "32",
    tumbon_code: "01",
    name: "ประเวศ",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "32",
    tumbon_code: "02",
    name: "หนองบอน",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "32",
    tumbon_code: "03",
    name: "ดอกไม้",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "32",
    tumbon_code: "04",
    name: "สวนหลวง",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "33",
    tumbon_code: "01",
    name: "คลองเตย",
    zipcode: "10110",
  },
  {
    jw_code: "10",
    amph_code: "33",
    tumbon_code: "02",
    name: "คลองตัน",
    zipcode: "10110",
  },
  {
    jw_code: "10",
    amph_code: "33",
    tumbon_code: "03",
    name: "พระโขนง",
    zipcode: "10260",
  },
  {
    jw_code: "10",
    amph_code: "33",
    tumbon_code: "04",
    name: "คลองเตยเหนือ",
    zipcode: "10110",
  },
  {
    jw_code: "10",
    amph_code: "33",
    tumbon_code: "05",
    name: "คลองตันเหนือ",
    zipcode: "10110",
  },
  {
    jw_code: "10",
    amph_code: "33",
    tumbon_code: "06",
    name: "พระโขนงเหนือ",
    zipcode: "10260",
  },
  {
    jw_code: "10",
    amph_code: "34",
    tumbon_code: "01",
    name: "สวนหลวง",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "34",
    tumbon_code: "02",
    name: "อ่อนนุช",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "34",
    tumbon_code: "03",
    name: "พัฒนาการ",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "35",
    tumbon_code: "01",
    name: "บางขุนเทียน",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "35",
    tumbon_code: "02",
    name: "บางค้อ",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "35",
    tumbon_code: "03",
    name: "บางมด",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "35",
    tumbon_code: "04",
    name: "จอมทอง",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "36",
    tumbon_code: "02",
    name: "สีกัน",
    zipcode: "10213",
  },
  {
    jw_code: "10",
    amph_code: "36",
    tumbon_code: "04",
    name: "ดอนเมือง",
    zipcode: "10210",
  },
  {
    jw_code: "10",
    amph_code: "36",
    tumbon_code: "05",
    name: "สนามบิน",
    zipcode: "10210",
  },
  {
    jw_code: "10",
    amph_code: "37",
    tumbon_code: "01",
    name: "ทุ่งพญาไท",
    zipcode: "10400",
  },
  {
    jw_code: "10",
    amph_code: "37",
    tumbon_code: "02",
    name: "ถนนพญาไท",
    zipcode: "10400",
  },
  {
    jw_code: "10",
    amph_code: "37",
    tumbon_code: "03",
    name: "ถนนเพชรบุรี",
    zipcode: "10400",
  },
  {
    jw_code: "10",
    amph_code: "37",
    tumbon_code: "04",
    name: "มักกะสัน",
    zipcode: "10400",
  },
  {
    jw_code: "10",
    amph_code: "38",
    tumbon_code: "01",
    name: "ลาดพร้าว",
    zipcode: "10230",
  },
  {
    jw_code: "10",
    amph_code: "38",
    tumbon_code: "02",
    name: "จรเข้บัว",
    zipcode: "10230",
  },
  {
    jw_code: "10",
    amph_code: "39",
    tumbon_code: "01",
    name: "คลองเตยเหนือ",
    zipcode: "10110",
  },
  {
    jw_code: "10",
    amph_code: "39",
    tumbon_code: "02",
    name: "คลองตันเหนือ",
    zipcode: "10110",
  },
  {
    jw_code: "10",
    amph_code: "39",
    tumbon_code: "03",
    name: "พระโขนงเหนือ",
    zipcode: "10260",
  },
  {
    jw_code: "10",
    amph_code: "40",
    tumbon_code: "01",
    name: "บางแค",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "40",
    tumbon_code: "02",
    name: "บางแคเหนือ",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "40",
    tumbon_code: "03",
    name: "บางไผ่",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "40",
    tumbon_code: "04",
    name: "หลักสอง",
    zipcode: "10160",
  },
  {
    jw_code: "10",
    amph_code: "41",
    tumbon_code: "01",
    name: "ทุ่งสองห้อง",
    zipcode: "10210",
  },
  {
    jw_code: "10",
    amph_code: "41",
    tumbon_code: "02",
    name: "ตลาดบางเขน",
    zipcode: "10210",
  },
  {
    jw_code: "10",
    amph_code: "42",
    tumbon_code: "01",
    name: "สายไหม",
    zipcode: "10220",
  },
  {
    jw_code: "10",
    amph_code: "42",
    tumbon_code: "02",
    name: "ออเงิน",
    zipcode: "10220",
  },
  {
    jw_code: "10",
    amph_code: "42",
    tumbon_code: "03",
    name: "คลองถนน",
    zipcode: "10220",
  },
  {
    jw_code: "10",
    amph_code: "43",
    tumbon_code: "01",
    name: "คันนายาว",
    zipcode: "10230",
  },
  {
    jw_code: "10",
    amph_code: "43",
    tumbon_code: "02",
    name: "รามอินทรา",
    zipcode: "10230",
  },
  {
    jw_code: "10",
    amph_code: "44",
    tumbon_code: "01",
    name: "สะพานสูง",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "44",
    tumbon_code: "02",
    name: "ราษฎร์พัฒนา",
    zipcode: "10240",
  },
  {
    jw_code: "10",
    amph_code: "44",
    tumbon_code: "03",
    name: "ทับช้าง",
    zipcode: "10250",
  },
  {
    jw_code: "10",
    amph_code: "45",
    tumbon_code: "01",
    name: "วังทองหลาง",
    zipcode: "10310",
  },
  {
    jw_code: "10",
    amph_code: "45",
    tumbon_code: "02",
    name: "สะพานสอง",
    zipcode: "10310",
  },
  {
    jw_code: "10",
    amph_code: "45",
    tumbon_code: "03",
    name: "คลองเจ้าคุณสิงห์",
    zipcode: "10310",
  },
  {
    jw_code: "10",
    amph_code: "45",
    tumbon_code: "04",
    name: "พลับพลา",
    zipcode: "10310",
  },
  {
    jw_code: "10",
    amph_code: "46",
    tumbon_code: "01",
    name: "สามวาตะวันตก",
    zipcode: "10510",
  },
  {
    jw_code: "10",
    amph_code: "46",
    tumbon_code: "02",
    name: "สามวาตะวันออก",
    zipcode: "10510",
  },
  {
    jw_code: "10",
    amph_code: "46",
    tumbon_code: "03",
    name: "บางชัน",
    zipcode: "10510",
  },
  {
    jw_code: "10",
    amph_code: "46",
    tumbon_code: "04",
    name: "ทรายกองดิน",
    zipcode: "10510",
  },
  {
    jw_code: "10",
    amph_code: "46",
    tumbon_code: "05",
    name: "ทรายกองดินใต้",
    zipcode: "10510",
  },
  {
    jw_code: "10",
    amph_code: "47",
    tumbon_code: "01",
    name: "บางนาเหนือ",
    zipcode: "10260",
  },
  {
    jw_code: "10",
    amph_code: "47",
    tumbon_code: "02",
    name: "บางนาใต้",
    zipcode: "10260",
  },
  {
    jw_code: "10",
    amph_code: "48",
    tumbon_code: "01",
    name: "ทวีวัฒนา",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "48",
    tumbon_code: "02",
    name: "ศาลาธรรมสพน์",
    zipcode: "10170",
  },
  {
    jw_code: "10",
    amph_code: "49",
    tumbon_code: "01",
    name: "บางมด",
    zipcode: "10140",
  },
  {
    jw_code: "10",
    amph_code: "49",
    tumbon_code: "02",
    name: "ทุ่งครุ",
    zipcode: "10140",
  },
  {
    jw_code: "10",
    amph_code: "50",
    tumbon_code: "01",
    name: "บางบอน",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "50",
    tumbon_code: "02",
    name: "บางบอนเหนือ",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "50",
    tumbon_code: "03",
    name: "บางบอนใต้",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "50",
    tumbon_code: "04",
    name: "คลองบางพราน",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "50",
    tumbon_code: "05",
    name: "คลองบางบอน",
    zipcode: "10150",
  },
  {
    jw_code: "10",
    amph_code: "AT",
    tumbon_code: "AT",
    name: "ตามรายการ",
    zipcode: "",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "01",
    name: "ปากน้ำ",
    zipcode: "10270",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "02",
    name: "สำโรงเหนือ",
    zipcode: "10270",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "03",
    name: "บางเมือง",
    zipcode: "10270",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "04",
    name: "ท้ายบ้าน",
    zipcode: "10280",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางปูใหม่",
    zipcode: "10280",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "10",
    name: "แพรกษา",
    zipcode: "10280",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "11",
    name: "บางโปรง",
    zipcode: "10270",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "12",
    name: "บางปู",
    zipcode: "10280",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "13",
    name: "บางด้วน",
    zipcode: "10270",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "14",
    name: "บางเมืองใหม่",
    zipcode: "10270",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "15",
    name: "เทพารักษ์",
    zipcode: "10270",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "16",
    name: "ท้ายบ้านใหม่",
    zipcode: "10280",
  },
  {
    jw_code: "11",
    amph_code: "01",
    tumbon_code: "17",
    name: "แพรกษาใหม่",
    zipcode: "10280",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "01",
    name: "บางบ่อ",
    zipcode: "10560",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "02",
    name: "บ้านระกาศ",
    zipcode: "10560",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางพลีน้อย",
    zipcode: "10560",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "04",
    name: "บางเพรียง",
    zipcode: "10560",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "05",
    name: "คลองด่าน",
    zipcode: "10550",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "06",
    name: "คลองสวน",
    zipcode: "10560",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "07",
    name: "เปร็ง",
    zipcode: "10560",
  },
  {
    jw_code: "11",
    amph_code: "02",
    tumbon_code: "08",
    name: "คลองนิยมยาตรา",
    zipcode: "10560",
  },
  {
    jw_code: "11",
    amph_code: "03",
    tumbon_code: "01",
    name: "บางพลีใหญ่",
    zipcode: "10540",
  },
  {
    jw_code: "11",
    amph_code: "03",
    tumbon_code: "02",
    name: "บางแก้ว",
    zipcode: "10540",
  },
  {
    jw_code: "11",
    amph_code: "03",
    tumbon_code: "03",
    name: "บางปลา",
    zipcode: "10540",
  },
  {
    jw_code: "11",
    amph_code: "03",
    tumbon_code: "04",
    name: "บางโฉลง",
    zipcode: "10540",
  },
  {
    jw_code: "11",
    amph_code: "03",
    tumbon_code: "08",
    name: "ราชาเทวะ",
    zipcode: "10540",
  },
  {
    jw_code: "11",
    amph_code: "03",
    tumbon_code: "09",
    name: "หนองปรือ",
    zipcode: "10540",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "01",
    name: "ตลาด",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "02",
    name: "บางพึ่ง",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "03",
    name: "บางจาก",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "04",
    name: "บางครุ",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "05",
    name: "บางหญ้าแพรก",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "06",
    name: "บางหัวเสือ",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "07",
    name: "สำโรงใต้",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "08",
    name: "บางยอ",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "09",
    name: "บางกะเจ้า",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "10",
    name: "บางน้ำผึ้ง",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "11",
    name: "บางกระสอบ",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "12",
    name: "บางกอบัว",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "13",
    name: "ทรงคนอง",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "14",
    name: "สำโรง",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "04",
    tumbon_code: "15",
    name: "สำโรงกลาง",
    zipcode: "10130",
  },
  {
    jw_code: "11",
    amph_code: "05",
    tumbon_code: "01",
    name: "นาเกลือ",
    zipcode: "10290",
  },
  {
    jw_code: "11",
    amph_code: "05",
    tumbon_code: "02",
    name: "บ้านคลองสวน",
    zipcode: "10290",
  },
  {
    jw_code: "11",
    amph_code: "05",
    tumbon_code: "03",
    name: "แหลมฟ้าผ่า",
    zipcode: "10290",
  },
  {
    jw_code: "11",
    amph_code: "05",
    tumbon_code: "04",
    name: "ปากคลองบางปลากด",
    zipcode: "10290",
  },
  {
    jw_code: "11",
    amph_code: "05",
    tumbon_code: "05",
    name: "ในคลองบางปลากด",
    zipcode: "10290",
  },
  {
    jw_code: "11",
    amph_code: "06",
    tumbon_code: "01",
    name: "บางเสาธง",
    zipcode: "10570",
  },
  {
    jw_code: "11",
    amph_code: "06",
    tumbon_code: "02",
    name: "ศีรษะจรเข้น้อย",
    zipcode: "10570",
  },
  {
    jw_code: "11",
    amph_code: "06",
    tumbon_code: "03",
    name: "ศีรษะจรเข้ใหญ่",
    zipcode: "10570",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "01",
    name: "สวนใหญ่",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "02",
    name: "ตลาดขวัญ",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "03",
    name: "บางเขน",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "04",
    name: "บางกระสอ",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "05",
    name: "ท่าทราย",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "06",
    name: "บางไผ่",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "07",
    name: "บางศรีเมือง",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางกร่าง",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "09",
    name: "ไทรม้า",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "01",
    tumbon_code: "10",
    name: "บางรักน้อย",
    zipcode: "11000",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "01",
    name: "วัดชลอ",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "02",
    name: "บางกรวย",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางสีทอง",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "04",
    name: "บางขนุน",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "05",
    name: "บางขุนกอง",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "06",
    name: "บางคูเวียง",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "07",
    name: "มหาสวัสดิ์",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "08",
    name: "ปลายบาง",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "02",
    tumbon_code: "09",
    name: "ศาลากลาง",
    zipcode: "11130",
  },
  {
    jw_code: "12",
    amph_code: "03",
    tumbon_code: "01",
    name: "บางม่วง",
    zipcode: "11140",
  },
  {
    jw_code: "12",
    amph_code: "03",
    tumbon_code: "02",
    name: "บางแม่นาง",
    zipcode: "11140",
  },
  {
    jw_code: "12",
    amph_code: "03",
    tumbon_code: "03",
    name: "บางเลน",
    zipcode: "11140",
  },
  {
    jw_code: "12",
    amph_code: "03",
    tumbon_code: "04",
    name: "เสาธงหิน",
    zipcode: "11140",
  },
  {
    jw_code: "12",
    amph_code: "03",
    tumbon_code: "05",
    name: "บางใหญ่",
    zipcode: "11140",
  },
  {
    jw_code: "12",
    amph_code: "03",
    tumbon_code: "06",
    name: "บ้านใหม่",
    zipcode: "11140",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "01",
    name: "โสนลอย",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "02",
    name: "บางบัวทอง",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "03",
    name: "บางรักใหญ่",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "04",
    name: "บางคูรัด",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "05",
    name: "ละหาร",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "06",
    name: "ลำโพ",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "07",
    name: "พิมลราช",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "04",
    tumbon_code: "08",
    name: "บางรักพัฒนา",
    zipcode: "11110",
  },
  {
    jw_code: "12",
    amph_code: "05",
    tumbon_code: "01",
    name: "ไทรน้อย",
    zipcode: "11150",
  },
  {
    jw_code: "12",
    amph_code: "05",
    tumbon_code: "02",
    name: "ราษฎร์นิยม",
    zipcode: "11150",
  },
  {
    jw_code: "12",
    amph_code: "05",
    tumbon_code: "03",
    name: "หนองเพรางาย",
    zipcode: "11150",
  },
  {
    jw_code: "12",
    amph_code: "05",
    tumbon_code: "04",
    name: "ไทรใหญ่",
    zipcode: "11150",
  },
  {
    jw_code: "12",
    amph_code: "05",
    tumbon_code: "05",
    name: "ขุนศรี",
    zipcode: "11150",
  },
  {
    jw_code: "12",
    amph_code: "05",
    tumbon_code: "06",
    name: "คลองขวาง",
    zipcode: "11150",
  },
  {
    jw_code: "12",
    amph_code: "05",
    tumbon_code: "07",
    name: "ทวีวัฒนา",
    zipcode: "11150",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปากเกร็ด",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "02",
    name: "บางตลาด",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "03",
    name: "บ้านใหม่",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "04",
    name: "บางพูด",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "05",
    name: "บางตะไนย์",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "06",
    name: "คลองพระอุดม",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "07",
    name: "ท่าอิฐ",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "08",
    name: "เกาะเกร็ด",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "09",
    name: "อ้อมเกร็ด",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "10",
    name: "คลองข่อย",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "11",
    name: "บางพลับ",
    zipcode: "11120",
  },
  {
    jw_code: "12",
    amph_code: "06",
    tumbon_code: "12",
    name: "คลองเกลือ",
    zipcode: "11120",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "01",
    name: "บางปรอก",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "02",
    name: "บ้านใหม่",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านกลาง",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "04",
    name: "บ้านฉาง",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านกระแชง",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "06",
    name: "บางขะแยง",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "07",
    name: "บางคูวัด",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางหลวง",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "09",
    name: "บางเดื่อ",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "10",
    name: "บางพูด",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "11",
    name: "บางพูน",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "12",
    name: "บางกะดี",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "13",
    name: "สวนพริกไทย",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "01",
    tumbon_code: "14",
    name: "หลักหก",
    zipcode: "12000",
  },
  {
    jw_code: "13",
    amph_code: "02",
    tumbon_code: "01",
    name: "คลองหนึ่ง",
    zipcode: "13180",
  },
  {
    jw_code: "13",
    amph_code: "02",
    tumbon_code: "02",
    name: "คลองสอง",
    zipcode: "12120",
  },
  {
    jw_code: "13",
    amph_code: "02",
    tumbon_code: "03",
    name: "คลองสาม",
    zipcode: "12120",
  },
  {
    jw_code: "13",
    amph_code: "02",
    tumbon_code: "04",
    name: "คลองสี่",
    zipcode: "12120",
  },
  {
    jw_code: "13",
    amph_code: "02",
    tumbon_code: "05",
    name: "คลองห้า",
    zipcode: "12110",
  },
  {
    jw_code: "13",
    amph_code: "02",
    tumbon_code: "06",
    name: "คลองหก",
    zipcode: "12110",
  },
  {
    jw_code: "13",
    amph_code: "02",
    tumbon_code: "07",
    name: "คลองเจ็ด",
    zipcode: "12120",
  },
  {
    jw_code: "13",
    amph_code: "03",
    tumbon_code: "01",
    name: "ประชาธิปัตย์",
    zipcode: "12130",
  },
  {
    jw_code: "13",
    amph_code: "03",
    tumbon_code: "02",
    name: "บึงยี่โถ",
    zipcode: "12130",
  },
  {
    jw_code: "13",
    amph_code: "03",
    tumbon_code: "03",
    name: "รังสิต",
    zipcode: "12110",
  },
  {
    jw_code: "13",
    amph_code: "03",
    tumbon_code: "04",
    name: "ลำผักกูด",
    zipcode: "12110",
  },
  {
    jw_code: "13",
    amph_code: "03",
    tumbon_code: "05",
    name: "บึงสนั่น",
    zipcode: "12110",
  },
  {
    jw_code: "13",
    amph_code: "03",
    tumbon_code: "06",
    name: "บึงน้ำรักษ์",
    zipcode: "12110",
  },
  {
    jw_code: "13",
    amph_code: "04",
    tumbon_code: "01",
    name: "บึงบา",
    zipcode: "12170",
  },
  {
    jw_code: "13",
    amph_code: "04",
    tumbon_code: "02",
    name: "บึงบอน",
    zipcode: "12170",
  },
  {
    jw_code: "13",
    amph_code: "04",
    tumbon_code: "03",
    name: "บึงกาสาม",
    zipcode: "12170",
  },
  {
    jw_code: "13",
    amph_code: "04",
    tumbon_code: "04",
    name: "บึงชำอ้อ",
    zipcode: "12170",
  },
  {
    jw_code: "13",
    amph_code: "04",
    tumbon_code: "05",
    name: "หนองสามวัง",
    zipcode: "12170",
  },
  {
    jw_code: "13",
    amph_code: "04",
    tumbon_code: "06",
    name: "ศาลาครุ",
    zipcode: "12170",
  },
  {
    jw_code: "13",
    amph_code: "04",
    tumbon_code: "07",
    name: "นพรัตน์",
    zipcode: "12170",
  },
  {
    jw_code: "13",
    amph_code: "05",
    tumbon_code: "01",
    name: "ระแหง",
    zipcode: "12140",
  },
  {
    jw_code: "13",
    amph_code: "05",
    tumbon_code: "02",
    name: "ลาดหลุมแก้ว",
    zipcode: "12140",
  },
  {
    jw_code: "13",
    amph_code: "05",
    tumbon_code: "03",
    name: "คูบางหลวง",
    zipcode: "12140",
  },
  {
    jw_code: "13",
    amph_code: "05",
    tumbon_code: "04",
    name: "คูขวาง",
    zipcode: "12140",
  },
  {
    jw_code: "13",
    amph_code: "05",
    tumbon_code: "05",
    name: "คลองพระอุดม",
    zipcode: "12140",
  },
  {
    jw_code: "13",
    amph_code: "05",
    tumbon_code: "06",
    name: "บ่อเงิน",
    zipcode: "12140",
  },
  {
    jw_code: "13",
    amph_code: "05",
    tumbon_code: "07",
    name: "หน้าไม้",
    zipcode: "12140",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "01",
    name: "คูคต",
    zipcode: "12130",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "02",
    name: "ลาดสวาย",
    zipcode: "12150",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "03",
    name: "บึงคำพร้อย",
    zipcode: "12150",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "04",
    name: "ลำลูกกา",
    zipcode: "12150",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "05",
    name: "บึงทองหลาง",
    zipcode: "12150",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "06",
    name: "ลำไทร",
    zipcode: "12150",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "07",
    name: "บึงคอไห",
    zipcode: "12150",
  },
  {
    jw_code: "13",
    amph_code: "06",
    tumbon_code: "08",
    name: "พืชอุดม",
    zipcode: "12150",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "01",
    name: "บางเตย",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "02",
    name: "คลองควาย",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "03",
    name: "สามโคก",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "04",
    name: "กระแชง",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "05",
    name: "บางโพธิ์เหนือ",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "06",
    name: "เชียงรากใหญ่",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "07",
    name: "บ้านปทุม",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "08",
    name: "บ้านงิ้ว",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "09",
    name: "เชียงรากน้อย",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "10",
    name: "บางกระบือ",
    zipcode: "12160",
  },
  {
    jw_code: "13",
    amph_code: "07",
    tumbon_code: "11",
    name: "ท้ายเกาะ",
    zipcode: "12160",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "01",
    name: "ประตูชัย",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "02",
    name: "กะมัง",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "03",
    name: "หอรัตนไชย",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "04",
    name: "หัวรอ",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "05",
    name: "ท่าวาสุกรี",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "06",
    name: "ไผ่ลิง",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "07",
    name: "ปากกราน",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "08",
    name: "ภูเขาทอง",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "09",
    name: "สำเภาล่ม",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "10",
    name: "สวนพริก",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "11",
    name: "คลองตะเคียน",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "12",
    name: "วัดตูม",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "13",
    name: "หันตรา",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "14",
    name: "ลุมพลี",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "15",
    name: "บ้านใหม่",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "16",
    name: "บ้านเกาะ",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "17",
    name: "คลองสวนพลู",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "18",
    name: "คลองสระบัว",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "19",
    name: "เกาะเรียน",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "20",
    name: "บ้านป้อม",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "01",
    tumbon_code: "21",
    name: "บ้านรุน",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "01",
    name: "ท่าเรือ",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "02",
    name: "จำปา",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "03",
    name: "ท่าหลวง",
    zipcode: "18270",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "04",
    name: "บ้านร่อม",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "05",
    name: "ศาลาลอย",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "06",
    name: "วังแดง",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "07",
    name: "โพธิ์เอน",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "08",
    name: "ปากท่า",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "09",
    name: "หนองขนาก",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "02",
    tumbon_code: "10",
    name: "ท่าเจ้าสนุก",
    zipcode: "13130",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "01",
    name: "นครหลวง",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "02",
    name: "ท่าช้าง",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "03",
    name: "บ่อโพง",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "04",
    name: "บ้านชุ้ง",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "05",
    name: "ปากจั่น",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "06",
    name: "บางระกำ",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "07",
    name: "บางพระครู",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "08",
    name: "แม่ลา",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "09",
    name: "หนองปลิง",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "10",
    name: "คลองสะแก",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "11",
    name: "สามไถ",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "03",
    tumbon_code: "12",
    name: "พระนอน",
    zipcode: "13260",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "01",
    name: "บางไทร",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "02",
    name: "บางพลี",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "03",
    name: "สนามชัย",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "04",
    name: "บ้านแป้ง",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "05",
    name: "หน้าไม้",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "06",
    name: "บางยี่โท",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "07",
    name: "แคออก",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "08",
    name: "แคตก",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "09",
    name: "ช่างเหล็ก",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "10",
    name: "กระแชง",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "11",
    name: "บ้านกลึง",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "12",
    name: "ช้างน้อย",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "13",
    name: "ห่อหมก",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "14",
    name: "ไผ่พระ",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "15",
    name: "กกแก้วบูรพา",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "16",
    name: "ไม้ตรา",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "17",
    name: "บ้านม้า",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "18",
    name: "บ้านเกาะ",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "19",
    name: "ราชคราม",
    zipcode: "13290",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "20",
    name: "ช้างใหญ่",
    zipcode: "13290",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "21",
    name: "โพแตง",
    zipcode: "13290",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "22",
    name: "เชียงรากน้อย",
    zipcode: "13290",
  },
  {
    jw_code: "14",
    amph_code: "04",
    tumbon_code: "23",
    name: "โคกช้าง",
    zipcode: "13190",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "01",
    name: "บางบาล",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "02",
    name: "วัดยม",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "03",
    name: "ไทรน้อย",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "04",
    name: "สะพานไทย",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "05",
    name: "มหาพราหมณ์",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "06",
    name: "กบเจา",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "07",
    name: "บ้านคลัง",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "08",
    name: "พระขาว",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "09",
    name: "น้ำเต้า",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "10",
    name: "ทางช้าง",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "11",
    name: "วัดตะกู",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "12",
    name: "บางหลวง",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "13",
    name: "บางหลวงโดด",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "14",
    name: "บางหัก",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "15",
    name: "บางชะนี",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "05",
    tumbon_code: "16",
    name: "บ้านกุ่ม",
    zipcode: "13250",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "01",
    name: "บ้านเลน",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "02",
    name: "เชียงรากน้อย",
    zipcode: "13290",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "03",
    name: "บ้านโพ",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "04",
    name: "บ้านกรด",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "05",
    name: "บางกระสั้น",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "06",
    name: "คลองจิก",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "07",
    name: "บ้านหว้า",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "08",
    name: "วัดยม",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "09",
    name: "บางประแดง",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "10",
    name: "สามเรือน",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "11",
    name: "เกาะเกิด",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "12",
    name: "บ้านพลับ",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "13",
    name: "บ้านแป้ง",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "14",
    name: "คุ้งลาน",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "15",
    name: "ตลิ่งชัน",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "16",
    name: "บ้านสร้าง",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "17",
    name: "ตลาดเกรียบ",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "06",
    tumbon_code: "18",
    name: "ขนอนหลวง",
    zipcode: "13160",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "01",
    name: "บางปะหัน",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "02",
    name: "ขยาย",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "03",
    name: "บางเดื่อ",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "04",
    name: "เสาธง",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "05",
    name: "ทางกลาง",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "06",
    name: "บางเพลิง",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "07",
    name: "หันสัง",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "08",
    name: "บางนางร้า",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "09",
    name: "ตานิม",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "10",
    name: "ทับน้ำ",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "11",
    name: "บ้านม้า",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "12",
    name: "ขวัญเมือง",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "13",
    name: "บ้านลี่",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "14",
    name: "โพธิ์สามต้น",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "15",
    name: "พุทเลา",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "16",
    name: "ตาลเอน",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "07",
    tumbon_code: "17",
    name: "บ้านขล้อ",
    zipcode: "13220",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "01",
    name: "ผักไห่",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "02",
    name: "อมฤต",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "03",
    name: "บ้านแค",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "04",
    name: "ลาดน้ำเค็ม",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "05",
    name: "ตาลาน",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "06",
    name: "ท่าดินแดง",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "07",
    name: "ดอนลาน",
    zipcode: "13280",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "08",
    name: "นาคู",
    zipcode: "13280",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "09",
    name: "กุฎี",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "10",
    name: "ลำตะเคียน",
    zipcode: "13280",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "11",
    name: "โคกช้าง",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "12",
    name: "จักราช",
    zipcode: "13280",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "13",
    name: "หนองน้ำใหญ่",
    zipcode: "13280",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "14",
    name: "ลาดชิด",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "15",
    name: "หน้าโคก",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "08",
    tumbon_code: "16",
    name: "บ้านใหญ่",
    zipcode: "13120",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "01",
    name: "ภาชี",
    zipcode: "13140",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "02",
    name: "โคกม่วง",
    zipcode: "13140",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "03",
    name: "ระโสม",
    zipcode: "18250",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "04",
    name: "หนองน้ำใส",
    zipcode: "13140",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "05",
    name: "ดอนหญ้านาง",
    zipcode: "13140",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "06",
    name: "ไผ่ล้อม",
    zipcode: "13140",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "07",
    name: "กระจิว",
    zipcode: "13140",
  },
  {
    jw_code: "14",
    amph_code: "09",
    tumbon_code: "08",
    name: "พระแก้ว",
    zipcode: "13140",
  },
  {
    jw_code: "14",
    amph_code: "10",
    tumbon_code: "01",
    name: "ลาดบัวหลวง",
    zipcode: "13230",
  },
  {
    jw_code: "14",
    amph_code: "10",
    tumbon_code: "02",
    name: "หลักชัย",
    zipcode: "13230",
  },
  {
    jw_code: "14",
    amph_code: "10",
    tumbon_code: "03",
    name: "สามเมือง",
    zipcode: "13230",
  },
  {
    jw_code: "14",
    amph_code: "10",
    tumbon_code: "04",
    name: "พระยาบันลือ",
    zipcode: "13230",
  },
  {
    jw_code: "14",
    amph_code: "10",
    tumbon_code: "05",
    name: "สิงหนาท",
    zipcode: "13230",
  },
  {
    jw_code: "14",
    amph_code: "10",
    tumbon_code: "06",
    name: "คู้สลอด",
    zipcode: "13230",
  },
  {
    jw_code: "14",
    amph_code: "10",
    tumbon_code: "07",
    name: "คลองพระยาบันลือ",
    zipcode: "13230",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "01",
    name: "ลำตาเสา",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "02",
    name: "บ่อตาโล่",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "03",
    name: "วังน้อย",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "04",
    name: "ลำไทร",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "05",
    name: "สนับทึบ",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "06",
    name: "พยอม",
    zipcode: "13180",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "07",
    name: "หันตะเภา",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "08",
    name: "วังจุฬา",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "09",
    name: "ข้าวงาม",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "11",
    tumbon_code: "10",
    name: "ชะแมบ",
    zipcode: "13170",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "01",
    name: "เสนา",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "02",
    name: "บ้านแพน",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "03",
    name: "เจ้าเจ็ด",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "04",
    name: "สามกอ",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "05",
    name: "บางนมโค",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "06",
    name: "หัวเวียง",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "07",
    name: "มารวิชัย",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "08",
    name: "บ้านโพธิ์",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "09",
    name: "รางจรเข้",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "10",
    name: "บ้านกระทุ่ม",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "11",
    name: "บ้านแถว",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "12",
    name: "ชายนา",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "13",
    name: "สามตุ่ม",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "14",
    name: "ลาดงา",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "15",
    name: "ดอนทอง",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "16",
    name: "บ้านหลวง",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "12",
    tumbon_code: "17",
    name: "เจ้าเสด็จ",
    zipcode: "13110",
  },
  {
    jw_code: "14",
    amph_code: "13",
    tumbon_code: "01",
    name: "บางซ้าย",
    zipcode: "13270",
  },
  {
    jw_code: "14",
    amph_code: "13",
    tumbon_code: "02",
    name: "แก้วฟ้า",
    zipcode: "13270",
  },
  {
    jw_code: "14",
    amph_code: "13",
    tumbon_code: "03",
    name: "เต่าเล่า",
    zipcode: "13270",
  },
  {
    jw_code: "14",
    amph_code: "13",
    tumbon_code: "04",
    name: "ปลายกลัด",
    zipcode: "13270",
  },
  {
    jw_code: "14",
    amph_code: "13",
    tumbon_code: "05",
    name: "เทพมงคล",
    zipcode: "13270",
  },
  {
    jw_code: "14",
    amph_code: "13",
    tumbon_code: "06",
    name: "วังพัฒนา",
    zipcode: "13270",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "01",
    name: "คานหาม",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "02",
    name: "บ้านช้าง",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "03",
    name: "สามบัณฑิต",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "04",
    name: "บ้านหีบ",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "05",
    name: "หนองไม้ซุง",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "06",
    name: "อุทัย",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "07",
    name: "เสนา",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "08",
    name: "หนองน้ำส้ม",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "09",
    name: "โพสาวหาญ",
    zipcode: "13210",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "10",
    name: "ธนู",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "14",
    tumbon_code: "11",
    name: "ข้าวเม่า",
    zipcode: "13000",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "01",
    name: "หัวไผ่",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "02",
    name: "กะทุ่ม",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "03",
    name: "มหาราช",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "04",
    name: "น้ำเต้า",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "05",
    name: "บางนา",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "06",
    name: "โรงช้าง",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "07",
    name: "เจ้าปลุก",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "08",
    name: "พิตเพียน",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "09",
    name: "บ้านนา",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "10",
    name: "บ้านขวาง",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "11",
    name: "ท่าตอ",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "15",
    tumbon_code: "12",
    name: "บ้านใหม่",
    zipcode: "13150",
  },
  {
    jw_code: "14",
    amph_code: "16",
    tumbon_code: "01",
    name: "บ้านแพรก",
    zipcode: "13240",
  },
  {
    jw_code: "14",
    amph_code: "16",
    tumbon_code: "02",
    name: "บ้านใหม่",
    zipcode: "13240",
  },
  {
    jw_code: "14",
    amph_code: "16",
    tumbon_code: "03",
    name: "สำพะเนียง",
    zipcode: "13240",
  },
  {
    jw_code: "14",
    amph_code: "16",
    tumbon_code: "04",
    name: "คลองน้อย",
    zipcode: "13240",
  },
  {
    jw_code: "14",
    amph_code: "16",
    tumbon_code: "05",
    name: "สองห้อง",
    zipcode: "13240",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "01",
    name: "ตลาดหลวง",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "02",
    name: "บางแก้ว",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "03",
    name: "ศาลาแดง",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "04",
    name: "ป่างิ้ว",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านแห",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "06",
    name: "ตลาดกรวด",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "07",
    name: "มหาดไทย",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "08",
    name: "บ้านอิฐ",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "09",
    name: "หัวไผ่",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "10",
    name: "จำปาหล่อ",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "11",
    name: "โพสะ",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "12",
    name: "บ้านรี",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "13",
    name: "คลองวัว",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "01",
    tumbon_code: "14",
    name: "ย่านซื่อ",
    zipcode: "14000",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "01",
    name: "จรเข้ร้อง",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "02",
    name: "ไชยภูมิ",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "03",
    name: "ชัยฤทธิ์",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "04",
    name: "เทวราช",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "05",
    name: "ราชสถิตย์",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "06",
    name: "ไชโย",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "07",
    name: "หลักฟ้า",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "08",
    name: "ชะไว",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "02",
    tumbon_code: "09",
    name: "ตรีณรงค์",
    zipcode: "14140",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "01",
    name: "บางปลากด",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "02",
    name: "ป่าโมก",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "03",
    name: "สายทอง",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "04",
    name: "โรงช้าง",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "05",
    name: "บางเสด็จ",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "06",
    name: "นรสิงห์",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "07",
    name: "เอกราช",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "03",
    tumbon_code: "08",
    name: "โผงเผง",
    zipcode: "14130",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "01",
    name: "อ่างแก้ว",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "02",
    name: "อินทประมูล",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "03",
    name: "บางพลับ",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "04",
    name: "หนองแม่ไก่",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "05",
    name: "รำมะสัก",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "06",
    name: "บางระกำ",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "07",
    name: "โพธิ์รังนก",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "08",
    name: "องครักษ์",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "09",
    name: "โคกพุทรา",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "10",
    name: "ยางช้าย",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "11",
    name: "บ่อแร่",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "12",
    name: "ทางพระ",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "13",
    name: "สามง่าม",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "14",
    name: "บางเจ้าฉ่า",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "04",
    tumbon_code: "15",
    name: "คำหยาด",
    zipcode: "14120",
  },
  {
    jw_code: "15",
    amph_code: "05",
    tumbon_code: "01",
    name: "แสวงหา",
    zipcode: "14150",
  },
  {
    jw_code: "15",
    amph_code: "05",
    tumbon_code: "02",
    name: "ศรีพราน",
    zipcode: "14150",
  },
  {
    jw_code: "15",
    amph_code: "05",
    tumbon_code: "03",
    name: "บ้านพราน",
    zipcode: "14150",
  },
  {
    jw_code: "15",
    amph_code: "05",
    tumbon_code: "04",
    name: "วังน้ำเย็น",
    zipcode: "14150",
  },
  {
    jw_code: "15",
    amph_code: "05",
    tumbon_code: "05",
    name: "สีบัวทอง",
    zipcode: "14150",
  },
  {
    jw_code: "15",
    amph_code: "05",
    tumbon_code: "06",
    name: "ห้วยไผ่",
    zipcode: "14150",
  },
  {
    jw_code: "15",
    amph_code: "05",
    tumbon_code: "07",
    name: "จำลอง",
    zipcode: "14150",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "01",
    name: "ไผ่จำศิล",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "02",
    name: "ศาลเจ้าโรงทอง",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "03",
    name: "ไผ่ดำพัฒนา",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "04",
    name: "สาวร้องไห้",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "05",
    name: "ท่าช้าง",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "06",
    name: "ยี่ล้น",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "07",
    name: "บางจัก",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "08",
    name: "ห้วยคันแหลน",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "09",
    name: "คลองขนาก",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "10",
    name: "ไผ่วง",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "11",
    name: "สี่ร้อย",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "12",
    name: "ม่วงเตี้ย",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "13",
    name: "หัวตะพาน",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "14",
    name: "หลักแก้ว",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "06",
    tumbon_code: "15",
    name: "ตลาดใหม่",
    zipcode: "14110",
  },
  {
    jw_code: "15",
    amph_code: "07",
    tumbon_code: "01",
    name: "สามโก้",
    zipcode: "14160",
  },
  {
    jw_code: "15",
    amph_code: "07",
    tumbon_code: "02",
    name: "ราษฎรพัฒนา",
    zipcode: "14160",
  },
  {
    jw_code: "15",
    amph_code: "07",
    tumbon_code: "03",
    name: "อบทม",
    zipcode: "14160",
  },
  {
    jw_code: "15",
    amph_code: "07",
    tumbon_code: "04",
    name: "โพธิ์ม่วงพันธ์",
    zipcode: "14160",
  },
  {
    jw_code: "15",
    amph_code: "07",
    tumbon_code: "05",
    name: "มงคลธรรมนิมิต",
    zipcode: "14160",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "01",
    name: "ทะเลชุบศร",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "02",
    name: "ท่าหิน",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "03",
    name: "กกโก",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "04",
    name: "โก่งธนู",
    zipcode: "13240",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "05",
    name: "เขาพระงาม",
    zipcode: "15160",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "06",
    name: "เขาสามยอด",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "07",
    name: "โคกกะเทียม",
    zipcode: "15160",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "08",
    name: "โคกลำพาน",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "09",
    name: "โคกตูม",
    zipcode: "15210",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "10",
    name: "งิ้วราย",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "11",
    name: "ดอนโพธิ์",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "12",
    name: "ตะลุง",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "14",
    name: "ท่าแค",
    zipcode: "15160",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "15",
    name: "ท่าศาลา",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "16",
    name: "นิคมสร้างตนเอง",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "17",
    name: "บางขันหมาก",
    zipcode: "15160",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "18",
    name: "บ้านข่อย",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "19",
    name: "ท้ายตลาด",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "20",
    name: "ป่าตาล",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "21",
    name: "พรหมมาสตร์",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "22",
    name: "โพธิ์เก้าต้น",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "23",
    name: "โพธิ์ตรุ",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "24",
    name: "สี่คลอง",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "01",
    tumbon_code: "25",
    name: "ถนนใหญ่",
    zipcode: "15000",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "01",
    name: "พัฒนานิคม",
    zipcode: "15140",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "02",
    name: "ช่องสาริกา",
    zipcode: "15220",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "03",
    name: "มะนาวหวาน",
    zipcode: "15140",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "04",
    name: "ดีลัง",
    zipcode: "15220",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "05",
    name: "โคกสลุง",
    zipcode: "15140",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "06",
    name: "ชอนน้อย",
    zipcode: "15140",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองบัว",
    zipcode: "15140",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "08",
    name: "ห้วยขุนราม",
    zipcode: "18220",
  },
  {
    jw_code: "16",
    amph_code: "02",
    tumbon_code: "09",
    name: "น้ำสุด",
    zipcode: "15140",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "01",
    name: "โคกสำโรง",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "02",
    name: "เกาะแก้ว",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "03",
    name: "ถลุงเหล็ก",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "04",
    name: "หลุมข้าว",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "05",
    name: "ห้วยโป่ง",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "06",
    name: "คลองเกตุ",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "07",
    name: "สะแกราบ",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "08",
    name: "เพนียด",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "09",
    name: "วังเพลิง",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "10",
    name: "ดงมะรุม",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "18",
    name: "วังขอนขว้าง",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "20",
    name: "วังจั่น",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "03",
    tumbon_code: "22",
    name: "หนองแขม",
    zipcode: "15120",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "01",
    name: "ลำนารายณ์",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "02",
    name: "ชัยนารายณ์",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "03",
    name: "ศิลาทิพย์",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "04",
    name: "ห้วยหิน",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "05",
    name: "ม่วงค่อม",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "06",
    name: "บัวชุม",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "07",
    name: "ท่าดินดำ",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "08",
    name: "มะกอกหวาน",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "09",
    name: "ซับตะเคียน",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "10",
    name: "นาโสม",
    zipcode: "15190",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "11",
    name: "หนองยายโต๊ะ",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "12",
    name: "เกาะรัง",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "14",
    name: "ท่ามะนาว",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "17",
    name: "นิคมลำนารายณ์",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "18",
    name: "ชัยบาดาล",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "19",
    name: "บ้านใหม่สามัคคี",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "04",
    tumbon_code: "22",
    name: "เขาแหลม",
    zipcode: "15130",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "01",
    name: "ท่าวุ้ง",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "02",
    name: "บางคู้",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "03",
    name: "โพตลาดแก้ว",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "04",
    name: "บางลี่",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "05",
    name: "บางงา",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "06",
    name: "โคกสลุด",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "07",
    name: "เขาสมอคอน",
    zipcode: "15180",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "08",
    name: "หัวสำโรง",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "09",
    name: "ลาดสาลี่",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "10",
    name: "บ้านเบิก",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "05",
    tumbon_code: "11",
    name: "มุจลินท์",
    zipcode: "15150",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "01",
    name: "ไผ่ใหญ่",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ้านทราย",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "03",
    name: "บ้านกล้วย",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "04",
    name: "ดงพลับ",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "05",
    name: "บ้านชี",
    zipcode: "15180",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "06",
    name: "พุคา",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "07",
    name: "หินปัก",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "08",
    name: "บางพึ่ง",
    zipcode: "15180",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "09",
    name: "หนองทรายขาว",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "10",
    name: "บางกะพี้",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "11",
    name: "หนองเต่า",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "12",
    name: "โพนทอง",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "13",
    name: "บางขาม",
    zipcode: "15180",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "14",
    name: "ดอนดึง",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "15",
    name: "ชอนม่วง",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "16",
    name: "หนองกระเบียน",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "17",
    name: "สายห้วยแก้ว",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "18",
    name: "มหาสอน",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "19",
    name: "บ้านหมี่",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "20",
    name: "เชียงงา",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "21",
    name: "หนองเมือง",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "06",
    tumbon_code: "22",
    name: "สนามแจง",
    zipcode: "15110",
  },
  {
    jw_code: "16",
    amph_code: "07",
    tumbon_code: "01",
    name: "ท่าหลวง",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "07",
    tumbon_code: "02",
    name: "แก่งผักกูด",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "07",
    tumbon_code: "03",
    name: "ซับจำปา",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "07",
    tumbon_code: "04",
    name: "หนองผักแว่น",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "07",
    tumbon_code: "05",
    name: "ทะเลวังวัด",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "07",
    tumbon_code: "06",
    name: "หัวลำ",
    zipcode: "15230",
  },
  {
    jw_code: "16",
    amph_code: "08",
    tumbon_code: "01",
    name: "สระโบสถ์",
    zipcode: "15240",
  },
  {
    jw_code: "16",
    amph_code: "08",
    tumbon_code: "02",
    name: "มหาโพธิ",
    zipcode: "15250",
  },
  {
    jw_code: "16",
    amph_code: "08",
    tumbon_code: "03",
    name: "ทุ่งท่าช้าง",
    zipcode: "15240",
  },
  {
    jw_code: "16",
    amph_code: "08",
    tumbon_code: "04",
    name: "ห้วยใหญ่",
    zipcode: "15240",
  },
  {
    jw_code: "16",
    amph_code: "08",
    tumbon_code: "05",
    name: "นิยมชัย",
    zipcode: "15240",
  },
  {
    jw_code: "16",
    amph_code: "09",
    tumbon_code: "01",
    name: "โคกเจริญ",
    zipcode: "15250",
  },
  {
    jw_code: "16",
    amph_code: "09",
    tumbon_code: "02",
    name: "ยางราก",
    zipcode: "15250",
  },
  {
    jw_code: "16",
    amph_code: "09",
    tumbon_code: "03",
    name: "หนองมะค่า",
    zipcode: "15250",
  },
  {
    jw_code: "16",
    amph_code: "09",
    tumbon_code: "04",
    name: "วังทอง",
    zipcode: "15250",
  },
  {
    jw_code: "16",
    amph_code: "09",
    tumbon_code: "05",
    name: "โคกแสมสาร",
    zipcode: "15250",
  },
  {
    jw_code: "16",
    amph_code: "10",
    tumbon_code: "01",
    name: "ลำสนธิ",
    zipcode: "15190",
  },
  {
    jw_code: "16",
    amph_code: "10",
    tumbon_code: "02",
    name: "ซับสมบูรณ์",
    zipcode: "15190",
  },
  {
    jw_code: "16",
    amph_code: "10",
    tumbon_code: "03",
    name: "หนองรี",
    zipcode: "15190",
  },
  {
    jw_code: "16",
    amph_code: "10",
    tumbon_code: "04",
    name: "กุดตาเพชร",
    zipcode: "15190",
  },
  {
    jw_code: "16",
    amph_code: "10",
    tumbon_code: "05",
    name: "เขารวก",
    zipcode: "15190",
  },
  {
    jw_code: "16",
    amph_code: "10",
    tumbon_code: "06",
    name: "เขาน้อย",
    zipcode: "15190",
  },
  {
    jw_code: "16",
    amph_code: "11",
    tumbon_code: "01",
    name: "หนองม่วง",
    zipcode: "15170",
  },
  {
    jw_code: "16",
    amph_code: "11",
    tumbon_code: "02",
    name: "บ่อทอง",
    zipcode: "15170",
  },
  {
    jw_code: "16",
    amph_code: "11",
    tumbon_code: "03",
    name: "ดงดินแดง",
    zipcode: "15170",
  },
  {
    jw_code: "16",
    amph_code: "11",
    tumbon_code: "04",
    name: "ชอนสมบูรณ์",
    zipcode: "15170",
  },
  {
    jw_code: "16",
    amph_code: "11",
    tumbon_code: "05",
    name: "ยางโทน",
    zipcode: "15170",
  },
  {
    jw_code: "16",
    amph_code: "11",
    tumbon_code: "06",
    name: "ชอนสารเดช",
    zipcode: "15170",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "01",
    name: "บางพุทรา",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "02",
    name: "บางมัญ",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "03",
    name: "โพกรวม",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "04",
    name: "ม่วงหมู่",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "05",
    name: "หัวไผ่",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "06",
    name: "ต้นโพธิ์",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "07",
    name: "จักรสีห์",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางกระบือ",
    zipcode: "16000",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "01",
    name: "สิงห์",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "02",
    name: "ไม้ดัด",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "03",
    name: "เชิงกลัด",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "04",
    name: "โพชนไก่",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "05",
    name: "แม่ลา",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "06",
    name: "บ้านจ่า",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "07",
    name: "พักทัน",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "02",
    tumbon_code: "08",
    name: "สระแจง",
    zipcode: "16130",
  },
  {
    jw_code: "17",
    amph_code: "03",
    tumbon_code: "01",
    name: "โพทะเล",
    zipcode: "16150",
  },
  {
    jw_code: "17",
    amph_code: "03",
    tumbon_code: "02",
    name: "บางระจัน",
    zipcode: "16150",
  },
  {
    jw_code: "17",
    amph_code: "03",
    tumbon_code: "03",
    name: "โพสังโฆ",
    zipcode: "16150",
  },
  {
    jw_code: "17",
    amph_code: "03",
    tumbon_code: "04",
    name: "ท่าข้าม",
    zipcode: "16150",
  },
  {
    jw_code: "17",
    amph_code: "03",
    tumbon_code: "05",
    name: "คอทราย",
    zipcode: "16150",
  },
  {
    jw_code: "17",
    amph_code: "03",
    tumbon_code: "06",
    name: "หนองกระทุ่ม",
    zipcode: "16150",
  },
  {
    jw_code: "17",
    amph_code: "04",
    tumbon_code: "01",
    name: "พระงาม",
    zipcode: "16120",
  },
  {
    jw_code: "17",
    amph_code: "04",
    tumbon_code: "02",
    name: "พรหมบุรี",
    zipcode: "16160",
  },
  {
    jw_code: "17",
    amph_code: "04",
    tumbon_code: "03",
    name: "บางน้ำเชี่ยว",
    zipcode: "16120",
  },
  {
    jw_code: "17",
    amph_code: "04",
    tumbon_code: "04",
    name: "บ้านหม้อ",
    zipcode: "16120",
  },
  {
    jw_code: "17",
    amph_code: "04",
    tumbon_code: "05",
    name: "บ้านแป้ง",
    zipcode: "16120",
  },
  {
    jw_code: "17",
    amph_code: "04",
    tumbon_code: "06",
    name: "หัวป่า",
    zipcode: "16120",
  },
  {
    jw_code: "17",
    amph_code: "04",
    tumbon_code: "07",
    name: "โรงช้าง",
    zipcode: "16120",
  },
  {
    jw_code: "17",
    amph_code: "05",
    tumbon_code: "01",
    name: "ถอนสมอ",
    zipcode: "16140",
  },
  {
    jw_code: "17",
    amph_code: "05",
    tumbon_code: "02",
    name: "โพประจักษ์",
    zipcode: "16140",
  },
  {
    jw_code: "17",
    amph_code: "05",
    tumbon_code: "03",
    name: "วิหารขาว",
    zipcode: "16140",
  },
  {
    jw_code: "17",
    amph_code: "05",
    tumbon_code: "04",
    name: "พิกุลทอง",
    zipcode: "16140",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "01",
    name: "อินทร์บุรี",
    zipcode: "16111",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "02",
    name: "ประศุก",
    zipcode: "16110",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "03",
    name: "ทับยา",
    zipcode: "16110",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "04",
    name: "งิ้วราย",
    zipcode: "16110",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "05",
    name: "ชีน้ำร้าย",
    zipcode: "16110",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "06",
    name: "ท่างาม",
    zipcode: "16111",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "07",
    name: "น้ำตาล",
    zipcode: "16110",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "08",
    name: "ทองเอน",
    zipcode: "16110",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "09",
    name: "ห้วยชัน",
    zipcode: "16110",
  },
  {
    jw_code: "17",
    amph_code: "06",
    tumbon_code: "10",
    name: "โพธิ์ชัย",
    zipcode: "16110",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "02",
    name: "บ้านกล้วย",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "03",
    name: "ท่าชัย",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "04",
    name: "ชัยนาท",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "05",
    name: "เขาท่าพระ",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "06",
    name: "หาดท่าเสา",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "07",
    name: "ธรรมามูล",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "08",
    name: "เสือโฮก",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "01",
    tumbon_code: "09",
    name: "นางลือ",
    zipcode: "17000",
  },
  {
    jw_code: "18",
    amph_code: "02",
    tumbon_code: "01",
    name: "คุ้งสำเภา",
    zipcode: "17110",
  },
  {
    jw_code: "18",
    amph_code: "02",
    tumbon_code: "02",
    name: "วัดโคก",
    zipcode: "17170",
  },
  {
    jw_code: "18",
    amph_code: "02",
    tumbon_code: "03",
    name: "ศิลาดาน",
    zipcode: "17110",
  },
  {
    jw_code: "18",
    amph_code: "02",
    tumbon_code: "04",
    name: "ท่าฉนวน",
    zipcode: "17110",
  },
  {
    jw_code: "18",
    amph_code: "02",
    tumbon_code: "05",
    name: "หางน้ำสาคร",
    zipcode: "17170",
  },
  {
    jw_code: "18",
    amph_code: "02",
    tumbon_code: "06",
    name: "ไร่พัฒนา",
    zipcode: "17170",
  },
  {
    jw_code: "18",
    amph_code: "02",
    tumbon_code: "07",
    name: "อู่ตะเภา",
    zipcode: "17170",
  },
  {
    jw_code: "18",
    amph_code: "03",
    tumbon_code: "01",
    name: "วัดสิงห์",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "03",
    tumbon_code: "02",
    name: "มะขามเฒ่า",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "03",
    tumbon_code: "03",
    name: "หนองน้อย",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "03",
    tumbon_code: "04",
    name: "หนองบัว",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "03",
    tumbon_code: "06",
    name: "หนองขุ่น",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "03",
    tumbon_code: "07",
    name: "บ่อแร่",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "03",
    tumbon_code: "11",
    name: "วังหมัน",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "04",
    tumbon_code: "01",
    name: "สรรพยา",
    zipcode: "17150",
  },
  {
    jw_code: "18",
    amph_code: "04",
    tumbon_code: "02",
    name: "ตลุก",
    zipcode: "17150",
  },
  {
    jw_code: "18",
    amph_code: "04",
    tumbon_code: "03",
    name: "เขาแก้ว",
    zipcode: "17150",
  },
  {
    jw_code: "18",
    amph_code: "04",
    tumbon_code: "04",
    name: "โพนางดำตก",
    zipcode: "17150",
  },
  {
    jw_code: "18",
    amph_code: "04",
    tumbon_code: "05",
    name: "โพนางดำออก",
    zipcode: "17150",
  },
  {
    jw_code: "18",
    amph_code: "04",
    tumbon_code: "06",
    name: "บางหลวง",
    zipcode: "17150",
  },
  {
    jw_code: "18",
    amph_code: "04",
    tumbon_code: "07",
    name: "หาดอาษา",
    zipcode: "17150",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "01",
    name: "แพรกศรีราชา",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "02",
    name: "เที่ยงแท้",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "03",
    name: "ห้วยกรด",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "04",
    name: "โพงาม",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "05",
    name: "บางขุด",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "06",
    name: "ดงคอน",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "07",
    name: "ดอนกำ",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "05",
    tumbon_code: "08",
    name: "ห้วยกรดพัฒนา",
    zipcode: "17140",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "01",
    name: "หันคา",
    zipcode: "17130",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ้านเชี่ยน",
    zipcode: "17130",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "05",
    name: "ไพรนกยูง",
    zipcode: "17130",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "06",
    name: "หนองแซง",
    zipcode: "17160",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "07",
    name: "ห้วยงู",
    zipcode: "17160",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "08",
    name: "วังไก่เถื่อน",
    zipcode: "17130",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "09",
    name: "เด่นใหญ่",
    zipcode: "17130",
  },
  {
    jw_code: "18",
    amph_code: "06",
    tumbon_code: "11",
    name: "สามง่ามท่าโบสถ์",
    zipcode: "17160",
  },
  {
    jw_code: "18",
    amph_code: "07",
    tumbon_code: "01",
    name: "หนองมะโมง",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "07",
    tumbon_code: "02",
    name: "วังตะเคียน",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "07",
    tumbon_code: "03",
    name: "สะพานหิน",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "07",
    tumbon_code: "04",
    name: "กุดจอก",
    zipcode: "17120",
  },
  {
    jw_code: "18",
    amph_code: "08",
    tumbon_code: "01",
    name: "เนินขาม",
    zipcode: "17130",
  },
  {
    jw_code: "18",
    amph_code: "08",
    tumbon_code: "02",
    name: "กะบกเตี้ย",
    zipcode: "17130",
  },
  {
    jw_code: "18",
    amph_code: "08",
    tumbon_code: "03",
    name: "สุขเดือนห้า",
    zipcode: "17130",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "01",
    name: "ปากเพรียว",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "05",
    name: "ดาวเรือง",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "06",
    name: "นาโฉง",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "07",
    name: "โคกสว่าง",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "08",
    name: "หนองโน",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "09",
    name: "หนองยาว",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "10",
    name: "ปากข้าวสาร",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "11",
    name: "หนองปลาไหล",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "12",
    name: "กุดนกเปล้า",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "13",
    name: "ตลิ่งชัน",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "01",
    tumbon_code: "14",
    name: "ตะกุด",
    zipcode: "18000",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "01",
    name: "แก่งคอย",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "02",
    name: "ทับกวาง",
    zipcode: "18260",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "03",
    name: "ตาลเดี่ยว",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "04",
    name: "ห้วยแห้ง",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "05",
    name: "ท่าคล้อ",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "06",
    name: "หินซ้อน",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "07",
    name: "บ้านธาตุ",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "08",
    name: "บ้านป่า",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "09",
    name: "ท่าตูม",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "10",
    name: "ชะอม",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "11",
    name: "สองคอน",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "12",
    name: "เตาปูน",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "13",
    name: "ชำผักแพว",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "02",
    tumbon_code: "15",
    name: "ท่ามะปราง",
    zipcode: "18110",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "01",
    name: "หนองแค",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "02",
    name: "กุ่มหัก",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "03",
    name: "คชสิทธิ์",
    zipcode: "18250",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "04",
    name: "โคกตูม",
    zipcode: "18250",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "05",
    name: "โคกแย้",
    zipcode: "18230",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "06",
    name: "บัวลอย",
    zipcode: "18230",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "07",
    name: "ไผ่ต่ำ",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "08",
    name: "โพนทอง",
    zipcode: "18250",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "09",
    name: "ห้วยขมิ้น",
    zipcode: "18230",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "10",
    name: "ห้วยทราย",
    zipcode: "18230",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "11",
    name: "หนองไข่น้ำ",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "12",
    name: "หนองแขม",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "13",
    name: "หนองจิก",
    zipcode: "18230",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "14",
    name: "หนองจรเข้",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "15",
    name: "หนองนาก",
    zipcode: "18230",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "16",
    name: "หนองปลาหมอ",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "17",
    name: "หนองปลิง",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "03",
    tumbon_code: "18",
    name: "หนองโรง",
    zipcode: "18140",
  },
  {
    jw_code: "19",
    amph_code: "04",
    tumbon_code: "01",
    name: "หนองหมู",
    zipcode: "18150",
  },
  {
    jw_code: "19",
    amph_code: "04",
    tumbon_code: "02",
    name: "บ้านลำ",
    zipcode: "18150",
  },
  {
    jw_code: "19",
    amph_code: "04",
    tumbon_code: "03",
    name: "คลองเรือ",
    zipcode: "18150",
  },
  {
    jw_code: "19",
    amph_code: "04",
    tumbon_code: "04",
    name: "วิหารแดง",
    zipcode: "18150",
  },
  {
    jw_code: "19",
    amph_code: "04",
    tumbon_code: "05",
    name: "หนองสรวง",
    zipcode: "18150",
  },
  {
    jw_code: "19",
    amph_code: "04",
    tumbon_code: "06",
    name: "เจริญธรรม",
    zipcode: "18150",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "01",
    name: "หนองแซง",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "02",
    name: "หนองควายโซ",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "03",
    name: "หนองหัวโพ",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "04",
    name: "หนองสีดา",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "05",
    name: "หนองกบ",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "06",
    name: "ไก่เส่า",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "07",
    name: "โคกสะอาด",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "08",
    name: "ม่วงหวาน",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "05",
    tumbon_code: "09",
    name: "เขาดิน",
    zipcode: "18171",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "01",
    name: "บ้านหมอ",
    zipcode: "18130",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "02",
    name: "บางโขมด",
    zipcode: "18270",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "03",
    name: "สร่างโศก",
    zipcode: "18130",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "04",
    name: "ตลาดน้อย",
    zipcode: "18130",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "05",
    name: "หรเทพ",
    zipcode: "18210",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "06",
    name: "โคกใหญ่",
    zipcode: "18130",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "07",
    name: "ไผ่ขวาง",
    zipcode: "18130",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "08",
    name: "บ้านครัว",
    zipcode: "18270",
  },
  {
    jw_code: "19",
    amph_code: "06",
    tumbon_code: "09",
    name: "หนองบัว",
    zipcode: "18130",
  },
  {
    jw_code: "19",
    amph_code: "07",
    tumbon_code: "01",
    name: "ดอนพุด",
    zipcode: "18210",
  },
  {
    jw_code: "19",
    amph_code: "07",
    tumbon_code: "02",
    name: "ไผ่หลิ่ว",
    zipcode: "18210",
  },
  {
    jw_code: "19",
    amph_code: "07",
    tumbon_code: "03",
    name: "บ้านหลวง",
    zipcode: "18210",
  },
  {
    jw_code: "19",
    amph_code: "07",
    tumbon_code: "04",
    name: "ดงตะงาว",
    zipcode: "18210",
  },
  {
    jw_code: "19",
    amph_code: "08",
    tumbon_code: "01",
    name: "หนองโดน",
    zipcode: "18190",
  },
  {
    jw_code: "19",
    amph_code: "08",
    tumbon_code: "02",
    name: "บ้านกลับ",
    zipcode: "18190",
  },
  {
    jw_code: "19",
    amph_code: "08",
    tumbon_code: "03",
    name: "ดอนทอง",
    zipcode: "18190",
  },
  {
    jw_code: "19",
    amph_code: "08",
    tumbon_code: "04",
    name: "บ้านโปร่ง",
    zipcode: "18190",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "01",
    name: "พระพุทธบาท",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "02",
    name: "ขุนโขลน",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "03",
    name: "ธารเกษม",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "04",
    name: "นายาว",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "05",
    name: "พุคำจาน",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "06",
    name: "เขาวง",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "07",
    name: "ห้วยป่าหวาย",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "08",
    name: "พุกร่าง",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "09",
    tumbon_code: "09",
    name: "หนองแก",
    zipcode: "18120",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "01",
    name: "เสาไห้",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "02",
    name: "บ้านยาง",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "03",
    name: "หัวปลวก",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "04",
    name: "งิ้วงาม",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "05",
    name: "ศาลารีไทย",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "06",
    name: "ต้นตาล",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "07",
    name: "ท่าช้าง",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "08",
    name: "พระยาทด",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "09",
    name: "ม่วงงาม",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "10",
    name: "เริงราง",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "11",
    name: "เมืองเก่า",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "10",
    tumbon_code: "12",
    name: "สวนดอกไม้",
    zipcode: "18160",
  },
  {
    jw_code: "19",
    amph_code: "11",
    tumbon_code: "01",
    name: "มวกเหล็ก",
    zipcode: "18180",
  },
  {
    jw_code: "19",
    amph_code: "11",
    tumbon_code: "02",
    name: "มิตรภาพ",
    zipcode: "18180",
  },
  {
    jw_code: "19",
    amph_code: "11",
    tumbon_code: "04",
    name: "หนองย่างเสือ",
    zipcode: "18180",
  },
  {
    jw_code: "19",
    amph_code: "11",
    tumbon_code: "05",
    name: "ลำสมพุง",
    zipcode: "18180",
  },
  {
    jw_code: "19",
    amph_code: "11",
    tumbon_code: "07",
    name: "ลำพญากลาง",
    zipcode: "18180",
  },
  {
    jw_code: "19",
    amph_code: "11",
    tumbon_code: "09",
    name: "ซับสนุ่น",
    zipcode: "18220",
  },
  {
    jw_code: "19",
    amph_code: "12",
    tumbon_code: "01",
    name: "แสลงพัน",
    zipcode: "18220",
  },
  {
    jw_code: "19",
    amph_code: "12",
    tumbon_code: "02",
    name: "คำพราน",
    zipcode: "18220",
  },
  {
    jw_code: "19",
    amph_code: "12",
    tumbon_code: "03",
    name: "วังม่วง",
    zipcode: "18220",
  },
  {
    jw_code: "19",
    amph_code: "13",
    tumbon_code: "01",
    name: "เขาดินพัฒนา",
    zipcode: "30230",
  },
  {
    jw_code: "19",
    amph_code: "13",
    tumbon_code: "02",
    name: "บ้านแก้ง",
    zipcode: "30230",
  },
  {
    jw_code: "19",
    amph_code: "13",
    tumbon_code: "03",
    name: "ผึ้งรวง",
    zipcode: "30230",
  },
  {
    jw_code: "19",
    amph_code: "13",
    tumbon_code: "04",
    name: "พุแค",
    zipcode: "18240",
  },
  {
    jw_code: "19",
    amph_code: "13",
    tumbon_code: "05",
    name: "ห้วยบง",
    zipcode: "18240",
  },
  {
    jw_code: "19",
    amph_code: "13",
    tumbon_code: "06",
    name: "หน้าพระลาน",
    zipcode: "18240",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "01",
    name: "บางปลาสร้อย",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "02",
    name: "มะขามหย่ง",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านโขด",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "04",
    name: "แสนสุข",
    zipcode: "20130",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านสวน",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "06",
    name: "หนองรี",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "07",
    name: "นาป่า",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "08",
    name: "หนองข้างคอก",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "09",
    name: "ดอนหัวฬ่อ",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "10",
    name: "หนองไม้แดง",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "11",
    name: "บางทราย",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "12",
    name: "คลองตำหรุ",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "13",
    name: "เหมือง",
    zipcode: "20130",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "14",
    name: "บ้านปึก",
    zipcode: "20130",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "15",
    name: "ห้วยกะปิ",
    zipcode: "20130",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "16",
    name: "เสม็ด",
    zipcode: "20130",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "17",
    name: "อ่างศิลา",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "01",
    tumbon_code: "18",
    name: "สำนักบก",
    zipcode: "20000",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "01",
    name: "บ้านบึง",
    zipcode: "20170",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "02",
    name: "คลองกิ่ว",
    zipcode: "20220",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "03",
    name: "มาบไผ่",
    zipcode: "20170",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "04",
    name: "หนองซ้ำซาก",
    zipcode: "20170",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "05",
    name: "หนองบอนแดง",
    zipcode: "20170",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "06",
    name: "หนองชาก",
    zipcode: "20170",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองอิรุณ",
    zipcode: "20220",
  },
  {
    jw_code: "20",
    amph_code: "02",
    tumbon_code: "08",
    name: "หนองไผ่แก้ว",
    zipcode: "20220",
  },
  {
    jw_code: "20",
    amph_code: "03",
    tumbon_code: "01",
    name: "หนองใหญ่",
    zipcode: "20190",
  },
  {
    jw_code: "20",
    amph_code: "03",
    tumbon_code: "02",
    name: "คลองพลู",
    zipcode: "20190",
  },
  {
    jw_code: "20",
    amph_code: "03",
    tumbon_code: "03",
    name: "หนองเสือช้าง",
    zipcode: "20190",
  },
  {
    jw_code: "20",
    amph_code: "03",
    tumbon_code: "04",
    name: "ห้างสูง",
    zipcode: "20190",
  },
  {
    jw_code: "20",
    amph_code: "03",
    tumbon_code: "05",
    name: "เขาซก",
    zipcode: "20190",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "01",
    name: "บางละมุง",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "02",
    name: "หนองปรือ",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "03",
    name: "หนองปลาไหล",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "04",
    name: "โป่ง",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "05",
    name: "เขาไม้แก้ว",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "06",
    name: "ห้วยใหญ่",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "07",
    name: "ตะเคียนเตี้ย",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "04",
    tumbon_code: "08",
    name: "นาเกลือ",
    zipcode: "20150",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "01",
    name: "พานทอง",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "02",
    name: "หนองตำลึง",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "03",
    name: "มาบโป่ง",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "04",
    name: "หนองกะขะ",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "05",
    name: "หนองหงษ์",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "06",
    name: "โคกขี้หนอน",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "07",
    name: "บ้านเก่า",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "08",
    name: "หน้าประดู่",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "09",
    name: "บางนาง",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "10",
    name: "เกาะลอย",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "05",
    tumbon_code: "11",
    name: "บางหัก",
    zipcode: "20160",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "01",
    name: "พนัสนิคม",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "02",
    name: "หน้าพระธาตุ",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "03",
    name: "วัดหลวง",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "04",
    name: "บ้านเซิด",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "05",
    name: "นาเริก",
    zipcode: "20240",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "06",
    name: "หมอนนาง",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "07",
    name: "สระสี่เหลี่ยม",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "08",
    name: "วัดโบสถ์",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "09",
    name: "กุฎโง้ง",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "10",
    name: "หัวถนน",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "11",
    name: "ท่าข้าม",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "13",
    name: "หนองปรือ",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "14",
    name: "หนองขยาด",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "15",
    name: "ทุ่งขวาง",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "16",
    name: "หนองเหียง",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "17",
    name: "นาวังหิน",
    zipcode: "20240",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "18",
    name: "บ้านช้าง",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "20",
    name: "โคกเพลาะ",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "21",
    name: "ไร่หลักทอง",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "06",
    tumbon_code: "22",
    name: "นามะตูม",
    zipcode: "20140",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "01",
    name: "ศรีราชา",
    zipcode: "20110",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "02",
    name: "สุรศักดิ์",
    zipcode: "20110",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "03",
    name: "ทุ่งสุขลา",
    zipcode: "20230",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "04",
    name: "บึง",
    zipcode: "20230",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "05",
    name: "หนองขาม",
    zipcode: "20230",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "06",
    name: "เขาคันทรง",
    zipcode: "20110",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "07",
    name: "บางพระ",
    zipcode: "20110",
  },
  {
    jw_code: "20",
    amph_code: "07",
    tumbon_code: "08",
    name: "บ่อวิน",
    zipcode: "20230",
  },
  {
    jw_code: "20",
    amph_code: "08",
    tumbon_code: "01",
    name: "ท่าเทววงษ์",
    zipcode: "20120",
  },
  {
    jw_code: "20",
    amph_code: "09",
    tumbon_code: "01",
    name: "สัตหีบ",
    zipcode: "20180",
  },
  {
    jw_code: "20",
    amph_code: "09",
    tumbon_code: "02",
    name: "นาจอมเทียน",
    zipcode: "20250",
  },
  {
    jw_code: "20",
    amph_code: "09",
    tumbon_code: "03",
    name: "พลูตาหลวง",
    zipcode: "20180",
  },
  {
    jw_code: "20",
    amph_code: "09",
    tumbon_code: "04",
    name: "บางเสร่",
    zipcode: "20250",
  },
  {
    jw_code: "20",
    amph_code: "09",
    tumbon_code: "05",
    name: "แสมสาร",
    zipcode: "20180",
  },
  {
    jw_code: "20",
    amph_code: "10",
    tumbon_code: "01",
    name: "บ่อทอง",
    zipcode: "20270",
  },
  {
    jw_code: "20",
    amph_code: "10",
    tumbon_code: "02",
    name: "วัดสุวรรณ",
    zipcode: "20270",
  },
  {
    jw_code: "20",
    amph_code: "10",
    tumbon_code: "03",
    name: "บ่อกวางทอง",
    zipcode: "20270",
  },
  {
    jw_code: "20",
    amph_code: "10",
    tumbon_code: "04",
    name: "ธาตุทอง",
    zipcode: "20270",
  },
  {
    jw_code: "20",
    amph_code: "10",
    tumbon_code: "05",
    name: "เกษตรสุวรรณ",
    zipcode: "20270",
  },
  {
    jw_code: "20",
    amph_code: "10",
    tumbon_code: "06",
    name: "พลวงทอง",
    zipcode: "20270",
  },
  {
    jw_code: "20",
    amph_code: "11",
    tumbon_code: "01",
    name: "เกาะจันทร์",
    zipcode: "20240",
  },
  {
    jw_code: "20",
    amph_code: "11",
    tumbon_code: "02",
    name: "ท่าบุญมี",
    zipcode: "20240",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "01",
    name: "ท่าประดู่",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "02",
    name: "เชิงเนิน",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "03",
    name: "ตะพง",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "04",
    name: "ปากน้ำ",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "05",
    name: "เพ",
    zipcode: "21160",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "06",
    name: "แกลง",
    zipcode: "21160",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "07",
    name: "บ้านแลง",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "08",
    name: "นาตาขวัญ",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "09",
    name: "เนินพระ",
    zipcode: "21150",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "10",
    name: "กะเฉด",
    zipcode: "21100",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "11",
    name: "ทับมา",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "12",
    name: "น้ำคอก",
    zipcode: "21000",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "13",
    name: "ห้วยโป่ง",
    zipcode: "21150",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "14",
    name: "มาบตาพุด",
    zipcode: "21150",
  },
  {
    jw_code: "21",
    amph_code: "01",
    tumbon_code: "15",
    name: "สำนักทอง",
    zipcode: "21100",
  },
  {
    jw_code: "21",
    amph_code: "02",
    tumbon_code: "01",
    name: "สำนักท้อน",
    zipcode: "21130",
  },
  {
    jw_code: "21",
    amph_code: "02",
    tumbon_code: "02",
    name: "พลา",
    zipcode: "21130",
  },
  {
    jw_code: "21",
    amph_code: "02",
    tumbon_code: "03",
    name: "บ้านฉาง",
    zipcode: "21130",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "01",
    name: "ทางเกวียน",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "02",
    name: "วังหว้า",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "03",
    name: "ชากโดน",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "04",
    name: "เนินฆ้อ",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "05",
    name: "กร่ำ",
    zipcode: "21190",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "06",
    name: "ชากพง",
    zipcode: "21190",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "07",
    name: "กระแสบน",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "08",
    name: "บ้านนา",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "09",
    name: "ทุ่งควายกิน",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "10",
    name: "กองดิน",
    zipcode: "22160",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "11",
    name: "คลองปูน",
    zipcode: "21170",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "12",
    name: "พังราด",
    zipcode: "21170",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "13",
    name: "ปากน้ำกระแส",
    zipcode: "21170",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "17",
    name: "ห้วยยาง",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "03",
    tumbon_code: "18",
    name: "สองสลึง",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "04",
    tumbon_code: "01",
    name: "วังจันทร์",
    zipcode: "21210",
  },
  {
    jw_code: "21",
    amph_code: "04",
    tumbon_code: "02",
    name: "ชุมแสง",
    zipcode: "21210",
  },
  {
    jw_code: "21",
    amph_code: "04",
    tumbon_code: "03",
    name: "ป่ายุบใน",
    zipcode: "21210",
  },
  {
    jw_code: "21",
    amph_code: "04",
    tumbon_code: "04",
    name: "พลงตาเอี่ยม",
    zipcode: "21210",
  },
  {
    jw_code: "21",
    amph_code: "05",
    tumbon_code: "01",
    name: "บ้านค่าย",
    zipcode: "21120",
  },
  {
    jw_code: "21",
    amph_code: "05",
    tumbon_code: "02",
    name: "หนองละลอก",
    zipcode: "21120",
  },
  {
    jw_code: "21",
    amph_code: "05",
    tumbon_code: "03",
    name: "หนองตะพาน",
    zipcode: "21120",
  },
  {
    jw_code: "21",
    amph_code: "05",
    tumbon_code: "04",
    name: "ตาขัน",
    zipcode: "21120",
  },
  {
    jw_code: "21",
    amph_code: "05",
    tumbon_code: "05",
    name: "บางบุตร",
    zipcode: "21120",
  },
  {
    jw_code: "21",
    amph_code: "05",
    tumbon_code: "06",
    name: "หนองบัว",
    zipcode: "21120",
  },
  {
    jw_code: "21",
    amph_code: "05",
    tumbon_code: "07",
    name: "ชากบก",
    zipcode: "21120",
  },
  {
    jw_code: "21",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปลวกแดง",
    zipcode: "21140",
  },
  {
    jw_code: "21",
    amph_code: "06",
    tumbon_code: "02",
    name: "ตาสิทธิ์",
    zipcode: "21140",
  },
  {
    jw_code: "21",
    amph_code: "06",
    tumbon_code: "03",
    name: "ละหาร",
    zipcode: "21140",
  },
  {
    jw_code: "21",
    amph_code: "06",
    tumbon_code: "04",
    name: "แม่น้ำคู้",
    zipcode: "21140",
  },
  {
    jw_code: "21",
    amph_code: "06",
    tumbon_code: "05",
    name: "มาบยางพร",
    zipcode: "21140",
  },
  {
    jw_code: "21",
    amph_code: "06",
    tumbon_code: "06",
    name: "หนองไร่",
    zipcode: "21140",
  },
  {
    jw_code: "21",
    amph_code: "07",
    tumbon_code: "01",
    name: "น้ำเป็น",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "07",
    tumbon_code: "02",
    name: "ห้วยทับมอญ",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "07",
    tumbon_code: "03",
    name: "ชำฆ้อ",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "07",
    tumbon_code: "04",
    name: "เขาน้อย",
    zipcode: "21110",
  },
  {
    jw_code: "21",
    amph_code: "08",
    tumbon_code: "01",
    name: "นิคมพัฒนา",
    zipcode: "21180",
  },
  {
    jw_code: "21",
    amph_code: "08",
    tumbon_code: "02",
    name: "มาบข่า",
    zipcode: "21180",
  },
  {
    jw_code: "21",
    amph_code: "08",
    tumbon_code: "03",
    name: "พนานิคม",
    zipcode: "21180",
  },
  {
    jw_code: "21",
    amph_code: "08",
    tumbon_code: "04",
    name: "มะขามคู่",
    zipcode: "21180",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "01",
    name: "ตลาด",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "02",
    name: "วัดใหม่",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "03",
    name: "คลองนารายณ์",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "04",
    name: "เกาะขวาง",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "05",
    name: "คมบาง",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "06",
    name: "ท่าช้าง",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "07",
    name: "จันทนิมิต",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางกะจะ",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "09",
    name: "แสลง",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "10",
    name: "หนองบัว",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "01",
    tumbon_code: "11",
    name: "พลับพลา",
    zipcode: "22000",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "01",
    name: "ขลุง",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "02",
    name: "บ่อ",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "03",
    name: "เกวียนหัก",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "04",
    name: "ตะปอน",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "05",
    name: "บางชัน",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "06",
    name: "วันยาว",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "07",
    name: "ซึ้ง",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "08",
    name: "มาบไพ",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "09",
    name: "วังสรรพรส",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "10",
    name: "ตรอกนอง",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "11",
    name: "ตกพรม",
    zipcode: "22110",
  },
  {
    jw_code: "22",
    amph_code: "02",
    tumbon_code: "12",
    name: "บ่อเวฬุ",
    zipcode: "22150",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "01",
    name: "ท่าใหม่",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "02",
    name: "ยายร้า",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "03",
    name: "สีพยา",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "04",
    name: "บ่อพุ",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "05",
    name: "พลอยแหวน",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "06",
    name: "เขาวัว",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "07",
    name: "เขาบายศรี",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "08",
    name: "สองพี่น้อง",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "09",
    name: "ทุ่งเบญจา",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "11",
    name: "รำพัน",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "12",
    name: "โขมง",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "13",
    name: "ตะกาดเง้า",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "14",
    name: "คลองขุด",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "03",
    tumbon_code: "24",
    name: "เขาแก้ว",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "04",
    tumbon_code: "01",
    name: "ทับไทร",
    zipcode: "22140",
  },
  {
    jw_code: "22",
    amph_code: "04",
    tumbon_code: "02",
    name: "โป่งน้ำร้อน",
    zipcode: "22140",
  },
  {
    jw_code: "22",
    amph_code: "04",
    tumbon_code: "04",
    name: "หนองตาคง",
    zipcode: "22140",
  },
  {
    jw_code: "22",
    amph_code: "04",
    tumbon_code: "09",
    name: "เทพนิมิต",
    zipcode: "22140",
  },
  {
    jw_code: "22",
    amph_code: "04",
    tumbon_code: "10",
    name: "คลองใหญ่",
    zipcode: "22140",
  },
  {
    jw_code: "22",
    amph_code: "05",
    tumbon_code: "01",
    name: "มะขาม",
    zipcode: "22150",
  },
  {
    jw_code: "22",
    amph_code: "05",
    tumbon_code: "02",
    name: "ท่าหลวง",
    zipcode: "22150",
  },
  {
    jw_code: "22",
    amph_code: "05",
    tumbon_code: "03",
    name: "ปัถวี",
    zipcode: "22150",
  },
  {
    jw_code: "22",
    amph_code: "05",
    tumbon_code: "04",
    name: "วังแซ้ม",
    zipcode: "22150",
  },
  {
    jw_code: "22",
    amph_code: "05",
    tumbon_code: "06",
    name: "ฉมัน",
    zipcode: "22150",
  },
  {
    jw_code: "22",
    amph_code: "05",
    tumbon_code: "08",
    name: "อ่างคีรี",
    zipcode: "22150",
  },
  {
    jw_code: "22",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปากน้ำแหลมสิงห์",
    zipcode: "22130",
  },
  {
    jw_code: "22",
    amph_code: "06",
    tumbon_code: "02",
    name: "เกาะเปริด",
    zipcode: "22130",
  },
  {
    jw_code: "22",
    amph_code: "06",
    tumbon_code: "03",
    name: "หนองชิ่ม",
    zipcode: "22130",
  },
  {
    jw_code: "22",
    amph_code: "06",
    tumbon_code: "04",
    name: "พลิ้ว",
    zipcode: "22190",
  },
  {
    jw_code: "22",
    amph_code: "06",
    tumbon_code: "05",
    name: "คลองน้ำเค็ม",
    zipcode: "22130",
  },
  {
    jw_code: "22",
    amph_code: "06",
    tumbon_code: "06",
    name: "บางสระเก้า",
    zipcode: "22130",
  },
  {
    jw_code: "22",
    amph_code: "06",
    tumbon_code: "07",
    name: "บางกะไชย",
    zipcode: "22120",
  },
  {
    jw_code: "22",
    amph_code: "07",
    tumbon_code: "01",
    name: "ปะตง",
    zipcode: "22180",
  },
  {
    jw_code: "22",
    amph_code: "07",
    tumbon_code: "02",
    name: "ทุ่งขนาน",
    zipcode: "22180",
  },
  {
    jw_code: "22",
    amph_code: "07",
    tumbon_code: "03",
    name: "ทับช้าง",
    zipcode: "22180",
  },
  {
    jw_code: "22",
    amph_code: "07",
    tumbon_code: "04",
    name: "ทรายขาว",
    zipcode: "22180",
  },
  {
    jw_code: "22",
    amph_code: "07",
    tumbon_code: "05",
    name: "สะตอน",
    zipcode: "22180",
  },
  {
    jw_code: "22",
    amph_code: "08",
    tumbon_code: "01",
    name: "แก่งหางแมว",
    zipcode: "22160",
  },
  {
    jw_code: "22",
    amph_code: "08",
    tumbon_code: "02",
    name: "ขุนซ่อง",
    zipcode: "22160",
  },
  {
    jw_code: "22",
    amph_code: "08",
    tumbon_code: "03",
    name: "สามพี่น้อง",
    zipcode: "22160",
  },
  {
    jw_code: "22",
    amph_code: "08",
    tumbon_code: "04",
    name: "พวา",
    zipcode: "22160",
  },
  {
    jw_code: "22",
    amph_code: "08",
    tumbon_code: "05",
    name: "เขาวงกต",
    zipcode: "22160",
  },
  {
    jw_code: "22",
    amph_code: "09",
    tumbon_code: "01",
    name: "นายายอาม",
    zipcode: "22160",
  },
  {
    jw_code: "22",
    amph_code: "09",
    tumbon_code: "02",
    name: "วังโตนด",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "09",
    tumbon_code: "03",
    name: "กระแจะ",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "09",
    tumbon_code: "04",
    name: "สนามไชย",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "09",
    tumbon_code: "05",
    name: "ช้างข้าม",
    zipcode: "22160",
  },
  {
    jw_code: "22",
    amph_code: "09",
    tumbon_code: "06",
    name: "วังใหม่",
    zipcode: "22170",
  },
  {
    jw_code: "22",
    amph_code: "10",
    tumbon_code: "01",
    name: "ชากไทย",
    zipcode: "22210",
  },
  {
    jw_code: "22",
    amph_code: "10",
    tumbon_code: "02",
    name: "พลวง",
    zipcode: "22210",
  },
  {
    jw_code: "22",
    amph_code: "10",
    tumbon_code: "03",
    name: "ตะเคียนทอง",
    zipcode: "22210",
  },
  {
    jw_code: "22",
    amph_code: "10",
    tumbon_code: "04",
    name: "คลองพลู",
    zipcode: "22210",
  },
  {
    jw_code: "22",
    amph_code: "10",
    tumbon_code: "05",
    name: "จันทเขลม",
    zipcode: "22210",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "01",
    name: "บางพระ",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "02",
    name: "หนองเสม็ด",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "03",
    name: "หนองโสน",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "04",
    name: "หนองคันทรง",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "05",
    name: "ห้วงน้ำขาว",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "06",
    name: "อ่าวใหญ่",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "07",
    name: "วังกระแจะ",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "08",
    name: "ห้วยแร้ง",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "09",
    name: "เนินทราย",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "10",
    name: "ท่าพริก",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "11",
    name: "ท่ากุ่ม",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "12",
    name: "ตะกาง",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "13",
    name: "ชำราก",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "01",
    tumbon_code: "14",
    name: "แหลมกลัด",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "02",
    tumbon_code: "01",
    name: "คลองใหญ่",
    zipcode: "23110",
  },
  {
    jw_code: "23",
    amph_code: "02",
    tumbon_code: "02",
    name: "ไม้รูด",
    zipcode: "23110",
  },
  {
    jw_code: "23",
    amph_code: "02",
    tumbon_code: "03",
    name: "หาดเล็ก",
    zipcode: "23110",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "01",
    name: "เขาสมิง",
    zipcode: "23130",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "02",
    name: "แสนตุ้ง",
    zipcode: "23150",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "03",
    name: "วังตะเคียน",
    zipcode: "23130",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "04",
    name: "ท่าโสม",
    zipcode: "23150",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "05",
    name: "สะตอ",
    zipcode: "23150",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "06",
    name: "ประณีต",
    zipcode: "23150",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "07",
    name: "เทพนิมิต",
    zipcode: "23150",
  },
  {
    jw_code: "23",
    amph_code: "03",
    tumbon_code: "08",
    name: "ทุ่งนนทรี",
    zipcode: "23130",
  },
  {
    jw_code: "23",
    amph_code: "04",
    tumbon_code: "01",
    name: "บ่อพลอย",
    zipcode: "23140",
  },
  {
    jw_code: "23",
    amph_code: "04",
    tumbon_code: "02",
    name: "ช้างทูน",
    zipcode: "23140",
  },
  {
    jw_code: "23",
    amph_code: "04",
    tumbon_code: "03",
    name: "ด่านชุมพล",
    zipcode: "23140",
  },
  {
    jw_code: "23",
    amph_code: "04",
    tumbon_code: "04",
    name: "หนองบอน",
    zipcode: "23160",
  },
  {
    jw_code: "23",
    amph_code: "04",
    tumbon_code: "05",
    name: "นนทรีย์",
    zipcode: "23140",
  },
  {
    jw_code: "23",
    amph_code: "05",
    tumbon_code: "01",
    name: "แหลมงอบ",
    zipcode: "23120",
  },
  {
    jw_code: "23",
    amph_code: "05",
    tumbon_code: "02",
    name: "น้ำเชี่ยว",
    zipcode: "23120",
  },
  {
    jw_code: "23",
    amph_code: "05",
    tumbon_code: "03",
    name: "บางปิด",
    zipcode: "23120",
  },
  {
    jw_code: "23",
    amph_code: "05",
    tumbon_code: "07",
    name: "คลองใหญ่",
    zipcode: "23120",
  },
  {
    jw_code: "23",
    amph_code: "06",
    tumbon_code: "01",
    name: "เกาะหมาก",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "06",
    tumbon_code: "02",
    name: "เกาะกูด",
    zipcode: "23000",
  },
  {
    jw_code: "23",
    amph_code: "07",
    tumbon_code: "01",
    name: "เกาะช้าง",
    zipcode: "23170",
  },
  {
    jw_code: "23",
    amph_code: "07",
    tumbon_code: "02",
    name: "เกาะช้างใต้",
    zipcode: "23170",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "01",
    name: "หน้าเมือง",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "02",
    name: "ท่าไข่",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านใหม่",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "04",
    name: "คลองนา",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "05",
    name: "บางตีนเป็ด",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "06",
    name: "บางไผ่",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "07",
    name: "คลองจุกกระเฌอ",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางแก้ว",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "09",
    name: "บางขวัญ",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "10",
    name: "คลองนครเนื่องเขต",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "11",
    name: "วังตะเคียน",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "12",
    name: "โสธร",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "13",
    name: "บางพระ",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "14",
    name: "บางกะไห",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "15",
    name: "หนามแดง",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "16",
    name: "คลองเปรง",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "17",
    name: "คลองอุดมชลจร",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "18",
    name: "คลองหลวงแพ่ง",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "01",
    tumbon_code: "19",
    name: "บางเตย",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "01",
    name: "บางคล้า",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "04",
    name: "บางสวน",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "08",
    name: "บางกระเจ็ด",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "09",
    name: "ปากน้ำ",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "10",
    name: "ท่าทองหลาง",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "11",
    name: "สาวชะโงก",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "12",
    name: "เสม็ดเหนือ",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "13",
    name: "เสม็ดใต้",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "02",
    tumbon_code: "14",
    name: "หัวไทร",
    zipcode: "24110",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "01",
    name: "บางน้ำเปรี้ยว",
    zipcode: "24150",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "02",
    name: "บางขนาก",
    zipcode: "24150",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "03",
    name: "สิงโตทอง",
    zipcode: "24150",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "04",
    name: "หมอนทอง",
    zipcode: "24150",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "05",
    name: "บึงน้ำรักษ์",
    zipcode: "24170",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "06",
    name: "ดอนเกาะกา",
    zipcode: "24170",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "07",
    name: "โยธะกา",
    zipcode: "24150",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "08",
    name: "ดอนฉิมพลี",
    zipcode: "24170",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "09",
    name: "ศาลาแดง",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "03",
    tumbon_code: "10",
    name: "โพรงอากาศ",
    zipcode: "24150",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "01",
    name: "บางปะกง",
    zipcode: "24130",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "02",
    name: "ท่าสะอ้าน",
    zipcode: "24130",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "03",
    name: "บางวัว",
    zipcode: "24180",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "04",
    name: "บางสมัคร",
    zipcode: "24180",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "05",
    name: "บางผึ้ง",
    zipcode: "24130",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "06",
    name: "บางเกลือ",
    zipcode: "24180",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "07",
    name: "สองคลอง",
    zipcode: "24130",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "08",
    name: "หนองจอก",
    zipcode: "24130",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "09",
    name: "พิมพา",
    zipcode: "24180",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "10",
    name: "ท่าข้าม",
    zipcode: "24130",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "11",
    name: "หอมศีล",
    zipcode: "24180",
  },
  {
    jw_code: "24",
    amph_code: "04",
    tumbon_code: "12",
    name: "เขาดิน",
    zipcode: "24130",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "01",
    name: "บ้านโพธิ์",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "02",
    name: "เกาะไร่",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "03",
    name: "คลองขุด",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "04",
    name: "คลองบ้านโพธิ์",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "05",
    name: "คลองประเวศ",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "06",
    name: "ดอนทราย",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "07",
    name: "เทพราช",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "08",
    name: "ท่าพลับ",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "09",
    name: "หนองตีนนก",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "10",
    name: "หนองบัว",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "11",
    name: "บางซ่อน",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "12",
    name: "บางกรูด",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "13",
    name: "แหลมประดู่",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "14",
    name: "ลาดขวาง",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "15",
    name: "สนามจันทร์",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "16",
    name: "แสนภูดาษ",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "05",
    tumbon_code: "17",
    name: "สิบเอ็ดศอก",
    zipcode: "24140",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "01",
    name: "เกาะขนุน",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ้านซ่อง",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "03",
    name: "พนมสารคาม",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "04",
    name: "เมืองเก่า",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "05",
    name: "หนองยาว",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "06",
    name: "ท่าถ่าน",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "07",
    name: "หนองแหน",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "06",
    tumbon_code: "08",
    name: "เขาหินซ้อน",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "07",
    tumbon_code: "01",
    name: "บางคา",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "07",
    tumbon_code: "02",
    name: "เมืองใหม่",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "07",
    tumbon_code: "03",
    name: "ดงน้อย",
    zipcode: "24120",
  },
  {
    jw_code: "24",
    amph_code: "08",
    tumbon_code: "01",
    name: "คู้ยายหมี",
    zipcode: "24160",
  },
  {
    jw_code: "24",
    amph_code: "08",
    tumbon_code: "02",
    name: "ท่ากระดาน",
    zipcode: "24160",
  },
  {
    jw_code: "24",
    amph_code: "08",
    tumbon_code: "03",
    name: "ทุ่งพระยา",
    zipcode: "24160",
  },
  {
    jw_code: "24",
    amph_code: "08",
    tumbon_code: "05",
    name: "ลาดกระทิง",
    zipcode: "24160",
  },
  {
    jw_code: "24",
    amph_code: "09",
    tumbon_code: "01",
    name: "แปลงยาว",
    zipcode: "24190",
  },
  {
    jw_code: "24",
    amph_code: "09",
    tumbon_code: "02",
    name: "วังเย็น",
    zipcode: "24190",
  },
  {
    jw_code: "24",
    amph_code: "09",
    tumbon_code: "03",
    name: "หัวสำโรง",
    zipcode: "24190",
  },
  {
    jw_code: "24",
    amph_code: "09",
    tumbon_code: "04",
    name: "หนองไม้แก่น",
    zipcode: "24190",
  },
  {
    jw_code: "24",
    amph_code: "10",
    tumbon_code: "01",
    name: "ท่าตะเกียบ",
    zipcode: "24160",
  },
  {
    jw_code: "24",
    amph_code: "10",
    tumbon_code: "02",
    name: "คลองตะเกรา",
    zipcode: "24160",
  },
  {
    jw_code: "24",
    amph_code: "11",
    tumbon_code: "01",
    name: "ก้อนแก้ว",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "11",
    tumbon_code: "02",
    name: "คลองเขื่อน",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "11",
    tumbon_code: "03",
    name: "บางเล่า",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "11",
    tumbon_code: "04",
    name: "บางโรง",
    zipcode: "24000",
  },
  {
    jw_code: "24",
    amph_code: "11",
    tumbon_code: "05",
    name: "บางตลาด",
    zipcode: "24110",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "01",
    name: "หน้าเมือง",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "02",
    name: "รอบเมือง",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "03",
    name: "วัดโบสถ์",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "04",
    name: "บางเดชะ",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "05",
    name: "ท่างาม",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "06",
    name: "บางบริบูรณ์",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "07",
    name: "ดงพระราม",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "08",
    name: "บ้านพระ",
    zipcode: "25230",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "09",
    name: "โคกไม้ลาย",
    zipcode: "25230",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "10",
    name: "ไม้เค็ด",
    zipcode: "25230",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "11",
    name: "ดงขี้เหล็ก",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "12",
    name: "เนินหอม",
    zipcode: "25230",
  },
  {
    jw_code: "25",
    amph_code: "01",
    tumbon_code: "13",
    name: "โนนห้อม",
    zipcode: "25000",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "01",
    name: "กบินทร์",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "02",
    name: "เมืองเก่า",
    zipcode: "25240",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "03",
    name: "วังดาล",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "04",
    name: "นนทรี",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "05",
    name: "ย่านรี",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "06",
    name: "วังตะเคียน",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "07",
    name: "หาดนางแก้ว",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "08",
    name: "ลาดตะเคียน",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "09",
    name: "บ้านนา",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "10",
    name: "บ่อทอง",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "11",
    name: "หนองกี่",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "12",
    name: "นาแขม",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "13",
    name: "เขาไม้แก้ว",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "02",
    tumbon_code: "14",
    name: "วังท่าช้าง",
    zipcode: "25110",
  },
  {
    jw_code: "25",
    amph_code: "03",
    tumbon_code: "01",
    name: "นาดี",
    zipcode: "25220",
  },
  {
    jw_code: "25",
    amph_code: "03",
    tumbon_code: "02",
    name: "สำพันตา",
    zipcode: "25220",
  },
  {
    jw_code: "25",
    amph_code: "03",
    tumbon_code: "03",
    name: "สะพานหิน",
    zipcode: "25220",
  },
  {
    jw_code: "25",
    amph_code: "03",
    tumbon_code: "04",
    name: "ทุ่งโพธิ์",
    zipcode: "25220",
  },
  {
    jw_code: "25",
    amph_code: "03",
    tumbon_code: "05",
    name: "แก่งดินสอ",
    zipcode: "25220",
  },
  {
    jw_code: "25",
    amph_code: "03",
    tumbon_code: "06",
    name: "บุพราหมณ์",
    zipcode: "25220",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "01",
    name: "บ้านสร้าง",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "02",
    name: "บางกระเบา",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "03",
    name: "บางเตย",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "04",
    name: "บางยาง",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "05",
    name: "บางแตน",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "06",
    name: "บางพลวง",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "07",
    name: "บางปลาร้า",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "08",
    name: "บางขาม",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "06",
    tumbon_code: "09",
    name: "กระทุ่มแพ้ว",
    zipcode: "25150",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "01",
    name: "ประจันตคาม",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "02",
    name: "เกาะลอย",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "03",
    name: "บ้านหอย",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "04",
    name: "หนองแสง",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "05",
    name: "ดงบัง",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "06",
    name: "คำโตนด",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "07",
    name: "บุฝ้าย",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "08",
    name: "หนองแก้ว",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "07",
    tumbon_code: "09",
    name: "โพธิ์งาม",
    zipcode: "25130",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "01",
    name: "ศรีมหาโพธิ",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "02",
    name: "สัมพันธ์",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "03",
    name: "บ้านทาม",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "04",
    name: "ท่าตูม",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "05",
    name: "บางกุ้ง",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "06",
    name: "ดงกระทงยาม",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "07",
    name: "หนองโพรง",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "08",
    name: "หัวหว้า",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "09",
    name: "หาดยาง",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "08",
    tumbon_code: "10",
    name: "กรอกสมบูรณ์",
    zipcode: "25140",
  },
  {
    jw_code: "25",
    amph_code: "09",
    tumbon_code: "01",
    name: "โคกปีบ",
    zipcode: "25190",
  },
  {
    jw_code: "25",
    amph_code: "09",
    tumbon_code: "02",
    name: "โคกไทย",
    zipcode: "25190",
  },
  {
    jw_code: "25",
    amph_code: "09",
    tumbon_code: "03",
    name: "คู้ลำพัน",
    zipcode: "25190",
  },
  {
    jw_code: "25",
    amph_code: "09",
    tumbon_code: "04",
    name: "ไผ่ชะเลือด",
    zipcode: "25190",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "01",
    name: "นครนายก",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "02",
    name: "ท่าช้าง",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านใหญ่",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "04",
    name: "วังกระโจม",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "05",
    name: "ท่าทราย",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "06",
    name: "ดอนยอ",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "07",
    name: "ศรีจุฬา",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "08",
    name: "ดงละคร",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "09",
    name: "ศรีนาวา",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "10",
    name: "สาริกา",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "11",
    name: "หินตั้ง",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "12",
    name: "เขาพระ",
    zipcode: "26000",
  },
  {
    jw_code: "26",
    amph_code: "01",
    tumbon_code: "13",
    name: "พรหมณี",
    zipcode: "26001",
  },
  {
    jw_code: "26",
    amph_code: "02",
    tumbon_code: "01",
    name: "เกาะหวาย",
    zipcode: "26130",
  },
  {
    jw_code: "26",
    amph_code: "02",
    tumbon_code: "02",
    name: "เกาะโพธิ์",
    zipcode: "26130",
  },
  {
    jw_code: "26",
    amph_code: "02",
    tumbon_code: "03",
    name: "ปากพลี",
    zipcode: "26130",
  },
  {
    jw_code: "26",
    amph_code: "02",
    tumbon_code: "04",
    name: "โคกกรวด",
    zipcode: "26130",
  },
  {
    jw_code: "26",
    amph_code: "02",
    tumbon_code: "05",
    name: "ท่าเรือ",
    zipcode: "26130",
  },
  {
    jw_code: "26",
    amph_code: "02",
    tumbon_code: "06",
    name: "หนองแสง",
    zipcode: "26130",
  },
  {
    jw_code: "26",
    amph_code: "02",
    tumbon_code: "07",
    name: "นาหินลาด",
    zipcode: "26130",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "01",
    name: "บ้านนา",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "02",
    name: "บ้านพร้าว",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "03",
    name: "บ้านพริก",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "04",
    name: "อาษา",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "05",
    name: "ทองหลาง",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "06",
    name: "บางอ้อ",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "07",
    name: "พิกุลออก",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "08",
    name: "ป่าขะ",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "09",
    name: "เขาเพิ่ม",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "03",
    tumbon_code: "10",
    name: "ศรีกะอาง",
    zipcode: "26110",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "01",
    name: "พระอาจารย์",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "02",
    name: "บึงศาล",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "03",
    name: "ศีรษะกระบือ",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "04",
    name: "โพธิ์แทน",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "05",
    name: "บางสมบูรณ์",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "06",
    name: "ทรายมูล",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "07",
    name: "บางปลากด",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "08",
    name: "บางลูกเสือ",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "09",
    name: "องครักษ์",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "10",
    name: "ชุมพล",
    zipcode: "26120",
  },
  {
    jw_code: "26",
    amph_code: "04",
    tumbon_code: "11",
    name: "คลองใหญ่",
    zipcode: "26120",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "01",
    name: "สระแก้ว",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "02",
    name: "บ้านแก้ง",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "03",
    name: "ศาลาลำดวน",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "04",
    name: "โคกปี่ฆ้อง",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "05",
    name: "ท่าแยก",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "06",
    name: "ท่าเกษม",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "08",
    name: "สระขวัญ",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "01",
    tumbon_code: "11",
    name: "หนองบอน",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "02",
    tumbon_code: "01",
    name: "คลองหาด",
    zipcode: "27260",
  },
  {
    jw_code: "27",
    amph_code: "02",
    tumbon_code: "02",
    name: "ไทยอุดม",
    zipcode: "27260",
  },
  {
    jw_code: "27",
    amph_code: "02",
    tumbon_code: "03",
    name: "ซับมะกรูด",
    zipcode: "27260",
  },
  {
    jw_code: "27",
    amph_code: "02",
    tumbon_code: "04",
    name: "ไทรเดี่ยว",
    zipcode: "27260",
  },
  {
    jw_code: "27",
    amph_code: "02",
    tumbon_code: "05",
    name: "คลองไก่เถื่อน",
    zipcode: "27260",
  },
  {
    jw_code: "27",
    amph_code: "02",
    tumbon_code: "06",
    name: "เบญจขร",
    zipcode: "27260",
  },
  {
    jw_code: "27",
    amph_code: "02",
    tumbon_code: "07",
    name: "ไทรทอง",
    zipcode: "27260",
  },
  {
    jw_code: "27",
    amph_code: "03",
    tumbon_code: "01",
    name: "ตาพระยา",
    zipcode: "27180",
  },
  {
    jw_code: "27",
    amph_code: "03",
    tumbon_code: "02",
    name: "ทัพเสด็จ",
    zipcode: "27180",
  },
  {
    jw_code: "27",
    amph_code: "03",
    tumbon_code: "06",
    name: "ทัพราช",
    zipcode: "27180",
  },
  {
    jw_code: "27",
    amph_code: "03",
    tumbon_code: "07",
    name: "ทัพไทย",
    zipcode: "27180",
  },
  {
    jw_code: "27",
    amph_code: "03",
    tumbon_code: "09",
    name: "โคคลาน",
    zipcode: "27180",
  },
  {
    jw_code: "27",
    amph_code: "04",
    tumbon_code: "01",
    name: "วังน้ำเย็น",
    zipcode: "27210",
  },
  {
    jw_code: "27",
    amph_code: "04",
    tumbon_code: "03",
    name: "ตาหลังใน",
    zipcode: "27210",
  },
  {
    jw_code: "27",
    amph_code: "04",
    tumbon_code: "05",
    name: "คลองหินปูน",
    zipcode: "27210",
  },
  {
    jw_code: "27",
    amph_code: "04",
    tumbon_code: "06",
    name: "ทุ่งมหาเจริญ",
    zipcode: "27210",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "01",
    name: "วัฒนานคร",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "02",
    name: "ท่าเกวียน",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "03",
    name: "ผักขะ",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "04",
    name: "โนนหมากเค็ง",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "05",
    name: "หนองน้ำใส",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "06",
    name: "ช่องกุ่ม",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "07",
    name: "หนองแวง",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "08",
    name: "แซร์ออ",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "09",
    name: "หนองหมากฝ้าย",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "10",
    name: "หนองตะเคียนบอน",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "05",
    tumbon_code: "11",
    name: "ห้วยโจด",
    zipcode: "27160",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "01",
    name: "อรัญประเทศ",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "02",
    name: "เมืองไผ่",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "03",
    name: "หันทราย",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "04",
    name: "คลองน้ำใส",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "05",
    name: "ท่าข้าม",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "06",
    name: "ป่าไร่",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "07",
    name: "ทับพริก",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "08",
    name: "บ้านใหม่หนองไทร",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "09",
    name: "ผ่านศึก",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "10",
    name: "หนองสังข์",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "11",
    name: "คลองทับจันทร์",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "12",
    name: "ฟากห้วย",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "06",
    tumbon_code: "13",
    name: "บ้านด่าน",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "07",
    tumbon_code: "01",
    name: "เขาฉกรรจ์",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "07",
    tumbon_code: "02",
    name: "หนองหว้า",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "07",
    tumbon_code: "03",
    name: "พระเพลิง",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "07",
    tumbon_code: "04",
    name: "เขาสามสิบ",
    zipcode: "27000",
  },
  {
    jw_code: "27",
    amph_code: "08",
    tumbon_code: "01",
    name: "โคกสูง",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "08",
    tumbon_code: "02",
    name: "หนองม่วง",
    zipcode: "27180",
  },
  {
    jw_code: "27",
    amph_code: "08",
    tumbon_code: "03",
    name: "หนองแวง",
    zipcode: "27180",
  },
  {
    jw_code: "27",
    amph_code: "08",
    tumbon_code: "04",
    name: "โนนหมากมุ่น",
    zipcode: "27120",
  },
  {
    jw_code: "27",
    amph_code: "09",
    tumbon_code: "01",
    name: "วังสมบูรณ์",
    zipcode: "27250",
  },
  {
    jw_code: "27",
    amph_code: "09",
    tumbon_code: "02",
    name: "วังใหม่",
    zipcode: "27210",
  },
  {
    jw_code: "27",
    amph_code: "09",
    tumbon_code: "03",
    name: "วังทอง",
    zipcode: "27250",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "02",
    name: "โพธิ์กลาง",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "03",
    name: "หนองจะบก",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "04",
    name: "โคกสูง",
    zipcode: "30310",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "05",
    name: "มะเริง",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "06",
    name: "หนองระเวียง",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "07",
    name: "ปรุใหญ่",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "08",
    name: "หมื่นไวย",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "09",
    name: "พลกรัง",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "10",
    name: "หนองไผ่ล้อม",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "11",
    name: "หัวทะเล",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "12",
    name: "บ้านเกาะ",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "13",
    name: "บ้านใหม่",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "14",
    name: "พุดซา",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "15",
    name: "บ้านโพธิ์",
    zipcode: "30310",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "16",
    name: "จอหอ",
    zipcode: "30310",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "17",
    name: "โคกกรวด",
    zipcode: "30280",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "18",
    name: "ไชยมงคล",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "19",
    name: "หนองบัวศาลา",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "20",
    name: "สุรนารี",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "21",
    name: "สีมุม",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "22",
    name: "ตลาด",
    zipcode: "30310",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "23",
    name: "พะเนา",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "24",
    name: "หนองกระทุ่ม",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "01",
    tumbon_code: "25",
    name: "หนองไข่น้ำ",
    zipcode: "30310",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "01",
    name: "แชะ",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "02",
    name: "เฉลียง",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "03",
    name: "ครบุรี",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "04",
    name: "โคกกระชาย",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "05",
    name: "จระเข้หิน",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "06",
    name: "มาบตะโกเอน",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "07",
    name: "อรพิมพ์",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "08",
    name: "บ้านใหม่",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "09",
    name: "ลำเพียก",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "10",
    name: "ครบุรีใต้",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "11",
    name: "ตะแบกบาน",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "02",
    tumbon_code: "12",
    name: "สระว่านพระยา",
    zipcode: "30250",
  },
  {
    jw_code: "30",
    amph_code: "03",
    tumbon_code: "01",
    name: "เสิงสาง",
    zipcode: "30330",
  },
  {
    jw_code: "30",
    amph_code: "03",
    tumbon_code: "02",
    name: "สระตะเคียน",
    zipcode: "30330",
  },
  {
    jw_code: "30",
    amph_code: "03",
    tumbon_code: "03",
    name: "โนนสมบูรณ์",
    zipcode: "30330",
  },
  {
    jw_code: "30",
    amph_code: "03",
    tumbon_code: "04",
    name: "กุดโบสถ์",
    zipcode: "30330",
  },
  {
    jw_code: "30",
    amph_code: "03",
    tumbon_code: "05",
    name: "สุขไพบูลย์",
    zipcode: "30330",
  },
  {
    jw_code: "30",
    amph_code: "03",
    tumbon_code: "06",
    name: "บ้านราษฎร์",
    zipcode: "30330",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "01",
    name: "เมืองคง",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "02",
    name: "คูขาด",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "03",
    name: "เทพาลัย",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "04",
    name: "ตาจั่น",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "05",
    name: "บ้านปรางค์",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "06",
    name: "หนองมะนาว",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "07",
    name: "หนองบัว",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "08",
    name: "โนนเต็ง",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "09",
    name: "ดอนใหญ่",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "04",
    tumbon_code: "10",
    name: "ขามสมบูรณ์",
    zipcode: "30260",
  },
  {
    jw_code: "30",
    amph_code: "05",
    tumbon_code: "01",
    name: "บ้านเหลื่อม",
    zipcode: "30350",
  },
  {
    jw_code: "30",
    amph_code: "05",
    tumbon_code: "02",
    name: "วังโพธิ์",
    zipcode: "30350",
  },
  {
    jw_code: "30",
    amph_code: "05",
    tumbon_code: "03",
    name: "โคกกระเบื้อง",
    zipcode: "30350",
  },
  {
    jw_code: "30",
    amph_code: "05",
    tumbon_code: "04",
    name: "ช่อระกา",
    zipcode: "30350",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "01",
    name: "จักราช",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "02",
    name: "ท่าช้าง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "03",
    name: "ทองหลาง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "04",
    name: "สีสุก",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "05",
    name: "หนองขาม",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "06",
    name: "หนองงูเหลือม",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "07",
    name: "หนองพลวง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "08",
    name: "หนองยาง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "09",
    name: "พระพุทธ",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "10",
    name: "ศรีละกอ",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "11",
    name: "คลองเมือง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "12",
    name: "ช้างทอง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "06",
    tumbon_code: "13",
    name: "หินโคน",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "01",
    name: "กระโทก",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "02",
    name: "พลับพลา",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "03",
    name: "ท่าอ่าง",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "04",
    name: "ทุ่งอรุณ",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "05",
    name: "ท่าลาดขาว",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "06",
    name: "ท่าจะหลุง",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "07",
    name: "ท่าเยี่ยม",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "08",
    name: "โชคชัย",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "09",
    name: "ละลมใหม่พัฒนา",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "07",
    tumbon_code: "10",
    name: "ด่านเกวียน",
    zipcode: "30190",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "01",
    name: "กุดพิมาน",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "02",
    name: "ด่านขุนทด",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "03",
    name: "ด่านนอก",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "04",
    name: "ด่านใน",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "05",
    name: "ตะเคียน",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "06",
    name: "บ้านเก่า",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "07",
    name: "บ้านแปรง",
    zipcode: "36220",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "08",
    name: "พันชนะ",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "09",
    name: "สระจรเข้",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "10",
    name: "หนองกราด",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "11",
    name: "หนองบัวตะเกียด",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "12",
    name: "หนองบัวละคร",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "13",
    name: "หินดาด",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "15",
    name: "ห้วยบง",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "17",
    name: "โนนเมืองพัฒนา",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "08",
    tumbon_code: "18",
    name: "หนองไทร",
    zipcode: "36220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "01",
    name: "โนนไทย",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "02",
    name: "ด่านจาก",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "03",
    name: "กำปัง",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "04",
    name: "สำโรง",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "05",
    name: "ค้างพลู",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "06",
    name: "บ้านวัง",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "07",
    name: "บัลลังก์",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "08",
    name: "สายออ",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "09",
    name: "ถนนโพธิ์",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "09",
    tumbon_code: "14",
    name: "มะค่า",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "01",
    name: "โนนสูง",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "02",
    name: "ใหม่",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "03",
    name: "โตนด",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "04",
    name: "บิง",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "05",
    name: "ดอนชมพู",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "06",
    name: "ธารปราสาท",
    zipcode: "30420",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "07",
    name: "หลุมข้าว",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "08",
    name: "มะค่า",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "09",
    name: "พลสงคราม",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "10",
    name: "จันอัด",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "11",
    name: "ขามเฒ่า",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "12",
    name: "ด่านคล้า",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "13",
    name: "ลำคอหงษ์",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "14",
    name: "เมืองปราสาท",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "15",
    name: "ดอนหวาย",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "10",
    tumbon_code: "16",
    name: "ลำมูล",
    zipcode: "30160",
  },
  {
    jw_code: "30",
    amph_code: "11",
    tumbon_code: "01",
    name: "ขามสะแกแสง",
    zipcode: "30290",
  },
  {
    jw_code: "30",
    amph_code: "11",
    tumbon_code: "02",
    name: "โนนเมือง",
    zipcode: "30290",
  },
  {
    jw_code: "30",
    amph_code: "11",
    tumbon_code: "03",
    name: "เมืองนาท",
    zipcode: "30290",
  },
  {
    jw_code: "30",
    amph_code: "11",
    tumbon_code: "04",
    name: "ชีวึก",
    zipcode: "30290",
  },
  {
    jw_code: "30",
    amph_code: "11",
    tumbon_code: "05",
    name: "พะงาด",
    zipcode: "30290",
  },
  {
    jw_code: "30",
    amph_code: "11",
    tumbon_code: "06",
    name: "หนองหัวฟาน",
    zipcode: "30290",
  },
  {
    jw_code: "30",
    amph_code: "11",
    tumbon_code: "07",
    name: "เมืองเกษตร",
    zipcode: "30290",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "01",
    name: "บัวใหญ่",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "03",
    name: "ห้วยยาง",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "04",
    name: "เสมาใหญ่",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "06",
    name: "ดอนตะหนิน",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "07",
    name: "หนองบัวสะอาด",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "08",
    name: "โนนทองหลาง",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "09",
    name: "หนองหว้า",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "10",
    name: "บัวลาย",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "11",
    name: "สีดา",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "12",
    name: "โพนทอง",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "14",
    name: "กุดจอก",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "15",
    name: "ด่านช้าง",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "16",
    name: "โนนจาน",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "18",
    name: "สามเมือง",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "20",
    name: "ขุนทอง",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "21",
    name: "หนองตาดใหญ่",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "22",
    name: "เมืองพะไล",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "23",
    name: "โนนประดู่",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "12",
    tumbon_code: "24",
    name: "หนองแจ้งใหญ่",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "01",
    name: "ประทาย",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "03",
    name: "กระทุ่มราย",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "04",
    name: "วังไม้แดง",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "06",
    name: "ตลาดไทร",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "07",
    name: "หนองพลวง",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "08",
    name: "หนองค่าย",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "09",
    name: "หันห้วยทราย",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "10",
    name: "ดอนมัน",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "13",
    name: "นางรำ",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "14",
    name: "โนนเพ็ด",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "15",
    name: "ทุ่งสว่าง",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "17",
    name: "โคกกลาง",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "13",
    tumbon_code: "18",
    name: "เมืองโดน",
    zipcode: "30180",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "01",
    name: "เมืองปัก",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "02",
    name: "ตะคุ",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "03",
    name: "โคกไทย",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "04",
    name: "สำโรง",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "05",
    name: "ตะขบ",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "06",
    name: "นกออก",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "07",
    name: "ดอน",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "09",
    name: "ตูม",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "10",
    name: "งิ้ว",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "11",
    name: "สะแกราช",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "12",
    name: "ลำนางแก้ว",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "16",
    name: "ภูหลวง",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "17",
    name: "ธงชัยเหนือ",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "18",
    name: "สุขเกษม",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "19",
    name: "เกษมทรัพย์",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "14",
    tumbon_code: "20",
    name: "บ่อปลาทอง",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "02",
    name: "สัมฤทธิ์",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "03",
    name: "โบสถ์",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "04",
    name: "กระเบื้องใหญ่",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "05",
    name: "ท่าหลวง",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "06",
    name: "รังกาใหญ่",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "07",
    name: "ชีวาน",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "08",
    name: "นิคมสร้างตนเอง",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "09",
    name: "กระชอน",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "10",
    name: "ดงใหญ่",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "11",
    name: "ธารละหลอด",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "15",
    tumbon_code: "12",
    name: "หนองระเวียง",
    zipcode: "30110",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "01",
    name: "ห้วยแถลง",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "02",
    name: "ทับสวาย",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "03",
    name: "เมืองพลับพลา",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "04",
    name: "หลุ่งตะเคียน",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "05",
    name: "หินดาด",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "06",
    name: "งิ้ว",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "07",
    name: "กงรถ",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "08",
    name: "หลุ่งประดู่",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "09",
    name: "ตะโก",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "16",
    tumbon_code: "10",
    name: "ห้วยแคน",
    zipcode: "30240",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "01",
    name: "ชุมพวง",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "02",
    name: "ประสุข",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "03",
    name: "ท่าลาด",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "04",
    name: "สาหร่าย",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "05",
    name: "ตลาดไทร",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "06",
    name: "ช่องแมว",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "07",
    name: "ขุย",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "10",
    name: "โนนรัง",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "11",
    name: "บ้านยาง",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "14",
    name: "หนองหลัก",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "15",
    name: "ไพล",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "16",
    name: "โนนตูม",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "17",
    tumbon_code: "17",
    name: "โนนยอ",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "01",
    name: "สูงเนิน",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "02",
    name: "เสมา",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "03",
    name: "โคราช",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "04",
    name: "บุ่งขี้เหล็ก",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "05",
    name: "โนนค่า",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "06",
    name: "โค้งยาง",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "07",
    name: "มะเกลือเก่า",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "08",
    name: "มะเกลือใหม่",
    zipcode: "30170",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "09",
    name: "นากลาง",
    zipcode: "30380",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "10",
    name: "หนองตะไก้",
    zipcode: "30380",
  },
  {
    jw_code: "30",
    amph_code: "18",
    tumbon_code: "11",
    name: "กุดจิก",
    zipcode: "30380",
  },
  {
    jw_code: "30",
    amph_code: "19",
    tumbon_code: "01",
    name: "ขามทะเลสอ",
    zipcode: "30280",
  },
  {
    jw_code: "30",
    amph_code: "19",
    tumbon_code: "02",
    name: "โป่งแดง",
    zipcode: "30280",
  },
  {
    jw_code: "30",
    amph_code: "19",
    tumbon_code: "03",
    name: "พันดุง",
    zipcode: "30280",
  },
  {
    jw_code: "30",
    amph_code: "19",
    tumbon_code: "04",
    name: "หนองสรวง",
    zipcode: "30280",
  },
  {
    jw_code: "30",
    amph_code: "19",
    tumbon_code: "05",
    name: "บึงอ้อ",
    zipcode: "30280",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "01",
    name: "สีคิ้ว",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "02",
    name: "บ้านหัน",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "03",
    name: "กฤษณา",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "04",
    name: "ลาดบัวขาว",
    zipcode: "30340",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "05",
    name: "หนองหญ้าขาว",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "06",
    name: "กุดน้อย",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "07",
    name: "หนองน้ำใส",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "08",
    name: "วังโรงใหญ่",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "09",
    name: "มิตรภาพ",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "10",
    name: "คลองไผ่",
    zipcode: "30340",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "11",
    name: "ดอนเมือง",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "20",
    tumbon_code: "12",
    name: "หนองบัวน้อย",
    zipcode: "30140",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "01",
    name: "ปากช่อง",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "02",
    name: "กลางดง",
    zipcode: "30320",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "03",
    name: "จันทึก",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "04",
    name: "วังกะทะ",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "05",
    name: "หมูสี",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "06",
    name: "หนองสาหร่าย",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "07",
    name: "ขนงพระ",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "08",
    name: "โป่งตาลอง",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "09",
    name: "คลองม่วง",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "10",
    name: "หนองน้ำแดง",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "11",
    name: "วังไทร",
    zipcode: "30130",
  },
  {
    jw_code: "30",
    amph_code: "21",
    tumbon_code: "12",
    name: "พญาเย็น",
    zipcode: "30320",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "01",
    name: "หนองบุนนาก",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "02",
    name: "สารภี",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "03",
    name: "ไทยเจริญ",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "04",
    name: "หนองหัวแรต",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "05",
    name: "แหลมทอง",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "06",
    name: "หนองตะไก้",
    zipcode: "30380",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "07",
    name: "ลุงเขว้า",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "08",
    name: "หนองไม้ไผ่",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "22",
    tumbon_code: "09",
    name: "บ้านใหม่",
    zipcode: "30410",
  },
  {
    jw_code: "30",
    amph_code: "23",
    tumbon_code: "01",
    name: "แก้งสนามนาง",
    zipcode: "30440",
  },
  {
    jw_code: "30",
    amph_code: "23",
    tumbon_code: "02",
    name: "โนนสำราญ",
    zipcode: "30440",
  },
  {
    jw_code: "30",
    amph_code: "23",
    tumbon_code: "03",
    name: "บึงพะไล",
    zipcode: "30440",
  },
  {
    jw_code: "30",
    amph_code: "23",
    tumbon_code: "04",
    name: "สีสุก",
    zipcode: "30440",
  },
  {
    jw_code: "30",
    amph_code: "23",
    tumbon_code: "05",
    name: "บึงสำโรง",
    zipcode: "30440",
  },
  {
    jw_code: "30",
    amph_code: "24",
    tumbon_code: "01",
    name: "โนนแดง",
    zipcode: "30360",
  },
  {
    jw_code: "30",
    amph_code: "24",
    tumbon_code: "02",
    name: "โนนตาเถร",
    zipcode: "30360",
  },
  {
    jw_code: "30",
    amph_code: "24",
    tumbon_code: "03",
    name: "สำพะเนียง",
    zipcode: "30360",
  },
  {
    jw_code: "30",
    amph_code: "24",
    tumbon_code: "04",
    name: "วังหิน",
    zipcode: "30360",
  },
  {
    jw_code: "30",
    amph_code: "24",
    tumbon_code: "05",
    name: "ดอนยาวใหญ่",
    zipcode: "30360",
  },
  {
    jw_code: "30",
    amph_code: "25",
    tumbon_code: "01",
    name: "วังน้ำเขียว",
    zipcode: "30370",
  },
  {
    jw_code: "30",
    amph_code: "25",
    tumbon_code: "02",
    name: "วังหมี",
    zipcode: "30370",
  },
  {
    jw_code: "30",
    amph_code: "25",
    tumbon_code: "03",
    name: "ระเริง",
    zipcode: "30150",
  },
  {
    jw_code: "30",
    amph_code: "25",
    tumbon_code: "04",
    name: "อุดมทรัพย์",
    zipcode: "30370",
  },
  {
    jw_code: "30",
    amph_code: "25",
    tumbon_code: "05",
    name: "ไทยสามัคคี",
    zipcode: "30370",
  },
  {
    jw_code: "30",
    amph_code: "26",
    tumbon_code: "01",
    name: "สำนักตะคร้อ",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "26",
    tumbon_code: "02",
    name: "หนองแวง",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "26",
    tumbon_code: "03",
    name: "บึงปรือ",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "26",
    tumbon_code: "04",
    name: "วังยายทอง",
    zipcode: "30210",
  },
  {
    jw_code: "30",
    amph_code: "27",
    tumbon_code: "01",
    name: "เมืองยาง",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "27",
    tumbon_code: "02",
    name: "กระเบื้องนอก",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "27",
    tumbon_code: "03",
    name: "ละหานปลาค้าว",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "27",
    tumbon_code: "04",
    name: "โนนอุดม",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "28",
    tumbon_code: "01",
    name: "สระพระ",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "28",
    tumbon_code: "02",
    name: "มาบกราด",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "28",
    tumbon_code: "03",
    name: "พังเทียม",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "28",
    tumbon_code: "04",
    name: "ทัพรั้ง",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "28",
    tumbon_code: "05",
    name: "หนองหอย",
    zipcode: "30220",
  },
  {
    jw_code: "30",
    amph_code: "29",
    tumbon_code: "01",
    name: "ขุย",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "29",
    tumbon_code: "02",
    name: "บ้านยาง",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "29",
    tumbon_code: "03",
    name: "ช่องแมว",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "29",
    tumbon_code: "04",
    name: "ไพล",
    zipcode: "30270",
  },
  {
    jw_code: "30",
    amph_code: "30",
    tumbon_code: "01",
    name: "เมืองพะไล",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "30",
    tumbon_code: "02",
    name: "โนนจาน",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "30",
    tumbon_code: "03",
    name: "บัวลาย",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "30",
    tumbon_code: "04",
    name: "หนองหว้า",
    zipcode: "30120",
  },
  {
    jw_code: "30",
    amph_code: "31",
    tumbon_code: "01",
    name: "สีดา",
    zipcode: "30430",
  },
  {
    jw_code: "30",
    amph_code: "31",
    tumbon_code: "02",
    name: "โพนทอง",
    zipcode: "30430",
  },
  {
    jw_code: "30",
    amph_code: "31",
    tumbon_code: "03",
    name: "โนนประดู่",
    zipcode: "30430",
  },
  {
    jw_code: "30",
    amph_code: "31",
    tumbon_code: "04",
    name: "สามเมือง",
    zipcode: "30430",
  },
  {
    jw_code: "30",
    amph_code: "31",
    tumbon_code: "05",
    name: "หนองตาดใหญ่",
    zipcode: "30430",
  },
  {
    jw_code: "30",
    amph_code: "32",
    tumbon_code: "01",
    name: "ช้างทอง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "32",
    tumbon_code: "02",
    name: "ท่าช้าง",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "32",
    tumbon_code: "03",
    name: "พระพุทธ",
    zipcode: "30230",
  },
  {
    jw_code: "30",
    amph_code: "32",
    tumbon_code: "04",
    name: "หนองงูเหลือม",
    zipcode: "30000",
  },
  {
    jw_code: "30",
    amph_code: "32",
    tumbon_code: "05",
    name: "หนองยาง",
    zipcode: "30230",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "02",
    name: "อิสาณ",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "03",
    name: "เสม็ด",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "04",
    name: "บ้านบัว",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "05",
    name: "สะแกโพรง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "06",
    name: "สวายจีก",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "08",
    name: "บ้านยาง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "12",
    name: "พระครู",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "13",
    name: "ถลุงเหล็ก",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "14",
    name: "หนองตาด",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "17",
    name: "ลุมปุ๊ก",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "18",
    name: "สองห้อง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "19",
    name: "บัวทอง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "20",
    name: "ชุมเห็ด",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "22",
    name: "หลักเขต",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "25",
    name: "สะแกซำ",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "26",
    name: "กลันทา",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "27",
    name: "กระสัง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "01",
    tumbon_code: "28",
    name: "เมืองฝาง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "02",
    tumbon_code: "01",
    name: "คูเมือง",
    zipcode: "31190",
  },
  {
    jw_code: "31",
    amph_code: "02",
    tumbon_code: "02",
    name: "ปะเคียบ",
    zipcode: "31190",
  },
  {
    jw_code: "31",
    amph_code: "02",
    tumbon_code: "03",
    name: "บ้านแพ",
    zipcode: "31190",
  },
  {
    jw_code: "31",
    amph_code: "02",
    tumbon_code: "04",
    name: "พรสำราญ",
    zipcode: "31190",
  },
  {
    jw_code: "31",
    amph_code: "02",
    tumbon_code: "05",
    name: "หินเหล็กไฟ",
    zipcode: "31190",
  },
  {
    jw_code: "31",
    amph_code: "02",
    tumbon_code: "06",
    name: "ตูมใหญ่",
    zipcode: "31190",
  },
  {
    jw_code: "31",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองขมาร",
    zipcode: "31190",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "01",
    name: "กระสัง",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "02",
    name: "ลำดวน",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "03",
    name: "สองชั้น",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "04",
    name: "สูงเนิน",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "05",
    name: "หนองเต็ง",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "06",
    name: "เมืองไผ่",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "07",
    name: "ชุมแสง",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "08",
    name: "บ้านปรือ",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "09",
    name: "ห้วยสำราญ",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "10",
    name: "กันทรารมย์",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "03",
    tumbon_code: "11",
    name: "ศรีภูมิ",
    zipcode: "31160",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "01",
    name: "นางรอง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "03",
    name: "สะเดา",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "05",
    name: "ชุมแสง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "06",
    name: "หนองโบสถ์",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "08",
    name: "หนองกง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "13",
    name: "ถนนหัก",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "14",
    name: "หนองไทร",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "15",
    name: "ก้านเหลือง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "16",
    name: "บ้านสิงห์",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "17",
    name: "ลำไทรโยง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "18",
    name: "ทรัพย์พระยา",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "24",
    name: "หนองยายพิมพ์",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "25",
    name: "หัวถนน",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "26",
    name: "ทุ่งแสงทอง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "04",
    tumbon_code: "27",
    name: "หนองโสน",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "01",
    name: "หนองกี่",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "02",
    name: "เย้ยปราสาท",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "03",
    name: "เมืองไผ่",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "04",
    name: "ดอนอะราง",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "05",
    name: "โคกสว่าง",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "06",
    name: "ทุ่งกระตาดพัฒนา",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "07",
    name: "ทุ่งกระเต็น",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "08",
    name: "ท่าโพธิ์ชัย",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "09",
    name: "โคกสูง",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "05",
    tumbon_code: "10",
    name: "บุกระสัง",
    zipcode: "31210",
  },
  {
    jw_code: "31",
    amph_code: "06",
    tumbon_code: "01",
    name: "ละหานทราย",
    zipcode: "31170",
  },
  {
    jw_code: "31",
    amph_code: "06",
    tumbon_code: "03",
    name: "ตาจง",
    zipcode: "31170",
  },
  {
    jw_code: "31",
    amph_code: "06",
    tumbon_code: "04",
    name: "สำโรงใหม่",
    zipcode: "31170",
  },
  {
    jw_code: "31",
    amph_code: "06",
    tumbon_code: "07",
    name: "หนองแวง",
    zipcode: "31170",
  },
  {
    jw_code: "31",
    amph_code: "06",
    tumbon_code: "10",
    name: "หนองตะครอง",
    zipcode: "31170",
  },
  {
    jw_code: "31",
    amph_code: "06",
    tumbon_code: "11",
    name: "โคกว่าน",
    zipcode: "31170",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "01",
    name: "ประโคนชัย",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "02",
    name: "แสลงโทน",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "03",
    name: "บ้านไทร",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "05",
    name: "ละเวี้ย",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "06",
    name: "จรเข้มาก",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "07",
    name: "ปังกู",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "08",
    name: "โคกย่าง",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "10",
    name: "โคกม้า",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "13",
    name: "ไพศาล",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "14",
    name: "ตะโกตาพิ",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "15",
    name: "เขาคอก",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "16",
    name: "หนองบอน",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "18",
    name: "โคกมะขาม",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "19",
    name: "โคกตูม",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "20",
    name: "ประทัดบุ",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "07",
    tumbon_code: "21",
    name: "สี่เหลี่ยม",
    zipcode: "31140",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "01",
    name: "บ้านกรวด",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "02",
    name: "โนนเจริญ",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "03",
    name: "หนองไม้งาม",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "04",
    name: "ปราสาท",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "05",
    name: "สายตะกู",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "06",
    name: "หินลาด",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "07",
    name: "บึงเจริญ",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "08",
    name: "จันทบเพชร",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "08",
    tumbon_code: "09",
    name: "เขาดินเหนือ",
    zipcode: "31180",
  },
  {
    jw_code: "31",
    amph_code: "09",
    tumbon_code: "01",
    name: "พุทไธสง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "09",
    tumbon_code: "02",
    name: "มะเฟือง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "09",
    tumbon_code: "03",
    name: "บ้านจาน",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "09",
    tumbon_code: "06",
    name: "บ้านเป้า",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "09",
    tumbon_code: "07",
    name: "บ้านแวง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "09",
    tumbon_code: "09",
    name: "บ้านยาง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "09",
    tumbon_code: "10",
    name: "หายโศก",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "01",
    name: "ลำปลายมาศ",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "02",
    name: "หนองคู",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "03",
    name: "แสลงพัน",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "04",
    name: "ทะเมนชัย",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "05",
    name: "ตลาดโพธิ์",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "06",
    name: "หนองกะทิง",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "07",
    name: "โคกกลาง",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "08",
    name: "โคกสะอาด",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "09",
    name: "เมืองแฝก",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "10",
    name: "บ้านยาง",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "11",
    name: "ผไทรินทร์",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "12",
    name: "โคกล่าม",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "13",
    name: "หินโคน",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "14",
    name: "หนองบัวโคก",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "15",
    name: "บุโพธิ์",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "10",
    tumbon_code: "16",
    name: "หนองโดน",
    zipcode: "31130",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "01",
    name: "สตึก",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "02",
    name: "นิคม",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "03",
    name: "ทุ่งวัง",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "04",
    name: "เมืองแก",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "05",
    name: "หนองใหญ่",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "06",
    name: "ร่อนทอง",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "09",
    name: "ดอนมนต์",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "10",
    name: "ชุมแสง",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "11",
    name: "ท่าม่วง",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "12",
    name: "สะแก",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "14",
    name: "สนามชัย",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "11",
    tumbon_code: "15",
    name: "กระสัง",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "12",
    tumbon_code: "01",
    name: "ปะคำ",
    zipcode: "31220",
  },
  {
    jw_code: "31",
    amph_code: "12",
    tumbon_code: "02",
    name: "ไทยเจริญ",
    zipcode: "31220",
  },
  {
    jw_code: "31",
    amph_code: "12",
    tumbon_code: "03",
    name: "หนองบัว",
    zipcode: "31220",
  },
  {
    jw_code: "31",
    amph_code: "12",
    tumbon_code: "04",
    name: "โคกมะม่วง",
    zipcode: "31220",
  },
  {
    jw_code: "31",
    amph_code: "12",
    tumbon_code: "05",
    name: "หูทำนบ",
    zipcode: "31220",
  },
  {
    jw_code: "31",
    amph_code: "13",
    tumbon_code: "01",
    name: "นาโพธิ์",
    zipcode: "31230",
  },
  {
    jw_code: "31",
    amph_code: "13",
    tumbon_code: "02",
    name: "บ้านคู",
    zipcode: "31230",
  },
  {
    jw_code: "31",
    amph_code: "13",
    tumbon_code: "03",
    name: "บ้านดู่",
    zipcode: "31230",
  },
  {
    jw_code: "31",
    amph_code: "13",
    tumbon_code: "04",
    name: "ดอนกอก",
    zipcode: "31230",
  },
  {
    jw_code: "31",
    amph_code: "13",
    tumbon_code: "05",
    name: "ศรีสว่าง",
    zipcode: "31230",
  },
  {
    jw_code: "31",
    amph_code: "14",
    tumbon_code: "01",
    name: "สระแก้ว",
    zipcode: "31240",
  },
  {
    jw_code: "31",
    amph_code: "14",
    tumbon_code: "02",
    name: "ห้วยหิน",
    zipcode: "31240",
  },
  {
    jw_code: "31",
    amph_code: "14",
    tumbon_code: "03",
    name: "ไทยสามัคคี",
    zipcode: "31240",
  },
  {
    jw_code: "31",
    amph_code: "14",
    tumbon_code: "04",
    name: "หนองชัยศรี",
    zipcode: "31240",
  },
  {
    jw_code: "31",
    amph_code: "14",
    tumbon_code: "05",
    name: "เสาเดียว",
    zipcode: "31240",
  },
  {
    jw_code: "31",
    amph_code: "14",
    tumbon_code: "06",
    name: "เมืองฝ้าย",
    zipcode: "31240",
  },
  {
    jw_code: "31",
    amph_code: "14",
    tumbon_code: "07",
    name: "สระทอง",
    zipcode: "31240",
  },
  {
    jw_code: "31",
    amph_code: "15",
    tumbon_code: "01",
    name: "จันดุม",
    zipcode: "31250",
  },
  {
    jw_code: "31",
    amph_code: "15",
    tumbon_code: "02",
    name: "โคกขมิ้น",
    zipcode: "31250",
  },
  {
    jw_code: "31",
    amph_code: "15",
    tumbon_code: "03",
    name: "ป่าชัน",
    zipcode: "31250",
  },
  {
    jw_code: "31",
    amph_code: "15",
    tumbon_code: "04",
    name: "สะเดา",
    zipcode: "31250",
  },
  {
    jw_code: "31",
    amph_code: "15",
    tumbon_code: "05",
    name: "สำโรง",
    zipcode: "31250",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "01",
    name: "ห้วยราช",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "02",
    name: "สามแวง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "03",
    name: "ตาเสา",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "04",
    name: "บ้านตะโก",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "05",
    name: "สนวน",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "06",
    name: "โคกเหล็ก",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "07",
    name: "เมืองโพธิ์",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "16",
    tumbon_code: "08",
    name: "ห้วยราชา",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "17",
    tumbon_code: "01",
    name: "โนนสุวรรณ",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "17",
    tumbon_code: "02",
    name: "ทุ่งจังหัน",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "17",
    tumbon_code: "03",
    name: "โกรกแก้ว",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "17",
    tumbon_code: "04",
    name: "ดงอีจาน",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "18",
    tumbon_code: "01",
    name: "ชำนิ",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "18",
    tumbon_code: "02",
    name: "หนองปล่อง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "18",
    tumbon_code: "03",
    name: "เมืองยาง",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "18",
    tumbon_code: "04",
    name: "ช่อผกา",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "18",
    tumbon_code: "05",
    name: "ละลวด",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "18",
    tumbon_code: "06",
    name: "โคกสนวน",
    zipcode: "31110",
  },
  {
    jw_code: "31",
    amph_code: "19",
    tumbon_code: "01",
    name: "หนองแวง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "19",
    tumbon_code: "02",
    name: "ทองหลาง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "19",
    tumbon_code: "03",
    name: "แดงใหญ่",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "19",
    tumbon_code: "04",
    name: "กู่สวนแตง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "19",
    tumbon_code: "05",
    name: "หนองเยือง",
    zipcode: "31120",
  },
  {
    jw_code: "31",
    amph_code: "20",
    tumbon_code: "01",
    name: "โนนดินแดง",
    zipcode: "31260",
  },
  {
    jw_code: "31",
    amph_code: "20",
    tumbon_code: "02",
    name: "ส้มป่อย",
    zipcode: "31260",
  },
  {
    jw_code: "31",
    amph_code: "20",
    tumbon_code: "03",
    name: "ลำนางรอง",
    zipcode: "31260",
  },
  {
    jw_code: "31",
    amph_code: "21",
    tumbon_code: "01",
    name: "บ้านด่าน",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "21",
    tumbon_code: "02",
    name: "ปราสาท",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "21",
    tumbon_code: "03",
    name: "วังเหนือ",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "21",
    tumbon_code: "04",
    name: "โนนขวาง",
    zipcode: "31000",
  },
  {
    jw_code: "31",
    amph_code: "22",
    tumbon_code: "01",
    name: "แคนดง",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "22",
    tumbon_code: "02",
    name: "ดงพลอง",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "22",
    tumbon_code: "03",
    name: "สระบัว",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "22",
    tumbon_code: "04",
    name: "หัวฝาย",
    zipcode: "31150",
  },
  {
    jw_code: "31",
    amph_code: "23",
    tumbon_code: "01",
    name: "เจริญสุข",
    zipcode: "30230",
  },
  {
    jw_code: "31",
    amph_code: "23",
    tumbon_code: "02",
    name: "ตาเป๊ก",
    zipcode: "30230",
  },
  {
    jw_code: "31",
    amph_code: "23",
    tumbon_code: "03",
    name: "อีสานเขต",
    zipcode: "30230",
  },
  {
    jw_code: "31",
    amph_code: "23",
    tumbon_code: "04",
    name: "ถาวร",
    zipcode: "31170",
  },
  {
    jw_code: "31",
    amph_code: "23",
    tumbon_code: "05",
    name: "ยายแย้มวัฒนา",
    zipcode: "31170",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "02",
    name: "ตั้งใจ",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "03",
    name: "เพี้ยราม",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "04",
    name: "นาดี",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "05",
    name: "ท่าสว่าง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "06",
    name: "สลักได",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "07",
    name: "ตาอ็อง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "09",
    name: "สำโรง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "10",
    name: "แกใหญ่",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "11",
    name: "นอกเมือง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "12",
    name: "คอโค",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "13",
    name: "สวาย",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "14",
    name: "เฉนียง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "16",
    name: "เทนมีย์",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "18",
    name: "นาบัว",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "19",
    name: "เมืองที",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "20",
    name: "ราม",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "21",
    name: "บุฤาษี",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "22",
    name: "ตระแสง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "25",
    name: "แสลงพันธ์",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "01",
    tumbon_code: "26",
    name: "กาเกาะ",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "01",
    name: "ชุมพลบุรี",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "02",
    name: "นาหนองไผ่",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "03",
    name: "ไพรขลา",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "04",
    name: "ศรีณรงค์",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "05",
    name: "ยะวึก",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "06",
    name: "เมืองบัว",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "07",
    name: "สระขุด",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "08",
    name: "กระเบื้อง",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "02",
    tumbon_code: "09",
    name: "หนองเรือ",
    zipcode: "32190",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "01",
    name: "ท่าตูม",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "02",
    name: "กระโพ",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "03",
    name: "พรมเทพ",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "04",
    name: "โพนครก",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "05",
    name: "เมืองแก",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "06",
    name: "บะ",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "07",
    name: "หนองบัว",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "08",
    name: "บัวโคก",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "09",
    name: "หนองเมธี",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "03",
    tumbon_code: "10",
    name: "ทุ่งกุลา",
    zipcode: "32120",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "01",
    name: "จอมพระ",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "02",
    name: "เมืองลีง",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "03",
    name: "กระหาด",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "04",
    name: "บุแกรง",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "05",
    name: "หนองสนิท",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "06",
    name: "บ้านผือ",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "07",
    name: "ลุ่มระวี",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "08",
    name: "ชุมแสง",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "04",
    tumbon_code: "09",
    name: "เป็นสุข",
    zipcode: "32180",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "01",
    name: "กังแอน",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "02",
    name: "ทมอ",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "03",
    name: "ไพล",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "04",
    name: "ปรือ",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "05",
    name: "ทุ่งมน",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "06",
    name: "ตาเบา",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "07",
    name: "หนองใหญ่",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "08",
    name: "โคกยาง",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "09",
    name: "โคกสะอาด",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "10",
    name: "บ้านไทร",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "11",
    name: "โชคนาสาม",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "12",
    name: "เชื้อเพลิง",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "13",
    name: "ปราสาททนง",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "14",
    name: "ตานี",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "15",
    name: "บ้านพลวง",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "16",
    name: "กันตวจระมวล",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "17",
    name: "สมุด",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "05",
    tumbon_code: "18",
    name: "ประทัดบุ",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "06",
    tumbon_code: "01",
    name: "กาบเชิง",
    zipcode: "32210",
  },
  {
    jw_code: "32",
    amph_code: "06",
    tumbon_code: "04",
    name: "คูตัน",
    zipcode: "32210",
  },
  {
    jw_code: "32",
    amph_code: "06",
    tumbon_code: "05",
    name: "ด่าน",
    zipcode: "32210",
  },
  {
    jw_code: "32",
    amph_code: "06",
    tumbon_code: "06",
    name: "แนงมุด",
    zipcode: "32210",
  },
  {
    jw_code: "32",
    amph_code: "06",
    tumbon_code: "07",
    name: "โคกตะเคียน",
    zipcode: "32210",
  },
  {
    jw_code: "32",
    amph_code: "06",
    tumbon_code: "10",
    name: "ตะเคียน",
    zipcode: "32210",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "01",
    name: "รัตนบุรี",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "02",
    name: "ธาตุ",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "03",
    name: "แก",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "04",
    name: "ดอนแรด",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "05",
    name: "หนองบัวทอง",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "06",
    name: "หนองบัวบาน",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "09",
    name: "ไผ่",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "11",
    name: "เบิด",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "13",
    name: "น้ำเขียว",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "14",
    name: "กุดขาคีม",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "15",
    name: "ยางสว่าง",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "07",
    tumbon_code: "16",
    name: "ทับใหญ่",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "08",
    tumbon_code: "01",
    name: "สนม",
    zipcode: "32160",
  },
  {
    jw_code: "32",
    amph_code: "08",
    tumbon_code: "02",
    name: "โพนโก",
    zipcode: "32160",
  },
  {
    jw_code: "32",
    amph_code: "08",
    tumbon_code: "03",
    name: "หนองระฆัง",
    zipcode: "32160",
  },
  {
    jw_code: "32",
    amph_code: "08",
    tumbon_code: "04",
    name: "นานวน",
    zipcode: "32160",
  },
  {
    jw_code: "32",
    amph_code: "08",
    tumbon_code: "05",
    name: "แคน",
    zipcode: "32160",
  },
  {
    jw_code: "32",
    amph_code: "08",
    tumbon_code: "06",
    name: "หัวงัว",
    zipcode: "32160",
  },
  {
    jw_code: "32",
    amph_code: "08",
    tumbon_code: "07",
    name: "หนองอียอ",
    zipcode: "32160",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "01",
    name: "ระแงง",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "02",
    name: "ตรึม",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "03",
    name: "จารพัต",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "04",
    name: "ยาง",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "05",
    name: "แตล",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "06",
    name: "หนองบัว",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "07",
    name: "คาละแมะ",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "08",
    name: "หนองเหล็ก",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "09",
    name: "หนองขวาว",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "10",
    name: "ช่างปี่",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "11",
    name: "กุดหวาย",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "12",
    name: "ขวาวใหญ่",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "13",
    name: "นารุ่ง",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "14",
    name: "ตรมไพร",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "09",
    tumbon_code: "15",
    name: "ผักไหม",
    zipcode: "32110",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "01",
    name: "สังขะ",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "02",
    name: "ขอนแตก",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "06",
    name: "ดม",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "07",
    name: "พระแก้ว",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "08",
    name: "บ้านจารย์",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "09",
    name: "กระเทียม",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "10",
    name: "สะกาด",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "11",
    name: "ตาตุม",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "12",
    name: "ทับทัน",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "13",
    name: "ตาคง",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "15",
    name: "บ้านชบ",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "10",
    tumbon_code: "17",
    name: "เทพรักษา",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "11",
    tumbon_code: "01",
    name: "ลำดวน",
    zipcode: "32220",
  },
  {
    jw_code: "32",
    amph_code: "11",
    tumbon_code: "02",
    name: "โชคเหนือ",
    zipcode: "32220",
  },
  {
    jw_code: "32",
    amph_code: "11",
    tumbon_code: "03",
    name: "อู่โลก",
    zipcode: "32220",
  },
  {
    jw_code: "32",
    amph_code: "11",
    tumbon_code: "04",
    name: "ตรำดม",
    zipcode: "32220",
  },
  {
    jw_code: "32",
    amph_code: "11",
    tumbon_code: "05",
    name: "ตระเปียงเตีย",
    zipcode: "32220",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "01",
    name: "สำโรงทาบ",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "02",
    name: "หนองไผ่ล้อม",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "03",
    name: "กระออม",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "04",
    name: "หนองฮะ",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "05",
    name: "ศรีสุข",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "06",
    name: "เกาะแก้ว",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "07",
    name: "หมื่นศรี",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "08",
    name: "เสม็จ",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "09",
    name: "สะโน",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "12",
    tumbon_code: "10",
    name: "ประดู่",
    zipcode: "32170",
  },
  {
    jw_code: "32",
    amph_code: "13",
    tumbon_code: "01",
    name: "บัวเชด",
    zipcode: "32230",
  },
  {
    jw_code: "32",
    amph_code: "13",
    tumbon_code: "02",
    name: "สะเดา",
    zipcode: "32230",
  },
  {
    jw_code: "32",
    amph_code: "13",
    tumbon_code: "03",
    name: "จรัส",
    zipcode: "32230",
  },
  {
    jw_code: "32",
    amph_code: "13",
    tumbon_code: "04",
    name: "ตาวัง",
    zipcode: "32230",
  },
  {
    jw_code: "32",
    amph_code: "13",
    tumbon_code: "05",
    name: "อาโพน",
    zipcode: "32230",
  },
  {
    jw_code: "32",
    amph_code: "13",
    tumbon_code: "06",
    name: "สำเภาลูน",
    zipcode: "32230",
  },
  {
    jw_code: "32",
    amph_code: "14",
    tumbon_code: "01",
    name: "บักได",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "14",
    tumbon_code: "02",
    name: "โคกกลาง",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "14",
    tumbon_code: "03",
    name: "จีกแดก",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "14",
    tumbon_code: "04",
    name: "ตาเมียง",
    zipcode: "32140",
  },
  {
    jw_code: "32",
    amph_code: "15",
    tumbon_code: "01",
    name: "ณรงค์",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "15",
    tumbon_code: "02",
    name: "แจนแวน",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "15",
    tumbon_code: "03",
    name: "ตรวจ",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "15",
    tumbon_code: "04",
    name: "หนองแวง",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "15",
    tumbon_code: "05",
    name: "ศรีสุข",
    zipcode: "32150",
  },
  {
    jw_code: "32",
    amph_code: "16",
    tumbon_code: "01",
    name: "เขวาสินรินทร์",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "16",
    tumbon_code: "02",
    name: "บึง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "16",
    tumbon_code: "03",
    name: "ตากูก",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "16",
    tumbon_code: "04",
    name: "ปราสาททอง",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "16",
    tumbon_code: "05",
    name: "บ้านแร่",
    zipcode: "32000",
  },
  {
    jw_code: "32",
    amph_code: "17",
    tumbon_code: "01",
    name: "หนองหลวง",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "17",
    tumbon_code: "02",
    name: "คำผง",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "17",
    tumbon_code: "03",
    name: "โนน",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "17",
    tumbon_code: "04",
    name: "ระเวียง",
    zipcode: "32130",
  },
  {
    jw_code: "32",
    amph_code: "17",
    tumbon_code: "05",
    name: "หนองเทพ",
    zipcode: "32130",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "01",
    name: "เมืองเหนือ",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "02",
    name: "เมืองใต้",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "03",
    name: "คูซอด",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "04",
    name: "ซำ",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "05",
    name: "จาน",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "06",
    name: "ตะดอบ",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "07",
    name: "หนองครก",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "11",
    name: "โพนข่า",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "12",
    name: "โพนค้อ",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "15",
    name: "โพนเขวา",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "16",
    name: "หญ้าปล้อง",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "18",
    name: "ทุ่ม",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "19",
    name: "หนองไฮ",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "21",
    name: "หนองแก้ว",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "22",
    name: "น้ำคำ",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "23",
    name: "โพธิ์",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "24",
    name: "หมากเขียบ",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "01",
    tumbon_code: "27",
    name: "หนองไผ่",
    zipcode: "33000",
  },
  {
    jw_code: "33",
    amph_code: "02",
    tumbon_code: "01",
    name: "ยางชุมน้อย",
    zipcode: "33190",
  },
  {
    jw_code: "33",
    amph_code: "02",
    tumbon_code: "02",
    name: "ลิ้นฟ้า",
    zipcode: "33190",
  },
  {
    jw_code: "33",
    amph_code: "02",
    tumbon_code: "03",
    name: "คอนกาม",
    zipcode: "33190",
  },
  {
    jw_code: "33",
    amph_code: "02",
    tumbon_code: "04",
    name: "โนนคูณ",
    zipcode: "33190",
  },
  {
    jw_code: "33",
    amph_code: "02",
    tumbon_code: "05",
    name: "กุดเมืองฮาม",
    zipcode: "33190",
  },
  {
    jw_code: "33",
    amph_code: "02",
    tumbon_code: "06",
    name: "บึงบอน",
    zipcode: "33190",
  },
  {
    jw_code: "33",
    amph_code: "02",
    tumbon_code: "07",
    name: "ยางชุมใหญ่",
    zipcode: "33190",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "01",
    name: "ดูน",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "02",
    name: "โนนสัง",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "03",
    name: "หนองหัวช้าง",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "04",
    name: "ยาง",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "05",
    name: "หนองแวง",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "06",
    name: "หนองแก้ว",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "07",
    name: "ทาม",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "08",
    name: "ละทาย",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "09",
    name: "เมืองน้อย",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "10",
    name: "อีปาด",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "11",
    name: "บัวน้อย",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "12",
    name: "หนองบัว",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "13",
    name: "ดู่",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "14",
    name: "ผักแพว",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "15",
    name: "จาน",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "03",
    tumbon_code: "20",
    name: "คำเนียม",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "01",
    name: "บึงมะลู",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "02",
    name: "กุดเสลา",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "03",
    name: "เมือง",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "05",
    name: "สังเม็ก",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "06",
    name: "น้ำอ้อม",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "07",
    name: "ละลาย",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "08",
    name: "รุง",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "09",
    name: "ตระกาจ",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "11",
    name: "จานใหญ่",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "12",
    name: "ภูเงิน",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "13",
    name: "ชำ",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "14",
    name: "กระแชง",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "15",
    name: "โนนสำราญ",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "16",
    name: "หนองหญ้าลาด",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "19",
    name: "เสาธงชัย",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "20",
    name: "ขนุน",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "21",
    name: "สวนกล้วย",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "23",
    name: "เวียงเหนือ",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "24",
    name: "ทุ่งใหญ่",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "04",
    tumbon_code: "25",
    name: "ภูผาหมอก",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "01",
    name: "กันทรารมย์",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "02",
    name: "จะกง",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "03",
    name: "ใจดี",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "04",
    name: "ดองกำเม็ด",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "05",
    name: "โสน",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "06",
    name: "ปรือใหญ่",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "07",
    name: "สะเดาใหญ่",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "08",
    name: "ตาอุด",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "09",
    name: "ห้วยเหนือ",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "10",
    name: "ห้วยใต้",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "11",
    name: "หัวเสือ",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "13",
    name: "ตะเคียน",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "15",
    name: "นิคมพัฒนา",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "17",
    name: "โคกเพชร",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "18",
    name: "ปราสาท",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "21",
    name: "สำโรงตาเจ็น",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "22",
    name: "ห้วยสำราญ",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "24",
    name: "กฤษณา",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "25",
    name: "ลมศักดิ์",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "26",
    name: "หนองฉลอง",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "27",
    name: "ศรีตระกูล",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "05",
    tumbon_code: "28",
    name: "ศรีสะอาด",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "06",
    tumbon_code: "01",
    name: "ไพรบึง",
    zipcode: "33180",
  },
  {
    jw_code: "33",
    amph_code: "06",
    tumbon_code: "02",
    name: "ดินแดง",
    zipcode: "33180",
  },
  {
    jw_code: "33",
    amph_code: "06",
    tumbon_code: "03",
    name: "ปราสาทเยอ",
    zipcode: "33180",
  },
  {
    jw_code: "33",
    amph_code: "06",
    tumbon_code: "04",
    name: "สำโรงพลัน",
    zipcode: "33180",
  },
  {
    jw_code: "33",
    amph_code: "06",
    tumbon_code: "05",
    name: "สุขสวัสดิ์",
    zipcode: "33180",
  },
  {
    jw_code: "33",
    amph_code: "06",
    tumbon_code: "06",
    name: "โนนปูน",
    zipcode: "33180",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "01",
    name: "พิมาย",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "02",
    name: "กู่",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "03",
    name: "หนองเชียงทูน",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "04",
    name: "ตูม",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "05",
    name: "สมอ",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "06",
    name: "โพธิ์ศรี",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "07",
    name: "สำโรงปราสาท",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "08",
    name: "ดู่",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "09",
    name: "สวาย",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "07",
    tumbon_code: "10",
    name: "พิมายเหนือ",
    zipcode: "33170",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "01",
    name: "สิ",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "02",
    name: "บักดอง",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "03",
    name: "พราน",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "04",
    name: "โพธิ์วงศ์",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "05",
    name: "ไพร",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "06",
    name: "กระหวัน",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "07",
    name: "ขุนหาญ",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "08",
    name: "โนนสูง",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "09",
    name: "กันทรอม",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "10",
    name: "ภูฝ้าย",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "11",
    name: "โพธิ์กระสังข์",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "08",
    tumbon_code: "12",
    name: "ห้วยจันทร์",
    zipcode: "33150",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "01",
    name: "เมืองคง",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "02",
    name: "เมืองแคน",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "03",
    name: "หนองแค",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "06",
    name: "จิกสังข์ทอง",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "07",
    name: "ด่าน",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "08",
    name: "ดู่",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "09",
    name: "หนองอึ่ง",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "10",
    name: "บัวหุ่ง",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "11",
    name: "ไผ่",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "12",
    name: "ส้มป่อย",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "13",
    name: "หนองหมี",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "14",
    name: "หว้านคำ",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "09",
    tumbon_code: "15",
    name: "สร้างปี่",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "01",
    name: "กำแพง",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "02",
    name: "อี่หล่ำ",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "03",
    name: "ก้านเหลือง",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "04",
    name: "ทุ่งไชย",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "05",
    name: "สำโรง",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "06",
    name: "แขม",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "07",
    name: "หนองไฮ",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "08",
    name: "ขะยูง",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "10",
    name: "ตาเกษ",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "11",
    name: "หัวช้าง",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "12",
    name: "รังแร้ง",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "14",
    name: "แต้",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "15",
    name: "แข้",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "16",
    name: "โพธิ์ชัย",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "17",
    name: "ปะอาว",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "18",
    name: "หนองห้าง",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "22",
    name: "สระกำแพงใหญ่",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "24",
    name: "โคกหล่าม",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "10",
    tumbon_code: "25",
    name: "โคกจาน",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "11",
    tumbon_code: "01",
    name: "เป๊าะ",
    zipcode: "33220",
  },
  {
    jw_code: "33",
    amph_code: "11",
    tumbon_code: "02",
    name: "บึงบูรพ์",
    zipcode: "33220",
  },
  {
    jw_code: "33",
    amph_code: "12",
    tumbon_code: "01",
    name: "ห้วยทับทัน",
    zipcode: "33210",
  },
  {
    jw_code: "33",
    amph_code: "12",
    tumbon_code: "02",
    name: "เมืองหลวง",
    zipcode: "33210",
  },
  {
    jw_code: "33",
    amph_code: "12",
    tumbon_code: "03",
    name: "กล้วยกว้าง",
    zipcode: "33210",
  },
  {
    jw_code: "33",
    amph_code: "12",
    tumbon_code: "04",
    name: "ผักไหม",
    zipcode: "33210",
  },
  {
    jw_code: "33",
    amph_code: "12",
    tumbon_code: "05",
    name: "จานแสนไชย",
    zipcode: "33210",
  },
  {
    jw_code: "33",
    amph_code: "12",
    tumbon_code: "06",
    name: "ปราสาท",
    zipcode: "33210",
  },
  {
    jw_code: "33",
    amph_code: "13",
    tumbon_code: "01",
    name: "โนนค้อ",
    zipcode: "33250",
  },
  {
    jw_code: "33",
    amph_code: "13",
    tumbon_code: "02",
    name: "บก",
    zipcode: "33250",
  },
  {
    jw_code: "33",
    amph_code: "13",
    tumbon_code: "03",
    name: "โพธิ์",
    zipcode: "33250",
  },
  {
    jw_code: "33",
    amph_code: "13",
    tumbon_code: "04",
    name: "หนองกุง",
    zipcode: "33250",
  },
  {
    jw_code: "33",
    amph_code: "13",
    tumbon_code: "05",
    name: "เหล่ากวาง",
    zipcode: "33250",
  },
  {
    jw_code: "33",
    amph_code: "14",
    tumbon_code: "01",
    name: "ศรีแก้ว",
    zipcode: "33240",
  },
  {
    jw_code: "33",
    amph_code: "14",
    tumbon_code: "02",
    name: "พิงพวย",
    zipcode: "33240",
  },
  {
    jw_code: "33",
    amph_code: "14",
    tumbon_code: "03",
    name: "สระเยาว์",
    zipcode: "33240",
  },
  {
    jw_code: "33",
    amph_code: "14",
    tumbon_code: "04",
    name: "ตูม",
    zipcode: "33240",
  },
  {
    jw_code: "33",
    amph_code: "14",
    tumbon_code: "05",
    name: "เสื่องข้าว",
    zipcode: "33240",
  },
  {
    jw_code: "33",
    amph_code: "14",
    tumbon_code: "06",
    name: "ศรีโนนงาม",
    zipcode: "33240",
  },
  {
    jw_code: "33",
    amph_code: "14",
    tumbon_code: "07",
    name: "สะพุง",
    zipcode: "33240",
  },
  {
    jw_code: "33",
    amph_code: "15",
    tumbon_code: "01",
    name: "น้ำเกลี้ยง",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "15",
    tumbon_code: "02",
    name: "ละเอาะ",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "15",
    tumbon_code: "03",
    name: "ตองปิด",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "15",
    tumbon_code: "04",
    name: "เขิน",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "15",
    tumbon_code: "05",
    name: "รุ่งระวี",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "15",
    tumbon_code: "06",
    name: "คูบ",
    zipcode: "33130",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "01",
    name: "บุสูง",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "02",
    name: "ธาตุ",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "03",
    name: "ดวนใหญ่",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "04",
    name: "บ่อแก้ว",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "05",
    name: "ศรีสำราญ",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "06",
    name: "ทุ่งสว่าง",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "07",
    name: "วังหิน",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "16",
    tumbon_code: "08",
    name: "โพนยาง",
    zipcode: "33270",
  },
  {
    jw_code: "33",
    amph_code: "17",
    tumbon_code: "01",
    name: "โคกตาล",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "17",
    tumbon_code: "02",
    name: "ห้วยตามอญ",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "17",
    tumbon_code: "03",
    name: "ห้วยตึ๊กชู",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "17",
    tumbon_code: "04",
    name: "ละลม",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "17",
    tumbon_code: "05",
    name: "ตะเคียนราม",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "17",
    tumbon_code: "06",
    name: "ดงรัก",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "17",
    tumbon_code: "07",
    name: "ไพรพัฒนา",
    zipcode: "33140",
  },
  {
    jw_code: "33",
    amph_code: "18",
    tumbon_code: "01",
    name: "เมืองจันทร์",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "18",
    tumbon_code: "02",
    name: "ตาโกน",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "18",
    tumbon_code: "03",
    name: "หนองใหญ่",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "19",
    tumbon_code: "01",
    name: "เสียว",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "19",
    tumbon_code: "02",
    name: "หนองหว้า",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "19",
    tumbon_code: "03",
    name: "หนองงูเหลือม",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "19",
    tumbon_code: "04",
    name: "หนองฮาง",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "19",
    tumbon_code: "05",
    name: "ท่าคล้อ",
    zipcode: "33110",
  },
  {
    jw_code: "33",
    amph_code: "20",
    tumbon_code: "01",
    name: "พยุห์",
    zipcode: "33230",
  },
  {
    jw_code: "33",
    amph_code: "20",
    tumbon_code: "02",
    name: "พรหมสวัสดิ์",
    zipcode: "33230",
  },
  {
    jw_code: "33",
    amph_code: "20",
    tumbon_code: "03",
    name: "ตำแย",
    zipcode: "33230",
  },
  {
    jw_code: "33",
    amph_code: "20",
    tumbon_code: "04",
    name: "โนนเพ็ก",
    zipcode: "33230",
  },
  {
    jw_code: "33",
    amph_code: "20",
    tumbon_code: "05",
    name: "หนองค้า",
    zipcode: "33230",
  },
  {
    jw_code: "33",
    amph_code: "21",
    tumbon_code: "01",
    name: "โดด",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "21",
    tumbon_code: "02",
    name: "เสียว",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "21",
    tumbon_code: "03",
    name: "หนองม้า",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "21",
    tumbon_code: "04",
    name: "ผือใหญ่",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "21",
    tumbon_code: "05",
    name: "อีเซ",
    zipcode: "33120",
  },
  {
    jw_code: "33",
    amph_code: "22",
    tumbon_code: "01",
    name: "กุง",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "22",
    tumbon_code: "02",
    name: "คลีกลิ้ง",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "22",
    tumbon_code: "03",
    name: "หนองบัวดง",
    zipcode: "33160",
  },
  {
    jw_code: "33",
    amph_code: "22",
    tumbon_code: "04",
    name: "โจดม่วง",
    zipcode: "33160",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "04",
    name: "หัวเรือ",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "05",
    name: "หนองขอน",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "07",
    name: "ปทุม",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "08",
    name: "ขามใหญ่",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "09",
    name: "แจระแม",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "11",
    name: "หนองบ่อ",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "12",
    name: "ไร่น้อย",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "13",
    name: "กระโสบ",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "16",
    name: "กุดลาด",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "19",
    name: "ขี้เหล็ก",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "01",
    tumbon_code: "20",
    name: "ปะอาว",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "01",
    name: "นาคำ",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "02",
    name: "แก้งกอก",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "03",
    name: "เอือดใหญ่",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "04",
    name: "วาริน",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "05",
    name: "ลาดควาย",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "06",
    name: "สงยาง",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "07",
    name: "ตะบ่าย",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "08",
    name: "คำไหล",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "09",
    name: "หนามแท่ง",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "10",
    name: "นาเลิน",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "02",
    tumbon_code: "11",
    name: "ดอนใหญ่",
    zipcode: "34250",
  },
  {
    jw_code: "34",
    amph_code: "03",
    tumbon_code: "01",
    name: "โขงเจียม",
    zipcode: "34220",
  },
  {
    jw_code: "34",
    amph_code: "03",
    tumbon_code: "02",
    name: "ห้วยยาง",
    zipcode: "34220",
  },
  {
    jw_code: "34",
    amph_code: "03",
    tumbon_code: "03",
    name: "นาโพธิ์กลาง",
    zipcode: "34220",
  },
  {
    jw_code: "34",
    amph_code: "03",
    tumbon_code: "04",
    name: "หนองแสงใหญ่",
    zipcode: "34220",
  },
  {
    jw_code: "34",
    amph_code: "03",
    tumbon_code: "05",
    name: "ห้วยไผ่",
    zipcode: "34220",
  },
  {
    jw_code: "34",
    amph_code: "03",
    tumbon_code: "06",
    name: "คำเขื่อนแก้ว",
    zipcode: "34220",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "01",
    name: "เขื่องใน",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "02",
    name: "สร้างถ่อ",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "03",
    name: "ค้อทอง",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "04",
    name: "ก่อเอ้",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "05",
    name: "หัวดอน",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "06",
    name: "ชีทวน",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "07",
    name: "ท่าไห",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "08",
    name: "นาคำใหญ่",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "09",
    name: "แดงหม้อ",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "10",
    name: "ธาตุน้อย",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "11",
    name: "บ้านไทย",
    zipcode: "34320",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "12",
    name: "บ้านกอก",
    zipcode: "34320",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "13",
    name: "กลางใหญ่",
    zipcode: "34320",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "14",
    name: "โนนรัง",
    zipcode: "34320",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "15",
    name: "ยางขี้นก",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "16",
    name: "ศรีสุข",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "17",
    name: "สหธาตุ",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "04",
    tumbon_code: "18",
    name: "หนองเหล่า",
    zipcode: "34150",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "01",
    name: "เขมราฐ",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "03",
    name: "ขามป้อม",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "04",
    name: "เจียด",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "07",
    name: "หนองผือ",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "08",
    name: "นาแวง",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "10",
    name: "แก้งเหนือ",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "11",
    name: "หนองนกทา",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "12",
    name: "หนองสิม",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "05",
    tumbon_code: "13",
    name: "หัวนา",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "01",
    name: "เมืองเดช",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "02",
    name: "นาส่วง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "04",
    name: "นาเจริญ",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "06",
    name: "ทุ่งเทิง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "08",
    name: "สมสะอาด",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "09",
    name: "กุดประทาย",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "10",
    name: "ตบหู",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "11",
    name: "กลาง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "12",
    name: "แก้ง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "13",
    name: "ท่าโพธิ์ศรี",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "15",
    name: "บัวงาม",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "16",
    name: "คำครั่ง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "17",
    name: "นากระแซง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "20",
    name: "โพนงาม",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "21",
    name: "ป่าโมง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "07",
    tumbon_code: "23",
    name: "โนนสมบูรณ์",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "08",
    tumbon_code: "01",
    name: "นาจะหลวย",
    zipcode: "34280",
  },
  {
    jw_code: "34",
    amph_code: "08",
    tumbon_code: "02",
    name: "โนนสมบูรณ์",
    zipcode: "34280",
  },
  {
    jw_code: "34",
    amph_code: "08",
    tumbon_code: "03",
    name: "พรสวรรค์",
    zipcode: "34280",
  },
  {
    jw_code: "34",
    amph_code: "08",
    tumbon_code: "04",
    name: "บ้านตูม",
    zipcode: "34280",
  },
  {
    jw_code: "34",
    amph_code: "08",
    tumbon_code: "05",
    name: "โสกแสง",
    zipcode: "34280",
  },
  {
    jw_code: "34",
    amph_code: "08",
    tumbon_code: "06",
    name: "โนนสวรรค์",
    zipcode: "34280",
  },
  {
    jw_code: "34",
    amph_code: "09",
    tumbon_code: "01",
    name: "โซง",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "09",
    tumbon_code: "03",
    name: "ยาง",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "09",
    tumbon_code: "04",
    name: "โดมประดิษฐ์",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "09",
    tumbon_code: "06",
    name: "บุเปือย",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "09",
    tumbon_code: "07",
    name: "สีวิเชียร",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "09",
    tumbon_code: "09",
    name: "ยางใหญ่",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "09",
    tumbon_code: "11",
    name: "เก่าขาม",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "01",
    name: "โพนงาม",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "02",
    name: "ห้วยข่า",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "03",
    name: "คอแลน",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "04",
    name: "นาโพธิ์",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "05",
    name: "หนองสะโน",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "06",
    name: "โนนค้อ",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "07",
    name: "บัวงาม",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "10",
    tumbon_code: "08",
    name: "บ้านแมด",
    zipcode: "34230",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "01",
    name: "ขุหลุ",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "02",
    name: "กระเดียน",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "03",
    name: "เกษม",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "04",
    name: "กุศกร",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "05",
    name: "ขามเปี้ย",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "06",
    name: "คอนสาย",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "07",
    name: "โคกจาน",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "08",
    name: "นาพิน",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "09",
    name: "นาสะไม",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "10",
    name: "โนนกุง",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "11",
    name: "ตระการ",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "12",
    name: "ตากแดด",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "13",
    name: "ไหล่ทุ่ง",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "14",
    name: "เป้า",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "15",
    name: "เซเป็ด",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "16",
    name: "สะพือ",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "17",
    name: "หนองเต่า",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "18",
    name: "ถ้ำแข้",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "19",
    name: "ท่าหลวง",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "20",
    name: "ห้วยฝ้ายพัฒนา",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "21",
    name: "กุดยาลวน",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "22",
    name: "บ้านแดง",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "11",
    tumbon_code: "23",
    name: "คำเจริญ",
    zipcode: "34130",
  },
  {
    jw_code: "34",
    amph_code: "12",
    tumbon_code: "01",
    name: "ข้าวปุ้น",
    zipcode: "34270",
  },
  {
    jw_code: "34",
    amph_code: "12",
    tumbon_code: "02",
    name: "โนนสวาง",
    zipcode: "34270",
  },
  {
    jw_code: "34",
    amph_code: "12",
    tumbon_code: "03",
    name: "แก่งเค็ง",
    zipcode: "34270",
  },
  {
    jw_code: "34",
    amph_code: "12",
    tumbon_code: "04",
    name: "กาบิน",
    zipcode: "34270",
  },
  {
    jw_code: "34",
    amph_code: "12",
    tumbon_code: "05",
    name: "หนองทันน้ำ",
    zipcode: "34270",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "01",
    name: "ม่วงสามสิบ",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "02",
    name: "เหล่าบก",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "03",
    name: "ดุมใหญ่",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "04",
    name: "หนองช้างใหญ่",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "05",
    name: "หนองเมือง",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "06",
    name: "เตย",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "07",
    name: "ยางสักกระโพหลุ่ม",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "08",
    name: "หนองไข่นก",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "09",
    name: "หนองเหล่า",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "10",
    name: "หนองฮาง",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "11",
    name: "ยางโยภาพ",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "12",
    name: "ไผ่ใหญ่",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "13",
    name: "นาเลิง",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "14",
    tumbon_code: "14",
    name: "โพนแพง",
    zipcode: "34140",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "01",
    name: "วารินชำราบ",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "02",
    name: "ธาตุ",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "04",
    name: "ท่าลาด",
    zipcode: "34310",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "05",
    name: "โนนโหนน",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "07",
    name: "คูเมือง",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "08",
    name: "สระสมิง",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "10",
    name: "คำน้ำแซบ",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "11",
    name: "บุ่งหวาย",
    zipcode: "34310",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "15",
    name: "คำขวาง",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "16",
    name: "โพธิ์ใหญ่",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "18",
    name: "แสนสุข",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "20",
    name: "หนองกินเพล",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "21",
    name: "โนนผึ้ง",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "22",
    name: "เมืองศรีไค",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "24",
    name: "ห้วยขะยุง",
    zipcode: "34310",
  },
  {
    jw_code: "34",
    amph_code: "15",
    tumbon_code: "26",
    name: "บุ่งไหม",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "01",
    name: "พิบูล",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "02",
    name: "กุดชมภู",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "04",
    name: "ดอนจิก",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "05",
    name: "ทรายมูล",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "06",
    name: "นาโพธิ์",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "07",
    name: "โนนกลาง",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "09",
    name: "โพธิ์ไทร",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "10",
    name: "โพธิ์ศรี",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "11",
    name: "ระเว",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "12",
    name: "ไร่ใต้",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "13",
    name: "หนองบัวฮี",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "14",
    name: "อ่างศิลา",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "18",
    name: "โนนกาหลง",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "19",
    tumbon_code: "19",
    name: "บ้านแขม",
    zipcode: "34110",
  },
  {
    jw_code: "34",
    amph_code: "20",
    tumbon_code: "01",
    name: "ตาลสุม",
    zipcode: "34330",
  },
  {
    jw_code: "34",
    amph_code: "20",
    tumbon_code: "02",
    name: "สำโรง",
    zipcode: "34330",
  },
  {
    jw_code: "34",
    amph_code: "20",
    tumbon_code: "03",
    name: "จิกเทิง",
    zipcode: "34330",
  },
  {
    jw_code: "34",
    amph_code: "20",
    tumbon_code: "04",
    name: "หนองกุง",
    zipcode: "34330",
  },
  {
    jw_code: "34",
    amph_code: "20",
    tumbon_code: "05",
    name: "นาคาย",
    zipcode: "34330",
  },
  {
    jw_code: "34",
    amph_code: "20",
    tumbon_code: "06",
    name: "คำหว้า",
    zipcode: "34330",
  },
  {
    jw_code: "34",
    amph_code: "21",
    tumbon_code: "01",
    name: "โพธิ์ไทร",
    zipcode: "34340",
  },
  {
    jw_code: "34",
    amph_code: "21",
    tumbon_code: "02",
    name: "ม่วงใหญ่",
    zipcode: "34340",
  },
  {
    jw_code: "34",
    amph_code: "21",
    tumbon_code: "03",
    name: "สำโรง",
    zipcode: "34340",
  },
  {
    jw_code: "34",
    amph_code: "21",
    tumbon_code: "04",
    name: "สองคอน",
    zipcode: "34340",
  },
  {
    jw_code: "34",
    amph_code: "21",
    tumbon_code: "05",
    name: "สารภี",
    zipcode: "34340",
  },
  {
    jw_code: "34",
    amph_code: "21",
    tumbon_code: "06",
    name: "เหล่างาม",
    zipcode: "34340",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "01",
    name: "สำโรง",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "02",
    name: "โคกก่อง",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "03",
    name: "หนองไฮ",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "04",
    name: "ค้อน้อย",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "05",
    name: "โนนกาเล็น",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "06",
    name: "โคกสว่าง",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "07",
    name: "โนนกลาง",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "08",
    name: "บอน",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "22",
    tumbon_code: "09",
    name: "ขามป้อม",
    zipcode: "34360",
  },
  {
    jw_code: "34",
    amph_code: "24",
    tumbon_code: "01",
    name: "ดอนมดแดง",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "24",
    tumbon_code: "02",
    name: "เหล่าแดง",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "24",
    tumbon_code: "03",
    name: "ท่าเมือง",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "24",
    tumbon_code: "04",
    name: "คำไฮใหญ่",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "25",
    tumbon_code: "01",
    name: "คันไร่",
    zipcode: "34350",
  },
  {
    jw_code: "34",
    amph_code: "25",
    tumbon_code: "02",
    name: "ช่องเม็ก",
    zipcode: "34350",
  },
  {
    jw_code: "34",
    amph_code: "25",
    tumbon_code: "03",
    name: "โนนก่อ",
    zipcode: "34350",
  },
  {
    jw_code: "34",
    amph_code: "25",
    tumbon_code: "04",
    name: "นิคมสร้างตนเองลำโดมน้อย",
    zipcode: "34350",
  },
  {
    jw_code: "34",
    amph_code: "25",
    tumbon_code: "05",
    name: "ฝางคำ",
    zipcode: "34350",
  },
  {
    jw_code: "34",
    amph_code: "25",
    tumbon_code: "06",
    name: "คำเขื่อนแก้ว",
    zipcode: "34350",
  },
  {
    jw_code: "34",
    amph_code: "26",
    tumbon_code: "02",
    name: "หนองอ้ม",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "26",
    tumbon_code: "03",
    name: "นาเกษม",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "26",
    tumbon_code: "04",
    name: "กุดเรือ",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "26",
    tumbon_code: "05",
    name: "โคกชำแระ",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "26",
    tumbon_code: "06",
    name: "นาห่อม",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "29",
    tumbon_code: "01",
    name: "นาเยีย",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "29",
    tumbon_code: "02",
    name: "นาดี",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "29",
    tumbon_code: "03",
    name: "นาเรือง",
    zipcode: "34160",
  },
  {
    jw_code: "34",
    amph_code: "30",
    tumbon_code: "01",
    name: "นาตาล",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "30",
    tumbon_code: "02",
    name: "พะลาน",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "30",
    tumbon_code: "03",
    name: "กองโพน",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "30",
    tumbon_code: "04",
    name: "พังเคน",
    zipcode: "34170",
  },
  {
    jw_code: "34",
    amph_code: "31",
    tumbon_code: "01",
    name: "เหล่าเสือโก้ก",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "31",
    tumbon_code: "02",
    name: "โพนเมือง",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "31",
    tumbon_code: "03",
    name: "แพงใหญ่",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "31",
    tumbon_code: "04",
    name: "หนองบก",
    zipcode: "34000",
  },
  {
    jw_code: "34",
    amph_code: "32",
    tumbon_code: "01",
    name: "แก่งโดม",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "32",
    tumbon_code: "02",
    name: "ท่าช้าง",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "32",
    tumbon_code: "03",
    name: "บุ่งมะแลง",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "32",
    tumbon_code: "04",
    name: "สว่าง",
    zipcode: "34190",
  },
  {
    jw_code: "34",
    amph_code: "33",
    tumbon_code: "01",
    name: "ตาเกา",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "33",
    tumbon_code: "02",
    name: "ไพบูลย์",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "33",
    tumbon_code: "03",
    name: "ขี้เหล็ก",
    zipcode: "34260",
  },
  {
    jw_code: "34",
    amph_code: "33",
    tumbon_code: "04",
    name: "โคกสะอาด",
    zipcode: "34260",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "02",
    name: "น้ำคำใหญ่",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "03",
    name: "ตาดทอง",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "04",
    name: "สำราญ",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "05",
    name: "ค้อเหนือ",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "06",
    name: "ดู่ทุ่ง",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "07",
    name: "เดิด",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "08",
    name: "ขั้นไดใหญ่",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "09",
    name: "ทุ่งแต้",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "10",
    name: "สิงห์",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "11",
    name: "นาสะไมย์",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "12",
    name: "เขื่องคำ",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "13",
    name: "หนองหิน",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "14",
    name: "หนองคู",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "15",
    name: "ขุมเงิน",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "16",
    name: "ทุ่งนางโอก",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "17",
    name: "หนองเรือ",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "01",
    tumbon_code: "18",
    name: "หนองเป็ด",
    zipcode: "35000",
  },
  {
    jw_code: "35",
    amph_code: "02",
    tumbon_code: "01",
    name: "ทรายมูล",
    zipcode: "35170",
  },
  {
    jw_code: "35",
    amph_code: "02",
    tumbon_code: "02",
    name: "ดู่ลาด",
    zipcode: "35170",
  },
  {
    jw_code: "35",
    amph_code: "02",
    tumbon_code: "03",
    name: "ดงมะไฟ",
    zipcode: "35170",
  },
  {
    jw_code: "35",
    amph_code: "02",
    tumbon_code: "04",
    name: "นาเวียง",
    zipcode: "35170",
  },
  {
    jw_code: "35",
    amph_code: "02",
    tumbon_code: "05",
    name: "ไผ่",
    zipcode: "35170",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "01",
    name: "กุดชุม",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "02",
    name: "โนนเปือย",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "03",
    name: "กำแมด",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "04",
    name: "นาโส่",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "05",
    name: "ห้วยแก้ง",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "06",
    name: "หนองหมี",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "07",
    name: "โพนงาม",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "08",
    name: "คำน้ำสร้าง",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "03",
    tumbon_code: "09",
    name: "หนองแหน",
    zipcode: "35140",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "01",
    name: "ลุมพุก",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "02",
    name: "ย่อ",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "03",
    name: "สงเปือย",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "04",
    name: "โพนทัน",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "05",
    name: "ทุ่งมน",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "06",
    name: "นาคำ",
    zipcode: "35180",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "07",
    name: "ดงแคนใหญ่",
    zipcode: "35180",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "08",
    name: "กู่จาน",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "09",
    name: "นาแก",
    zipcode: "35180",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "10",
    name: "กุดกุง",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "11",
    name: "เหล่าไฮ",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "12",
    name: "แคนน้อย",
    zipcode: "35180",
  },
  {
    jw_code: "35",
    amph_code: "04",
    tumbon_code: "13",
    name: "ดงเจริญ",
    zipcode: "35110",
  },
  {
    jw_code: "35",
    amph_code: "05",
    tumbon_code: "01",
    name: "โพธิ์ไทร",
    zipcode: "35150",
  },
  {
    jw_code: "35",
    amph_code: "05",
    tumbon_code: "02",
    name: "กระจาย",
    zipcode: "35150",
  },
  {
    jw_code: "35",
    amph_code: "05",
    tumbon_code: "03",
    name: "โคกนาโก",
    zipcode: "35150",
  },
  {
    jw_code: "35",
    amph_code: "05",
    tumbon_code: "04",
    name: "เชียงเพ็ง",
    zipcode: "35150",
  },
  {
    jw_code: "35",
    amph_code: "05",
    tumbon_code: "05",
    name: "ศรีฐาน",
    zipcode: "35150",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "01",
    name: "ฟ้าหยาด",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "02",
    name: "หัวเมือง",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "03",
    name: "คูเมือง",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "04",
    name: "ผือฮี",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "05",
    name: "บากเรือ",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "06",
    name: "ม่วง",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "07",
    name: "โนนทราย",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "08",
    name: "บึงแก",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "09",
    name: "พระเสาร์",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "06",
    tumbon_code: "10",
    name: "สงยาง",
    zipcode: "35130",
  },
  {
    jw_code: "35",
    amph_code: "07",
    tumbon_code: "01",
    name: "ฟ้าห่วน",
    zipcode: "35160",
  },
  {
    jw_code: "35",
    amph_code: "07",
    tumbon_code: "02",
    name: "กุดน้ำใส",
    zipcode: "35160",
  },
  {
    jw_code: "35",
    amph_code: "07",
    tumbon_code: "03",
    name: "น้ำอ้อม",
    zipcode: "35160",
  },
  {
    jw_code: "35",
    amph_code: "07",
    tumbon_code: "04",
    name: "ค้อวัง",
    zipcode: "35160",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "02",
    name: "บุ่งค้า",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "03",
    name: "สวาท",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "05",
    name: "ห้องแซง",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "06",
    name: "สามัคคี",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "07",
    name: "กุดเชียงหมี",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "10",
    name: "สามแยก",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "11",
    name: "กุดแห่",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "12",
    name: "โคกสำราญ",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "13",
    name: "สร้างมิ่ง",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "08",
    tumbon_code: "14",
    name: "ศรีแก้ว",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "09",
    tumbon_code: "01",
    name: "ไทยเจริญ",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "09",
    tumbon_code: "02",
    name: "น้ำคำ",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "09",
    tumbon_code: "03",
    name: "ส้มผ่อ",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "09",
    tumbon_code: "04",
    name: "คำเตย",
    zipcode: "35120",
  },
  {
    jw_code: "35",
    amph_code: "09",
    tumbon_code: "05",
    name: "คำไผ่",
    zipcode: "35120",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "02",
    name: "รอบเมือง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "03",
    name: "โพนทอง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "04",
    name: "นาฝาย",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านค่าย",
    zipcode: "36240",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "06",
    name: "กุดตุ้ม",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "07",
    name: "ชีลอง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "08",
    name: "บ้านเล่า",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "09",
    name: "นาเสียว",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "10",
    name: "หนองนาแซง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "11",
    name: "ลาดใหญ่",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "12",
    name: "หนองไผ่",
    zipcode: "36240",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "13",
    name: "ท่าหินโงม",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "14",
    name: "ห้วยต้อน",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "15",
    name: "ห้วยบง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "16",
    name: "โนนสำราญ",
    zipcode: "36240",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "17",
    name: "โคกสูง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "18",
    name: "บุ่งคล้า",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "01",
    tumbon_code: "19",
    name: "ซับสีทอง",
    zipcode: "36000",
  },
  {
    jw_code: "36",
    amph_code: "02",
    tumbon_code: "01",
    name: "บ้านเขว้า",
    zipcode: "36170",
  },
  {
    jw_code: "36",
    amph_code: "02",
    tumbon_code: "02",
    name: "ตลาดแร้ง",
    zipcode: "36170",
  },
  {
    jw_code: "36",
    amph_code: "02",
    tumbon_code: "03",
    name: "ลุ่มลำชี",
    zipcode: "36170",
  },
  {
    jw_code: "36",
    amph_code: "02",
    tumbon_code: "04",
    name: "ชีบน",
    zipcode: "36170",
  },
  {
    jw_code: "36",
    amph_code: "02",
    tumbon_code: "05",
    name: "ภูแลนคา",
    zipcode: "36170",
  },
  {
    jw_code: "36",
    amph_code: "02",
    tumbon_code: "06",
    name: "โนนแดง",
    zipcode: "36170",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "01",
    name: "คอนสวรรค์",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "02",
    name: "ยางหวาย",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "03",
    name: "ช่องสามหมอ",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "04",
    name: "โนนสะอาด",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "05",
    name: "ห้วยไร่",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "06",
    name: "บ้านโสก",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "07",
    name: "โคกมั่งงอย",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "08",
    name: "หนองขาม",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "03",
    tumbon_code: "09",
    name: "ศรีสำราญ",
    zipcode: "36140",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "01",
    name: "บ้านยาง",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "02",
    name: "บ้านหัน",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "03",
    name: "บ้านเดื่อ",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "04",
    name: "บ้านเป้า",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "05",
    name: "กุดเลาะ",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "06",
    name: "โนนกอก",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "07",
    name: "สระโพนทอง",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "08",
    name: "หนองข่า",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "09",
    name: "หนองโพนงาม",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "10",
    name: "บ้านบัว",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "04",
    tumbon_code: "12",
    name: "โนนทอง",
    zipcode: "36120",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "01",
    name: "หนองบัวแดง",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "02",
    name: "กุดชุมแสง",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "03",
    name: "ถ้ำวัวแดง",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "04",
    name: "นางแดด",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "07",
    name: "หนองแวง",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "08",
    name: "คูเมือง",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "09",
    name: "ท่าใหญ่",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "05",
    tumbon_code: "11",
    name: "วังชมภู",
    zipcode: "36210",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "01",
    name: "บ้านกอก",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "02",
    name: "หนองบัวบาน",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "03",
    name: "บ้านขาม",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "05",
    name: "กุดน้ำใส",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "06",
    name: "หนองโดน",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "07",
    name: "ละหาน",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "10",
    name: "หนองบัวใหญ่",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "11",
    name: "หนองบัวโคก",
    zipcode: "36220",
  },
  {
    jw_code: "36",
    amph_code: "06",
    tumbon_code: "13",
    name: "ส้มป่อย",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "07",
    tumbon_code: "01",
    name: "บ้านชวน",
    zipcode: "36160",
  },
  {
    jw_code: "36",
    amph_code: "07",
    tumbon_code: "02",
    name: "บ้านเพชร",
    zipcode: "36160",
  },
  {
    jw_code: "36",
    amph_code: "07",
    tumbon_code: "03",
    name: "บ้านตาล",
    zipcode: "36220",
  },
  {
    jw_code: "36",
    amph_code: "07",
    tumbon_code: "04",
    name: "หัวทะเล",
    zipcode: "36220",
  },
  {
    jw_code: "36",
    amph_code: "07",
    tumbon_code: "05",
    name: "โคกเริงรมย์",
    zipcode: "36160",
  },
  {
    jw_code: "36",
    amph_code: "07",
    tumbon_code: "06",
    name: "เกาะมะนาว",
    zipcode: "36160",
  },
  {
    jw_code: "36",
    amph_code: "07",
    tumbon_code: "07",
    name: "โคกเพชรพัฒนา",
    zipcode: "36160",
  },
  {
    jw_code: "36",
    amph_code: "08",
    tumbon_code: "01",
    name: "หนองบัวระเหว",
    zipcode: "36250",
  },
  {
    jw_code: "36",
    amph_code: "08",
    tumbon_code: "02",
    name: "วังตะเฆ่",
    zipcode: "36250",
  },
  {
    jw_code: "36",
    amph_code: "08",
    tumbon_code: "03",
    name: "ห้วยแย้",
    zipcode: "36250",
  },
  {
    jw_code: "36",
    amph_code: "08",
    tumbon_code: "04",
    name: "โคกสะอาด",
    zipcode: "36250",
  },
  {
    jw_code: "36",
    amph_code: "08",
    tumbon_code: "05",
    name: "โสกปลาดุก",
    zipcode: "36250",
  },
  {
    jw_code: "36",
    amph_code: "09",
    tumbon_code: "01",
    name: "วะตะแบก",
    zipcode: "36230",
  },
  {
    jw_code: "36",
    amph_code: "09",
    tumbon_code: "02",
    name: "ห้วยยายจิ๋ว",
    zipcode: "36230",
  },
  {
    jw_code: "36",
    amph_code: "09",
    tumbon_code: "03",
    name: "นายางกลัก",
    zipcode: "36230",
  },
  {
    jw_code: "36",
    amph_code: "09",
    tumbon_code: "04",
    name: "บ้านไร่",
    zipcode: "36230",
  },
  {
    jw_code: "36",
    amph_code: "09",
    tumbon_code: "05",
    name: "โป่งนก",
    zipcode: "36230",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "01",
    name: "ผักปัง",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "02",
    name: "กวางโจน",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "03",
    name: "หนองคอนไทย",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "04",
    name: "บ้านแก้ง",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "05",
    name: "กุดยม",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "06",
    name: "บ้านเพชร",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "07",
    name: "โคกสะอาด",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "08",
    name: "หนองตูม",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "09",
    name: "โอโล",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "10",
    name: "ธาตุทอง",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "10",
    tumbon_code: "11",
    name: "บ้านดอน",
    zipcode: "36110",
  },
  {
    jw_code: "36",
    amph_code: "11",
    tumbon_code: "01",
    name: "บ้านแท่น",
    zipcode: "36190",
  },
  {
    jw_code: "36",
    amph_code: "11",
    tumbon_code: "02",
    name: "สามสวน",
    zipcode: "36190",
  },
  {
    jw_code: "36",
    amph_code: "11",
    tumbon_code: "03",
    name: "สระพัง",
    zipcode: "36190",
  },
  {
    jw_code: "36",
    amph_code: "11",
    tumbon_code: "04",
    name: "บ้านเต่า",
    zipcode: "36190",
  },
  {
    jw_code: "36",
    amph_code: "11",
    tumbon_code: "05",
    name: "หนองคู",
    zipcode: "36190",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "01",
    name: "ช่องสามหมอ",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "02",
    name: "หนองขาม",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "03",
    name: "นาหนองทุ่ม",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "04",
    name: "บ้านแก้ง",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "05",
    name: "หนองสังข์",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "06",
    name: "หลุบคา",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "07",
    name: "โคกกุง",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "08",
    name: "เก่าย่าดี",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "09",
    name: "ท่ามะไฟหวาน",
    zipcode: "36150",
  },
  {
    jw_code: "36",
    amph_code: "12",
    tumbon_code: "10",
    name: "หนองไผ่",
    zipcode: "36240",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "01",
    name: "คอนสาร",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "02",
    name: "ทุ่งพระ",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "03",
    name: "โนนคูณ",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "04",
    name: "ห้วยยาง",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "05",
    name: "ทุ่งลุยลาย",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "06",
    name: "ดงบัง",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "07",
    name: "ทุ่งนาเลา",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "13",
    tumbon_code: "08",
    name: "ดงกลาง",
    zipcode: "36180",
  },
  {
    jw_code: "36",
    amph_code: "14",
    tumbon_code: "01",
    name: "บ้านเจียง",
    zipcode: "36260",
  },
  {
    jw_code: "36",
    amph_code: "14",
    tumbon_code: "02",
    name: "เจาทอง",
    zipcode: "36260",
  },
  {
    jw_code: "36",
    amph_code: "14",
    tumbon_code: "03",
    name: "วังทอง",
    zipcode: "36260",
  },
  {
    jw_code: "36",
    amph_code: "14",
    tumbon_code: "04",
    name: "แหลมทอง",
    zipcode: "36260",
  },
  {
    jw_code: "36",
    amph_code: "15",
    tumbon_code: "01",
    name: "หนองฉิม",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "15",
    tumbon_code: "02",
    name: "ตาเนิน",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "15",
    tumbon_code: "03",
    name: "กะฮาด",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "15",
    tumbon_code: "04",
    name: "รังงาม",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "16",
    tumbon_code: "01",
    name: "ซับใหญ่",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "16",
    tumbon_code: "02",
    name: "ท่ากูบ",
    zipcode: "36130",
  },
  {
    jw_code: "36",
    amph_code: "16",
    tumbon_code: "03",
    name: "ตะโกทอง",
    zipcode: "36130",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "01",
    name: "บุ่ง",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "02",
    name: "ไก่คำ",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "03",
    name: "นาจิก",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "04",
    name: "ปลาค้าว",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "05",
    name: "เหล่าพรวน",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "06",
    name: "สร้างนกทา",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "07",
    name: "คึมใหญ่",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "08",
    name: "นาผือ",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "09",
    name: "น้ำปลีก",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "10",
    name: "นาวัง",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "11",
    name: "นาหมอม้า",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "12",
    name: "โนนโพธิ์",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "13",
    name: "โนนหนามแท่ง",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "14",
    name: "ห้วยไร่",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "15",
    name: "หนองมะแซว",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "16",
    name: "กุดปลาดุก",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "17",
    name: "ดอนเมย",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "18",
    name: "นายม",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "01",
    tumbon_code: "19",
    name: "นาแต้",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "02",
    tumbon_code: "01",
    name: "ชานุมาน",
    zipcode: "37210",
  },
  {
    jw_code: "37",
    amph_code: "02",
    tumbon_code: "02",
    name: "โคกสาร",
    zipcode: "37210",
  },
  {
    jw_code: "37",
    amph_code: "02",
    tumbon_code: "03",
    name: "คำเขื่อนแก้ว",
    zipcode: "37210",
  },
  {
    jw_code: "37",
    amph_code: "02",
    tumbon_code: "04",
    name: "โคกก่ง",
    zipcode: "37210",
  },
  {
    jw_code: "37",
    amph_code: "02",
    tumbon_code: "05",
    name: "ป่าก่อ",
    zipcode: "37210",
  },
  {
    jw_code: "37",
    amph_code: "03",
    tumbon_code: "01",
    name: "หนองข่า",
    zipcode: "37110",
  },
  {
    jw_code: "37",
    amph_code: "03",
    tumbon_code: "02",
    name: "คำโพน",
    zipcode: "37110",
  },
  {
    jw_code: "37",
    amph_code: "03",
    tumbon_code: "03",
    name: "นาหว้า",
    zipcode: "37110",
  },
  {
    jw_code: "37",
    amph_code: "03",
    tumbon_code: "04",
    name: "ลือ",
    zipcode: "37110",
  },
  {
    jw_code: "37",
    amph_code: "03",
    tumbon_code: "05",
    name: "ห้วย",
    zipcode: "37110",
  },
  {
    jw_code: "37",
    amph_code: "03",
    tumbon_code: "06",
    name: "โนนงาม",
    zipcode: "37110",
  },
  {
    jw_code: "37",
    amph_code: "03",
    tumbon_code: "07",
    name: "นาป่าแซง",
    zipcode: "37110",
  },
  {
    jw_code: "37",
    amph_code: "04",
    tumbon_code: "01",
    name: "พนา",
    zipcode: "37180",
  },
  {
    jw_code: "37",
    amph_code: "04",
    tumbon_code: "02",
    name: "จานลาน",
    zipcode: "37180",
  },
  {
    jw_code: "37",
    amph_code: "04",
    tumbon_code: "03",
    name: "ไม้กลอน",
    zipcode: "37180",
  },
  {
    jw_code: "37",
    amph_code: "04",
    tumbon_code: "04",
    name: "พระเหลา",
    zipcode: "37180",
  },
  {
    jw_code: "37",
    amph_code: "05",
    tumbon_code: "01",
    name: "เสนางคนิคม",
    zipcode: "37290",
  },
  {
    jw_code: "37",
    amph_code: "05",
    tumbon_code: "02",
    name: "โพนทอง",
    zipcode: "37290",
  },
  {
    jw_code: "37",
    amph_code: "05",
    tumbon_code: "03",
    name: "ไร่สีสุก",
    zipcode: "37290",
  },
  {
    jw_code: "37",
    amph_code: "05",
    tumbon_code: "04",
    name: "นาเวียง",
    zipcode: "37290",
  },
  {
    jw_code: "37",
    amph_code: "05",
    tumbon_code: "05",
    name: "หนองไฮ",
    zipcode: "37290",
  },
  {
    jw_code: "37",
    amph_code: "05",
    tumbon_code: "06",
    name: "หนองสามสี",
    zipcode: "37290",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "01",
    name: "หัวตะพาน",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "02",
    name: "คำพระ",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "03",
    name: "เค็งใหญ่",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "04",
    name: "หนองแก้ว",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "05",
    name: "โพนเมืองน้อย",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "06",
    name: "สร้างถ่อน้อย",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "07",
    name: "จิกดู่",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "06",
    tumbon_code: "08",
    name: "รัตนวารี",
    zipcode: "37240",
  },
  {
    jw_code: "37",
    amph_code: "07",
    tumbon_code: "01",
    name: "อำนาจ",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "07",
    tumbon_code: "02",
    name: "ดงมะยาง",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "07",
    tumbon_code: "03",
    name: "เปือย",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "07",
    tumbon_code: "04",
    name: "ดงบัง",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "07",
    tumbon_code: "05",
    name: "ไร่ขี",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "07",
    tumbon_code: "06",
    name: "แมด",
    zipcode: "37000",
  },
  {
    jw_code: "37",
    amph_code: "07",
    tumbon_code: "07",
    name: "โคกกลาง",
    zipcode: "37000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "01",
    name: "บึงกาฬ",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "02",
    name: "โนนสมบูรณ์",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "03",
    name: "โนนสว่าง",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "04",
    name: "หอคำ",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "05",
    name: "หนองเลิง",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "06",
    name: "โคกก่อง",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "07",
    name: "นาสวรรค์",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "08",
    name: "ไคสี",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "09",
    name: "ชัยพร",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "10",
    name: "วิศิษฐ์",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "11",
    name: "คำนาดี",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "01",
    tumbon_code: "12",
    name: "โป่งเปือย",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "02",
    tumbon_code: "01",
    name: "ศรีชมภู",
    zipcode: "38180",
  },
  {
    jw_code: "38",
    amph_code: "02",
    tumbon_code: "02",
    name: "ดอนหญ้านาง",
    zipcode: "38180",
  },
  {
    jw_code: "38",
    amph_code: "02",
    tumbon_code: "03",
    name: "พรเจริญ",
    zipcode: "38180",
  },
  {
    jw_code: "38",
    amph_code: "02",
    tumbon_code: "04",
    name: "หนองหัวช้าง",
    zipcode: "38180",
  },
  {
    jw_code: "38",
    amph_code: "02",
    tumbon_code: "05",
    name: "วังชมภู",
    zipcode: "38180",
  },
  {
    jw_code: "38",
    amph_code: "02",
    tumbon_code: "06",
    name: "ป่าแฝก",
    zipcode: "38180",
  },
  {
    jw_code: "38",
    amph_code: "02",
    tumbon_code: "07",
    name: "ศรีสำราญ",
    zipcode: "38180",
  },
  {
    jw_code: "38",
    amph_code: "03",
    tumbon_code: "01",
    name: "โซ่",
    zipcode: "38170",
  },
  {
    jw_code: "38",
    amph_code: "03",
    tumbon_code: "02",
    name: "หนองพันทา",
    zipcode: "38170",
  },
  {
    jw_code: "38",
    amph_code: "03",
    tumbon_code: "03",
    name: "ศรีชมภู",
    zipcode: "38170",
  },
  {
    jw_code: "38",
    amph_code: "03",
    tumbon_code: "04",
    name: "คำแก้ว",
    zipcode: "38170",
  },
  {
    jw_code: "38",
    amph_code: "03",
    tumbon_code: "05",
    name: "บัวตูม",
    zipcode: "38170",
  },
  {
    jw_code: "38",
    amph_code: "03",
    tumbon_code: "06",
    name: "ถ้ำเจริญ",
    zipcode: "38170",
  },
  {
    jw_code: "38",
    amph_code: "03",
    tumbon_code: "07",
    name: "เหล่าทอง",
    zipcode: "38170",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "01",
    name: "เซกา",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "02",
    name: "ซาง",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "03",
    name: "ท่ากกแดง",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "04",
    name: "บ้านต้อง",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "05",
    name: "ป่งไฮ",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "06",
    name: "น้ำจั้น",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "07",
    name: "ท่าสะอาด",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "08",
    name: "หนองทุ่ม",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "04",
    tumbon_code: "09",
    name: "โสกก่าม",
    zipcode: "38150",
  },
  {
    jw_code: "38",
    amph_code: "05",
    tumbon_code: "01",
    name: "ปากคาด",
    zipcode: "38190",
  },
  {
    jw_code: "38",
    amph_code: "05",
    tumbon_code: "02",
    name: "หนองยอง",
    zipcode: "38190",
  },
  {
    jw_code: "38",
    amph_code: "05",
    tumbon_code: "03",
    name: "นากั้ง",
    zipcode: "38190",
  },
  {
    jw_code: "38",
    amph_code: "05",
    tumbon_code: "04",
    name: "โนนศิลา",
    zipcode: "38190",
  },
  {
    jw_code: "38",
    amph_code: "05",
    tumbon_code: "05",
    name: "สมสนุก",
    zipcode: "38190",
  },
  {
    jw_code: "38",
    amph_code: "05",
    tumbon_code: "06",
    name: "นาดง",
    zipcode: "38190",
  },
  {
    jw_code: "38",
    amph_code: "06",
    tumbon_code: "01",
    name: "บึงโขงหลง",
    zipcode: "38220",
  },
  {
    jw_code: "38",
    amph_code: "06",
    tumbon_code: "02",
    name: "โพธิ์หมากแข้ง",
    zipcode: "38220",
  },
  {
    jw_code: "38",
    amph_code: "06",
    tumbon_code: "03",
    name: "ดงบัง",
    zipcode: "38220",
  },
  {
    jw_code: "38",
    amph_code: "06",
    tumbon_code: "04",
    name: "ท่าดอกคำ",
    zipcode: "38220",
  },
  {
    jw_code: "38",
    amph_code: "07",
    tumbon_code: "01",
    name: "ศรีวิไล",
    zipcode: "38210",
  },
  {
    jw_code: "38",
    amph_code: "07",
    tumbon_code: "02",
    name: "ชุมภูพร",
    zipcode: "38210",
  },
  {
    jw_code: "38",
    amph_code: "07",
    tumbon_code: "03",
    name: "นาแสง",
    zipcode: "38210",
  },
  {
    jw_code: "38",
    amph_code: "07",
    tumbon_code: "04",
    name: "นาสะแบง",
    zipcode: "38210",
  },
  {
    jw_code: "38",
    amph_code: "07",
    tumbon_code: "05",
    name: "นาสิงห์",
    zipcode: "38210",
  },
  {
    jw_code: "38",
    amph_code: "08",
    tumbon_code: "01",
    name: "บุ่งคล้า",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "08",
    tumbon_code: "02",
    name: "หนองเดิ่น",
    zipcode: "38000",
  },
  {
    jw_code: "38",
    amph_code: "08",
    tumbon_code: "03",
    name: "โคกกว้าง",
    zipcode: "38000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "01",
    name: "หนองบัว",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "02",
    name: "หนองภัยศูนย์",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "03",
    name: "โพธิ์ชัย",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "04",
    name: "หนองสวรรค์",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "05",
    name: "หัวนา",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "06",
    name: "บ้านขาม",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "07",
    name: "นามะเฟือง",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "08",
    name: "บ้านพร้าว",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "09",
    name: "โนนขมิ้น",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "10",
    name: "ลำภู",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "11",
    name: "กุดจิก",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "12",
    name: "โนนทัน",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "13",
    name: "นาคำไฮ",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "14",
    name: "ป่าไม้งาม",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "01",
    tumbon_code: "15",
    name: "หนองหว้า",
    zipcode: "39000",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "01",
    name: "นากลาง",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "02",
    name: "ด่านช้าง",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "05",
    name: "กุดดินจี่",
    zipcode: "39350",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "06",
    name: "ฝั่งแดง",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "07",
    name: "เก่ากลอย",
    zipcode: "39350",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "09",
    name: "โนนเมือง",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "10",
    name: "อุทัยสวรรค์",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "11",
    name: "ดงสวรรค์",
    zipcode: "39350",
  },
  {
    jw_code: "39",
    amph_code: "02",
    tumbon_code: "13",
    name: "กุดแห่",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "01",
    name: "โนนสัง",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "02",
    name: "บ้านถิ่น",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "03",
    name: "หนองเรือ",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "04",
    name: "กุดดู่",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "05",
    name: "บ้านค้อ",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "06",
    name: "โนนเมือง",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "07",
    name: "โคกใหญ่",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "08",
    name: "โคกม่วง",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "09",
    name: "นิคมพัฒนา",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "03",
    tumbon_code: "10",
    name: "ปางกู่",
    zipcode: "39140",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "01",
    name: "เมืองใหม่",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "02",
    name: "ศรีบุญเรือง",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "03",
    name: "หนองบัวใต้",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "04",
    name: "กุดสะเทียน",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "05",
    name: "นากอก",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "06",
    name: "โนนสะอาด",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "07",
    name: "ยางหล่อ",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "08",
    name: "โนนม่วง",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "09",
    name: "หนองกุงแก้ว",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "10",
    name: "หนองแก",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "11",
    name: "ทรายทอง",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "04",
    tumbon_code: "12",
    name: "หันนางาม",
    zipcode: "39180",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "01",
    name: "นาสี",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "02",
    name: "บ้านโคก",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "03",
    name: "นาดี",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "04",
    name: "นาด่าน",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "05",
    name: "ดงมะไฟ",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "06",
    name: "สุวรรณคูหา",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "07",
    name: "บุญทัน",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "05",
    tumbon_code: "08",
    name: "กุดผึ้ง",
    zipcode: "39270",
  },
  {
    jw_code: "39",
    amph_code: "06",
    tumbon_code: "01",
    name: "นาเหล่า",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "06",
    tumbon_code: "02",
    name: "นาแก",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "06",
    tumbon_code: "03",
    name: "วังทอง",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "06",
    tumbon_code: "04",
    name: "วังปลาป้อม",
    zipcode: "39170",
  },
  {
    jw_code: "39",
    amph_code: "06",
    tumbon_code: "05",
    name: "เทพคีรี",
    zipcode: "39170",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "02",
    name: "สำราญ",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "03",
    name: "โคกสี",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "04",
    name: "ท่าพระ",
    zipcode: "40260",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านทุ่ม",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "06",
    name: "เมืองเก่า",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "07",
    name: "พระลับ",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "08",
    name: "สาวะถี",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "09",
    name: "บ้านหว้า",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "10",
    name: "บ้านค้อ",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "11",
    name: "แดงใหญ่",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "12",
    name: "ดอนช้าง",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "13",
    name: "ดอนหัน",
    zipcode: "40260",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "14",
    name: "ศิลา",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "15",
    name: "บ้านเป็ด",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "16",
    name: "หนองตูม",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "17",
    name: "บึงเนียม",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "01",
    tumbon_code: "18",
    name: "โนนท่อน",
    zipcode: "40000",
  },
  {
    jw_code: "40",
    amph_code: "02",
    tumbon_code: "01",
    name: "หนองบัว",
    zipcode: "40270",
  },
  {
    jw_code: "40",
    amph_code: "02",
    tumbon_code: "02",
    name: "ป่าหวายนั่ง",
    zipcode: "40270",
  },
  {
    jw_code: "40",
    amph_code: "02",
    tumbon_code: "03",
    name: "โนนฆ้อง",
    zipcode: "40270",
  },
  {
    jw_code: "40",
    amph_code: "02",
    tumbon_code: "04",
    name: "บ้านเหล่า",
    zipcode: "40270",
  },
  {
    jw_code: "40",
    amph_code: "02",
    tumbon_code: "05",
    name: "ป่ามะนาว",
    zipcode: "40270",
  },
  {
    jw_code: "40",
    amph_code: "02",
    tumbon_code: "06",
    name: "บ้านฝาง",
    zipcode: "40270",
  },
  {
    jw_code: "40",
    amph_code: "02",
    tumbon_code: "07",
    name: "โคกงาม",
    zipcode: "40270",
  },
  {
    jw_code: "40",
    amph_code: "03",
    tumbon_code: "01",
    name: "พระยืน",
    zipcode: "40320",
  },
  {
    jw_code: "40",
    amph_code: "03",
    tumbon_code: "02",
    name: "พระบุ",
    zipcode: "40320",
  },
  {
    jw_code: "40",
    amph_code: "03",
    tumbon_code: "03",
    name: "บ้านโต้น",
    zipcode: "40320",
  },
  {
    jw_code: "40",
    amph_code: "03",
    tumbon_code: "04",
    name: "หนองแวง",
    zipcode: "40320",
  },
  {
    jw_code: "40",
    amph_code: "03",
    tumbon_code: "05",
    name: "ขามป้อม",
    zipcode: "40320",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "01",
    name: "หนองเรือ",
    zipcode: "40210",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "02",
    name: "บ้านเม็ง",
    zipcode: "40210",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "03",
    name: "บ้านกง",
    zipcode: "40240",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "04",
    name: "ยางคำ",
    zipcode: "40240",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "05",
    name: "จระเข้",
    zipcode: "40240",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "06",
    name: "โนนทอง",
    zipcode: "40210",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "07",
    name: "กุดกว้าง",
    zipcode: "40210",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "08",
    name: "โนนทัน",
    zipcode: "40210",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "09",
    name: "โนนสะอาด",
    zipcode: "40290",
  },
  {
    jw_code: "40",
    amph_code: "04",
    tumbon_code: "10",
    name: "บ้านผือ",
    zipcode: "40240",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "01",
    name: "ชุมแพ",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "02",
    name: "โนนหัน",
    zipcode: "40290",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "03",
    name: "นาหนองทุ่ม",
    zipcode: "40290",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "04",
    name: "โนนอุดม",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "05",
    name: "ขัวเรียง",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "06",
    name: "หนองไผ่",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "07",
    name: "ไชยสอ",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "08",
    name: "วังหินลาด",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "09",
    name: "นาเพียง",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "10",
    name: "หนองเขียด",
    zipcode: "40290",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "11",
    name: "หนองเสาเล้า",
    zipcode: "40130",
  },
  {
    jw_code: "40",
    amph_code: "05",
    tumbon_code: "12",
    name: "โนนสะอาด",
    zipcode: "40290",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "01",
    name: "สีชมพู",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "02",
    name: "ศรีสุข",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "03",
    name: "นาจาน",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "04",
    name: "วังเพิ่ม",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "05",
    name: "ซำยาง",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "06",
    name: "หนองแดง",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "07",
    name: "ดงลาน",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "08",
    name: "บริบูรณ์",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "09",
    name: "บ้านใหม่",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "06",
    tumbon_code: "10",
    name: "ภูห่าน",
    zipcode: "40220",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "01",
    name: "น้ำพอง",
    zipcode: "40310",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "02",
    name: "วังชัย",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "03",
    name: "หนองกุง",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "04",
    name: "บัวใหญ่",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "05",
    name: "สะอาด",
    zipcode: "40310",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "06",
    name: "ม่วงหวาน",
    zipcode: "40310",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "07",
    name: "บ้านขาม",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "08",
    name: "บัวเงิน",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "09",
    name: "ทรายมูล",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "10",
    name: "ท่ากระเสริม",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "11",
    name: "พังทุย",
    zipcode: "40140",
  },
  {
    jw_code: "40",
    amph_code: "07",
    tumbon_code: "12",
    name: "กุดน้ำใส",
    zipcode: "40310",
  },
  {
    jw_code: "40",
    amph_code: "08",
    tumbon_code: "01",
    name: "โคกสูง",
    zipcode: "40250",
  },
  {
    jw_code: "40",
    amph_code: "08",
    tumbon_code: "02",
    name: "บ้านดง",
    zipcode: "40250",
  },
  {
    jw_code: "40",
    amph_code: "08",
    tumbon_code: "03",
    name: "เขื่อนอุบลรัตน์",
    zipcode: "40250",
  },
  {
    jw_code: "40",
    amph_code: "08",
    tumbon_code: "04",
    name: "นาคำ",
    zipcode: "40250",
  },
  {
    jw_code: "40",
    amph_code: "08",
    tumbon_code: "05",
    name: "ศรีสุขสำราญ",
    zipcode: "40250",
  },
  {
    jw_code: "40",
    amph_code: "08",
    tumbon_code: "06",
    name: "ทุ่งโป่ง",
    zipcode: "40250",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "01",
    name: "หนองโก",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "02",
    name: "หนองกุงใหญ่",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "05",
    name: "ห้วยโจด",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "06",
    name: "ห้วยยาง",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "07",
    name: "บ้านฝาง",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "09",
    name: "ดูนสาด",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "10",
    name: "หนองโน",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "11",
    name: "น้ำอ้อม",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "09",
    tumbon_code: "12",
    name: "หัวนาคำ",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "01",
    name: "บ้านไผ่",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "02",
    name: "ในเมือง",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "05",
    name: "เมืองเพีย",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "09",
    name: "บ้านลาน",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "10",
    name: "แคนเหนือ",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "11",
    name: "ภูเหล็ก",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "13",
    name: "ป่าปอ",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "14",
    name: "หินตั้ง",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "16",
    name: "หนองน้ำใส",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "10",
    tumbon_code: "17",
    name: "หัวหนอง",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "11",
    tumbon_code: "01",
    name: "เปือยน้อย",
    zipcode: "40340",
  },
  {
    jw_code: "40",
    amph_code: "11",
    tumbon_code: "02",
    name: "วังม่วง",
    zipcode: "40340",
  },
  {
    jw_code: "40",
    amph_code: "11",
    tumbon_code: "03",
    name: "ขามป้อม",
    zipcode: "40340",
  },
  {
    jw_code: "40",
    amph_code: "11",
    tumbon_code: "04",
    name: "สระแก้ว",
    zipcode: "40340",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "01",
    name: "เมืองพล",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "03",
    name: "โจดหนองแก",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "04",
    name: "เก่างิ้ว",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "05",
    name: "หนองมะเขือ",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "06",
    name: "หนองแวงโสกพระ",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "07",
    name: "เพ็กใหญ่",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "08",
    name: "โคกสง่า",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "09",
    name: "หนองแวงนางเบ้า",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "10",
    name: "ลอมคอม",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "11",
    name: "โนนข่า",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "12",
    name: "โสกนกเต็น",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "12",
    tumbon_code: "13",
    name: "หัวทุ่ง",
    zipcode: "40120",
  },
  {
    jw_code: "40",
    amph_code: "13",
    tumbon_code: "01",
    name: "คอนฉิม",
    zipcode: "40330",
  },
  {
    jw_code: "40",
    amph_code: "13",
    tumbon_code: "02",
    name: "ใหม่นาเพียง",
    zipcode: "40330",
  },
  {
    jw_code: "40",
    amph_code: "13",
    tumbon_code: "03",
    name: "โนนทอง",
    zipcode: "40330",
  },
  {
    jw_code: "40",
    amph_code: "13",
    tumbon_code: "04",
    name: "แวงใหญ่",
    zipcode: "40330",
  },
  {
    jw_code: "40",
    amph_code: "13",
    tumbon_code: "05",
    name: "โนนสะอาด",
    zipcode: "40290",
  },
  {
    jw_code: "40",
    amph_code: "14",
    tumbon_code: "01",
    name: "แวงน้อย",
    zipcode: "40230",
  },
  {
    jw_code: "40",
    amph_code: "14",
    tumbon_code: "02",
    name: "ก้านเหลือง",
    zipcode: "40230",
  },
  {
    jw_code: "40",
    amph_code: "14",
    tumbon_code: "03",
    name: "ท่านางแนว",
    zipcode: "40230",
  },
  {
    jw_code: "40",
    amph_code: "14",
    tumbon_code: "04",
    name: "ละหานนา",
    zipcode: "40230",
  },
  {
    jw_code: "40",
    amph_code: "14",
    tumbon_code: "05",
    name: "ท่าวัด",
    zipcode: "40230",
  },
  {
    jw_code: "40",
    amph_code: "14",
    tumbon_code: "06",
    name: "ทางขวาง",
    zipcode: "40230",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "01",
    name: "หนองสองห้อง",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "02",
    name: "คึมชาด",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "03",
    name: "โนนธาตุ",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "04",
    name: "ตะกั่วป่า",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "05",
    name: "สำโรง",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "06",
    name: "หนองเม็ก",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "07",
    name: "ดอนดู่",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "08",
    name: "ดงเค็ง",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "09",
    name: "หันโจด",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "10",
    name: "ดอนดั่ง",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "11",
    name: "วังหิน",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "15",
    tumbon_code: "12",
    name: "หนองไผ่ล้อม",
    zipcode: "40190",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "01",
    name: "บ้านเรือ",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "04",
    name: "หว้าทอง",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "05",
    name: "กุดขอนแก่น",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "06",
    name: "นาชุมแสง",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "07",
    name: "นาหว้า",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "10",
    name: "หนองกุงธนสาร",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "12",
    name: "หนองกุงเซิน",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "13",
    name: "สงเปือย",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "14",
    name: "ทุ่งชมพู",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "16",
    name: "ดินดำ",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "16",
    tumbon_code: "17",
    name: "ภูเวียง",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "01",
    name: "กุดเค้า",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "02",
    name: "สวนหม่อน",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "03",
    name: "หนองแปน",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "04",
    name: "โพนเพ็ก",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "05",
    name: "คำแคน",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "06",
    name: "นาข่า",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "07",
    name: "นางาม",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "17",
    tumbon_code: "10",
    name: "ท่าศาลา",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "01",
    name: "ชนบท",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "02",
    name: "กุดเพียขอม",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "03",
    name: "วังแสง",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "04",
    name: "ห้วยแก",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "05",
    name: "บ้านแท่น",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "06",
    name: "ศรีบุญเรือง",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "07",
    name: "โนนพะยอม",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "18",
    tumbon_code: "08",
    name: "ปอแดง",
    zipcode: "40180",
  },
  {
    jw_code: "40",
    amph_code: "19",
    tumbon_code: "01",
    name: "เขาสวนกวาง",
    zipcode: "40280",
  },
  {
    jw_code: "40",
    amph_code: "19",
    tumbon_code: "02",
    name: "ดงเมืองแอม",
    zipcode: "40280",
  },
  {
    jw_code: "40",
    amph_code: "19",
    tumbon_code: "03",
    name: "นางิ้ว",
    zipcode: "40280",
  },
  {
    jw_code: "40",
    amph_code: "19",
    tumbon_code: "04",
    name: "โนนสมบูรณ์",
    zipcode: "40280",
  },
  {
    jw_code: "40",
    amph_code: "19",
    tumbon_code: "05",
    name: "คำม่วง",
    zipcode: "40280",
  },
  {
    jw_code: "40",
    amph_code: "20",
    tumbon_code: "01",
    name: "โนนคอม",
    zipcode: "40350",
  },
  {
    jw_code: "40",
    amph_code: "20",
    tumbon_code: "02",
    name: "นาฝาย",
    zipcode: "40350",
  },
  {
    jw_code: "40",
    amph_code: "20",
    tumbon_code: "03",
    name: "ภูผาม่าน",
    zipcode: "40350",
  },
  {
    jw_code: "40",
    amph_code: "20",
    tumbon_code: "04",
    name: "วังสวาบ",
    zipcode: "40350",
  },
  {
    jw_code: "40",
    amph_code: "20",
    tumbon_code: "05",
    name: "ห้วยม่วง",
    zipcode: "40350",
  },
  {
    jw_code: "40",
    amph_code: "21",
    tumbon_code: "01",
    name: "กระนวน",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "21",
    tumbon_code: "02",
    name: "คำแมด",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "21",
    tumbon_code: "03",
    name: "บ้านโนน",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "21",
    tumbon_code: "04",
    name: "คูคำ",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "21",
    tumbon_code: "05",
    name: "ห้วยเตย",
    zipcode: "40170",
  },
  {
    jw_code: "40",
    amph_code: "22",
    tumbon_code: "01",
    name: "บ้านโคก",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "22",
    tumbon_code: "02",
    name: "โพธิ์ไชย",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "22",
    tumbon_code: "03",
    name: "ซับสมบูรณ์",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "22",
    tumbon_code: "04",
    name: "นาแพง",
    zipcode: "40160",
  },
  {
    jw_code: "40",
    amph_code: "23",
    tumbon_code: "01",
    name: "กุดธาตุ",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "23",
    tumbon_code: "02",
    name: "บ้านโคก",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "23",
    tumbon_code: "03",
    name: "ขนวน",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "24",
    tumbon_code: "01",
    name: "บ้านแฮด",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "24",
    tumbon_code: "02",
    name: "โคกสำราญ",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "24",
    tumbon_code: "03",
    name: "โนนสมบูรณ์",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "24",
    tumbon_code: "04",
    name: "หนองแซง",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "25",
    tumbon_code: "01",
    name: "โนนศิลา",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "25",
    tumbon_code: "02",
    name: "หนองปลาหมอ",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "25",
    tumbon_code: "03",
    name: "บ้านหัน",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "25",
    tumbon_code: "04",
    name: "เปือยใหญ่",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "25",
    tumbon_code: "05",
    name: "โนนแดง",
    zipcode: "40110",
  },
  {
    jw_code: "40",
    amph_code: "29",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "29",
    tumbon_code: "02",
    name: "เมืองเก่าพัฒนา",
    zipcode: "40150",
  },
  {
    jw_code: "40",
    amph_code: "29",
    tumbon_code: "03",
    name: "เขาน้อย",
    zipcode: "40150",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "01",
    name: "หมากแข้ง",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "02",
    name: "นิคมสงเคราะห์",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านขาว",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "04",
    name: "หนองบัว",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านตาด",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "06",
    name: "โนนสูง",
    zipcode: "41330",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "07",
    name: "หมูม่น",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "08",
    name: "เชียงยืน",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "09",
    name: "หนองนาคำ",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "10",
    name: "กุดสระ",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "11",
    name: "นาดี",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "12",
    name: "บ้านเลื่อม",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "13",
    name: "เชียงพิณ",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "14",
    name: "สามพร้าว",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "15",
    name: "หนองไฮ",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "16",
    name: "นาข่า",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "17",
    name: "บ้านจั่น",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "18",
    name: "หนองขอนกว้าง",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "19",
    name: "โคกสะอาด",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "20",
    name: "นากว้าง",
    zipcode: "41000",
  },
  {
    jw_code: "41",
    amph_code: "01",
    tumbon_code: "21",
    name: "หนองไผ่",
    zipcode: "41330",
  },
  {
    jw_code: "41",
    amph_code: "02",
    tumbon_code: "01",
    name: "กุดจับ",
    zipcode: "41250",
  },
  {
    jw_code: "41",
    amph_code: "02",
    tumbon_code: "02",
    name: "ปะโค",
    zipcode: "41370",
  },
  {
    jw_code: "41",
    amph_code: "02",
    tumbon_code: "03",
    name: "ขอนยูง",
    zipcode: "41250",
  },
  {
    jw_code: "41",
    amph_code: "02",
    tumbon_code: "04",
    name: "เชียงเพ็ง",
    zipcode: "41250",
  },
  {
    jw_code: "41",
    amph_code: "02",
    tumbon_code: "05",
    name: "สร้างก่อ",
    zipcode: "41250",
  },
  {
    jw_code: "41",
    amph_code: "02",
    tumbon_code: "06",
    name: "เมืองเพีย",
    zipcode: "41250",
  },
  {
    jw_code: "41",
    amph_code: "02",
    tumbon_code: "07",
    name: "ตาลเลียน",
    zipcode: "41250",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "01",
    name: "หมากหญ้า",
    zipcode: "41360",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "02",
    name: "หนองอ้อ",
    zipcode: "41220",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "03",
    name: "อูบมุง",
    zipcode: "41220",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "04",
    name: "กุดหมากไฟ",
    zipcode: "41220",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "05",
    name: "น้ำพ่น",
    zipcode: "41360",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "06",
    name: "หนองบัวบาน",
    zipcode: "41360",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "07",
    name: "โนนหวาย",
    zipcode: "41220",
  },
  {
    jw_code: "41",
    amph_code: "03",
    tumbon_code: "08",
    name: "หนองวัวซอ",
    zipcode: "41360",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "01",
    name: "ตูมใต้",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "02",
    name: "พันดอน",
    zipcode: "41370",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "03",
    name: "เวียงคำ",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "04",
    name: "แชแล",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "06",
    name: "เชียงแหว",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "07",
    name: "ห้วยเกิ้ง",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "09",
    name: "เสอเพลอ",
    zipcode: "41370",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "10",
    name: "สีออ",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "11",
    name: "ปะโค",
    zipcode: "41370",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "13",
    name: "ผาสุก",
    zipcode: "41370",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "14",
    name: "ท่าลี่",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "15",
    name: "กุมภวาปี",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "04",
    tumbon_code: "16",
    name: "หนองหว้า",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "05",
    tumbon_code: "01",
    name: "โนนสะอาด",
    zipcode: "41240",
  },
  {
    jw_code: "41",
    amph_code: "05",
    tumbon_code: "02",
    name: "บุ่งแก้ว",
    zipcode: "41240",
  },
  {
    jw_code: "41",
    amph_code: "05",
    tumbon_code: "03",
    name: "โพธิ์ศรีสำราญ",
    zipcode: "41240",
  },
  {
    jw_code: "41",
    amph_code: "05",
    tumbon_code: "04",
    name: "ทมนางาม",
    zipcode: "41240",
  },
  {
    jw_code: "41",
    amph_code: "05",
    tumbon_code: "05",
    name: "หนองกุงศรี",
    zipcode: "41240",
  },
  {
    jw_code: "41",
    amph_code: "05",
    tumbon_code: "06",
    name: "โคกกลาง",
    zipcode: "41240",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "01",
    name: "หนองหาน",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "02",
    name: "หนองเม็ก",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "05",
    name: "พังงู",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "06",
    name: "สะแบง",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "07",
    name: "สร้อยพร้าว",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "09",
    name: "บ้านเชียง",
    zipcode: "41320",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "10",
    name: "บ้านยา",
    zipcode: "41320",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "11",
    name: "โพนงาม",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "12",
    name: "ผักตบ",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "14",
    name: "หนองไผ่",
    zipcode: "41330",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "17",
    name: "ดอนหายโศก",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "06",
    tumbon_code: "18",
    name: "หนองสระปลา",
    zipcode: "41320",
  },
  {
    jw_code: "41",
    amph_code: "07",
    tumbon_code: "01",
    name: "ทุ่งฝน",
    zipcode: "41310",
  },
  {
    jw_code: "41",
    amph_code: "07",
    tumbon_code: "02",
    name: "ทุ่งใหญ่",
    zipcode: "41310",
  },
  {
    jw_code: "41",
    amph_code: "07",
    tumbon_code: "03",
    name: "นาชุมแสง",
    zipcode: "41310",
  },
  {
    jw_code: "41",
    amph_code: "07",
    tumbon_code: "04",
    name: "นาทม",
    zipcode: "41310",
  },
  {
    jw_code: "41",
    amph_code: "08",
    tumbon_code: "01",
    name: "ไชยวาน",
    zipcode: "41290",
  },
  {
    jw_code: "41",
    amph_code: "08",
    tumbon_code: "02",
    name: "หนองหลัก",
    zipcode: "41290",
  },
  {
    jw_code: "41",
    amph_code: "08",
    tumbon_code: "03",
    name: "คำเลาะ",
    zipcode: "41290",
  },
  {
    jw_code: "41",
    amph_code: "08",
    tumbon_code: "04",
    name: "โพนสูง",
    zipcode: "41290",
  },
  {
    jw_code: "41",
    amph_code: "09",
    tumbon_code: "01",
    name: "ศรีธาตุ",
    zipcode: "41230",
  },
  {
    jw_code: "41",
    amph_code: "09",
    tumbon_code: "02",
    name: "จำปี",
    zipcode: "41230",
  },
  {
    jw_code: "41",
    amph_code: "09",
    tumbon_code: "03",
    name: "บ้านโปร่ง",
    zipcode: "41230",
  },
  {
    jw_code: "41",
    amph_code: "09",
    tumbon_code: "04",
    name: "หัวนาคำ",
    zipcode: "41230",
  },
  {
    jw_code: "41",
    amph_code: "09",
    tumbon_code: "05",
    name: "หนองนกเขียน",
    zipcode: "41230",
  },
  {
    jw_code: "41",
    amph_code: "09",
    tumbon_code: "06",
    name: "นายูง",
    zipcode: "41230",
  },
  {
    jw_code: "41",
    amph_code: "09",
    tumbon_code: "07",
    name: "ตาดทอง",
    zipcode: "41230",
  },
  {
    jw_code: "41",
    amph_code: "10",
    tumbon_code: "01",
    name: "หนองกุงทับม้า",
    zipcode: "41280",
  },
  {
    jw_code: "41",
    amph_code: "10",
    tumbon_code: "02",
    name: "หนองหญ้าไซ",
    zipcode: "41280",
  },
  {
    jw_code: "41",
    amph_code: "10",
    tumbon_code: "03",
    name: "บะยาว",
    zipcode: "41280",
  },
  {
    jw_code: "41",
    amph_code: "10",
    tumbon_code: "04",
    name: "ผาสุก",
    zipcode: "41370",
  },
  {
    jw_code: "41",
    amph_code: "10",
    tumbon_code: "05",
    name: "คำโคกสูง",
    zipcode: "41280",
  },
  {
    jw_code: "41",
    amph_code: "10",
    tumbon_code: "06",
    name: "วังสามหมอ",
    zipcode: "41280",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "01",
    name: "ศรีสุทโธ",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "02",
    name: "บ้านดุง",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "03",
    name: "ดงเย็น",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "04",
    name: "โพนสูง",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "05",
    name: "อ้อมกอ",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "06",
    name: "บ้านจันทน์",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "07",
    name: "บ้านชัย",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "08",
    name: "นาไหม",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "09",
    name: "ถ่อนนาลับ",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "10",
    name: "วังทอง",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "11",
    name: "บ้านม่วง",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "12",
    name: "บ้านตาด",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "11",
    tumbon_code: "13",
    name: "นาคำ",
    zipcode: "41190",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "01",
    name: "บ้านผือ",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "02",
    name: "หายโศก",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "03",
    name: "เขือน้ำ",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "04",
    name: "คำบง",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "05",
    name: "โนนทอง",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "06",
    name: "ข้าวสาร",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "07",
    name: "จำปาโมง",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "08",
    name: "กลางใหญ่",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "09",
    name: "เมืองพาน",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "10",
    name: "คำด้วง",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "11",
    name: "หนองหัวคู",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "12",
    name: "บ้านค้อ",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "17",
    tumbon_code: "13",
    name: "หนองแวง",
    zipcode: "41160",
  },
  {
    jw_code: "41",
    amph_code: "18",
    tumbon_code: "01",
    name: "นางัว",
    zipcode: "41210",
  },
  {
    jw_code: "41",
    amph_code: "18",
    tumbon_code: "02",
    name: "น้ำโสม",
    zipcode: "41210",
  },
  {
    jw_code: "41",
    amph_code: "18",
    tumbon_code: "05",
    name: "หนองแวง",
    zipcode: "41210",
  },
  {
    jw_code: "41",
    amph_code: "18",
    tumbon_code: "06",
    name: "บ้านหยวก",
    zipcode: "41210",
  },
  {
    jw_code: "41",
    amph_code: "18",
    tumbon_code: "07",
    name: "โสมเยี่ยม",
    zipcode: "41210",
  },
  {
    jw_code: "41",
    amph_code: "18",
    tumbon_code: "10",
    name: "ศรีสำราญ",
    zipcode: "41210",
  },
  {
    jw_code: "41",
    amph_code: "18",
    tumbon_code: "12",
    name: "สามัคคี",
    zipcode: "41210",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "01",
    name: "เพ็ญ",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "02",
    name: "บ้านธาตุ",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "03",
    name: "นาพู่",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "04",
    name: "เชียงหวาง",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "05",
    name: "สุมเส้า",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "06",
    name: "นาบัว",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "07",
    name: "บ้านเหล่า",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "08",
    name: "จอมศรี",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "09",
    name: "เตาไห",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "10",
    name: "โคกกลาง",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "19",
    tumbon_code: "11",
    name: "สร้างแป้น",
    zipcode: "41150",
  },
  {
    jw_code: "41",
    amph_code: "20",
    tumbon_code: "01",
    name: "สร้างคอม",
    zipcode: "41260",
  },
  {
    jw_code: "41",
    amph_code: "20",
    tumbon_code: "02",
    name: "เชียงดา",
    zipcode: "41260",
  },
  {
    jw_code: "41",
    amph_code: "20",
    tumbon_code: "03",
    name: "บ้านยวด",
    zipcode: "41260",
  },
  {
    jw_code: "41",
    amph_code: "20",
    tumbon_code: "04",
    name: "บ้านโคก",
    zipcode: "41260",
  },
  {
    jw_code: "41",
    amph_code: "20",
    tumbon_code: "05",
    name: "นาสะอาด",
    zipcode: "41260",
  },
  {
    jw_code: "41",
    amph_code: "20",
    tumbon_code: "06",
    name: "บ้านหินโงม",
    zipcode: "41260",
  },
  {
    jw_code: "41",
    amph_code: "21",
    tumbon_code: "01",
    name: "หนองแสง",
    zipcode: "41340",
  },
  {
    jw_code: "41",
    amph_code: "21",
    tumbon_code: "02",
    name: "แสงสว่าง",
    zipcode: "41340",
  },
  {
    jw_code: "41",
    amph_code: "21",
    tumbon_code: "03",
    name: "นาดี",
    zipcode: "41340",
  },
  {
    jw_code: "41",
    amph_code: "21",
    tumbon_code: "04",
    name: "ทับกุง",
    zipcode: "41340",
  },
  {
    jw_code: "41",
    amph_code: "22",
    tumbon_code: "01",
    name: "นายูง",
    zipcode: "41380",
  },
  {
    jw_code: "41",
    amph_code: "22",
    tumbon_code: "02",
    name: "บ้านก้อง",
    zipcode: "41380",
  },
  {
    jw_code: "41",
    amph_code: "22",
    tumbon_code: "03",
    name: "นาแค",
    zipcode: "41380",
  },
  {
    jw_code: "41",
    amph_code: "22",
    tumbon_code: "04",
    name: "โนนทอง",
    zipcode: "41380",
  },
  {
    jw_code: "41",
    amph_code: "23",
    tumbon_code: "01",
    name: "บ้านแดง",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "23",
    tumbon_code: "02",
    name: "นาทราย",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "23",
    tumbon_code: "03",
    name: "ดอนกลอย",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "24",
    tumbon_code: "01",
    name: "บ้านจีต",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "24",
    tumbon_code: "02",
    name: "โนนทองอินทร์",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "24",
    tumbon_code: "03",
    name: "ค้อใหญ่",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "24",
    tumbon_code: "04",
    name: "คอนสาย",
    zipcode: "41130",
  },
  {
    jw_code: "41",
    amph_code: "25",
    tumbon_code: "01",
    name: "นาม่วง",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "25",
    tumbon_code: "02",
    name: "ห้วยสามพาด",
    zipcode: "41110",
  },
  {
    jw_code: "41",
    amph_code: "25",
    tumbon_code: "03",
    name: "อุ่มจาน",
    zipcode: "41110",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "01",
    name: "กุดป่อง",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "02",
    name: "เมือง",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "03",
    name: "นาอ้อ",
    zipcode: "42100",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "04",
    name: "กกดู่",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "05",
    name: "น้ำหมาน",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "06",
    name: "เสี้ยว",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "07",
    name: "นาอาน",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "08",
    name: "นาโป่ง",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "09",
    name: "นาดินดำ",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "10",
    name: "น้ำสวย",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "11",
    name: "ชัยพฤกษ์",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "12",
    name: "นาแขม",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "13",
    name: "ศรีสองรัก",
    zipcode: "42100",
  },
  {
    jw_code: "42",
    amph_code: "01",
    tumbon_code: "14",
    name: "กกทอง",
    zipcode: "42000",
  },
  {
    jw_code: "42",
    amph_code: "02",
    tumbon_code: "01",
    name: "นาด้วง",
    zipcode: "42210",
  },
  {
    jw_code: "42",
    amph_code: "02",
    tumbon_code: "02",
    name: "นาดอกคำ",
    zipcode: "42210",
  },
  {
    jw_code: "42",
    amph_code: "02",
    tumbon_code: "03",
    name: "ท่าสะอาด",
    zipcode: "42210",
  },
  {
    jw_code: "42",
    amph_code: "02",
    tumbon_code: "04",
    name: "ท่าสวรรค์",
    zipcode: "42210",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "01",
    name: "เชียงคาน",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "02",
    name: "ธาตุ",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "03",
    name: "นาซ่าว",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "04",
    name: "เขาแก้ว",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "05",
    name: "ปากตม",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "06",
    name: "บุฮม",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "07",
    name: "จอมศรี",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "03",
    tumbon_code: "08",
    name: "หาดทรายขาว",
    zipcode: "42110",
  },
  {
    jw_code: "42",
    amph_code: "04",
    tumbon_code: "01",
    name: "ปากชม",
    zipcode: "42150",
  },
  {
    jw_code: "42",
    amph_code: "04",
    tumbon_code: "02",
    name: "เชียงกลม",
    zipcode: "42150",
  },
  {
    jw_code: "42",
    amph_code: "04",
    tumbon_code: "03",
    name: "หาดคัมภีร์",
    zipcode: "42150",
  },
  {
    jw_code: "42",
    amph_code: "04",
    tumbon_code: "04",
    name: "ห้วยบ่อซืน",
    zipcode: "42150",
  },
  {
    jw_code: "42",
    amph_code: "04",
    tumbon_code: "05",
    name: "ห้วยพิชัย",
    zipcode: "42150",
  },
  {
    jw_code: "42",
    amph_code: "04",
    tumbon_code: "06",
    name: "ชมเจริญ",
    zipcode: "42150",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "01",
    name: "ด่านซ้าย",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "02",
    name: "ปากหมัน",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "03",
    name: "นาดี",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "04",
    name: "โคกงาม",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "05",
    name: "โพนสูง",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "06",
    name: "อิปุ่ม",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "07",
    name: "กกสะทอน",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "08",
    name: "โป่ง",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "09",
    name: "วังยาว",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "05",
    tumbon_code: "10",
    name: "นาหอ",
    zipcode: "42120",
  },
  {
    jw_code: "42",
    amph_code: "06",
    tumbon_code: "01",
    name: "นาแห้ว",
    zipcode: "42170",
  },
  {
    jw_code: "42",
    amph_code: "06",
    tumbon_code: "02",
    name: "แสงภา",
    zipcode: "42170",
  },
  {
    jw_code: "42",
    amph_code: "06",
    tumbon_code: "03",
    name: "นาพึง",
    zipcode: "42170",
  },
  {
    jw_code: "42",
    amph_code: "06",
    tumbon_code: "04",
    name: "นามาลา",
    zipcode: "42170",
  },
  {
    jw_code: "42",
    amph_code: "06",
    tumbon_code: "05",
    name: "เหล่ากอหก",
    zipcode: "42170",
  },
  {
    jw_code: "42",
    amph_code: "07",
    tumbon_code: "01",
    name: "หนองบัว",
    zipcode: "42160",
  },
  {
    jw_code: "42",
    amph_code: "07",
    tumbon_code: "02",
    name: "ท่าศาลา",
    zipcode: "42160",
  },
  {
    jw_code: "42",
    amph_code: "07",
    tumbon_code: "03",
    name: "ร่องจิก",
    zipcode: "42160",
  },
  {
    jw_code: "42",
    amph_code: "07",
    tumbon_code: "04",
    name: "ปลาบ่า",
    zipcode: "42160",
  },
  {
    jw_code: "42",
    amph_code: "07",
    tumbon_code: "05",
    name: "ลาดค่าง",
    zipcode: "42160",
  },
  {
    jw_code: "42",
    amph_code: "07",
    tumbon_code: "06",
    name: "สานตม",
    zipcode: "42160",
  },
  {
    jw_code: "42",
    amph_code: "08",
    tumbon_code: "01",
    name: "ท่าลี่",
    zipcode: "42140",
  },
  {
    jw_code: "42",
    amph_code: "08",
    tumbon_code: "02",
    name: "หนองผือ",
    zipcode: "42140",
  },
  {
    jw_code: "42",
    amph_code: "08",
    tumbon_code: "03",
    name: "อาฮี",
    zipcode: "42140",
  },
  {
    jw_code: "42",
    amph_code: "08",
    tumbon_code: "04",
    name: "น้ำแคม",
    zipcode: "42140",
  },
  {
    jw_code: "42",
    amph_code: "08",
    tumbon_code: "05",
    name: "โคกใหญ่",
    zipcode: "42140",
  },
  {
    jw_code: "42",
    amph_code: "08",
    tumbon_code: "06",
    name: "น้ำทูน",
    zipcode: "42140",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "01",
    name: "วังสะพุง",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "02",
    name: "ทรายขาว",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "03",
    name: "หนองหญ้าปล้อง",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "04",
    name: "หนองงิ้ว",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "05",
    name: "ปากปวน",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "06",
    name: "ผาน้อย",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "10",
    name: "ผาบิ้ง",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "11",
    name: "เขาหลวง",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "12",
    name: "โคกขมิ้น",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "09",
    tumbon_code: "13",
    name: "ศรีสงคราม",
    zipcode: "42130",
  },
  {
    jw_code: "42",
    amph_code: "10",
    tumbon_code: "01",
    name: "ศรีฐาน",
    zipcode: "42180",
  },
  {
    jw_code: "42",
    amph_code: "10",
    tumbon_code: "05",
    name: "ผานกเค้า",
    zipcode: "42180",
  },
  {
    jw_code: "42",
    amph_code: "10",
    tumbon_code: "07",
    name: "ภูกระดึง",
    zipcode: "42180",
  },
  {
    jw_code: "42",
    amph_code: "10",
    tumbon_code: "10",
    name: "ห้วยส้ม",
    zipcode: "42180",
  },
  {
    jw_code: "42",
    amph_code: "11",
    tumbon_code: "01",
    name: "ภูหอ",
    zipcode: "42230",
  },
  {
    jw_code: "42",
    amph_code: "11",
    tumbon_code: "02",
    name: "หนองคัน",
    zipcode: "42230",
  },
  {
    jw_code: "42",
    amph_code: "11",
    tumbon_code: "04",
    name: "ห้วยสีเสียด",
    zipcode: "42230",
  },
  {
    jw_code: "42",
    amph_code: "11",
    tumbon_code: "05",
    name: "เลยวังไสย์",
    zipcode: "42230",
  },
  {
    jw_code: "42",
    amph_code: "11",
    tumbon_code: "06",
    name: "แก่งศรีภูมิ",
    zipcode: "42230",
  },
  {
    jw_code: "42",
    amph_code: "12",
    tumbon_code: "01",
    name: "ผาขาว",
    zipcode: "42240",
  },
  {
    jw_code: "42",
    amph_code: "12",
    tumbon_code: "02",
    name: "ท่าช้างคล้อง",
    zipcode: "42240",
  },
  {
    jw_code: "42",
    amph_code: "12",
    tumbon_code: "03",
    name: "โนนปอแดง",
    zipcode: "42240",
  },
  {
    jw_code: "42",
    amph_code: "12",
    tumbon_code: "04",
    name: "โนนป่าซาง",
    zipcode: "42240",
  },
  {
    jw_code: "42",
    amph_code: "12",
    tumbon_code: "05",
    name: "บ้านเพิ่ม",
    zipcode: "42240",
  },
  {
    jw_code: "42",
    amph_code: "13",
    tumbon_code: "01",
    name: "เอราวัณ",
    zipcode: "42220",
  },
  {
    jw_code: "42",
    amph_code: "13",
    tumbon_code: "02",
    name: "ผาอินทร์แปลง",
    zipcode: "42220",
  },
  {
    jw_code: "42",
    amph_code: "13",
    tumbon_code: "03",
    name: "ผาสามยอด",
    zipcode: "42220",
  },
  {
    jw_code: "42",
    amph_code: "13",
    tumbon_code: "04",
    name: "ทรัพย์ไพวัลย์",
    zipcode: "42220",
  },
  {
    jw_code: "42",
    amph_code: "14",
    tumbon_code: "01",
    name: "หนองหิน",
    zipcode: "42190",
  },
  {
    jw_code: "42",
    amph_code: "14",
    tumbon_code: "02",
    name: "ตาดข่า",
    zipcode: "42190",
  },
  {
    jw_code: "42",
    amph_code: "14",
    tumbon_code: "03",
    name: "ปวนพุ",
    zipcode: "42190",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "02",
    name: "มีชัย",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "03",
    name: "โพธิ์ชัย",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "04",
    name: "กวนวัน",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "05",
    name: "เวียงคุก",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "06",
    name: "วัดธาตุ",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "07",
    name: "หาดคำ",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "08",
    name: "หินโงม",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "09",
    name: "บ้านเดื่อ",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "10",
    name: "ค่ายบกหวาน",
    zipcode: "43100",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "11",
    name: "โพนสว่าง",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "13",
    name: "พระธาตุบังพวน",
    zipcode: "43100",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "16",
    name: "หนองกอมเกาะ",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "17",
    name: "ปะโค",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "18",
    name: "เมืองหมี",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "01",
    tumbon_code: "19",
    name: "สีกาย",
    zipcode: "43000",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "01",
    name: "ท่าบ่อ",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "02",
    name: "น้ำโมง",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "03",
    name: "กองนาง",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "04",
    name: "โคกคอน",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "05",
    name: "บ้านเดื่อ",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "06",
    name: "บ้านถ่อน",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "07",
    name: "บ้านว่าน",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "08",
    name: "นาข่า",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "09",
    name: "โพนสา",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "02",
    tumbon_code: "10",
    name: "หนองนาง",
    zipcode: "43110",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "01",
    name: "จุมพล",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "02",
    name: "วัดหลวง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "03",
    name: "กุดบง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "04",
    name: "ชุมช้าง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "06",
    name: "ทุ่งหลวง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "07",
    name: "เหล่าต่างคำ",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "08",
    name: "นาหนัง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "09",
    name: "เซิม",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "13",
    name: "บ้านโพธิ์",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "21",
    name: "บ้านผือ",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "05",
    tumbon_code: "22",
    name: "สร้างนางขาว",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "07",
    tumbon_code: "01",
    name: "พานพร้าว",
    zipcode: "43130",
  },
  {
    jw_code: "43",
    amph_code: "07",
    tumbon_code: "03",
    name: "บ้านหม้อ",
    zipcode: "43130",
  },
  {
    jw_code: "43",
    amph_code: "07",
    tumbon_code: "04",
    name: "พระพุทธบาท",
    zipcode: "43130",
  },
  {
    jw_code: "43",
    amph_code: "07",
    tumbon_code: "05",
    name: "หนองปลาปาก",
    zipcode: "43130",
  },
  {
    jw_code: "43",
    amph_code: "08",
    tumbon_code: "01",
    name: "แก้งไก่",
    zipcode: "43160",
  },
  {
    jw_code: "43",
    amph_code: "08",
    tumbon_code: "02",
    name: "ผาตั้ง",
    zipcode: "43160",
  },
  {
    jw_code: "43",
    amph_code: "08",
    tumbon_code: "03",
    name: "บ้านม่วง",
    zipcode: "43160",
  },
  {
    jw_code: "43",
    amph_code: "08",
    tumbon_code: "04",
    name: "นางิ้ว",
    zipcode: "43160",
  },
  {
    jw_code: "43",
    amph_code: "08",
    tumbon_code: "05",
    name: "สังคม",
    zipcode: "43160",
  },
  {
    jw_code: "43",
    amph_code: "14",
    tumbon_code: "01",
    name: "สระใคร",
    zipcode: "43100",
  },
  {
    jw_code: "43",
    amph_code: "14",
    tumbon_code: "02",
    name: "คอกช้าง",
    zipcode: "43100",
  },
  {
    jw_code: "43",
    amph_code: "14",
    tumbon_code: "03",
    name: "บ้านฝาง",
    zipcode: "43100",
  },
  {
    jw_code: "43",
    amph_code: "15",
    tumbon_code: "01",
    name: "เฝ้าไร่",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "15",
    tumbon_code: "02",
    name: "นาดี",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "15",
    tumbon_code: "03",
    name: "หนองหลวง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "15",
    tumbon_code: "04",
    name: "วังหลวง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "15",
    tumbon_code: "05",
    name: "อุดมพร",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "16",
    tumbon_code: "01",
    name: "รัตนวาปี",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "16",
    tumbon_code: "02",
    name: "นาทับไฮ",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "16",
    tumbon_code: "03",
    name: "บ้านต้อน",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "16",
    tumbon_code: "04",
    name: "พระบาทนาสิงห์",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "16",
    tumbon_code: "05",
    name: "โพนแพง",
    zipcode: "43120",
  },
  {
    jw_code: "43",
    amph_code: "17",
    tumbon_code: "01",
    name: "โพธิ์ตาก",
    zipcode: "43130",
  },
  {
    jw_code: "43",
    amph_code: "17",
    tumbon_code: "02",
    name: "โพนทอง",
    zipcode: "43130",
  },
  {
    jw_code: "43",
    amph_code: "17",
    tumbon_code: "03",
    name: "ด่านศรีสุข",
    zipcode: "43130",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "01",
    name: "ตลาด",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "02",
    name: "เขวา",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "03",
    name: "ท่าตูม",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "04",
    name: "แวงน่าง",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "05",
    name: "โคกก่อ",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "06",
    name: "ดอนหว่าน",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "07",
    name: "เกิ้ง",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "08",
    name: "แก่งเลิงจาน",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "09",
    name: "ท่าสองคอน",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "10",
    name: "ลาดพัฒนา",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "11",
    name: "หนองปลิง",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "12",
    name: "ห้วยแอ่ง",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "13",
    name: "หนองโน",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "01",
    tumbon_code: "14",
    name: "บัวค้อ",
    zipcode: "44000",
  },
  {
    jw_code: "44",
    amph_code: "02",
    tumbon_code: "01",
    name: "แกดำ",
    zipcode: "44190",
  },
  {
    jw_code: "44",
    amph_code: "02",
    tumbon_code: "02",
    name: "วังแสง",
    zipcode: "44190",
  },
  {
    jw_code: "44",
    amph_code: "02",
    tumbon_code: "03",
    name: "มิตรภาพ",
    zipcode: "44190",
  },
  {
    jw_code: "44",
    amph_code: "02",
    tumbon_code: "04",
    name: "หนองกุง",
    zipcode: "44190",
  },
  {
    jw_code: "44",
    amph_code: "02",
    tumbon_code: "05",
    name: "โนนภิบาล",
    zipcode: "44190",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "01",
    name: "หัวขวาง",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "02",
    name: "ยางน้อย",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "03",
    name: "วังยาว",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "04",
    name: "เขวาไร่",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "05",
    name: "แพง",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "06",
    name: "แก้งแก",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "07",
    name: "หนองเหล็ก",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "08",
    name: "หนองบัว",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "09",
    name: "เหล่า",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "10",
    name: "เขื่อน",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "11",
    name: "หนองบอน",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "12",
    name: "โพนงาม",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "13",
    name: "ยางท่าแจ้ง",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "14",
    name: "แห่ใต้",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "15",
    name: "หนองกุงสวรรค์",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "16",
    name: "เลิงใต้",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "03",
    tumbon_code: "17",
    name: "ดอนกลาง",
    zipcode: "44140",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "01",
    name: "โคกพระ",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "02",
    name: "คันธารราษฎร์",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "03",
    name: "มะค่า",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "04",
    name: "ท่าขอนยาง",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "05",
    name: "นาสีนวน",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "06",
    name: "ขามเรียง",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "07",
    name: "เขวาใหญ่",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "08",
    name: "ศรีสุข",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "09",
    name: "กุดใส้จ่อ",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "04",
    tumbon_code: "10",
    name: "ขามเฒ่าพัฒนา",
    zipcode: "44150",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "01",
    name: "เชียงยืน",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "03",
    name: "หนองซอน",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "05",
    name: "ดอนเงิน",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "06",
    name: "กู่ทอง",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "07",
    name: "นาทอง",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "08",
    name: "เสือเฒ่า",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "11",
    name: "โพนทอง",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "05",
    tumbon_code: "12",
    name: "เหล่าบัวบาน",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "01",
    name: "บรบือ",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ่อใหญ่",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "04",
    name: "วังไชย",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "05",
    name: "หนองม่วง",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "06",
    name: "กำพี้",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "07",
    name: "โนนราษี",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "08",
    name: "โนนแดง",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "10",
    name: "หนองจิก",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "11",
    name: "บัวมาศ",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "13",
    name: "หนองคูขาด",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "15",
    name: "วังใหม่",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "16",
    name: "ยาง",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "18",
    name: "หนองสิม",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "19",
    name: "หนองโก",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "06",
    tumbon_code: "20",
    name: "ดอนงัว",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "01",
    name: "นาเชือก",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "02",
    name: "สำโรง",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "03",
    name: "หนองแดง",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "04",
    name: "เขวาไร่",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "05",
    name: "หนองโพธิ์",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "06",
    name: "ปอพาน",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "07",
    name: "หนองเม็ก",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "08",
    name: "หนองเรือ",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "09",
    name: "หนองกุง",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "07",
    tumbon_code: "10",
    name: "สันป่าตอง",
    zipcode: "44170",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "01",
    name: "ปะหลาน",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "02",
    name: "ก้ามปู",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "03",
    name: "เวียงสะอาด",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "04",
    name: "เม็กดำ",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "05",
    name: "นาสีนวล",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "09",
    name: "ราษฎร์เจริญ",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "10",
    name: "หนองบัวแก้ว",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "12",
    name: "เมืองเตา",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "15",
    name: "ลานสะแก",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "16",
    name: "เวียงชัย",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "17",
    name: "หนองบัว",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "18",
    name: "ราษฎร์พัฒนา",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "19",
    name: "เมืองเสือ",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "08",
    tumbon_code: "20",
    name: "ภารแอ่น",
    zipcode: "44110",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "01",
    name: "หนองแสง",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "02",
    name: "ขามป้อม",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "03",
    name: "เสือโก้ก",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "04",
    name: "ดงใหญ่",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "05",
    name: "โพธิ์ชัย",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "06",
    name: "หัวเรือ",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "07",
    name: "แคน",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "08",
    name: "งัวบา",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "09",
    name: "นาข่า",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "10",
    name: "บ้านหวาย",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "11",
    name: "หนองไฮ",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "12",
    name: "ประชาพัฒนา",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "13",
    name: "หนองทุ่ม",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "14",
    name: "หนองแสน",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "09",
    tumbon_code: "15",
    name: "โคกสีทองหลาง",
    zipcode: "44120",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "01",
    name: "นาดูน",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "02",
    name: "หนองไผ่",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "03",
    name: "หนองคู",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "04",
    name: "ดงบัง",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "05",
    name: "ดงดวน",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "06",
    name: "หัวดง",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "07",
    name: "ดงยาง",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "08",
    name: "กู่สันตรัตน์",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "10",
    tumbon_code: "09",
    name: "พระธาตุ",
    zipcode: "44180",
  },
  {
    jw_code: "44",
    amph_code: "11",
    tumbon_code: "01",
    name: "ยางสีสุราช",
    zipcode: "44210",
  },
  {
    jw_code: "44",
    amph_code: "11",
    tumbon_code: "02",
    name: "นาภู",
    zipcode: "44210",
  },
  {
    jw_code: "44",
    amph_code: "11",
    tumbon_code: "03",
    name: "แวงดง",
    zipcode: "44210",
  },
  {
    jw_code: "44",
    amph_code: "11",
    tumbon_code: "04",
    name: "บ้านกู่",
    zipcode: "44210",
  },
  {
    jw_code: "44",
    amph_code: "11",
    tumbon_code: "05",
    name: "ดงเมือง",
    zipcode: "44210",
  },
  {
    jw_code: "44",
    amph_code: "11",
    tumbon_code: "06",
    name: "สร้างแซ่ง",
    zipcode: "44210",
  },
  {
    jw_code: "44",
    amph_code: "11",
    tumbon_code: "07",
    name: "หนองบัวสันตุ",
    zipcode: "44210",
  },
  {
    jw_code: "44",
    amph_code: "12",
    tumbon_code: "01",
    name: "กุดรัง",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "12",
    tumbon_code: "02",
    name: "นาโพธิ์",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "12",
    tumbon_code: "03",
    name: "เลิงแฝก",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "12",
    tumbon_code: "04",
    name: "หนองแวง",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "12",
    tumbon_code: "05",
    name: "ห้วยเตย",
    zipcode: "44130",
  },
  {
    jw_code: "44",
    amph_code: "13",
    tumbon_code: "01",
    name: "ชื่นชม",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "13",
    tumbon_code: "02",
    name: "กุดปลาดุก",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "13",
    tumbon_code: "03",
    name: "เหล่าดอกไม้",
    zipcode: "44160",
  },
  {
    jw_code: "44",
    amph_code: "13",
    tumbon_code: "04",
    name: "หนองกุง",
    zipcode: "44160",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "02",
    name: "รอบเมือง",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "03",
    name: "เหนือเมือง",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "04",
    name: "ขอนแก่น",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "05",
    name: "นาโพธิ์",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "06",
    name: "สะอาดสมบูรณ์",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "08",
    name: "สีแก้ว",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "09",
    name: "ปอภาร  (ปอพาน)",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "10",
    name: "โนนรัง",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "17",
    name: "หนองแก้ว",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "18",
    name: "หนองแวง",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "20",
    name: "ดงลาน",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "23",
    name: "แคนใหญ่",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "24",
    name: "โนนตาล",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "01",
    tumbon_code: "25",
    name: "เมืองทอง",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "01",
    name: "เกษตรวิสัย",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "02",
    name: "เมืองบัว",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "03",
    name: "เหล่าหลวง",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "04",
    name: "สิงห์โคก",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "05",
    name: "ดงครั่งใหญ่",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "06",
    name: "บ้านฝาง",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองแวง",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "08",
    name: "กำแพง",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "09",
    name: "กู่กาสิงห์",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "10",
    name: "น้ำอ้อม",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "11",
    name: "โนนสว่าง",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "12",
    name: "ทุ่งทอง",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "02",
    tumbon_code: "13",
    name: "ดงครั่งน้อย",
    zipcode: "45150",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "01",
    name: "บัวแดง",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "02",
    name: "ดอกล้ำ",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "03",
    name: "หนองแคน",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "04",
    name: "โพนสูง",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "05",
    name: "โนนสวรรค์",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "06",
    name: "สระบัว",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "07",
    name: "โนนสง่า",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "03",
    tumbon_code: "08",
    name: "ขี้เหล็ก",
    zipcode: "45190",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "01",
    name: "หัวช้าง",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "02",
    name: "หนองผือ",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "03",
    name: "เมืองหงส์",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "04",
    name: "โคกล่าม",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "05",
    name: "น้ำใส",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "06",
    name: "ดงแดง",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "07",
    name: "ดงกลาง",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "08",
    name: "ป่าสังข์",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "09",
    name: "อีง่อง",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "10",
    name: "ลิ้นฟ้า",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "11",
    name: "ดู่น้อย",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "04",
    tumbon_code: "12",
    name: "ศรีโคตร",
    zipcode: "45180",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "01",
    name: "นิเวศน์",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "02",
    name: "ธงธานี",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "03",
    name: "หนองไผ่",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "04",
    name: "ธวัชบุรี",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "06",
    name: "อุ่มเม้า",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "07",
    name: "มะอึ",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "10",
    name: "เขวาทุ่ง",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "15",
    name: "ไพศาล",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "17",
    name: "เมืองน้อย",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "20",
    name: "บึงนคร",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "22",
    name: "ราชธานี",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "05",
    tumbon_code: "24",
    name: "หนองพอก",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "01",
    name: "พนมไพร",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "02",
    name: "แสนสุข",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "03",
    name: "กุดน้ำใส",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "04",
    name: "หนองทัพไทย",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "05",
    name: "โพธิ์ใหญ่",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "06",
    name: "วารีสวัสดิ์",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "07",
    name: "โคกสว่าง",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "11",
    name: "โพธิ์ชัย",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "12",
    name: "นานวล",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "13",
    name: "คำไฮ",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "14",
    name: "สระแก้ว",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "15",
    name: "ค้อใหญ่",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "06",
    tumbon_code: "17",
    name: "ชานุวรรณ",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "01",
    name: "แวง",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "02",
    name: "โคกกกม่วง",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "03",
    name: "นาอุดม",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "04",
    name: "สว่าง",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "05",
    name: "หนองใหญ่",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "06",
    name: "โพธิ์ทอง",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "07",
    name: "โนนชัยศรี",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "08",
    name: "โพธิ์ศรีสว่าง",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "09",
    name: "อุ่มเม่า",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "10",
    name: "คำนาดี",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "11",
    name: "พรมสวรรค์",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "12",
    name: "สระนกแก้ว",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "13",
    name: "วังสามัคคี",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "07",
    tumbon_code: "14",
    name: "โคกสูง",
    zipcode: "45110",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "01",
    name: "ขามเปี้ย",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "02",
    name: "เชียงใหม่",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "03",
    name: "บัวคำ",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "04",
    name: "อัคคะคำ",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "05",
    name: "สะอาด",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "06",
    name: "คำพอุง",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "07",
    name: "หนองตาไก้",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "08",
    name: "ดอนโอง",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "08",
    tumbon_code: "09",
    name: "โพธิ์ศรี",
    zipcode: "45230",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "01",
    name: "หนองพอก",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "02",
    name: "บึงงาม",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "03",
    name: "ภูเขาทอง",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "04",
    name: "กกโพธิ์",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "05",
    name: "โคกสว่าง",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "06",
    name: "หนองขุ่นใหญ่",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "07",
    name: "รอบเมือง",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "08",
    name: "ผาน้ำย้อย",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "09",
    tumbon_code: "09",
    name: "ท่าสีดา",
    zipcode: "45210",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "01",
    name: "กลาง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "02",
    name: "นางาม",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "03",
    name: "เมืองไพร",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "04",
    name: "นาแซง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "05",
    name: "นาเมือง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "06",
    name: "วังหลวง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "07",
    name: "ท่าม่วง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "08",
    name: "ขวาว",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "09",
    name: "โพธิ์ทอง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "10",
    name: "ภูเงิน",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "11",
    name: "เกาะแก้ว",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "12",
    name: "นาเลิง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "13",
    name: "เหล่าน้อย",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "14",
    name: "ศรีวิลัย",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "15",
    name: "หนองหลวง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "16",
    name: "พรสวรรค์",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "17",
    name: "ขวัญเมือง",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "10",
    tumbon_code: "18",
    name: "บึงเกลือ",
    zipcode: "45120",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "01",
    name: "สระคู",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "02",
    name: "ดอกไม้",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "03",
    name: "นาใหญ่",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "04",
    name: "หินกอง",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "05",
    name: "เมืองทุ่ง",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "06",
    name: "หัวโทน",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "07",
    name: "บ่อพันขัน",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "08",
    name: "ทุ่งหลวง",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "09",
    name: "หัวช้าง",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "10",
    name: "น้ำคำ",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "11",
    name: "ห้วยหินลาด",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "12",
    name: "ช้างเผือก",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "13",
    name: "ทุ่งกุลา",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "14",
    name: "ทุ่งศรีเมือง",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "11",
    tumbon_code: "15",
    name: "จำปาขัน",
    zipcode: "45130",
  },
  {
    jw_code: "45",
    amph_code: "12",
    tumbon_code: "01",
    name: "หนองผือ",
    zipcode: "45220",
  },
  {
    jw_code: "45",
    amph_code: "12",
    tumbon_code: "02",
    name: "หนองหิน",
    zipcode: "45220",
  },
  {
    jw_code: "45",
    amph_code: "12",
    tumbon_code: "03",
    name: "คูเมือง",
    zipcode: "45220",
  },
  {
    jw_code: "45",
    amph_code: "12",
    tumbon_code: "04",
    name: "กกกุง",
    zipcode: "45220",
  },
  {
    jw_code: "45",
    amph_code: "12",
    tumbon_code: "05",
    name: "เมืองสรวง",
    zipcode: "45220",
  },
  {
    jw_code: "45",
    amph_code: "13",
    tumbon_code: "01",
    name: "โพนทราย",
    zipcode: "45240",
  },
  {
    jw_code: "45",
    amph_code: "13",
    tumbon_code: "02",
    name: "สามขา",
    zipcode: "45240",
  },
  {
    jw_code: "45",
    amph_code: "13",
    tumbon_code: "03",
    name: "ศรีสว่าง",
    zipcode: "45240",
  },
  {
    jw_code: "45",
    amph_code: "13",
    tumbon_code: "04",
    name: "ยางคำ",
    zipcode: "45240",
  },
  {
    jw_code: "45",
    amph_code: "13",
    tumbon_code: "05",
    name: "ท่าหาดยาว",
    zipcode: "45240",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "01",
    name: "อาจสามารถ",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "02",
    name: "โพนเมือง",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "03",
    name: "บ้านแจ้ง",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "04",
    name: "หน่อม",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "05",
    name: "หนองหมื่นถ่าน",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "06",
    name: "หนองขาม",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "07",
    name: "โหรา",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "08",
    name: "หนองบัว",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "09",
    name: "ขี้เหล็ก",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "14",
    tumbon_code: "10",
    name: "บ้านดู่",
    zipcode: "45160",
  },
  {
    jw_code: "45",
    amph_code: "15",
    tumbon_code: "01",
    name: "เมยวดี",
    zipcode: "45250",
  },
  {
    jw_code: "45",
    amph_code: "15",
    tumbon_code: "02",
    name: "ชุมพร",
    zipcode: "45250",
  },
  {
    jw_code: "45",
    amph_code: "15",
    tumbon_code: "03",
    name: "บุ่งเลิศ",
    zipcode: "45250",
  },
  {
    jw_code: "45",
    amph_code: "15",
    tumbon_code: "04",
    name: "ชมสะอาด",
    zipcode: "45250",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "01",
    name: "โพธิ์ทอง",
    zipcode: "45260",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "02",
    name: "ศรีสมเด็จ",
    zipcode: "45260",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "03",
    name: "เมืองเปลือย",
    zipcode: "45260",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "04",
    name: "หนองใหญ่",
    zipcode: "45260",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "05",
    name: "สวนจิก",
    zipcode: "45280",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "06",
    name: "โพธิ์สัย",
    zipcode: "45280",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "07",
    name: "หนองแวงควง",
    zipcode: "45260",
  },
  {
    jw_code: "45",
    amph_code: "16",
    tumbon_code: "08",
    name: "บ้านบาก",
    zipcode: "45260",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "01",
    name: "ดินดำ",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "02",
    name: "ปาฝา",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "03",
    name: "ม่วงลาด",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "04",
    name: "จังหาร",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "05",
    name: "ดงสิงห์",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "06",
    name: "ยางใหญ่",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "07",
    name: "ผักแว่น",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "17",
    tumbon_code: "08",
    name: "แสนชาติ",
    zipcode: "45270",
  },
  {
    jw_code: "45",
    amph_code: "18",
    tumbon_code: "01",
    name: "เชียงขวัญ",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "18",
    tumbon_code: "02",
    name: "พลับพลา",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "18",
    tumbon_code: "03",
    name: "พระธาตุ",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "18",
    tumbon_code: "04",
    name: "พระเจ้า",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "18",
    tumbon_code: "05",
    name: "หมูม้น",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "18",
    tumbon_code: "06",
    name: "บ้านเขือง",
    zipcode: "45000",
  },
  {
    jw_code: "45",
    amph_code: "19",
    tumbon_code: "01",
    name: "หนองฮี",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "19",
    tumbon_code: "02",
    name: "สาวแห",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "19",
    tumbon_code: "03",
    name: "ดูกอึ่ง",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "19",
    tumbon_code: "04",
    name: "เด่นราษฎร์",
    zipcode: "45140",
  },
  {
    jw_code: "45",
    amph_code: "20",
    tumbon_code: "01",
    name: "ทุ่งเขาหลวง",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "20",
    tumbon_code: "02",
    name: "เทอดไทย",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "20",
    tumbon_code: "03",
    name: "บึงงาม",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "20",
    tumbon_code: "04",
    name: "มะบ้า",
    zipcode: "45170",
  },
  {
    jw_code: "45",
    amph_code: "20",
    tumbon_code: "05",
    name: "เหล่า",
    zipcode: "45170",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "01",
    name: "กาฬสินธุ์",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "02",
    name: "เหนือ",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "03",
    name: "หลุบ",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "04",
    name: "ไผ่",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "05",
    name: "ลำปาว",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "06",
    name: "ลำพาน",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "07",
    name: "เชียงเครือ",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "08",
    name: "บึงวิชัย",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "09",
    name: "ห้วยโพธิ์",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "11",
    name: "ภูปอ",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "13",
    name: "ภูดิน",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "15",
    name: "หนองกุง",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "16",
    name: "กลางหมื่น",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "17",
    name: "ขมิ้น",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "19",
    name: "โพนทอง",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "20",
    name: "นาจารย์",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "01",
    tumbon_code: "21",
    name: "ลำคลอง",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "02",
    tumbon_code: "01",
    name: "นามน",
    zipcode: "46230",
  },
  {
    jw_code: "46",
    amph_code: "02",
    tumbon_code: "02",
    name: "ยอดแกง",
    zipcode: "46230",
  },
  {
    jw_code: "46",
    amph_code: "02",
    tumbon_code: "03",
    name: "สงเปลือย",
    zipcode: "46230",
  },
  {
    jw_code: "46",
    amph_code: "02",
    tumbon_code: "04",
    name: "หลักเหลี่ยม",
    zipcode: "46230",
  },
  {
    jw_code: "46",
    amph_code: "02",
    tumbon_code: "05",
    name: "หนองบัว",
    zipcode: "46230",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "01",
    name: "กมลาไสย",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "02",
    name: "หลักเมือง",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "03",
    name: "โพนงาม",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "04",
    name: "ดงลิง",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "05",
    name: "ธัญญา",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "08",
    name: "หนองแปน",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "10",
    name: "เจ้าท่า",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "03",
    tumbon_code: "11",
    name: "โคกสมบูรณ์",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "04",
    tumbon_code: "01",
    name: "ร่องคำ",
    zipcode: "46210",
  },
  {
    jw_code: "46",
    amph_code: "04",
    tumbon_code: "02",
    name: "สามัคคี",
    zipcode: "46210",
  },
  {
    jw_code: "46",
    amph_code: "04",
    tumbon_code: "03",
    name: "เหล่าอ้อย",
    zipcode: "46210",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "01",
    name: "บัวขาว",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "02",
    name: "แจนแลน",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "03",
    name: "เหล่าใหญ่",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "04",
    name: "จุมจัง",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "05",
    name: "เหล่าไฮงาม",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "06",
    name: "กุดหว้า",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "07",
    name: "สามขา",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "08",
    name: "นาขาม",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "09",
    name: "หนองห้าง",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "10",
    name: "นาโก",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "11",
    name: "สมสะอาด",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "05",
    tumbon_code: "12",
    name: "กุดค้าว",
    zipcode: "46110",
  },
  {
    jw_code: "46",
    amph_code: "06",
    tumbon_code: "01",
    name: "คุ้มเก่า",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "06",
    tumbon_code: "02",
    name: "สงเปลือย",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "06",
    tumbon_code: "03",
    name: "หนองผือ",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "06",
    tumbon_code: "06",
    name: "กุดสิมคุ้มใหม่",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "06",
    tumbon_code: "08",
    name: "สระพังทอง",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "06",
    tumbon_code: "11",
    name: "กุดปลาค้าว",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "01",
    name: "ยางตลาด",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "02",
    name: "หัวงัว",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "03",
    name: "อุ่มเม่า",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "04",
    name: "บัวบาน",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "05",
    name: "เว่อ",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "06",
    name: "อิตื้อ",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "07",
    name: "หัวนาคำ",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "08",
    name: "หนองอิเฒ่า",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "09",
    name: "ดอนสมบูรณ์",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "10",
    name: "นาเชือก",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "11",
    name: "คลองขาม",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "12",
    name: "เขาพระนอน",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "13",
    name: "นาดี",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "14",
    name: "โนนสูง",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "07",
    tumbon_code: "15",
    name: "หนองตอกแป้น",
    zipcode: "46120",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "01",
    name: "ห้วยเม็ก",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "02",
    name: "คำใหญ่",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "03",
    name: "กุดโดน",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "04",
    name: "บึงนาเรียง",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "05",
    name: "หัวหิน",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "06",
    name: "พิมูล",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "07",
    name: "คำเหมือดแก้ว",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "08",
    name: "โนนสะอาด",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "08",
    tumbon_code: "09",
    name: "ทรายทอง",
    zipcode: "46170",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "01",
    name: "ภูสิงห์",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "02",
    name: "สหัสขันธ์",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "03",
    name: "นามะเขือ",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "04",
    name: "โนนศิลา",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "05",
    name: "นิคม",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "06",
    name: "โนนแหลมทอง",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "07",
    name: "โนนบุรี",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "09",
    tumbon_code: "08",
    name: "โนนน้ำเกลี้ยง",
    zipcode: "46140",
  },
  {
    jw_code: "46",
    amph_code: "10",
    tumbon_code: "01",
    name: "ทุ่งคลอง",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "10",
    tumbon_code: "02",
    name: "โพน",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "10",
    tumbon_code: "05",
    name: "ดินจี่",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "10",
    tumbon_code: "06",
    name: "นาบอน",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "10",
    tumbon_code: "07",
    name: "นาทัน",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "10",
    tumbon_code: "09",
    name: "เนินยาง",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "11",
    tumbon_code: "01",
    name: "ท่าคันโท",
    zipcode: "46190",
  },
  {
    jw_code: "46",
    amph_code: "11",
    tumbon_code: "02",
    name: "กุงเก่า",
    zipcode: "46190",
  },
  {
    jw_code: "46",
    amph_code: "11",
    tumbon_code: "03",
    name: "ยางอู้ม",
    zipcode: "46190",
  },
  {
    jw_code: "46",
    amph_code: "11",
    tumbon_code: "04",
    name: "กุดจิก",
    zipcode: "46190",
  },
  {
    jw_code: "46",
    amph_code: "11",
    tumbon_code: "05",
    name: "นาตาล",
    zipcode: "46190",
  },
  {
    jw_code: "46",
    amph_code: "11",
    tumbon_code: "06",
    name: "ดงสมบูรณ์",
    zipcode: "46190",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "01",
    name: "หนองกุงศรี",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "02",
    name: "หนองบัว",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "03",
    name: "โคกเครือ",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "04",
    name: "หนองสรวง",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "05",
    name: "เสาเล้า",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "06",
    name: "หนองใหญ่",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "07",
    name: "ดงมูล",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "08",
    name: "ลำหนองแสน",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "12",
    tumbon_code: "09",
    name: "หนองหิน",
    zipcode: "46220",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "01",
    name: "สมเด็จ",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "02",
    name: "หนองแวง",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "03",
    name: "แซงบาดาล",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "04",
    name: "มหาไชย",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "05",
    name: "หมูม่น",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "06",
    name: "ผาเสวย",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "07",
    name: "ศรีสมเด็จ",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "13",
    tumbon_code: "08",
    name: "ลำห้วยหลัว",
    zipcode: "46150",
  },
  {
    jw_code: "46",
    amph_code: "14",
    tumbon_code: "01",
    name: "คำบง",
    zipcode: "46240",
  },
  {
    jw_code: "46",
    amph_code: "14",
    tumbon_code: "02",
    name: "ไค้นุ่น",
    zipcode: "46240",
  },
  {
    jw_code: "46",
    amph_code: "14",
    tumbon_code: "03",
    name: "นิคมห้วยผึ้ง",
    zipcode: "46240",
  },
  {
    jw_code: "46",
    amph_code: "14",
    tumbon_code: "04",
    name: "หนองอีบุตร",
    zipcode: "46240",
  },
  {
    jw_code: "46",
    amph_code: "15",
    tumbon_code: "01",
    name: "สำราญ",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "15",
    tumbon_code: "02",
    name: "สำราญใต้",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "15",
    tumbon_code: "03",
    name: "คำสร้างเที่ยง",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "15",
    tumbon_code: "04",
    name: "หนองช้าง",
    zipcode: "46180",
  },
  {
    jw_code: "46",
    amph_code: "16",
    tumbon_code: "01",
    name: "นาคู",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "16",
    tumbon_code: "02",
    name: "สายนาวัง",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "16",
    tumbon_code: "03",
    name: "โนนนาจาน",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "16",
    tumbon_code: "04",
    name: "บ่อแก้ว",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "16",
    tumbon_code: "05",
    name: "ภูแล่นช้าง",
    zipcode: "46160",
  },
  {
    jw_code: "46",
    amph_code: "17",
    tumbon_code: "01",
    name: "ดอนจาน",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "17",
    tumbon_code: "02",
    name: "สะอาดไชยศรี",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "17",
    tumbon_code: "03",
    name: "ดงพยุง",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "17",
    tumbon_code: "04",
    name: "ม่วงนา",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "17",
    tumbon_code: "05",
    name: "นาจำปา",
    zipcode: "46000",
  },
  {
    jw_code: "46",
    amph_code: "18",
    tumbon_code: "01",
    name: "ฆ้องชัยพัฒนา",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "18",
    tumbon_code: "02",
    name: "เหล่ากลาง",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "18",
    tumbon_code: "03",
    name: "โคกสะอาด",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "18",
    tumbon_code: "04",
    name: "โนนศิลาเลิง",
    zipcode: "46130",
  },
  {
    jw_code: "46",
    amph_code: "18",
    tumbon_code: "05",
    name: "ลำชี",
    zipcode: "46130",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "01",
    name: "ธาตุเชิงชุม",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "02",
    name: "ขมิ้น",
    zipcode: "47220",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "03",
    name: "งิ้วด่อน",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "04",
    name: "โนนหอม",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "06",
    name: "เชียงเครือ",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "07",
    name: "ท่าแร่",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "09",
    name: "ม่วงลาย",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "11",
    name: "ดงชน",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "12",
    name: "ห้วยยาง",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "13",
    name: "พังขว้าง",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "15",
    name: "ดงมะไฟ",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "16",
    name: "ธาตุนาเวง",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "17",
    name: "เหล่าปอแดง",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "18",
    name: "หนองลาด",
    zipcode: "47220",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "20",
    name: "ฮางโฮง",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "01",
    tumbon_code: "21",
    name: "โคกก่อง",
    zipcode: "47000",
  },
  {
    jw_code: "47",
    amph_code: "02",
    tumbon_code: "01",
    name: "กุสุมาลย์",
    zipcode: "47210",
  },
  {
    jw_code: "47",
    amph_code: "02",
    tumbon_code: "02",
    name: "นาโพธิ์",
    zipcode: "47210",
  },
  {
    jw_code: "47",
    amph_code: "02",
    tumbon_code: "03",
    name: "นาเพียง",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "02",
    tumbon_code: "04",
    name: "โพธิไพศาล",
    zipcode: "47210",
  },
  {
    jw_code: "47",
    amph_code: "02",
    tumbon_code: "05",
    name: "อุ่มจาน",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "03",
    tumbon_code: "01",
    name: "กุดบาก",
    zipcode: "47180",
  },
  {
    jw_code: "47",
    amph_code: "03",
    tumbon_code: "03",
    name: "นาม่อง",
    zipcode: "47180",
  },
  {
    jw_code: "47",
    amph_code: "03",
    tumbon_code: "05",
    name: "กุดไห",
    zipcode: "47180",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "01",
    name: "พรรณา",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "02",
    name: "วังยาง",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "03",
    name: "พอกน้อย",
    zipcode: "47220",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "04",
    name: "นาหัวบ่อ",
    zipcode: "47220",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "05",
    name: "ไร่",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "06",
    name: "ช้างมิ่ง",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "07",
    name: "นาใน",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "08",
    name: "สว่าง",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "09",
    name: "บะฮี",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "04",
    tumbon_code: "10",
    name: "เชิงชุม",
    zipcode: "47130",
  },
  {
    jw_code: "47",
    amph_code: "05",
    tumbon_code: "01",
    name: "พังโคน",
    zipcode: "47160",
  },
  {
    jw_code: "47",
    amph_code: "05",
    tumbon_code: "02",
    name: "ม่วงไข่",
    zipcode: "47160",
  },
  {
    jw_code: "47",
    amph_code: "05",
    tumbon_code: "03",
    name: "แร่",
    zipcode: "47160",
  },
  {
    jw_code: "47",
    amph_code: "05",
    tumbon_code: "04",
    name: "ไฮหย่อง",
    zipcode: "47160",
  },
  {
    jw_code: "47",
    amph_code: "05",
    tumbon_code: "05",
    name: "ต้นผึ้ง",
    zipcode: "47160",
  },
  {
    jw_code: "47",
    amph_code: "06",
    tumbon_code: "01",
    name: "วาริชภูมิ",
    zipcode: "47150",
  },
  {
    jw_code: "47",
    amph_code: "06",
    tumbon_code: "02",
    name: "ปลาโหล",
    zipcode: "47150",
  },
  {
    jw_code: "47",
    amph_code: "06",
    tumbon_code: "03",
    name: "หนองลาด",
    zipcode: "47220",
  },
  {
    jw_code: "47",
    amph_code: "06",
    tumbon_code: "04",
    name: "คำบ่อ",
    zipcode: "47150",
  },
  {
    jw_code: "47",
    amph_code: "06",
    tumbon_code: "05",
    name: "ค้อเขียว",
    zipcode: "47150",
  },
  {
    jw_code: "47",
    amph_code: "07",
    tumbon_code: "01",
    name: "นิคมน้ำอูน",
    zipcode: "47270",
  },
  {
    jw_code: "47",
    amph_code: "07",
    tumbon_code: "02",
    name: "หนองปลิง",
    zipcode: "47270",
  },
  {
    jw_code: "47",
    amph_code: "07",
    tumbon_code: "03",
    name: "หนองบัว",
    zipcode: "47270",
  },
  {
    jw_code: "47",
    amph_code: "07",
    tumbon_code: "04",
    name: "สุวรรณคาม",
    zipcode: "47270",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "01",
    name: "วานรนิวาส",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "02",
    name: "เดื่อศรีคันไชย",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "03",
    name: "ขัวก่าย",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "04",
    name: "หนองสนม",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "05",
    name: "คูสะคาม",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "06",
    name: "ธาตุ",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "07",
    name: "หนองแวง",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "08",
    name: "ศรีวิชัย",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "09",
    name: "นาซอ",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "10",
    name: "อินทร์แปลง",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "11",
    name: "นาคำ",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "12",
    name: "คอนสวรรค์",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "13",
    name: "กุดเรือคำ",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "08",
    tumbon_code: "14",
    name: "หนองแวงใต้",
    zipcode: "47120",
  },
  {
    jw_code: "47",
    amph_code: "09",
    tumbon_code: "01",
    name: "คำตากล้า",
    zipcode: "47250",
  },
  {
    jw_code: "47",
    amph_code: "09",
    tumbon_code: "02",
    name: "หนองบัวสิม",
    zipcode: "47250",
  },
  {
    jw_code: "47",
    amph_code: "09",
    tumbon_code: "03",
    name: "นาแต้",
    zipcode: "47250",
  },
  {
    jw_code: "47",
    amph_code: "09",
    tumbon_code: "04",
    name: "แพด",
    zipcode: "47250",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "01",
    name: "ม่วง",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "02",
    name: "มาย",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "03",
    name: "ดงหม้อทอง",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "04",
    name: "ดงเหนือ",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "05",
    name: "ดงหม้อทองใต้",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "06",
    name: "ห้วยหลัว",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "07",
    name: "โนนสะอาด",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "08",
    name: "หนองกวั่ง",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "10",
    tumbon_code: "09",
    name: "บ่อแก้ว",
    zipcode: "47140",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "01",
    name: "อากาศ",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "02",
    name: "โพนแพง",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "03",
    name: "วาใหญ่",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "04",
    name: "โพนงาม",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "05",
    name: "ท่าก้อน",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "06",
    name: "นาฮี",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "07",
    name: "บะหว้า",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "11",
    tumbon_code: "08",
    name: "สามัคคีพัฒนา",
    zipcode: "47170",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "01",
    name: "สว่างแดนดิน",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "03",
    name: "คำสะอาด",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "04",
    name: "บ้านต้าย",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "06",
    name: "บงเหนือ",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "07",
    name: "โพนสูง",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "08",
    name: "โคกสี",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "10",
    name: "หนองหลวง",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "11",
    name: "บงใต้",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "12",
    name: "ค้อใต้",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "13",
    name: "พันนา",
    zipcode: "47240",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "14",
    name: "แวง",
    zipcode: "47240",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "15",
    name: "ทรายมูล",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "16",
    name: "ตาลโกน",
    zipcode: "47240",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "17",
    name: "ตาลเนิ้ง",
    zipcode: "47240",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "20",
    name: "ธาตุทอง",
    zipcode: "47240",
  },
  {
    jw_code: "47",
    amph_code: "12",
    tumbon_code: "21",
    name: "บ้านถ่อน",
    zipcode: "47110",
  },
  {
    jw_code: "47",
    amph_code: "13",
    tumbon_code: "01",
    name: "ส่องดาว",
    zipcode: "47190",
  },
  {
    jw_code: "47",
    amph_code: "13",
    tumbon_code: "02",
    name: "ท่าศิลา",
    zipcode: "47190",
  },
  {
    jw_code: "47",
    amph_code: "13",
    tumbon_code: "03",
    name: "วัฒนา",
    zipcode: "47190",
  },
  {
    jw_code: "47",
    amph_code: "13",
    tumbon_code: "04",
    name: "ปทุมวาปี",
    zipcode: "47190",
  },
  {
    jw_code: "47",
    amph_code: "14",
    tumbon_code: "01",
    name: "เต่างอย",
    zipcode: "47260",
  },
  {
    jw_code: "47",
    amph_code: "14",
    tumbon_code: "02",
    name: "บึงทวาย",
    zipcode: "47260",
  },
  {
    jw_code: "47",
    amph_code: "14",
    tumbon_code: "03",
    name: "นาตาล",
    zipcode: "47260",
  },
  {
    jw_code: "47",
    amph_code: "14",
    tumbon_code: "04",
    name: "จันทร์เพ็ญ",
    zipcode: "47260",
  },
  {
    jw_code: "47",
    amph_code: "15",
    tumbon_code: "01",
    name: "ตองโขบ",
    zipcode: "47280",
  },
  {
    jw_code: "47",
    amph_code: "15",
    tumbon_code: "02",
    name: "เหล่าโพนค้อ",
    zipcode: "47280",
  },
  {
    jw_code: "47",
    amph_code: "15",
    tumbon_code: "03",
    name: "ด่านม่วงคำ",
    zipcode: "47280",
  },
  {
    jw_code: "47",
    amph_code: "15",
    tumbon_code: "04",
    name: "แมดนาท่ม",
    zipcode: "47280",
  },
  {
    jw_code: "47",
    amph_code: "16",
    tumbon_code: "01",
    name: "บ้านเหล่า",
    zipcode: "47290",
  },
  {
    jw_code: "47",
    amph_code: "16",
    tumbon_code: "02",
    name: "เจริญศิลป์",
    zipcode: "47290",
  },
  {
    jw_code: "47",
    amph_code: "16",
    tumbon_code: "03",
    name: "ทุ่งแก",
    zipcode: "47290",
  },
  {
    jw_code: "47",
    amph_code: "16",
    tumbon_code: "04",
    name: "โคกศิลา",
    zipcode: "47290",
  },
  {
    jw_code: "47",
    amph_code: "16",
    tumbon_code: "05",
    name: "หนองแปน",
    zipcode: "47290",
  },
  {
    jw_code: "47",
    amph_code: "17",
    tumbon_code: "01",
    name: "บ้านโพน",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "17",
    tumbon_code: "02",
    name: "นาแก้ว",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "17",
    tumbon_code: "03",
    name: "นาตงวัฒนา",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "17",
    tumbon_code: "04",
    name: "บ้านแป้น",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "17",
    tumbon_code: "05",
    name: "เชียงสือ",
    zipcode: "47230",
  },
  {
    jw_code: "47",
    amph_code: "18",
    tumbon_code: "01",
    name: "สร้างค้อ",
    zipcode: "47180",
  },
  {
    jw_code: "47",
    amph_code: "18",
    tumbon_code: "02",
    name: "หลุบเลา",
    zipcode: "47180",
  },
  {
    jw_code: "47",
    amph_code: "18",
    tumbon_code: "03",
    name: "โคกภู",
    zipcode: "47180",
  },
  {
    jw_code: "47",
    amph_code: "18",
    tumbon_code: "04",
    name: "กกปลาซิว",
    zipcode: "47180",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "02",
    name: "หนองแสง",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "03",
    name: "นาทราย",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "04",
    name: "นาราชควาย",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "05",
    name: "กุรุคุ",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "06",
    name: "บ้านผึ้ง",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "07",
    name: "อาจสามารถ",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "08",
    name: "ขามเฒ่า",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "09",
    name: "บ้านกลาง",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "10",
    name: "ท่าค้อ",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "11",
    name: "คำเตย",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "12",
    name: "หนองญาติ",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "13",
    name: "ดงขวาง",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "14",
    name: "วังตามัว",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "01",
    tumbon_code: "15",
    name: "โพธิ์ตาก",
    zipcode: "48000",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "01",
    name: "ปลาปาก",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "02",
    name: "หนองฮี",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "03",
    name: "กุตาไก้",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "04",
    name: "โคกสว่าง",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "05",
    name: "โคกสูง",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "06",
    name: "มหาชัย",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "07",
    name: "นามะเขือ",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "02",
    tumbon_code: "08",
    name: "หนองเทาใหญ่",
    zipcode: "48160",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "01",
    name: "ท่าอุเทน",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "02",
    name: "โนนตาล",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "03",
    name: "ท่าจำปา",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "04",
    name: "ไชยบุรี",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "05",
    name: "พนอม",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "06",
    name: "พะทาย",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "11",
    name: "เวินพระบาท",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "12",
    name: "รามราช",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "03",
    tumbon_code: "14",
    name: "หนองเทา",
    zipcode: "48120",
  },
  {
    jw_code: "48",
    amph_code: "04",
    tumbon_code: "01",
    name: "บ้านแพง",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "04",
    tumbon_code: "02",
    name: "ไผ่ล้อม",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "04",
    tumbon_code: "03",
    name: "โพนทอง",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "04",
    tumbon_code: "04",
    name: "หนองแวง",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "04",
    tumbon_code: "08",
    name: "นางัว",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "04",
    tumbon_code: "09",
    name: "นาเข",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "01",
    name: "ธาตุพนม",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "02",
    name: "ฝั่งแดง",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "03",
    name: "โพนแพง",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "04",
    name: "พระกลางทุ่ง",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "05",
    name: "นาถ่อน",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "06",
    name: "แสนพัน",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "07",
    name: "ดอนนางหงส์",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "08",
    name: "น้ำก่ำ",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "09",
    name: "อุ่มเหม้า",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "10",
    name: "นาหนาด",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "11",
    name: "กุดฉิม",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "05",
    tumbon_code: "12",
    name: "ธาตุพนมเหนือ",
    zipcode: "48110",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "01",
    name: "เรณู",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "02",
    name: "โพนทอง",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "03",
    name: "ท่าลาด",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "04",
    name: "นางาม",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "05",
    name: "โคกหินแฮ่",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "07",
    name: "หนองย่างชิ้น",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "08",
    name: "เรณูใต้",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "06",
    tumbon_code: "09",
    name: "นาขาม",
    zipcode: "48170",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "01",
    name: "นาแก",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "02",
    name: "พระซอง",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "03",
    name: "หนองสังข์",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "04",
    name: "นาคู่",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "05",
    name: "พิมาน",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "06",
    name: "พุ่มแก",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "07",
    name: "ก้านเหลือง",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "08",
    name: "หนองบ่อ",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "09",
    name: "นาเลียง",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "12",
    name: "บ้านแก้ง",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "13",
    name: "คำพี้",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "07",
    tumbon_code: "15",
    name: "สีชมพู",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "01",
    name: "ศรีสงคราม",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "02",
    name: "นาเดื่อ",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "03",
    name: "บ้านเอื้อง",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "04",
    name: "สามผง",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "05",
    name: "ท่าบ่อสงคราม",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "06",
    name: "บ้านข่า",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "07",
    name: "นาคำ",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "08",
    name: "โพนสว่าง",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "08",
    tumbon_code: "09",
    name: "หาดแพง",
    zipcode: "48150",
  },
  {
    jw_code: "48",
    amph_code: "09",
    tumbon_code: "01",
    name: "นาหว้า",
    zipcode: "48180",
  },
  {
    jw_code: "48",
    amph_code: "09",
    tumbon_code: "02",
    name: "นางัว",
    zipcode: "48180",
  },
  {
    jw_code: "48",
    amph_code: "09",
    tumbon_code: "03",
    name: "บ้านเสียว",
    zipcode: "48180",
  },
  {
    jw_code: "48",
    amph_code: "09",
    tumbon_code: "04",
    name: "นาคูณใหญ่",
    zipcode: "48180",
  },
  {
    jw_code: "48",
    amph_code: "09",
    tumbon_code: "05",
    name: "เหล่าพัฒนา",
    zipcode: "48180",
  },
  {
    jw_code: "48",
    amph_code: "09",
    tumbon_code: "06",
    name: "ท่าเรือ",
    zipcode: "48180",
  },
  {
    jw_code: "48",
    amph_code: "10",
    tumbon_code: "01",
    name: "โพนสวรรค์",
    zipcode: "48190",
  },
  {
    jw_code: "48",
    amph_code: "10",
    tumbon_code: "02",
    name: "นาหัวบ่อ",
    zipcode: "48190",
  },
  {
    jw_code: "48",
    amph_code: "10",
    tumbon_code: "03",
    name: "นาขมิ้น",
    zipcode: "48190",
  },
  {
    jw_code: "48",
    amph_code: "10",
    tumbon_code: "04",
    name: "โพนบก",
    zipcode: "48190",
  },
  {
    jw_code: "48",
    amph_code: "10",
    tumbon_code: "05",
    name: "บ้านค้อ",
    zipcode: "48190",
  },
  {
    jw_code: "48",
    amph_code: "10",
    tumbon_code: "06",
    name: "โพนจาน",
    zipcode: "48190",
  },
  {
    jw_code: "48",
    amph_code: "10",
    tumbon_code: "07",
    name: "นาใน",
    zipcode: "48190",
  },
  {
    jw_code: "48",
    amph_code: "11",
    tumbon_code: "01",
    name: "นาทม",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "11",
    tumbon_code: "02",
    name: "หนองซน",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "11",
    tumbon_code: "03",
    name: "ดอนเตย",
    zipcode: "48140",
  },
  {
    jw_code: "48",
    amph_code: "12",
    tumbon_code: "01",
    name: "วังยาง",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "12",
    tumbon_code: "02",
    name: "โคกสี",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "12",
    tumbon_code: "03",
    name: "ยอดชาด",
    zipcode: "48130",
  },
  {
    jw_code: "48",
    amph_code: "12",
    tumbon_code: "04",
    name: "หนองโพธิ์",
    zipcode: "48130",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "01",
    name: "มุกดาหาร",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "02",
    name: "ศรีบุญเรือง",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านโคก",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "04",
    name: "บางทรายใหญ่",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "05",
    name: "โพนทราย",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "06",
    name: "ผึ่งแดด",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "07",
    name: "นาโสก",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "08",
    name: "นาสีนวน",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "09",
    name: "คำป่าหลาย",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "10",
    name: "คำอาฮวน",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "11",
    name: "ดงเย็น",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "12",
    name: "ดงมอน",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "01",
    tumbon_code: "13",
    name: "กุดแข้",
    zipcode: "49000",
  },
  {
    jw_code: "49",
    amph_code: "02",
    tumbon_code: "01",
    name: "นิคมคำสร้อย",
    zipcode: "49130",
  },
  {
    jw_code: "49",
    amph_code: "02",
    tumbon_code: "02",
    name: "นากอก",
    zipcode: "49130",
  },
  {
    jw_code: "49",
    amph_code: "02",
    tumbon_code: "03",
    name: "หนองแวง",
    zipcode: "49130",
  },
  {
    jw_code: "49",
    amph_code: "02",
    tumbon_code: "04",
    name: "กกแดง",
    zipcode: "49130",
  },
  {
    jw_code: "49",
    amph_code: "02",
    tumbon_code: "05",
    name: "นาอุดม",
    zipcode: "49130",
  },
  {
    jw_code: "49",
    amph_code: "02",
    tumbon_code: "06",
    name: "โชคชัย",
    zipcode: "49130",
  },
  {
    jw_code: "49",
    amph_code: "02",
    tumbon_code: "07",
    name: "ร่มเกล้า",
    zipcode: "49130",
  },
  {
    jw_code: "49",
    amph_code: "03",
    tumbon_code: "01",
    name: "ดอนตาล",
    zipcode: "49120",
  },
  {
    jw_code: "49",
    amph_code: "03",
    tumbon_code: "02",
    name: "โพธิ์ไทร",
    zipcode: "49120",
  },
  {
    jw_code: "49",
    amph_code: "03",
    tumbon_code: "03",
    name: "ป่าไร่",
    zipcode: "49120",
  },
  {
    jw_code: "49",
    amph_code: "03",
    tumbon_code: "04",
    name: "เหล่าหมี",
    zipcode: "49120",
  },
  {
    jw_code: "49",
    amph_code: "03",
    tumbon_code: "05",
    name: "บ้านบาก",
    zipcode: "49120",
  },
  {
    jw_code: "49",
    amph_code: "03",
    tumbon_code: "06",
    name: "นาสะเม็ง",
    zipcode: "49120",
  },
  {
    jw_code: "49",
    amph_code: "03",
    tumbon_code: "07",
    name: "บ้านแก้ง",
    zipcode: "49120",
  },
  {
    jw_code: "49",
    amph_code: "04",
    tumbon_code: "01",
    name: "ดงหลวง",
    zipcode: "49140",
  },
  {
    jw_code: "49",
    amph_code: "04",
    tumbon_code: "02",
    name: "หนองบัว",
    zipcode: "49140",
  },
  {
    jw_code: "49",
    amph_code: "04",
    tumbon_code: "03",
    name: "กกตูม",
    zipcode: "49140",
  },
  {
    jw_code: "49",
    amph_code: "04",
    tumbon_code: "04",
    name: "หนองแคน",
    zipcode: "49140",
  },
  {
    jw_code: "49",
    amph_code: "04",
    tumbon_code: "05",
    name: "ชะโนดน้อย",
    zipcode: "49140",
  },
  {
    jw_code: "49",
    amph_code: "04",
    tumbon_code: "06",
    name: "พังแดง",
    zipcode: "49140",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "03",
    name: "บ้านซ่ง",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "04",
    name: "คำชะอี",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "05",
    name: "หนองเอี่ยน",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "06",
    name: "บ้านค้อ",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "07",
    name: "บ้านเหล่า",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "08",
    name: "โพนงาม",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "11",
    name: "เหล่าสร้างถ่อ",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "12",
    name: "คำบก",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "05",
    tumbon_code: "14",
    name: "น้ำเที่ยง",
    zipcode: "49110",
  },
  {
    jw_code: "49",
    amph_code: "06",
    tumbon_code: "01",
    name: "หว้านใหญ่",
    zipcode: "49150",
  },
  {
    jw_code: "49",
    amph_code: "06",
    tumbon_code: "02",
    name: "ป่งขาม",
    zipcode: "49150",
  },
  {
    jw_code: "49",
    amph_code: "06",
    tumbon_code: "03",
    name: "บางทรายน้อย",
    zipcode: "49150",
  },
  {
    jw_code: "49",
    amph_code: "06",
    tumbon_code: "04",
    name: "ชะโนด",
    zipcode: "49150",
  },
  {
    jw_code: "49",
    amph_code: "06",
    tumbon_code: "05",
    name: "ดงหมู",
    zipcode: "49150",
  },
  {
    jw_code: "49",
    amph_code: "07",
    tumbon_code: "01",
    name: "หนองสูง",
    zipcode: "49160",
  },
  {
    jw_code: "49",
    amph_code: "07",
    tumbon_code: "02",
    name: "โนนยาง",
    zipcode: "49160",
  },
  {
    jw_code: "49",
    amph_code: "07",
    tumbon_code: "03",
    name: "ภูวง",
    zipcode: "49160",
  },
  {
    jw_code: "49",
    amph_code: "07",
    tumbon_code: "04",
    name: "บ้านเป้า",
    zipcode: "49160",
  },
  {
    jw_code: "49",
    amph_code: "07",
    tumbon_code: "05",
    name: "หนองสูงใต้",
    zipcode: "49160",
  },
  {
    jw_code: "49",
    amph_code: "07",
    tumbon_code: "06",
    name: "หนองสูงเหนือ",
    zipcode: "49160",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "01",
    name: "ศรีภูมิ",
    zipcode: "50200",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "02",
    name: "พระสิงห์",
    zipcode: "50200",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "03",
    name: "หายยา",
    zipcode: "50100",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "04",
    name: "ช้างม่อย",
    zipcode: "50300",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "05",
    name: "ช้างคลาน",
    zipcode: "50100",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "06",
    name: "วัดเกต",
    zipcode: "50000",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "07",
    name: "ช้างเผือก",
    zipcode: "50300",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "08",
    name: "สุเทพ",
    zipcode: "50200",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "09",
    name: "แม่เหียะ",
    zipcode: "50100",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "10",
    name: "ป่าแดด",
    zipcode: "50100",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "11",
    name: "หนองหอย",
    zipcode: "50000",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "12",
    name: "ท่าศาลา",
    zipcode: "50000",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "13",
    name: "หนองป่าครั่ง",
    zipcode: "50000",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "14",
    name: "ฟ้าฮ่าม",
    zipcode: "50000",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "15",
    name: "ป่าตัน",
    zipcode: "50300",
  },
  {
    jw_code: "50",
    amph_code: "01",
    tumbon_code: "16",
    name: "สันผีเสื้อ",
    zipcode: "50300",
  },
  {
    jw_code: "50",
    amph_code: "02",
    tumbon_code: "03",
    name: "บ้านหลวง",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "02",
    tumbon_code: "04",
    name: "ข่วงเปา",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "02",
    tumbon_code: "05",
    name: "สบเตี๊ยะ",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "02",
    tumbon_code: "06",
    name: "บ้านแปะ",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "02",
    tumbon_code: "07",
    name: "ดอยแก้ว",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "02",
    tumbon_code: "09",
    name: "แม่สอย",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "03",
    tumbon_code: "01",
    name: "ช่างเคิ่ง",
    zipcode: "50270",
  },
  {
    jw_code: "50",
    amph_code: "03",
    tumbon_code: "02",
    name: "ท่าผา",
    zipcode: "50270",
  },
  {
    jw_code: "50",
    amph_code: "03",
    tumbon_code: "03",
    name: "บ้านทับ",
    zipcode: "50270",
  },
  {
    jw_code: "50",
    amph_code: "03",
    tumbon_code: "04",
    name: "แม่ศึก",
    zipcode: "50270",
  },
  {
    jw_code: "50",
    amph_code: "03",
    tumbon_code: "05",
    name: "แม่นาจร",
    zipcode: "50270",
  },
  {
    jw_code: "50",
    amph_code: "03",
    tumbon_code: "07",
    name: "ปางหินฝน",
    zipcode: "50270",
  },
  {
    jw_code: "50",
    amph_code: "03",
    tumbon_code: "08",
    name: "กองแขก",
    zipcode: "50270",
  },
  {
    jw_code: "50",
    amph_code: "04",
    tumbon_code: "01",
    name: "เชียงดาว",
    zipcode: "50170",
  },
  {
    jw_code: "50",
    amph_code: "04",
    tumbon_code: "02",
    name: "เมืองนะ",
    zipcode: "50170",
  },
  {
    jw_code: "50",
    amph_code: "04",
    tumbon_code: "03",
    name: "เมืองงาย",
    zipcode: "50170",
  },
  {
    jw_code: "50",
    amph_code: "04",
    tumbon_code: "04",
    name: "แม่นะ",
    zipcode: "50170",
  },
  {
    jw_code: "50",
    amph_code: "04",
    tumbon_code: "05",
    name: "เมืองคอง",
    zipcode: "50170",
  },
  {
    jw_code: "50",
    amph_code: "04",
    tumbon_code: "06",
    name: "ปิงโค้ง",
    zipcode: "50170",
  },
  {
    jw_code: "50",
    amph_code: "04",
    tumbon_code: "07",
    name: "ทุ่งข้าวพวง",
    zipcode: "50170",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "01",
    name: "เชิงดอย",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "02",
    name: "สันปูเลย",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "03",
    name: "ลวงเหนือ",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "04",
    name: "ป่าป้อง",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "05",
    name: "สง่าบ้าน",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "06",
    name: "ป่าลาน",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "07",
    name: "ตลาดขวัญ",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "08",
    name: "สำราญราษฎร์",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "09",
    name: "แม่คือ",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "10",
    name: "ตลาดใหญ่",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "11",
    name: "แม่ฮ้อยเงิน",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "12",
    name: "แม่โป่ง",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "13",
    name: "ป่าเมี่ยง",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "05",
    tumbon_code: "14",
    name: "เทพเสด็จ",
    zipcode: "50220",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "01",
    name: "สันมหาพน",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "02",
    name: "แม่แตง",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "03",
    name: "ขี้เหล็ก",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "04",
    name: "ช่อแล",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "05",
    name: "แม่หอพระ",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "06",
    name: "สบเปิง",
    zipcode: "50330",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "07",
    name: "บ้านเป้า",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "08",
    name: "สันป่ายาง",
    zipcode: "50330",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "09",
    name: "ป่าแป๋",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "10",
    name: "เมืองก๋าย",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "11",
    name: "บ้านช้าง",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "12",
    name: "กื้ดช้าง",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "13",
    name: "อินทขิล",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "06",
    tumbon_code: "14",
    name: "สมก๋าย",
    zipcode: "50150",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "01",
    name: "ริมใต้",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "02",
    name: "ริมเหนือ",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "03",
    name: "สันโป่ง",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "04",
    name: "ขี้เหล็ก",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "05",
    name: "สะลวง",
    zipcode: "50330",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "06",
    name: "ห้วยทราย",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "07",
    name: "แม่แรม",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "08",
    name: "โป่งแยง",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "09",
    name: "แม่สา",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "10",
    name: "ดอนแก้ว",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "07",
    tumbon_code: "11",
    name: "เหมืองแก้ว",
    zipcode: "50180",
  },
  {
    jw_code: "50",
    amph_code: "08",
    tumbon_code: "01",
    name: "สะเมิงใต้",
    zipcode: "50250",
  },
  {
    jw_code: "50",
    amph_code: "08",
    tumbon_code: "02",
    name: "สะเมิงเหนือ",
    zipcode: "50250",
  },
  {
    jw_code: "50",
    amph_code: "08",
    tumbon_code: "03",
    name: "แม่สาบ",
    zipcode: "50250",
  },
  {
    jw_code: "50",
    amph_code: "08",
    tumbon_code: "04",
    name: "บ่อแก้ว",
    zipcode: "50250",
  },
  {
    jw_code: "50",
    amph_code: "08",
    tumbon_code: "05",
    name: "ยั้งเมิน",
    zipcode: "50250",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "01",
    name: "เวียง",
    zipcode: "50110",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "03",
    name: "ม่อนปิ่น",
    zipcode: "50110",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "04",
    name: "แม่งอน",
    zipcode: "50320",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "05",
    name: "แม่สูน",
    zipcode: "50110",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "06",
    name: "สันทราย",
    zipcode: "50110",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "10",
    name: "แม่คะ",
    zipcode: "50110",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "11",
    name: "แม่ข่า",
    zipcode: "50320",
  },
  {
    jw_code: "50",
    amph_code: "09",
    tumbon_code: "12",
    name: "โป่งน้ำร้อน",
    zipcode: "50110",
  },
  {
    jw_code: "50",
    amph_code: "10",
    tumbon_code: "01",
    name: "แม่อาย",
    zipcode: "50280",
  },
  {
    jw_code: "50",
    amph_code: "10",
    tumbon_code: "02",
    name: "แม่สาว",
    zipcode: "50280",
  },
  {
    jw_code: "50",
    amph_code: "10",
    tumbon_code: "03",
    name: "สันต้นหมื้อ",
    zipcode: "50280",
  },
  {
    jw_code: "50",
    amph_code: "10",
    tumbon_code: "04",
    name: "แม่นาวาง",
    zipcode: "50280",
  },
  {
    jw_code: "50",
    amph_code: "10",
    tumbon_code: "05",
    name: "ท่าตอน",
    zipcode: "50280",
  },
  {
    jw_code: "50",
    amph_code: "10",
    tumbon_code: "06",
    name: "บ้านหลวง",
    zipcode: "50280",
  },
  {
    jw_code: "50",
    amph_code: "10",
    tumbon_code: "07",
    name: "มะลิกา",
    zipcode: "50280",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "01",
    name: "เวียง",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "02",
    name: "ทุ่งหลวง",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "03",
    name: "ป่าตุ้ม",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "04",
    name: "ป่าไหน่",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "05",
    name: "สันทราย",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "06",
    name: "บ้านโป่ง",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "07",
    name: "น้ำแพร่",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "08",
    name: "เขื่อนผาก",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "09",
    name: "แม่แวน",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "10",
    name: "แม่ปั๋ง",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "11",
    tumbon_code: "11",
    name: "โหล่งขอด",
    zipcode: "50190",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "01",
    name: "ยุหว่า",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "02",
    name: "สันกลาง",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "03",
    name: "ท่าวังพร้าว",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "04",
    name: "มะขามหลวง",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "05",
    name: "แม่ก๊า",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "06",
    name: "บ้านแม",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "07",
    name: "บ้านกลาง",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "08",
    name: "ทุ่งสะโตก",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "10",
    name: "ทุ่งต้อม",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "14",
    name: "น้ำบ่อหลวง",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "12",
    tumbon_code: "15",
    name: "มะขุนหวาน",
    zipcode: "50120",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "01",
    name: "สันกำแพง",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "02",
    name: "ทรายมูล",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "03",
    name: "ร้องวัวแดง",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "04",
    name: "บวกค้าง",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "05",
    name: "แช่ช้าง",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "06",
    name: "ออนใต้",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "10",
    name: "แม่ปูคา",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "11",
    name: "ห้วยทราย",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "12",
    name: "ต้นเปา",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "13",
    tumbon_code: "13",
    name: "สันกลาง",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "01",
    name: "สันทรายหลวง",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "02",
    name: "สันทรายน้อย",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "03",
    name: "สันพระเนตร",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "04",
    name: "สันนาเม็ง",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "05",
    name: "สันป่าเปา",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "06",
    name: "หนองแหย่ง",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "07",
    name: "หนองจ๊อม",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "08",
    name: "หนองหาร",
    zipcode: "50290",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "09",
    name: "แม่แฝก",
    zipcode: "50290",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "10",
    name: "แม่แฝกใหม่",
    zipcode: "50290",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "11",
    name: "เมืองเล็น",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "14",
    tumbon_code: "12",
    name: "ป่าไผ่",
    zipcode: "50210",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "01",
    name: "หางดง",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "02",
    name: "หนองแก๋ว",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "03",
    name: "หารแก้ว",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "04",
    name: "หนองตอง",
    zipcode: "50340",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "05",
    name: "ขุนคง",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "06",
    name: "สบแม่ข่า",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "07",
    name: "บ้านแหวน",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "08",
    name: "สันผักหวาน",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "09",
    name: "หนองควาย",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "10",
    name: "บ้านปง",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "15",
    tumbon_code: "11",
    name: "น้ำแพร่",
    zipcode: "50230",
  },
  {
    jw_code: "50",
    amph_code: "16",
    tumbon_code: "01",
    name: "หางดง",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "16",
    tumbon_code: "02",
    name: "ฮอด",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "16",
    tumbon_code: "03",
    name: "บ้านตาล",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "16",
    tumbon_code: "04",
    name: "บ่อหลวง",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "16",
    tumbon_code: "05",
    name: "บ่อสลี",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "16",
    tumbon_code: "06",
    name: "นาคอเรือ",
    zipcode: "50240",
  },
  {
    jw_code: "50",
    amph_code: "17",
    tumbon_code: "01",
    name: "ดอยเต่า",
    zipcode: "50260",
  },
  {
    jw_code: "50",
    amph_code: "17",
    tumbon_code: "02",
    name: "ท่าเดื่อ",
    zipcode: "50260",
  },
  {
    jw_code: "50",
    amph_code: "17",
    tumbon_code: "03",
    name: "มืดกา",
    zipcode: "50260",
  },
  {
    jw_code: "50",
    amph_code: "17",
    tumbon_code: "04",
    name: "บ้านแอ่น",
    zipcode: "50260",
  },
  {
    jw_code: "50",
    amph_code: "17",
    tumbon_code: "05",
    name: "บงตัน",
    zipcode: "50260",
  },
  {
    jw_code: "50",
    amph_code: "17",
    tumbon_code: "06",
    name: "โปงทุ่ง",
    zipcode: "50260",
  },
  {
    jw_code: "50",
    amph_code: "18",
    tumbon_code: "01",
    name: "อมก๋อย",
    zipcode: "50310",
  },
  {
    jw_code: "50",
    amph_code: "18",
    tumbon_code: "02",
    name: "ยางเปียง",
    zipcode: "50310",
  },
  {
    jw_code: "50",
    amph_code: "18",
    tumbon_code: "03",
    name: "แม่ตื่น",
    zipcode: "50310",
  },
  {
    jw_code: "50",
    amph_code: "18",
    tumbon_code: "04",
    name: "ม่อนจอง",
    zipcode: "50310",
  },
  {
    jw_code: "50",
    amph_code: "18",
    tumbon_code: "05",
    name: "สบโขง",
    zipcode: "50310",
  },
  {
    jw_code: "50",
    amph_code: "18",
    tumbon_code: "06",
    name: "นาเกียน",
    zipcode: "50310",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "01",
    name: "ยางเนิ้ง",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "02",
    name: "สารภี",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "03",
    name: "ชมภู",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "04",
    name: "ไชยสถาน",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "05",
    name: "ขัวมุง",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "06",
    name: "หนองแฝก",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "07",
    name: "หนองผึ้ง",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "08",
    name: "ท่ากว้าง",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "09",
    name: "ดอนแก้ว",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "10",
    name: "ท่าวังตาล",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "11",
    name: "สันทราย",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "19",
    tumbon_code: "12",
    name: "ป่าบง",
    zipcode: "50140",
  },
  {
    jw_code: "50",
    amph_code: "20",
    tumbon_code: "01",
    name: "เมืองแหง",
    zipcode: "50350",
  },
  {
    jw_code: "50",
    amph_code: "20",
    tumbon_code: "02",
    name: "เปียงหลวง",
    zipcode: "50350",
  },
  {
    jw_code: "50",
    amph_code: "20",
    tumbon_code: "03",
    name: "แสนไห",
    zipcode: "50350",
  },
  {
    jw_code: "50",
    amph_code: "21",
    tumbon_code: "01",
    name: "ปงตำ",
    zipcode: "50320",
  },
  {
    jw_code: "50",
    amph_code: "21",
    tumbon_code: "02",
    name: "ศรีดงเย็น",
    zipcode: "50320",
  },
  {
    jw_code: "50",
    amph_code: "21",
    tumbon_code: "03",
    name: "แม่ทะลบ",
    zipcode: "50320",
  },
  {
    jw_code: "50",
    amph_code: "21",
    tumbon_code: "04",
    name: "หนองบัว",
    zipcode: "50320",
  },
  {
    jw_code: "50",
    amph_code: "22",
    tumbon_code: "01",
    name: "บ้านกาด",
    zipcode: "50360",
  },
  {
    jw_code: "50",
    amph_code: "22",
    tumbon_code: "02",
    name: "ทุ่งปี๊",
    zipcode: "50360",
  },
  {
    jw_code: "50",
    amph_code: "22",
    tumbon_code: "03",
    name: "ทุ่งรวงทอง",
    zipcode: "50360",
  },
  {
    jw_code: "50",
    amph_code: "22",
    tumbon_code: "04",
    name: "แม่วิน",
    zipcode: "50360",
  },
  {
    jw_code: "50",
    amph_code: "22",
    tumbon_code: "05",
    name: "ดอนเปา",
    zipcode: "50360",
  },
  {
    jw_code: "50",
    amph_code: "23",
    tumbon_code: "01",
    name: "ออนเหนือ",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "23",
    tumbon_code: "02",
    name: "ออนกลาง",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "23",
    tumbon_code: "03",
    name: "บ้านสหกรณ์",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "23",
    tumbon_code: "04",
    name: "ห้วยแก้ว",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "23",
    tumbon_code: "05",
    name: "แม่ทา",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "23",
    tumbon_code: "06",
    name: "ทาเหนือ",
    zipcode: "50130",
  },
  {
    jw_code: "50",
    amph_code: "24",
    tumbon_code: "01",
    name: "ดอยหล่อ",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "24",
    tumbon_code: "02",
    name: "สองแคว",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "24",
    tumbon_code: "03",
    name: "ยางคราม",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "24",
    tumbon_code: "04",
    name: "สันติสุข",
    zipcode: "50160",
  },
  {
    jw_code: "50",
    amph_code: "25",
    tumbon_code: "01",
    name: "บ้านจันทร์",
    zipcode: "58130",
  },
  {
    jw_code: "50",
    amph_code: "25",
    tumbon_code: "02",
    name: "แม่แดด",
    zipcode: "58130",
  },
  {
    jw_code: "50",
    amph_code: "25",
    tumbon_code: "03",
    name: "แจ่มหลวง",
    zipcode: "58130",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "02",
    name: "เหมืองง่า",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "03",
    name: "อุโมงค์",
    zipcode: "51150",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "04",
    name: "หนองช้างคืน",
    zipcode: "51150",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "05",
    name: "ประตูป่า",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "06",
    name: "ริมปิง",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "07",
    name: "ต้นธง",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "08",
    name: "บ้านแป้น",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "09",
    name: "เหมืองจี้",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "10",
    name: "ป่าสัก",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "11",
    name: "เวียงยอง",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "12",
    name: "บ้านกลาง",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "13",
    name: "มะเขือแจ้",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "16",
    name: "ศรีบัวบาน",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "01",
    tumbon_code: "17",
    name: "หนองหนาม",
    zipcode: "51000",
  },
  {
    jw_code: "51",
    amph_code: "02",
    tumbon_code: "01",
    name: "ทาปลาดุก",
    zipcode: "51140",
  },
  {
    jw_code: "51",
    amph_code: "02",
    tumbon_code: "02",
    name: "ทาสบเส้า",
    zipcode: "51140",
  },
  {
    jw_code: "51",
    amph_code: "02",
    tumbon_code: "03",
    name: "ทากาศ",
    zipcode: "51170",
  },
  {
    jw_code: "51",
    amph_code: "02",
    tumbon_code: "04",
    name: "ทาขุมเงิน",
    zipcode: "51170",
  },
  {
    jw_code: "51",
    amph_code: "02",
    tumbon_code: "05",
    name: "ทาทุ่งหลวง",
    zipcode: "51170",
  },
  {
    jw_code: "51",
    amph_code: "02",
    tumbon_code: "06",
    name: "ทาแม่ลอบ",
    zipcode: "51170",
  },
  {
    jw_code: "51",
    amph_code: "03",
    tumbon_code: "01",
    name: "บ้านโฮ่ง",
    zipcode: "51130",
  },
  {
    jw_code: "51",
    amph_code: "03",
    tumbon_code: "02",
    name: "ป่าพลู",
    zipcode: "51130",
  },
  {
    jw_code: "51",
    amph_code: "03",
    tumbon_code: "03",
    name: "เหล่ายาว",
    zipcode: "51130",
  },
  {
    jw_code: "51",
    amph_code: "03",
    tumbon_code: "04",
    name: "ศรีเตี้ย",
    zipcode: "51130",
  },
  {
    jw_code: "51",
    amph_code: "03",
    tumbon_code: "05",
    name: "หนองปลาสะวาย",
    zipcode: "51130",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "01",
    name: "ลี้",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "02",
    name: "แม่ตืน",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "03",
    name: "นาทราย",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "04",
    name: "ดงดำ",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "05",
    name: "ก้อ",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "06",
    name: "แม่ลาน",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "08",
    name: "ป่าไผ่",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "04",
    tumbon_code: "09",
    name: "ศรีวิชัย",
    zipcode: "51110",
  },
  {
    jw_code: "51",
    amph_code: "05",
    tumbon_code: "01",
    name: "ทุ่งหัวช้าง",
    zipcode: "51160",
  },
  {
    jw_code: "51",
    amph_code: "05",
    tumbon_code: "02",
    name: "บ้านปวง",
    zipcode: "51160",
  },
  {
    jw_code: "51",
    amph_code: "05",
    tumbon_code: "03",
    name: "ตะเคียนปม",
    zipcode: "51160",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปากบ่อง",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "02",
    name: "ป่าซาง",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "03",
    name: "แม่แรง",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "04",
    name: "ม่วงน้อย",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "05",
    name: "บ้านเรือน",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "06",
    name: "มะกอก",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "07",
    name: "ท่าตุ้ม",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "08",
    name: "น้ำดิบ",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "06",
    tumbon_code: "11",
    name: "นครเจดีย์",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "07",
    tumbon_code: "01",
    name: "บ้านธิ",
    zipcode: "51180",
  },
  {
    jw_code: "51",
    amph_code: "07",
    tumbon_code: "02",
    name: "ห้วยยาบ",
    zipcode: "51180",
  },
  {
    jw_code: "51",
    amph_code: "08",
    tumbon_code: "01",
    name: "หนองล่อง",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "08",
    tumbon_code: "02",
    name: "หนองยวง",
    zipcode: "51120",
  },
  {
    jw_code: "51",
    amph_code: "08",
    tumbon_code: "03",
    name: "วังผาง",
    zipcode: "51120",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "01",
    name: "เวียงเหนือ",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "02",
    name: "หัวเวียง",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "03",
    name: "สวนดอก",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "04",
    name: "สบตุ๋ย",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "05",
    name: "พระบาท",
    zipcode: "52220",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "06",
    name: "ชมพู",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "07",
    name: "กล้วยแพะ",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "08",
    name: "ปงแสนทอง",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "09",
    name: "บ้านแลง",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "10",
    name: "บ้านเสด็จ",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "11",
    name: "พิชัย",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "12",
    name: "ทุ่งฝาย",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "13",
    name: "บ้านเอื้อม",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "14",
    name: "บ้านเป้า",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "15",
    name: "บ้านค่า",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "16",
    name: "บ่อแฮ้ว",
    zipcode: "52100",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "17",
    name: "ต้นธงชัย",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "18",
    name: "นิคมพัฒนา",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "01",
    tumbon_code: "19",
    name: "บุญนาคพัฒนา",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "02",
    tumbon_code: "01",
    name: "บ้านดง",
    zipcode: "52000",
  },
  {
    jw_code: "52",
    amph_code: "02",
    tumbon_code: "02",
    name: "นาสัก",
    zipcode: "52220",
  },
  {
    jw_code: "52",
    amph_code: "02",
    tumbon_code: "03",
    name: "จางเหนือ",
    zipcode: "52220",
  },
  {
    jw_code: "52",
    amph_code: "02",
    tumbon_code: "04",
    name: "แม่เมาะ",
    zipcode: "52220",
  },
  {
    jw_code: "52",
    amph_code: "02",
    tumbon_code: "05",
    name: "สบป้าด",
    zipcode: "52220",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "01",
    name: "ลำปางหลวง",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "02",
    name: "นาแก้ว",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "03",
    name: "ไหล่หิน",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "04",
    name: "วังพร้าว",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "05",
    name: "ศาลา",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "06",
    name: "เกาะคา",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "07",
    name: "นาแส่ง",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "08",
    name: "ท่าผา",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "03",
    tumbon_code: "09",
    name: "ใหม่พัฒนา",
    zipcode: "52130",
  },
  {
    jw_code: "52",
    amph_code: "04",
    tumbon_code: "01",
    name: "ทุ่งงาม",
    zipcode: "52210",
  },
  {
    jw_code: "52",
    amph_code: "04",
    tumbon_code: "02",
    name: "เสริมขวา",
    zipcode: "52210",
  },
  {
    jw_code: "52",
    amph_code: "04",
    tumbon_code: "03",
    name: "เสริมซ้าย",
    zipcode: "52210",
  },
  {
    jw_code: "52",
    amph_code: "04",
    tumbon_code: "04",
    name: "เสริมกลาง",
    zipcode: "52210",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "01",
    name: "หลวงเหนือ",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "02",
    name: "หลวงใต้",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "03",
    name: "บ้านโป่ง",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "04",
    name: "บ้านร้อง",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "05",
    name: "ปงเตา",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "06",
    name: "นาแก",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "07",
    name: "บ้านอ้อน",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "08",
    name: "บ้านแหง",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "09",
    name: "บ้านหวด",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "05",
    tumbon_code: "10",
    name: "แม่ตีบ",
    zipcode: "52110",
  },
  {
    jw_code: "52",
    amph_code: "06",
    tumbon_code: "01",
    name: "แจ้ห่ม",
    zipcode: "52120",
  },
  {
    jw_code: "52",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ้านสา",
    zipcode: "52120",
  },
  {
    jw_code: "52",
    amph_code: "06",
    tumbon_code: "03",
    name: "ปงดอน",
    zipcode: "52120",
  },
  {
    jw_code: "52",
    amph_code: "06",
    tumbon_code: "04",
    name: "แม่สุก",
    zipcode: "52120",
  },
  {
    jw_code: "52",
    amph_code: "06",
    tumbon_code: "05",
    name: "เมืองมาย",
    zipcode: "52120",
  },
  {
    jw_code: "52",
    amph_code: "06",
    tumbon_code: "06",
    name: "ทุ่งผึ้ง",
    zipcode: "52120",
  },
  {
    jw_code: "52",
    amph_code: "06",
    tumbon_code: "07",
    name: "วิเชตนคร",
    zipcode: "52120",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "01",
    name: "ทุ่งฮั้ว",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "02",
    name: "วังเหนือ",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "03",
    name: "วังใต้",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "04",
    name: "ร่องเคาะ",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "05",
    name: "วังทอง",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "06",
    name: "วังซ้าย",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "07",
    name: "วังแก้ว",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "07",
    tumbon_code: "08",
    name: "วังทรายคำ",
    zipcode: "52140",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "01",
    name: "ล้อมแรด",
    zipcode: "52160",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "02",
    name: "แม่วะ",
    zipcode: "52230",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "03",
    name: "แม่ปะ",
    zipcode: "52160",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "04",
    name: "แม่มอก",
    zipcode: "52160",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "05",
    name: "เวียงมอก",
    zipcode: "52160",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "06",
    name: "นาโป่ง",
    zipcode: "52160",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "07",
    name: "แม่ถอด",
    zipcode: "52160",
  },
  {
    jw_code: "52",
    amph_code: "08",
    tumbon_code: "08",
    name: "เถินบุรี",
    zipcode: "52160",
  },
  {
    jw_code: "52",
    amph_code: "09",
    tumbon_code: "01",
    name: "แม่พริก",
    zipcode: "52180",
  },
  {
    jw_code: "52",
    amph_code: "09",
    tumbon_code: "02",
    name: "ผาปัง",
    zipcode: "52180",
  },
  {
    jw_code: "52",
    amph_code: "09",
    tumbon_code: "03",
    name: "แม่ปุ",
    zipcode: "52180",
  },
  {
    jw_code: "52",
    amph_code: "09",
    tumbon_code: "04",
    name: "พระบาทวังตวง",
    zipcode: "52230",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "01",
    name: "แม่ทะ",
    zipcode: "52220",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "02",
    name: "นาครัว",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "03",
    name: "ป่าตัน",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "04",
    name: "บ้านกิ่ว",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "05",
    name: "บ้านบอม",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "06",
    name: "น้ำโจ้",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "07",
    name: "ดอนไฟ",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "08",
    name: "หัวเสือ",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "10",
    name: "วังเงิน",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "10",
    tumbon_code: "11",
    name: "สันดอนแก้ว",
    zipcode: "52150",
  },
  {
    jw_code: "52",
    amph_code: "11",
    tumbon_code: "01",
    name: "สบปราบ",
    zipcode: "52170",
  },
  {
    jw_code: "52",
    amph_code: "11",
    tumbon_code: "02",
    name: "สมัย",
    zipcode: "52170",
  },
  {
    jw_code: "52",
    amph_code: "11",
    tumbon_code: "03",
    name: "แม่กัวะ",
    zipcode: "52170",
  },
  {
    jw_code: "52",
    amph_code: "11",
    tumbon_code: "04",
    name: "นายาง",
    zipcode: "52170",
  },
  {
    jw_code: "52",
    amph_code: "12",
    tumbon_code: "01",
    name: "ห้างฉัตร",
    zipcode: "52190",
  },
  {
    jw_code: "52",
    amph_code: "12",
    tumbon_code: "02",
    name: "หนองหล่ม",
    zipcode: "52190",
  },
  {
    jw_code: "52",
    amph_code: "12",
    tumbon_code: "03",
    name: "เมืองยาว",
    zipcode: "52190",
  },
  {
    jw_code: "52",
    amph_code: "12",
    tumbon_code: "04",
    name: "ปงยางคก",
    zipcode: "52190",
  },
  {
    jw_code: "52",
    amph_code: "12",
    tumbon_code: "05",
    name: "เวียงตาล",
    zipcode: "52190",
  },
  {
    jw_code: "52",
    amph_code: "12",
    tumbon_code: "06",
    name: "แม่สัน",
    zipcode: "52190",
  },
  {
    jw_code: "52",
    amph_code: "12",
    tumbon_code: "07",
    name: "วอแก้ว",
    zipcode: "52190",
  },
  {
    jw_code: "52",
    amph_code: "13",
    tumbon_code: "01",
    name: "เมืองปาน",
    zipcode: "52240",
  },
  {
    jw_code: "52",
    amph_code: "13",
    tumbon_code: "02",
    name: "บ้านขอ",
    zipcode: "52240",
  },
  {
    jw_code: "52",
    amph_code: "13",
    tumbon_code: "03",
    name: "ทุ่งกว๋าว",
    zipcode: "52240",
  },
  {
    jw_code: "52",
    amph_code: "13",
    tumbon_code: "04",
    name: "แจ้ซ้อน",
    zipcode: "52240",
  },
  {
    jw_code: "52",
    amph_code: "13",
    tumbon_code: "05",
    name: "หัวเมือง",
    zipcode: "52240",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "01",
    name: "ท่าอิฐ",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "02",
    name: "ท่าเสา",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านเกาะ",
    zipcode: "53170",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "04",
    name: "ป่าเซ่า",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "05",
    name: "คุ้งตะเภา",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "06",
    name: "วังกะพี้",
    zipcode: "53170",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "07",
    name: "หาดกรวด",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "08",
    name: "น้ำริด",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "09",
    name: "งิ้วงาม",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "10",
    name: "บ้านด่านนาขาม",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "11",
    name: "บ้านด่าน",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "12",
    name: "ผาจุก",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "13",
    name: "วังดิน",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "14",
    name: "แสนตอ",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "15",
    name: "หาดงิ้ว",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "16",
    name: "ขุนฝาง",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "01",
    tumbon_code: "17",
    name: "ถ้ำฉลอง",
    zipcode: "53000",
  },
  {
    jw_code: "53",
    amph_code: "02",
    tumbon_code: "01",
    name: "วังแดง",
    zipcode: "53140",
  },
  {
    jw_code: "53",
    amph_code: "02",
    tumbon_code: "02",
    name: "บ้านแก่ง",
    zipcode: "53140",
  },
  {
    jw_code: "53",
    amph_code: "02",
    tumbon_code: "03",
    name: "หาดสองแคว",
    zipcode: "53140",
  },
  {
    jw_code: "53",
    amph_code: "02",
    tumbon_code: "04",
    name: "น้ำอ่าง",
    zipcode: "53140",
  },
  {
    jw_code: "53",
    amph_code: "02",
    tumbon_code: "05",
    name: "ข่อยสูง",
    zipcode: "53140",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "01",
    name: "ท่าปลา",
    zipcode: "53150",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "02",
    name: "หาดล้า",
    zipcode: "53190",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "03",
    name: "ผาเลือด",
    zipcode: "53190",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "04",
    name: "จริม",
    zipcode: "53150",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "05",
    name: "น้ำหมัน",
    zipcode: "53150",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "06",
    name: "ท่าแฝก(ยกเลิก)",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "07",
    name: "นางพญา",
    zipcode: "53150",
  },
  {
    jw_code: "53",
    amph_code: "03",
    tumbon_code: "08",
    name: "ร่วมจิต",
    zipcode: "53190",
  },
  {
    jw_code: "53",
    amph_code: "04",
    tumbon_code: "01",
    name: "แสนตอ",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "04",
    tumbon_code: "02",
    name: "บ้านฝาย",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "04",
    tumbon_code: "03",
    name: "เด่นเหล็ก",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "04",
    tumbon_code: "04",
    name: "น้ำไคร้",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "04",
    tumbon_code: "05",
    name: "น้ำไผ่",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "04",
    tumbon_code: "06",
    name: "ห้วยมุ่น",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "04",
    tumbon_code: "07",
    name: "ท่าแฝก",
    zipcode: "53110",
  },
  {
    jw_code: "53",
    amph_code: "05",
    tumbon_code: "01",
    name: "ฟากท่า",
    zipcode: "53160",
  },
  {
    jw_code: "53",
    amph_code: "05",
    tumbon_code: "02",
    name: "สองคอน",
    zipcode: "53160",
  },
  {
    jw_code: "53",
    amph_code: "05",
    tumbon_code: "03",
    name: "บ้านเสี้ยว",
    zipcode: "53160",
  },
  {
    jw_code: "53",
    amph_code: "05",
    tumbon_code: "04",
    name: "สองห้อง",
    zipcode: "53160",
  },
  {
    jw_code: "53",
    amph_code: "06",
    tumbon_code: "01",
    name: "ม่วงเจ็ดต้น",
    zipcode: "53180",
  },
  {
    jw_code: "53",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ้านโคก",
    zipcode: "53180",
  },
  {
    jw_code: "53",
    amph_code: "06",
    tumbon_code: "03",
    name: "นาขุม",
    zipcode: "53180",
  },
  {
    jw_code: "53",
    amph_code: "06",
    tumbon_code: "04",
    name: "บ่อเบี้ย",
    zipcode: "53180",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "02",
    name: "บ้านดารา",
    zipcode: "53220",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "03",
    name: "ไร่อ้อย",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "04",
    name: "ท่าสัก",
    zipcode: "53220",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "05",
    name: "คอรุม",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "06",
    name: "บ้านหม้อ",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "07",
    name: "ท่ามะเฟือง",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "08",
    name: "บ้านโคน",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "09",
    name: "พญาแมน",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "10",
    name: "นาอิน",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "07",
    tumbon_code: "11",
    name: "นายาง",
    zipcode: "53120",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "01",
    name: "ศรีพนมมาศ",
    zipcode: "53130",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "02",
    name: "แม่พูล",
    zipcode: "53130",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "03",
    name: "นานกกก",
    zipcode: "53130",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "04",
    name: "ฝายหลวง",
    zipcode: "53130",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "05",
    name: "ชัยจุมพล",
    zipcode: "53130",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "06",
    name: "ไผ่ล้อม",
    zipcode: "53210",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "07",
    name: "ทุ่งยั้ง",
    zipcode: "53210",
  },
  {
    jw_code: "53",
    amph_code: "08",
    tumbon_code: "08",
    name: "ด่านแม่คำมัน",
    zipcode: "53210",
  },
  {
    jw_code: "53",
    amph_code: "09",
    tumbon_code: "01",
    name: "ผักขวง",
    zipcode: "53230",
  },
  {
    jw_code: "53",
    amph_code: "09",
    tumbon_code: "02",
    name: "บ่อทอง",
    zipcode: "53230",
  },
  {
    jw_code: "53",
    amph_code: "09",
    tumbon_code: "03",
    name: "ป่าคาย",
    zipcode: "53230",
  },
  {
    jw_code: "53",
    amph_code: "09",
    tumbon_code: "04",
    name: "น้ำพี้",
    zipcode: "53230",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเวียง",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "02",
    name: "นาจักร",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "03",
    name: "น้ำชำ",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "04",
    name: "ป่าแดง",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "05",
    name: "ทุ่งโฮ้ง",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "06",
    name: "เหมืองหม้อ",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "07",
    name: "วังธง",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "08",
    name: "แม่หล่าย",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "09",
    name: "ห้วยม้า",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "10",
    name: "ป่าแมต",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "11",
    name: "บ้านถิ่น",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "12",
    name: "สวนเขื่อน",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "13",
    name: "วังหงส์",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "14",
    name: "แม่คำมี",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "15",
    name: "ทุ่งกวาว",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "16",
    name: "ท่าข้าม",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "17",
    name: "แม่ยม",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "18",
    name: "ช่อแฮ",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "19",
    name: "ร่องฟอง",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "01",
    tumbon_code: "20",
    name: "กาญจนา",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "01",
    name: "ร้องกวาง",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "04",
    name: "ร้องเข็ม",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "05",
    name: "น้ำเลา",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "06",
    name: "บ้านเวียง",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "07",
    name: "ทุ่งศรี",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "08",
    name: "แม่ยางตาล",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "09",
    name: "แม่ยางฮ่อ",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "10",
    name: "ไผ่โทน",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "13",
    name: "ห้วยโรง",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "14",
    name: "แม่ทราย",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "02",
    tumbon_code: "15",
    name: "แม่ยางร้อง",
    zipcode: "54140",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "01",
    name: "ห้วยอ้อ",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "02",
    name: "บ้านปิน",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "03",
    name: "ต้าผามอก",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "04",
    name: "เวียงต้า",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "05",
    name: "ปากกาง",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "06",
    name: "หัวทุ่ง",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "07",
    name: "ทุ่งแล้ง",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "08",
    name: "บ่อเหล็กลอง",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "03",
    tumbon_code: "09",
    name: "แม่ปาน",
    zipcode: "54150",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "01",
    name: "สูงเม่น",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "02",
    name: "น้ำชำ",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "03",
    name: "หัวฝาย",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "04",
    name: "ดอนมูล",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "05",
    name: "บ้านเหล่า",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "06",
    name: "บ้านกวาง",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "07",
    name: "บ้านปง",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "08",
    name: "บ้านกาศ",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "09",
    name: "ร่องกาศ",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "10",
    name: "สบสาย",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "11",
    name: "เวียงทอง",
    zipcode: "54000",
  },
  {
    jw_code: "54",
    amph_code: "04",
    tumbon_code: "12",
    name: "พระหลวง",
    zipcode: "54130",
  },
  {
    jw_code: "54",
    amph_code: "05",
    tumbon_code: "01",
    name: "เด่นชัย",
    zipcode: "54110",
  },
  {
    jw_code: "54",
    amph_code: "05",
    tumbon_code: "02",
    name: "แม่จั๊วะ",
    zipcode: "54110",
  },
  {
    jw_code: "54",
    amph_code: "05",
    tumbon_code: "03",
    name: "ไทรย้อย",
    zipcode: "54110",
  },
  {
    jw_code: "54",
    amph_code: "05",
    tumbon_code: "04",
    name: "ห้วยไร่",
    zipcode: "54110",
  },
  {
    jw_code: "54",
    amph_code: "05",
    tumbon_code: "05",
    name: "ปงป่าหวาย",
    zipcode: "54110",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "01",
    name: "บ้านหนุน",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ้านกลาง",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "03",
    name: "ห้วยหม้าย",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "04",
    name: "เตาปูน",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "05",
    name: "หัวเมือง",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "06",
    name: "สะเอียบ",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "07",
    name: "แดนชุมพล",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "06",
    tumbon_code: "08",
    name: "ทุ่งน้าว",
    zipcode: "54120",
  },
  {
    jw_code: "54",
    amph_code: "07",
    tumbon_code: "01",
    name: "วังชิ้น",
    zipcode: "54160",
  },
  {
    jw_code: "54",
    amph_code: "07",
    tumbon_code: "02",
    name: "สรอย",
    zipcode: "54160",
  },
  {
    jw_code: "54",
    amph_code: "07",
    tumbon_code: "03",
    name: "แม่ป้าก",
    zipcode: "54160",
  },
  {
    jw_code: "54",
    amph_code: "07",
    tumbon_code: "04",
    name: "นาพูน",
    zipcode: "54160",
  },
  {
    jw_code: "54",
    amph_code: "07",
    tumbon_code: "05",
    name: "แม่พุง",
    zipcode: "54160",
  },
  {
    jw_code: "54",
    amph_code: "07",
    tumbon_code: "06",
    name: "ป่าสัก",
    zipcode: "54160",
  },
  {
    jw_code: "54",
    amph_code: "07",
    tumbon_code: "07",
    name: "แม่เกิ๋ง",
    zipcode: "54160",
  },
  {
    jw_code: "54",
    amph_code: "08",
    tumbon_code: "01",
    name: "แม่คำมี",
    zipcode: "54170",
  },
  {
    jw_code: "54",
    amph_code: "08",
    tumbon_code: "02",
    name: "หนองม่วงไข่",
    zipcode: "54170",
  },
  {
    jw_code: "54",
    amph_code: "08",
    tumbon_code: "03",
    name: "น้ำรัด",
    zipcode: "54170",
  },
  {
    jw_code: "54",
    amph_code: "08",
    tumbon_code: "04",
    name: "วังหลวง",
    zipcode: "54170",
  },
  {
    jw_code: "54",
    amph_code: "08",
    tumbon_code: "05",
    name: "ตำหนักธรรม",
    zipcode: "54170",
  },
  {
    jw_code: "54",
    amph_code: "08",
    tumbon_code: "06",
    name: "ทุ่งแค้ว",
    zipcode: "54170",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเวียง",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "02",
    name: "บ่อ",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "03",
    name: "ผาสิงห์",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "04",
    name: "ไชยสถาน",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "05",
    name: "ถืมตอง",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "06",
    name: "เรือง",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "07",
    name: "นาซาว",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "08",
    name: "ดู่ใต้",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "09",
    name: "กองควาย",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "16",
    name: "บ่อสวก",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "01",
    tumbon_code: "17",
    name: "สะเนียน",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "02",
    tumbon_code: "02",
    name: "หนองแดง",
    zipcode: "55170",
  },
  {
    jw_code: "55",
    amph_code: "02",
    tumbon_code: "03",
    name: "หมอเมือง",
    zipcode: "55170",
  },
  {
    jw_code: "55",
    amph_code: "02",
    tumbon_code: "04",
    name: "น้ำพาง",
    zipcode: "55170",
  },
  {
    jw_code: "55",
    amph_code: "02",
    tumbon_code: "05",
    name: "น้ำปาย",
    zipcode: "55170",
  },
  {
    jw_code: "55",
    amph_code: "02",
    tumbon_code: "06",
    name: "แม่จริม",
    zipcode: "55170",
  },
  {
    jw_code: "55",
    amph_code: "03",
    tumbon_code: "01",
    name: "บ้านฟ้า",
    zipcode: "55190",
  },
  {
    jw_code: "55",
    amph_code: "03",
    tumbon_code: "02",
    name: "ป่าคาหลวง",
    zipcode: "55190",
  },
  {
    jw_code: "55",
    amph_code: "03",
    tumbon_code: "03",
    name: "สวด",
    zipcode: "55190",
  },
  {
    jw_code: "55",
    amph_code: "03",
    tumbon_code: "04",
    name: "บ้านพี้",
    zipcode: "55190",
  },
  {
    jw_code: "55",
    amph_code: "04",
    tumbon_code: "01",
    name: "นาน้อย",
    zipcode: "55150",
  },
  {
    jw_code: "55",
    amph_code: "04",
    tumbon_code: "02",
    name: "เชียงของ",
    zipcode: "55150",
  },
  {
    jw_code: "55",
    amph_code: "04",
    tumbon_code: "03",
    name: "ศรีษะเกษ",
    zipcode: "55150",
  },
  {
    jw_code: "55",
    amph_code: "04",
    tumbon_code: "04",
    name: "สถาน",
    zipcode: "55150",
  },
  {
    jw_code: "55",
    amph_code: "04",
    tumbon_code: "05",
    name: "สันทะ",
    zipcode: "55150",
  },
  {
    jw_code: "55",
    amph_code: "04",
    tumbon_code: "06",
    name: "บัวใหญ่",
    zipcode: "55150",
  },
  {
    jw_code: "55",
    amph_code: "04",
    tumbon_code: "07",
    name: "น้ำตก",
    zipcode: "55150",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "01",
    name: "ปัว",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "02",
    name: "แงง",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "03",
    name: "สถาน",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "04",
    name: "ศิลาแลง",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "05",
    name: "ศิลาเพชร",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "06",
    name: "อวน",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "09",
    name: "ไชยวัฒนา",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "10",
    name: "เจดีย์ชัย",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "11",
    name: "ภูคา",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "12",
    name: "สกาด",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "13",
    name: "ป่ากลาง",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "05",
    tumbon_code: "14",
    name: "วรนคร",
    zipcode: "55120",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "01",
    name: "ริม",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "02",
    name: "ป่าคา",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "03",
    name: "ผาตอ",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "04",
    name: "ยม",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "05",
    name: "ตาลชุม",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "06",
    name: "ศรีภูมิ",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "07",
    name: "จอมพระ",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "08",
    name: "แสนทอง",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "09",
    name: "ท่าวังผา",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "06",
    tumbon_code: "10",
    name: "ผาทอง",
    zipcode: "55140",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "01",
    name: "กลางเวียง",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "02",
    name: "ขึ่ง",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "03",
    name: "ไหล่น่าน",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "04",
    name: "ตาลชุม",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "05",
    name: "นาเหลือง",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "06",
    name: "ส้าน",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "07",
    name: "น้ำมวบ",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "08",
    name: "น้ำปั้ว",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "09",
    name: "ยาบหัวนา",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "10",
    name: "ปงสนุก",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "11",
    name: "อ่ายนาไลย",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "12",
    name: "ส้านนาหนองใหม่",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "13",
    name: "แม่ขะนิง",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "14",
    name: "แม่สาคร",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "15",
    name: "จอมจันทร์",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "16",
    name: "แม่สา",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "07",
    tumbon_code: "17",
    name: "ทุ่งศรีทอง",
    zipcode: "55110",
  },
  {
    jw_code: "55",
    amph_code: "08",
    tumbon_code: "01",
    name: "ปอน",
    zipcode: "55130",
  },
  {
    jw_code: "55",
    amph_code: "08",
    tumbon_code: "02",
    name: "งอบ",
    zipcode: "55130",
  },
  {
    jw_code: "55",
    amph_code: "08",
    tumbon_code: "03",
    name: "และ",
    zipcode: "55130",
  },
  {
    jw_code: "55",
    amph_code: "08",
    tumbon_code: "04",
    name: "ทุ่งช้าง",
    zipcode: "55130",
  },
  {
    jw_code: "55",
    amph_code: "09",
    tumbon_code: "01",
    name: "เชียงกลาง",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "09",
    tumbon_code: "02",
    name: "เปือ",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "09",
    tumbon_code: "03",
    name: "เชียงคาน",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "09",
    tumbon_code: "04",
    name: "พระธาตุ",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "09",
    tumbon_code: "08",
    name: "พญาแก้ว",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "09",
    tumbon_code: "09",
    name: "พระพุทธบาท",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "10",
    tumbon_code: "01",
    name: "นาทะนุง",
    zipcode: "55180",
  },
  {
    jw_code: "55",
    amph_code: "10",
    tumbon_code: "02",
    name: "บ่อแก้ว",
    zipcode: "55180",
  },
  {
    jw_code: "55",
    amph_code: "10",
    tumbon_code: "03",
    name: "เมืองลี",
    zipcode: "55180",
  },
  {
    jw_code: "55",
    amph_code: "10",
    tumbon_code: "04",
    name: "ปิงหลวง",
    zipcode: "55180",
  },
  {
    jw_code: "55",
    amph_code: "11",
    tumbon_code: "01",
    name: "ดู่พงษ์",
    zipcode: "55210",
  },
  {
    jw_code: "55",
    amph_code: "11",
    tumbon_code: "02",
    name: "ป่าแลวหลวง",
    zipcode: "55210",
  },
  {
    jw_code: "55",
    amph_code: "11",
    tumbon_code: "03",
    name: "พงษ์",
    zipcode: "55210",
  },
  {
    jw_code: "55",
    amph_code: "12",
    tumbon_code: "01",
    name: "บ่อเกลือเหนือ",
    zipcode: "55220",
  },
  {
    jw_code: "55",
    amph_code: "12",
    tumbon_code: "02",
    name: "บ่อเกลือใต้",
    zipcode: "55220",
  },
  {
    jw_code: "55",
    amph_code: "12",
    tumbon_code: "04",
    name: "ภูฟ้า",
    zipcode: "55220",
  },
  {
    jw_code: "55",
    amph_code: "12",
    tumbon_code: "05",
    name: "ดงพญา",
    zipcode: "55220",
  },
  {
    jw_code: "55",
    amph_code: "13",
    tumbon_code: "01",
    name: "นาไร่หลวง",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "13",
    tumbon_code: "02",
    name: "ชนแดน",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "13",
    tumbon_code: "03",
    name: "ยอด",
    zipcode: "55160",
  },
  {
    jw_code: "55",
    amph_code: "14",
    tumbon_code: "01",
    name: "ม่วงตึ๊ด",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "14",
    tumbon_code: "02",
    name: "นาปัง",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "14",
    tumbon_code: "03",
    name: "น้ำแก่น",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "14",
    tumbon_code: "04",
    name: "น้ำเกี๋ยน",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "14",
    tumbon_code: "05",
    name: "เมืองจัง",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "14",
    tumbon_code: "06",
    name: "ท่าน้าว",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "14",
    tumbon_code: "07",
    name: "ฝายแก้ว",
    zipcode: "55000",
  },
  {
    jw_code: "55",
    amph_code: "15",
    tumbon_code: "01",
    name: "ห้วยโก๋น",
    zipcode: "30230",
  },
  {
    jw_code: "55",
    amph_code: "15",
    tumbon_code: "02",
    name: "ขุนน่าน",
    zipcode: "30230",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "01",
    name: "เวียง",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "02",
    name: "แม่ต๋ำ",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "04",
    name: "แม่นาเรือ",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านตุ่น",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "06",
    name: "บ้านต๊ำ",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "07",
    name: "บ้านต๋อม",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "08",
    name: "แม่ปืม",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "10",
    name: "แม่กา",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "11",
    name: "บ้านใหม่",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "12",
    name: "จำป่าหวาย",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "13",
    name: "ท่าวังทอง",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "14",
    name: "แม่ใส",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "15",
    name: "บ้านสาง",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "16",
    name: "ท่าจำปี",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "01",
    tumbon_code: "18",
    name: "สันป่าม่วง",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "02",
    tumbon_code: "01",
    name: "ห้วยข้าวก่ำ",
    zipcode: "56150",
  },
  {
    jw_code: "56",
    amph_code: "02",
    tumbon_code: "02",
    name: "จุน",
    zipcode: "56150",
  },
  {
    jw_code: "56",
    amph_code: "02",
    tumbon_code: "03",
    name: "ลอ",
    zipcode: "56150",
  },
  {
    jw_code: "56",
    amph_code: "02",
    tumbon_code: "04",
    name: "หงส์หิน",
    zipcode: "56150",
  },
  {
    jw_code: "56",
    amph_code: "02",
    tumbon_code: "05",
    name: "ทุ่งรวงทอง",
    zipcode: "56150",
  },
  {
    jw_code: "56",
    amph_code: "02",
    tumbon_code: "06",
    name: "ห้วยยางขาม",
    zipcode: "56150",
  },
  {
    jw_code: "56",
    amph_code: "02",
    tumbon_code: "07",
    name: "พระธาตุขิงแกง",
    zipcode: "56150",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "01",
    name: "หย่วน",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "06",
    name: "น้ำแวน",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "07",
    name: "เวียง",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "08",
    name: "ฝายกวาง",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "09",
    name: "เจดีย์คำ",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "10",
    name: "ร่มเย็น",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "11",
    name: "เชียงบาน",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "12",
    name: "แม่ลาว",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "13",
    name: "อ่างทอง",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "03",
    tumbon_code: "14",
    name: "ทุ่งผาสุข",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "04",
    tumbon_code: "01",
    name: "เชียงม่วน",
    zipcode: "56160",
  },
  {
    jw_code: "56",
    amph_code: "04",
    tumbon_code: "02",
    name: "บ้านมาง",
    zipcode: "56160",
  },
  {
    jw_code: "56",
    amph_code: "04",
    tumbon_code: "03",
    name: "สระ",
    zipcode: "56160",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "01",
    name: "ดอกคำใต้",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "02",
    name: "ดอนศรีชุม",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "03",
    name: "บ้านถ้ำ",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "04",
    name: "บ้านปิน",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "05",
    name: "ห้วยลาน",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "06",
    name: "สันโค้ง",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "07",
    name: "ป่าซาง",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "08",
    name: "หนองหล่ม",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "09",
    name: "ดงสุวรรณ",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "10",
    name: "บุญเกิด",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "11",
    name: "สว่างอารมณ์",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "05",
    tumbon_code: "12",
    name: "คือเวียง",
    zipcode: "56120",
  },
  {
    jw_code: "56",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปง",
    zipcode: "56140",
  },
  {
    jw_code: "56",
    amph_code: "06",
    tumbon_code: "02",
    name: "ควร",
    zipcode: "56140",
  },
  {
    jw_code: "56",
    amph_code: "06",
    tumbon_code: "03",
    name: "ออย",
    zipcode: "56140",
  },
  {
    jw_code: "56",
    amph_code: "06",
    tumbon_code: "04",
    name: "งิม",
    zipcode: "56140",
  },
  {
    jw_code: "56",
    amph_code: "06",
    tumbon_code: "05",
    name: "ผาช้างน้อย",
    zipcode: "56140",
  },
  {
    jw_code: "56",
    amph_code: "06",
    tumbon_code: "06",
    name: "นาปรัง",
    zipcode: "56140",
  },
  {
    jw_code: "56",
    amph_code: "06",
    tumbon_code: "07",
    name: "ขุนควร",
    zipcode: "56140",
  },
  {
    jw_code: "56",
    amph_code: "07",
    tumbon_code: "01",
    name: "แม่ใจ",
    zipcode: "56130",
  },
  {
    jw_code: "56",
    amph_code: "07",
    tumbon_code: "02",
    name: "ศรีถ้อย",
    zipcode: "56130",
  },
  {
    jw_code: "56",
    amph_code: "07",
    tumbon_code: "03",
    name: "แม่สุก",
    zipcode: "56130",
  },
  {
    jw_code: "56",
    amph_code: "07",
    tumbon_code: "04",
    name: "ป่าแฝก",
    zipcode: "56130",
  },
  {
    jw_code: "56",
    amph_code: "07",
    tumbon_code: "05",
    name: "บ้านเหล่า",
    zipcode: "56130",
  },
  {
    jw_code: "56",
    amph_code: "07",
    tumbon_code: "06",
    name: "เจริญราษฎร์",
    zipcode: "56130",
  },
  {
    jw_code: "56",
    amph_code: "08",
    tumbon_code: "01",
    name: "ภูซาง",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "08",
    tumbon_code: "02",
    name: "ป่าสัก",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "08",
    tumbon_code: "03",
    name: "ทุ่งกล้วย",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "08",
    tumbon_code: "04",
    name: "เชียงแรง",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "08",
    tumbon_code: "05",
    name: "สบบง",
    zipcode: "56110",
  },
  {
    jw_code: "56",
    amph_code: "09",
    tumbon_code: "01",
    name: "ห้วยแก้ว",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "09",
    tumbon_code: "02",
    name: "ดงเจน",
    zipcode: "56000",
  },
  {
    jw_code: "56",
    amph_code: "09",
    tumbon_code: "03",
    name: "แม่อิง",
    zipcode: "56000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "01",
    name: "เวียง",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "02",
    name: "รอบเวียง",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านดู่",
    zipcode: "57100",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "04",
    name: "นางแล",
    zipcode: "57100",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "05",
    name: "แม่ข้าวต้ม",
    zipcode: "57100",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "06",
    name: "แม่ยาว",
    zipcode: "57100",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "07",
    name: "สันทราย",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "11",
    name: "แม่กรณ์",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "12",
    name: "ห้วยชมภู",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "13",
    name: "ห้วยสัก",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "14",
    name: "ริมกก",
    zipcode: "57100",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "15",
    name: "ดอยลาน",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "16",
    name: "ป่าอ้อดอนชัย",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "18",
    name: "ท่าสาย",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "20",
    name: "ดอยฮาง",
    zipcode: "57000",
  },
  {
    jw_code: "57",
    amph_code: "01",
    tumbon_code: "21",
    name: "ท่าสุด",
    zipcode: "57100",
  },
  {
    jw_code: "57",
    amph_code: "02",
    tumbon_code: "02",
    name: "เวียงชัย",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "02",
    tumbon_code: "03",
    name: "ผางาม",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "02",
    tumbon_code: "04",
    name: "เวียงเหนือ",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "02",
    tumbon_code: "06",
    name: "ดอนศิลา",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "02",
    tumbon_code: "08",
    name: "เมืองชุม",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "03",
    tumbon_code: "01",
    name: "เวียง",
    zipcode: "57140",
  },
  {
    jw_code: "57",
    amph_code: "03",
    tumbon_code: "02",
    name: "สถาน",
    zipcode: "57140",
  },
  {
    jw_code: "57",
    amph_code: "03",
    tumbon_code: "03",
    name: "ครึ่ง",
    zipcode: "57140",
  },
  {
    jw_code: "57",
    amph_code: "03",
    tumbon_code: "04",
    name: "บุญเรือง",
    zipcode: "57140",
  },
  {
    jw_code: "57",
    amph_code: "03",
    tumbon_code: "05",
    name: "ห้วยซ้อ",
    zipcode: "57140",
  },
  {
    jw_code: "57",
    amph_code: "03",
    tumbon_code: "08",
    name: "ศรีดอนชัย",
    zipcode: "57140",
  },
  {
    jw_code: "57",
    amph_code: "03",
    tumbon_code: "10",
    name: "ริมโขง",
    zipcode: "57140",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "01",
    name: "เวียง",
    zipcode: "57160",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "02",
    name: "งิ้ว",
    zipcode: "57230",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "03",
    name: "ปล้อง",
    zipcode: "57230",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "04",
    name: "แม่ลอย",
    zipcode: "57230",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "05",
    name: "เชียงเคี่ยน",
    zipcode: "57230",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "09",
    name: "ตับเต่า",
    zipcode: "57160",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "10",
    name: "หงาว",
    zipcode: "57160",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "11",
    name: "สันทรายงาม",
    zipcode: "57160",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "12",
    name: "ศรีดอนไชย",
    zipcode: "57230",
  },
  {
    jw_code: "57",
    amph_code: "04",
    tumbon_code: "13",
    name: "หนองแรด",
    zipcode: "57230",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "01",
    name: "สันมะเค็ด",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "02",
    name: "แม่อ้อ",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "03",
    name: "ธารทอง",
    zipcode: "57250",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "04",
    name: "สันติสุข",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "05",
    name: "ดอยงาม",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "06",
    name: "หัวง้ม",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "07",
    name: "เจริญเมือง",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "08",
    name: "ป่าหุ่ง",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "09",
    name: "ม่วงคำ",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "10",
    name: "ทรายขาว",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "11",
    name: "สันกลาง",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "12",
    name: "แม่เย็น",
    zipcode: "57280",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "13",
    name: "เมืองพาน",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "14",
    name: "ทานตะวัน",
    zipcode: "57280",
  },
  {
    jw_code: "57",
    amph_code: "05",
    tumbon_code: "15",
    name: "เวียงห้าว",
    zipcode: "57120",
  },
  {
    jw_code: "57",
    amph_code: "06",
    tumbon_code: "01",
    name: "ป่าแดด",
    zipcode: "57190",
  },
  {
    jw_code: "57",
    amph_code: "06",
    tumbon_code: "02",
    name: "ป่าแงะ",
    zipcode: "57190",
  },
  {
    jw_code: "57",
    amph_code: "06",
    tumbon_code: "03",
    name: "สันมะค่า",
    zipcode: "57190",
  },
  {
    jw_code: "57",
    amph_code: "06",
    tumbon_code: "05",
    name: "โรงช้าง",
    zipcode: "57190",
  },
  {
    jw_code: "57",
    amph_code: "06",
    tumbon_code: "06",
    name: "ศรีโพธิ์เงิน",
    zipcode: "57190",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "01",
    name: "แม่จัน",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "02",
    name: "จันจว้า",
    zipcode: "57270",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "03",
    name: "แม่คำ",
    zipcode: "57240",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "04",
    name: "ป่าซาง",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "05",
    name: "สันทราย",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "06",
    name: "ท่าข้าวเปลือก",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "08",
    name: "ป่าตึง",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "10",
    name: "แม่ไร่",
    zipcode: "57240",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "11",
    name: "ศรีค้ำ",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "12",
    name: "จันจว้าใต้",
    zipcode: "57270",
  },
  {
    jw_code: "57",
    amph_code: "07",
    tumbon_code: "13",
    name: "จอมสวรรค์",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "08",
    tumbon_code: "01",
    name: "เวียง",
    zipcode: "57150",
  },
  {
    jw_code: "57",
    amph_code: "08",
    tumbon_code: "02",
    name: "ป่าสัก",
    zipcode: "57150",
  },
  {
    jw_code: "57",
    amph_code: "08",
    tumbon_code: "03",
    name: "บ้านแซว",
    zipcode: "57150",
  },
  {
    jw_code: "57",
    amph_code: "08",
    tumbon_code: "04",
    name: "ศรีดอนมูล",
    zipcode: "57150",
  },
  {
    jw_code: "57",
    amph_code: "08",
    tumbon_code: "05",
    name: "แม่เงิน",
    zipcode: "57150",
  },
  {
    jw_code: "57",
    amph_code: "08",
    tumbon_code: "06",
    name: "โยนก",
    zipcode: "57150",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "01",
    name: "แม่สาย",
    zipcode: "57130",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "02",
    name: "ห้วยไคร้",
    zipcode: "57220",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "03",
    name: "เกาะช้าง",
    zipcode: "57130",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "04",
    name: "โป่งผา",
    zipcode: "57130",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "05",
    name: "ศรีเมืองชุม",
    zipcode: "57130",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "06",
    name: "เวียงพางคำ",
    zipcode: "57130",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "08",
    name: "บ้านด้าย",
    zipcode: "57220",
  },
  {
    jw_code: "57",
    amph_code: "09",
    tumbon_code: "09",
    name: "โป่งงาม",
    zipcode: "57130",
  },
  {
    jw_code: "57",
    amph_code: "10",
    tumbon_code: "01",
    name: "แม่สรวย",
    zipcode: "57180",
  },
  {
    jw_code: "57",
    amph_code: "10",
    tumbon_code: "02",
    name: "ป่าแดด",
    zipcode: "57180",
  },
  {
    jw_code: "57",
    amph_code: "10",
    tumbon_code: "03",
    name: "แม่พริก",
    zipcode: "57180",
  },
  {
    jw_code: "57",
    amph_code: "10",
    tumbon_code: "04",
    name: "ศรีถ้อย",
    zipcode: "57180",
  },
  {
    jw_code: "57",
    amph_code: "10",
    tumbon_code: "05",
    name: "ท่าก๊อ",
    zipcode: "57180",
  },
  {
    jw_code: "57",
    amph_code: "10",
    tumbon_code: "06",
    name: "วาวี",
    zipcode: "57180",
  },
  {
    jw_code: "57",
    amph_code: "10",
    tumbon_code: "07",
    name: "เจดีย์หลวง",
    zipcode: "57180",
  },
  {
    jw_code: "57",
    amph_code: "11",
    tumbon_code: "01",
    name: "สันสลี",
    zipcode: "57170",
  },
  {
    jw_code: "57",
    amph_code: "11",
    tumbon_code: "02",
    name: "เวียง",
    zipcode: "57170",
  },
  {
    jw_code: "57",
    amph_code: "11",
    tumbon_code: "03",
    name: "บ้านโป่ง",
    zipcode: "57170",
  },
  {
    jw_code: "57",
    amph_code: "11",
    tumbon_code: "04",
    name: "ป่างิ้ว",
    zipcode: "57170",
  },
  {
    jw_code: "57",
    amph_code: "11",
    tumbon_code: "05",
    name: "เวียงกาหลง",
    zipcode: "57260",
  },
  {
    jw_code: "57",
    amph_code: "11",
    tumbon_code: "06",
    name: "แม่เจดีย์",
    zipcode: "57260",
  },
  {
    jw_code: "57",
    amph_code: "11",
    tumbon_code: "07",
    name: "แม่เจดีย์ใหม่",
    zipcode: "57260",
  },
  {
    jw_code: "57",
    amph_code: "12",
    tumbon_code: "01",
    name: "แม่เปา",
    zipcode: "57290",
  },
  {
    jw_code: "57",
    amph_code: "12",
    tumbon_code: "02",
    name: "แม่ต๋ำ",
    zipcode: "57290",
  },
  {
    jw_code: "57",
    amph_code: "12",
    tumbon_code: "03",
    name: "ไม้ยา",
    zipcode: "57290",
  },
  {
    jw_code: "57",
    amph_code: "12",
    tumbon_code: "04",
    name: "เม็งราย",
    zipcode: "57290",
  },
  {
    jw_code: "57",
    amph_code: "12",
    tumbon_code: "05",
    name: "ตาดควัน",
    zipcode: "57290",
  },
  {
    jw_code: "57",
    amph_code: "13",
    tumbon_code: "01",
    name: "ม่วงยาย",
    zipcode: "57310",
  },
  {
    jw_code: "57",
    amph_code: "13",
    tumbon_code: "02",
    name: "ปอ",
    zipcode: "57310",
  },
  {
    jw_code: "57",
    amph_code: "13",
    tumbon_code: "03",
    name: "หล่ายงาว",
    zipcode: "57310",
  },
  {
    jw_code: "57",
    amph_code: "13",
    tumbon_code: "04",
    name: "ท่าข้าม",
    zipcode: "57310",
  },
  {
    jw_code: "57",
    amph_code: "14",
    tumbon_code: "01",
    name: "ต้า",
    zipcode: "57340",
  },
  {
    jw_code: "57",
    amph_code: "14",
    tumbon_code: "02",
    name: "ป่าตาล",
    zipcode: "57340",
  },
  {
    jw_code: "57",
    amph_code: "14",
    tumbon_code: "03",
    name: "ยางฮอม",
    zipcode: "57340",
  },
  {
    jw_code: "57",
    amph_code: "15",
    tumbon_code: "01",
    name: "เทอดไทย",
    zipcode: "57240",
  },
  {
    jw_code: "57",
    amph_code: "15",
    tumbon_code: "02",
    name: "แม่สลองใน",
    zipcode: "57240",
  },
  {
    jw_code: "57",
    amph_code: "15",
    tumbon_code: "03",
    name: "แม่สลองนอก",
    zipcode: "57240",
  },
  {
    jw_code: "57",
    amph_code: "15",
    tumbon_code: "04",
    name: "แม่ฟ้าหลวง",
    zipcode: "57240",
  },
  {
    jw_code: "57",
    amph_code: "16",
    tumbon_code: "01",
    name: "ดงมะดะ",
    zipcode: "57250",
  },
  {
    jw_code: "57",
    amph_code: "16",
    tumbon_code: "02",
    name: "จอมหมอกแก้ว",
    zipcode: "57250",
  },
  {
    jw_code: "57",
    amph_code: "16",
    tumbon_code: "03",
    name: "บัวสลี",
    zipcode: "57250",
  },
  {
    jw_code: "57",
    amph_code: "16",
    tumbon_code: "04",
    name: "ป่าก่อดำ",
    zipcode: "57250",
  },
  {
    jw_code: "57",
    amph_code: "16",
    tumbon_code: "05",
    name: "โป่งแพร่",
    zipcode: "57250",
  },
  {
    jw_code: "57",
    amph_code: "17",
    tumbon_code: "01",
    name: "ทุ่งก่อ",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "17",
    tumbon_code: "02",
    name: "ดงมหาวัน",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "17",
    tumbon_code: "03",
    name: "ป่าซาง",
    zipcode: "57210",
  },
  {
    jw_code: "57",
    amph_code: "18",
    tumbon_code: "01",
    name: "ปงน้อย",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "18",
    tumbon_code: "02",
    name: "โชคชัย",
    zipcode: "57110",
  },
  {
    jw_code: "57",
    amph_code: "18",
    tumbon_code: "03",
    name: "หนองป่าก่อ",
    zipcode: "57110",
  },
  {
    jw_code: "58",
    amph_code: "01",
    tumbon_code: "01",
    name: "จองคำ",
    zipcode: "58000",
  },
  {
    jw_code: "58",
    amph_code: "01",
    tumbon_code: "02",
    name: "ห้วยโป่ง",
    zipcode: "58000",
  },
  {
    jw_code: "58",
    amph_code: "01",
    tumbon_code: "03",
    name: "ผาบ่อง",
    zipcode: "58000",
  },
  {
    jw_code: "58",
    amph_code: "01",
    tumbon_code: "04",
    name: "ปางหมู",
    zipcode: "58000",
  },
  {
    jw_code: "58",
    amph_code: "01",
    tumbon_code: "05",
    name: "หมอกจำแป่",
    zipcode: "58000",
  },
  {
    jw_code: "58",
    amph_code: "01",
    tumbon_code: "06",
    name: "ห้วยผา",
    zipcode: "58000",
  },
  {
    jw_code: "58",
    amph_code: "01",
    tumbon_code: "09",
    name: "ห้วยปูลิง",
    zipcode: "58000",
  },
  {
    jw_code: "58",
    amph_code: "02",
    tumbon_code: "01",
    name: "ขุนยวม",
    zipcode: "58140",
  },
  {
    jw_code: "58",
    amph_code: "02",
    tumbon_code: "02",
    name: "แม่เงา",
    zipcode: "58140",
  },
  {
    jw_code: "58",
    amph_code: "02",
    tumbon_code: "03",
    name: "เมืองปอน",
    zipcode: "58140",
  },
  {
    jw_code: "58",
    amph_code: "02",
    tumbon_code: "04",
    name: "แม่ยวมน้อย",
    zipcode: "58140",
  },
  {
    jw_code: "58",
    amph_code: "02",
    tumbon_code: "05",
    name: "แม่กิ๊",
    zipcode: "58140",
  },
  {
    jw_code: "58",
    amph_code: "02",
    tumbon_code: "06",
    name: "แม่อูคอ",
    zipcode: "58140",
  },
  {
    jw_code: "58",
    amph_code: "03",
    tumbon_code: "01",
    name: "เวียงใต้",
    zipcode: "58130",
  },
  {
    jw_code: "58",
    amph_code: "03",
    tumbon_code: "02",
    name: "เวียงเหนือ",
    zipcode: "58130",
  },
  {
    jw_code: "58",
    amph_code: "03",
    tumbon_code: "03",
    name: "แม่นาเติง",
    zipcode: "58130",
  },
  {
    jw_code: "58",
    amph_code: "03",
    tumbon_code: "04",
    name: "แม่ฮี้",
    zipcode: "58130",
  },
  {
    jw_code: "58",
    amph_code: "03",
    tumbon_code: "05",
    name: "ทุ่งยาว",
    zipcode: "58130",
  },
  {
    jw_code: "58",
    amph_code: "03",
    tumbon_code: "06",
    name: "เมืองแปง",
    zipcode: "58130",
  },
  {
    jw_code: "58",
    amph_code: "03",
    tumbon_code: "07",
    name: "โป่งสา",
    zipcode: "58130",
  },
  {
    jw_code: "58",
    amph_code: "04",
    tumbon_code: "01",
    name: "บ้านกาศ",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "04",
    tumbon_code: "02",
    name: "แม่สะเรียง",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "04",
    tumbon_code: "03",
    name: "แม่คง",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "04",
    tumbon_code: "04",
    name: "แม่เหาะ",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "04",
    tumbon_code: "05",
    name: "แม่ยวม",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "04",
    tumbon_code: "06",
    name: "เสาหิน",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "04",
    tumbon_code: "08",
    name: "ป่าแป๋",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "01",
    name: "แม่ลาน้อย",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "02",
    name: "แม่ลาหลวง",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "03",
    name: "ท่าผาปุ้ม",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "04",
    name: "แม่โถ",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "05",
    name: "ห้วยห้อม",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "06",
    name: "แม่นาจาง",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "07",
    name: "สันติคีรี",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "05",
    tumbon_code: "08",
    name: "ขุนแม่ลาน้อย",
    zipcode: "58120",
  },
  {
    jw_code: "58",
    amph_code: "06",
    tumbon_code: "01",
    name: "สบเมย",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "06",
    tumbon_code: "02",
    name: "แม่คะตวน",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "06",
    tumbon_code: "03",
    name: "กองก๋อย",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "06",
    tumbon_code: "04",
    name: "แม่สวด",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "06",
    tumbon_code: "05",
    name: "ป่าโปง",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "06",
    tumbon_code: "06",
    name: "แม่สามแลบ",
    zipcode: "58110",
  },
  {
    jw_code: "58",
    amph_code: "07",
    tumbon_code: "01",
    name: "สบป่อง",
    zipcode: "58150",
  },
  {
    jw_code: "58",
    amph_code: "07",
    tumbon_code: "02",
    name: "ปางมะผ้า",
    zipcode: "58150",
  },
  {
    jw_code: "58",
    amph_code: "07",
    tumbon_code: "03",
    name: "ถ้ำลอด",
    zipcode: "58150",
  },
  {
    jw_code: "58",
    amph_code: "07",
    tumbon_code: "04",
    name: "นาปู่ป้อม",
    zipcode: "58150",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "01",
    name: "ปากน้ำโพ",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "02",
    name: "กลางแดด",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "03",
    name: "เกรียงไกร",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "04",
    name: "แควใหญ่",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "05",
    name: "ตะเคียนเลื่อน",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "06",
    name: "นครสวรรค์ตก",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "07",
    name: "นครสวรรค์ออก",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางพระหลวง",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "09",
    name: "บางม่วง",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "10",
    name: "บ้านมะเกลือ",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "11",
    name: "บ้านแก่ง",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "12",
    name: "พระนอน",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "13",
    name: "วัดไทร",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "14",
    name: "หนองกรด",
    zipcode: "60240",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "15",
    name: "หนองกระโดน",
    zipcode: "60240",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "16",
    name: "หนองปลิง",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "01",
    tumbon_code: "17",
    name: "บึงเสนาท",
    zipcode: "60000",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "01",
    name: "โกรกพระ",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "02",
    name: "ยางตาล",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางมะฝ่อ",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "04",
    name: "บางประมุง",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "05",
    name: "นากลาง",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "06",
    name: "ศาลาแดง",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "07",
    name: "เนินกว้าว",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "08",
    name: "เนินศาลา",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "02",
    tumbon_code: "09",
    name: "หาดสูง",
    zipcode: "60170",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "01",
    name: "ชุมแสง",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "02",
    name: "ทับกฤช",
    zipcode: "60250",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "03",
    name: "พิกุล",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "04",
    name: "เกยไชย",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "05",
    name: "ท่าไม้",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "06",
    name: "บางเคียน",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "07",
    name: "หนองกระเจา",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "08",
    name: "พันลาน",
    zipcode: "60250",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "09",
    name: "โคกหม้อ",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "10",
    name: "ไผ่สิงห์",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "11",
    name: "ฆะมัง",
    zipcode: "60120",
  },
  {
    jw_code: "60",
    amph_code: "03",
    tumbon_code: "12",
    name: "ทับกฤชใต้",
    zipcode: "60250",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "01",
    name: "หนองบัว",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "02",
    name: "หนองกลับ",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "03",
    name: "ธารทหาร",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "04",
    name: "ห้วยร่วม",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "05",
    name: "ห้วยถั่วใต้",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "06",
    name: "ห้วยถั่วเหนือ",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "07",
    name: "ห้วยใหญ่",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "08",
    name: "ทุ่งทอง",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "04",
    tumbon_code: "09",
    name: "วังบ่อ",
    zipcode: "60110",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "01",
    name: "ท่างิ้ว",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "02",
    name: "บางตาหงาย",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "03",
    name: "หูกวาง",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "04",
    name: "อ่างทอง",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "05",
    name: "บ้านแดน",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "06",
    name: "บางแก้ว",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "07",
    name: "ตาขีด",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "08",
    name: "ตาสัง",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "09",
    name: "ด่านช้าง",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "10",
    name: "หนองกรด",
    zipcode: "60240",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "11",
    name: "หนองตางู",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "12",
    name: "บึงปลาทู",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "05",
    tumbon_code: "13",
    name: "เจริญผล",
    zipcode: "60180",
  },
  {
    jw_code: "60",
    amph_code: "06",
    tumbon_code: "01",
    name: "มหาโพธิ",
    zipcode: "60230",
  },
  {
    jw_code: "60",
    amph_code: "06",
    tumbon_code: "02",
    name: "เก้าเลี้ยว",
    zipcode: "60230",
  },
  {
    jw_code: "60",
    amph_code: "06",
    tumbon_code: "03",
    name: "หนองเต่า",
    zipcode: "60230",
  },
  {
    jw_code: "60",
    amph_code: "06",
    tumbon_code: "04",
    name: "เขาดิน",
    zipcode: "60230",
  },
  {
    jw_code: "60",
    amph_code: "06",
    tumbon_code: "05",
    name: "หัวดง",
    zipcode: "60230",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "01",
    name: "ตาคลี",
    zipcode: "60140",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "02",
    name: "ช่องแค",
    zipcode: "60210",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "03",
    name: "จันเสน",
    zipcode: "60260",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "04",
    name: "ห้วยหอม",
    zipcode: "60210",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "05",
    name: "หัวหวาย",
    zipcode: "60140",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "06",
    name: "หนองโพ",
    zipcode: "60140",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "07",
    name: "หนองหม้อ",
    zipcode: "60140",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "08",
    name: "สร้อยทอง",
    zipcode: "60210",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "09",
    name: "ลาดทิพรส",
    zipcode: "60260",
  },
  {
    jw_code: "60",
    amph_code: "07",
    tumbon_code: "10",
    name: "พรหมนิมิต",
    zipcode: "60210",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "01",
    name: "ท่าตะโก",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "02",
    name: "พนมรอก",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "03",
    name: "หัวถนน",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "04",
    name: "สายลำโพง",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "05",
    name: "วังมหากร",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "06",
    name: "ดอนคา",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "07",
    name: "ทำนบ",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "08",
    name: "วังใหญ่",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "09",
    name: "พนมเศษ",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "08",
    tumbon_code: "10",
    name: "หนองหลวง",
    zipcode: "60160",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "01",
    name: "โคกเดื่อ",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "02",
    name: "สำโรงชัย",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "03",
    name: "วังน้ำลัด",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "04",
    name: "ตะคร้อ",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "05",
    name: "โพธิ์ประสาท",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "06",
    name: "วังข่อย",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "07",
    name: "นาขอม",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "09",
    tumbon_code: "08",
    name: "ไพศาลี",
    zipcode: "60220",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "01",
    name: "พยุหะ",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "02",
    name: "เนินมะกอก",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "03",
    name: "นิคมเขาบ่อแก้ว",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "04",
    name: "ม่วงหัก",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "05",
    name: "ยางขาว",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "06",
    name: "ย่านมัทรี",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "07",
    name: "เขาทอง",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "08",
    name: "ท่าน้ำอ้อย",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "09",
    name: "น้ำทรง",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "10",
    name: "เขากะลา",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "10",
    tumbon_code: "11",
    name: "สระทะเล",
    zipcode: "60130",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "01",
    name: "ลาดยาว",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "02",
    name: "ห้วยน้ำหอม",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "03",
    name: "วังม้า",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "04",
    name: "วังเมือง",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "05",
    name: "สร้อยละคร",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "06",
    name: "มาบแก",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "07",
    name: "หนองยาว",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "08",
    name: "หนองนมวัว",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "09",
    name: "บ้านไร่",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "10",
    name: "เนินขี้เหล็ก",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "16",
    name: "ศาลเจ้าไก่ต่อ",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "11",
    tumbon_code: "17",
    name: "สระแก้ว",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "12",
    tumbon_code: "01",
    name: "ตากฟ้า",
    zipcode: "60190",
  },
  {
    jw_code: "60",
    amph_code: "12",
    tumbon_code: "02",
    name: "ลำพยนต์",
    zipcode: "60190",
  },
  {
    jw_code: "60",
    amph_code: "12",
    tumbon_code: "03",
    name: "สุขสำราญ",
    zipcode: "60190",
  },
  {
    jw_code: "60",
    amph_code: "12",
    tumbon_code: "04",
    name: "หนองพิกุล",
    zipcode: "60190",
  },
  {
    jw_code: "60",
    amph_code: "12",
    tumbon_code: "05",
    name: "พุนกยูง",
    zipcode: "60190",
  },
  {
    jw_code: "60",
    amph_code: "12",
    tumbon_code: "06",
    name: "อุดมธัญญา",
    zipcode: "60190",
  },
  {
    jw_code: "60",
    amph_code: "12",
    tumbon_code: "07",
    name: "เขาชายธง",
    zipcode: "60190",
  },
  {
    jw_code: "60",
    amph_code: "13",
    tumbon_code: "01",
    name: "แม่วงก์",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "13",
    tumbon_code: "03",
    name: "แม่เล่ย์",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "13",
    tumbon_code: "04",
    name: "วังซ่าน",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "13",
    tumbon_code: "05",
    name: "เขาชนกัน",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "14",
    tumbon_code: "01",
    name: "แม่เปิน",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "15",
    tumbon_code: "01",
    name: "ชุมตาบง",
    zipcode: "60150",
  },
  {
    jw_code: "60",
    amph_code: "15",
    tumbon_code: "02",
    name: "ปางสวรรค์",
    zipcode: "60150",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "01",
    name: "อุทัยใหม่",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "02",
    name: "น้ำซึม",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "03",
    name: "สะแกกรัง",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "04",
    name: "ดอนขวาง",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "05",
    name: "หาดทนง",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "06",
    name: "เกาะเทโพ",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "07",
    name: "ท่าซุง",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "08",
    name: "หนองแก",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "09",
    name: "โนนเหล็ก",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "10",
    name: "หนองเต่า",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "11",
    name: "หนองไผ่แบน",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "12",
    name: "หนองพังค่า",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "13",
    name: "ทุ่งใหญ่",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "01",
    tumbon_code: "14",
    name: "เนินแจง",
    zipcode: "61000",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "01",
    name: "ทัพทัน",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "02",
    name: "ทุ่งนาไทย",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "03",
    name: "เขาขี้ฝอย",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "04",
    name: "หนองหญ้าปล้อง",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "05",
    name: "โคกหม้อ",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "06",
    name: "หนองยายดา",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองกลางดง",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "08",
    name: "หนองกระทุ่ม",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "09",
    name: "หนองสระ",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "02",
    tumbon_code: "10",
    name: "ตลุกดู่",
    zipcode: "61120",
  },
  {
    jw_code: "61",
    amph_code: "03",
    tumbon_code: "01",
    name: "สว่างอารมณ์",
    zipcode: "61150",
  },
  {
    jw_code: "61",
    amph_code: "03",
    tumbon_code: "02",
    name: "หนองหลวง",
    zipcode: "61150",
  },
  {
    jw_code: "61",
    amph_code: "03",
    tumbon_code: "03",
    name: "พลวงสองนาง",
    zipcode: "61150",
  },
  {
    jw_code: "61",
    amph_code: "03",
    tumbon_code: "04",
    name: "ไผ่เขียว",
    zipcode: "61150",
  },
  {
    jw_code: "61",
    amph_code: "03",
    tumbon_code: "05",
    name: "บ่อยาง",
    zipcode: "61150",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "01",
    name: "หนองฉาง",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "02",
    name: "หนองยาง",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "03",
    name: "หนองนางนวล",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "04",
    name: "หนองสรวง",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "05",
    name: "บ้านเก่า",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "06",
    name: "อุทัยเก่า",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "07",
    name: "ทุ่งโพ",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "08",
    name: "ทุ่งพง",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "09",
    name: "เขาบางแกรก",
    zipcode: "61170",
  },
  {
    jw_code: "61",
    amph_code: "04",
    tumbon_code: "10",
    name: "เขากวางทอง",
    zipcode: "61110",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "01",
    name: "หนองขาหย่าง",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "02",
    name: "หนองไผ่",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "03",
    name: "ดอนกลอย",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "04",
    name: "ห้วยรอบ",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "05",
    name: "ทุ่งพึ่ง",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "06",
    name: "ท่าโพ",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "07",
    name: "หมกแถว",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "08",
    name: "หลุมเข้า",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "05",
    tumbon_code: "09",
    name: "ดงขวาง",
    zipcode: "61130",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "01",
    name: "บ้านไร่",
    zipcode: "61140",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "02",
    name: "ทัพหลวง",
    zipcode: "61140",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "03",
    name: "ห้วยแห้ง",
    zipcode: "61140",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "04",
    name: "คอกควาย",
    zipcode: "61140",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "05",
    name: "วังหิน",
    zipcode: "61180",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "06",
    name: "เมืองการุ้ง",
    zipcode: "61180",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "07",
    name: "แก่นมะกรูด",
    zipcode: "61140",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "09",
    name: "หนองจอก",
    zipcode: "61180",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "10",
    name: "หูช้าง",
    zipcode: "61180",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "11",
    name: "บ้านบึง",
    zipcode: "61140",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "12",
    name: "บ้านใหม่คลองเคียน",
    zipcode: "61180",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "13",
    name: "หนองบ่มกล้วย",
    zipcode: "61180",
  },
  {
    jw_code: "61",
    amph_code: "06",
    tumbon_code: "14",
    name: "เจ้าวัด",
    zipcode: "61140",
  },
  {
    jw_code: "61",
    amph_code: "07",
    tumbon_code: "01",
    name: "ลานสัก",
    zipcode: "61160",
  },
  {
    jw_code: "61",
    amph_code: "07",
    tumbon_code: "02",
    name: "ประดู่ยืน",
    zipcode: "61160",
  },
  {
    jw_code: "61",
    amph_code: "07",
    tumbon_code: "03",
    name: "ป่าอ้อ",
    zipcode: "61160",
  },
  {
    jw_code: "61",
    amph_code: "07",
    tumbon_code: "04",
    name: "ระบำ",
    zipcode: "61160",
  },
  {
    jw_code: "61",
    amph_code: "07",
    tumbon_code: "05",
    name: "น้ำรอบ",
    zipcode: "61160",
  },
  {
    jw_code: "61",
    amph_code: "07",
    tumbon_code: "06",
    name: "ทุ่งนางาม",
    zipcode: "61160",
  },
  {
    jw_code: "61",
    amph_code: "08",
    tumbon_code: "01",
    name: "สุขฤทัย",
    zipcode: "61170",
  },
  {
    jw_code: "61",
    amph_code: "08",
    tumbon_code: "02",
    name: "ทองหลาง",
    zipcode: "61170",
  },
  {
    jw_code: "61",
    amph_code: "08",
    tumbon_code: "03",
    name: "ห้วยคต",
    zipcode: "61170",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "02",
    name: "ไตรตรึงษ์",
    zipcode: "62160",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "03",
    name: "อ่างทอง",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "04",
    name: "นาบ่อคำ",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "05",
    name: "นครชุม",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "06",
    name: "ทรงธรรม",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "07",
    name: "ลานดอกไม้",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "10",
    name: "หนองปลิง",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "11",
    name: "คณฑี",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "12",
    name: "นิคมทุ่งโพธิ์ทะเล",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "13",
    name: "เทพนคร",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "14",
    name: "วังทอง",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "15",
    name: "ท่าขุนราม",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "17",
    name: "คลองแม่ลาย",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "18",
    name: "ธำมรงค์",
    zipcode: "62160",
  },
  {
    jw_code: "62",
    amph_code: "01",
    tumbon_code: "19",
    name: "สระแก้ว",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "02",
    tumbon_code: "01",
    name: "ไทรงาม",
    zipcode: "62150",
  },
  {
    jw_code: "62",
    amph_code: "02",
    tumbon_code: "02",
    name: "หนองคล้า",
    zipcode: "62150",
  },
  {
    jw_code: "62",
    amph_code: "02",
    tumbon_code: "03",
    name: "หนองทอง",
    zipcode: "62150",
  },
  {
    jw_code: "62",
    amph_code: "02",
    tumbon_code: "04",
    name: "หนองไม้กอง",
    zipcode: "62150",
  },
  {
    jw_code: "62",
    amph_code: "02",
    tumbon_code: "05",
    name: "มหาชัย",
    zipcode: "62150",
  },
  {
    jw_code: "62",
    amph_code: "02",
    tumbon_code: "06",
    name: "พานทอง",
    zipcode: "62150",
  },
  {
    jw_code: "62",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองแม่แตง",
    zipcode: "62150",
  },
  {
    jw_code: "62",
    amph_code: "03",
    tumbon_code: "01",
    name: "คลองน้ำไหล",
    zipcode: "62180",
  },
  {
    jw_code: "62",
    amph_code: "03",
    tumbon_code: "02",
    name: "โป่งน้ำร้อน",
    zipcode: "62180",
  },
  {
    jw_code: "62",
    amph_code: "03",
    tumbon_code: "03",
    name: "คลองลานพัฒนา",
    zipcode: "62180",
  },
  {
    jw_code: "62",
    amph_code: "03",
    tumbon_code: "04",
    name: "สักงาม",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "03",
    name: "ยางสูง",
    zipcode: "62130",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "04",
    name: "ป่าพุทรา",
    zipcode: "62130",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "05",
    name: "แสนตอ",
    zipcode: "62130",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "06",
    name: "สลกบาตร",
    zipcode: "62140",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "07",
    name: "บ่อถ้ำ",
    zipcode: "62140",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "08",
    name: "ดอนแตง",
    zipcode: "62140",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "09",
    name: "วังชะพลู",
    zipcode: "62140",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "10",
    name: "โค้งไผ่",
    zipcode: "62140",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "11",
    name: "ปางมะค่า",
    zipcode: "62140",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "12",
    name: "วังหามแห",
    zipcode: "62140",
  },
  {
    jw_code: "62",
    amph_code: "04",
    tumbon_code: "13",
    name: "เกาะตาล",
    zipcode: "62130",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "01",
    name: "คลองขลุง",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "02",
    name: "ท่ามะเขือ",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "04",
    name: "ท่าพุทรา",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "05",
    name: "แม่ลาด",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "06",
    name: "วังยาง",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "07",
    name: "วังแขม",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "08",
    name: "หัวถนน",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "09",
    name: "วังไทร",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "13",
    name: "วังบัว",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "05",
    tumbon_code: "16",
    name: "คลองสมบูรณ์",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "01",
    name: "พรานกระต่าย",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "02",
    name: "หนองหัววัว",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "03",
    name: "ท่าไม้",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "04",
    name: "วังควง",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "05",
    name: "วังตะแบก",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "06",
    name: "เขาคีริส",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "07",
    name: "คุยบ้านโอง",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "08",
    name: "คลองพิไกร",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "09",
    name: "ถ้ำกระต่ายทอง",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "06",
    tumbon_code: "10",
    name: "ห้วยยั้ง",
    zipcode: "62110",
  },
  {
    jw_code: "62",
    amph_code: "07",
    tumbon_code: "01",
    name: "ลานกระบือ",
    zipcode: "62170",
  },
  {
    jw_code: "62",
    amph_code: "07",
    tumbon_code: "02",
    name: "ช่องลม",
    zipcode: "62170",
  },
  {
    jw_code: "62",
    amph_code: "07",
    tumbon_code: "03",
    name: "หนองหลวง",
    zipcode: "62170",
  },
  {
    jw_code: "62",
    amph_code: "07",
    tumbon_code: "04",
    name: "โนนพลวง",
    zipcode: "62170",
  },
  {
    jw_code: "62",
    amph_code: "07",
    tumbon_code: "05",
    name: "ประชาสุขสันต์",
    zipcode: "62170",
  },
  {
    jw_code: "62",
    amph_code: "07",
    tumbon_code: "06",
    name: "บึงทับแรต",
    zipcode: "62170",
  },
  {
    jw_code: "62",
    amph_code: "07",
    tumbon_code: "07",
    name: "จันทิมา",
    zipcode: "62170",
  },
  {
    jw_code: "62",
    amph_code: "08",
    tumbon_code: "01",
    name: "ทุ่งทราย",
    zipcode: "62190",
  },
  {
    jw_code: "62",
    amph_code: "08",
    tumbon_code: "02",
    name: "ทุ่งทอง",
    zipcode: "62190",
  },
  {
    jw_code: "62",
    amph_code: "08",
    tumbon_code: "03",
    name: "ถาวรวัฒนา",
    zipcode: "62190",
  },
  {
    jw_code: "62",
    amph_code: "09",
    tumbon_code: "01",
    name: "โพธิ์ทอง",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "09",
    tumbon_code: "02",
    name: "หินดาต",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "09",
    tumbon_code: "03",
    name: "ปางตาไว",
    zipcode: "62120",
  },
  {
    jw_code: "62",
    amph_code: "10",
    tumbon_code: "01",
    name: "บึงสามัคคี",
    zipcode: "62210",
  },
  {
    jw_code: "62",
    amph_code: "10",
    tumbon_code: "02",
    name: "วังชะโอน",
    zipcode: "62210",
  },
  {
    jw_code: "62",
    amph_code: "10",
    tumbon_code: "03",
    name: "ระหาน",
    zipcode: "62210",
  },
  {
    jw_code: "62",
    amph_code: "10",
    tumbon_code: "04",
    name: "เทพนิมิต",
    zipcode: "62210",
  },
  {
    jw_code: "62",
    amph_code: "11",
    tumbon_code: "01",
    name: "โกสัมพี",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "11",
    tumbon_code: "02",
    name: "เพชรชมภู",
    zipcode: "62000",
  },
  {
    jw_code: "62",
    amph_code: "11",
    tumbon_code: "03",
    name: "ลานดอกไม้ตก",
    zipcode: "62000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "01",
    name: "ระแหง",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "02",
    name: "หนองหลวง",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "03",
    name: "เชียงเงิน",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "04",
    name: "หัวเดียด",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "05",
    name: "หนองบัวเหนือ",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "06",
    name: "ไม้งาม",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "07",
    name: "โป่งแดง",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "08",
    name: "น้ำรึม",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "09",
    name: "วังหิน",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "11",
    name: "แม่ท้อ",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "12",
    name: "ป่ามะม่วง",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "13",
    name: "หนองบัวใต้",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "14",
    name: "วังประจบ",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "01",
    tumbon_code: "15",
    name: "ตลุกกลางทุ่ง",
    zipcode: "63000",
  },
  {
    jw_code: "63",
    amph_code: "02",
    tumbon_code: "01",
    name: "ตากออก",
    zipcode: "63120",
  },
  {
    jw_code: "63",
    amph_code: "02",
    tumbon_code: "02",
    name: "สมอโคน",
    zipcode: "63120",
  },
  {
    jw_code: "63",
    amph_code: "02",
    tumbon_code: "03",
    name: "แม่สลิด",
    zipcode: "63120",
  },
  {
    jw_code: "63",
    amph_code: "02",
    tumbon_code: "04",
    name: "ตากตก",
    zipcode: "63120",
  },
  {
    jw_code: "63",
    amph_code: "02",
    tumbon_code: "05",
    name: "เกาะตะเภา",
    zipcode: "63120",
  },
  {
    jw_code: "63",
    amph_code: "02",
    tumbon_code: "06",
    name: "ทุ่งกระเชาะ",
    zipcode: "63120",
  },
  {
    jw_code: "63",
    amph_code: "02",
    tumbon_code: "07",
    name: "ท้องฟ้า",
    zipcode: "63120",
  },
  {
    jw_code: "63",
    amph_code: "03",
    tumbon_code: "01",
    name: "สามเงา",
    zipcode: "63130",
  },
  {
    jw_code: "63",
    amph_code: "03",
    tumbon_code: "02",
    name: "วังหมัน",
    zipcode: "63130",
  },
  {
    jw_code: "63",
    amph_code: "03",
    tumbon_code: "03",
    name: "ยกกระบัตร",
    zipcode: "63130",
  },
  {
    jw_code: "63",
    amph_code: "03",
    tumbon_code: "04",
    name: "ย่านรี",
    zipcode: "63130",
  },
  {
    jw_code: "63",
    amph_code: "03",
    tumbon_code: "05",
    name: "บ้านนา",
    zipcode: "63130",
  },
  {
    jw_code: "63",
    amph_code: "03",
    tumbon_code: "06",
    name: "วังจันทร์",
    zipcode: "63130",
  },
  {
    jw_code: "63",
    amph_code: "04",
    tumbon_code: "01",
    name: "แม่ระมาด",
    zipcode: "63140",
  },
  {
    jw_code: "63",
    amph_code: "04",
    tumbon_code: "02",
    name: "แม่จะเรา",
    zipcode: "63140",
  },
  {
    jw_code: "63",
    amph_code: "04",
    tumbon_code: "03",
    name: "ขะเนจื้อ",
    zipcode: "63140",
  },
  {
    jw_code: "63",
    amph_code: "04",
    tumbon_code: "04",
    name: "แม่ตื่น",
    zipcode: "63140",
  },
  {
    jw_code: "63",
    amph_code: "04",
    tumbon_code: "05",
    name: "สามหมื่น",
    zipcode: "63140",
  },
  {
    jw_code: "63",
    amph_code: "04",
    tumbon_code: "06",
    name: "พระธาตุ",
    zipcode: "63140",
  },
  {
    jw_code: "63",
    amph_code: "05",
    tumbon_code: "01",
    name: "ท่าสองยาง",
    zipcode: "63150",
  },
  {
    jw_code: "63",
    amph_code: "05",
    tumbon_code: "02",
    name: "แม่ต้าน",
    zipcode: "63150",
  },
  {
    jw_code: "63",
    amph_code: "05",
    tumbon_code: "03",
    name: "แม่สอง",
    zipcode: "63150",
  },
  {
    jw_code: "63",
    amph_code: "05",
    tumbon_code: "04",
    name: "แม่หละ",
    zipcode: "63150",
  },
  {
    jw_code: "63",
    amph_code: "05",
    tumbon_code: "05",
    name: "แม่วะหลวง",
    zipcode: "63150",
  },
  {
    jw_code: "63",
    amph_code: "05",
    tumbon_code: "06",
    name: "แม่อุสุ",
    zipcode: "63150",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "01",
    name: "แม่สอด",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "02",
    name: "แม่กุ",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "03",
    name: "พะวอ",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "04",
    name: "แม่ตาว",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "05",
    name: "แม่กาษา",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "06",
    name: "ท่าสายลวด",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "07",
    name: "แม่ปะ",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "08",
    name: "มหาวัน",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "09",
    name: "ด่านแม่ละเมา",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "06",
    tumbon_code: "10",
    name: "พระธาตุผาแดง",
    zipcode: "63110",
  },
  {
    jw_code: "63",
    amph_code: "07",
    tumbon_code: "01",
    name: "พบพระ",
    zipcode: "63160",
  },
  {
    jw_code: "63",
    amph_code: "07",
    tumbon_code: "02",
    name: "ช่องแคบ",
    zipcode: "63160",
  },
  {
    jw_code: "63",
    amph_code: "07",
    tumbon_code: "03",
    name: "คีรีราษฎร์",
    zipcode: "63160",
  },
  {
    jw_code: "63",
    amph_code: "07",
    tumbon_code: "04",
    name: "วาเล่ย์",
    zipcode: "63160",
  },
  {
    jw_code: "63",
    amph_code: "07",
    tumbon_code: "05",
    name: "รวมไทยพัฒนา",
    zipcode: "63160",
  },
  {
    jw_code: "63",
    amph_code: "08",
    tumbon_code: "01",
    name: "อุ้มผาง",
    zipcode: "63170",
  },
  {
    jw_code: "63",
    amph_code: "08",
    tumbon_code: "02",
    name: "หนองหลวง",
    zipcode: "63170",
  },
  {
    jw_code: "63",
    amph_code: "08",
    tumbon_code: "03",
    name: "โมโกร",
    zipcode: "63170",
  },
  {
    jw_code: "63",
    amph_code: "08",
    tumbon_code: "04",
    name: "แม่จัน",
    zipcode: "63170",
  },
  {
    jw_code: "63",
    amph_code: "08",
    tumbon_code: "05",
    name: "แม่ละมุ้ง",
    zipcode: "63170",
  },
  {
    jw_code: "63",
    amph_code: "08",
    tumbon_code: "06",
    name: "แม่กลอง",
    zipcode: "63170",
  },
  {
    jw_code: "63",
    amph_code: "09",
    tumbon_code: "01",
    name: "เชียงทอง",
    zipcode: "63180",
  },
  {
    jw_code: "63",
    amph_code: "09",
    tumbon_code: "02",
    name: "นาโบสถ์",
    zipcode: "63180",
  },
  {
    jw_code: "63",
    amph_code: "09",
    tumbon_code: "03",
    name: "ประดาง",
    zipcode: "63180",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "01",
    name: "ธานี",
    zipcode: "64000",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "02",
    name: "บ้านสวน",
    zipcode: "64220",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "03",
    name: "เมืองเก่า",
    zipcode: "64210",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "04",
    name: "ปากแคว",
    zipcode: "64000",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "05",
    name: "ยางซ้าย",
    zipcode: "64000",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "06",
    name: "บ้านกล้วย",
    zipcode: "64210",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "07",
    name: "บ้านหลุม",
    zipcode: "64000",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "08",
    name: "ตาลเตี้ย",
    zipcode: "64220",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "09",
    name: "ปากพระ",
    zipcode: "64000",
  },
  {
    jw_code: "64",
    amph_code: "01",
    tumbon_code: "10",
    name: "วังทองแดง",
    zipcode: "64210",
  },
  {
    jw_code: "64",
    amph_code: "02",
    tumbon_code: "01",
    name: "ลานหอย",
    zipcode: "64140",
  },
  {
    jw_code: "64",
    amph_code: "02",
    tumbon_code: "02",
    name: "บ้านด่าน",
    zipcode: "64140",
  },
  {
    jw_code: "64",
    amph_code: "02",
    tumbon_code: "03",
    name: "วังตะคร้อ",
    zipcode: "64140",
  },
  {
    jw_code: "64",
    amph_code: "02",
    tumbon_code: "04",
    name: "วังน้ำขาว",
    zipcode: "64140",
  },
  {
    jw_code: "64",
    amph_code: "02",
    tumbon_code: "05",
    name: "ตลิ่งชัน",
    zipcode: "64140",
  },
  {
    jw_code: "64",
    amph_code: "02",
    tumbon_code: "06",
    name: "หนองหญ้าปล้อง",
    zipcode: "64140",
  },
  {
    jw_code: "64",
    amph_code: "02",
    tumbon_code: "07",
    name: "วังลึก",
    zipcode: "64140",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "01",
    name: "โตนด",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "02",
    name: "ทุ่งหลวง",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "03",
    name: "บ้านป้อม",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "04",
    name: "สามพวง",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "05",
    name: "ศรีคีรีมาศ",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "06",
    name: "หนองจิก",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "07",
    name: "นาเชิงคีรี",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "08",
    name: "หนองกระดิ่ง",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "09",
    name: "บ้านน้ำพุ",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "03",
    tumbon_code: "10",
    name: "ทุ่งยางเมือง",
    zipcode: "64160",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "01",
    name: "กง",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "02",
    name: "บ้านกร่าง",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "03",
    name: "ไกรนอก",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "04",
    name: "ไกรกลาง",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "05",
    name: "ไกรใน",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "06",
    name: "ดงเดือย",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "07",
    name: "ป่าแฝก",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "08",
    name: "กกแรต",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "09",
    name: "ท่าฉนวน",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "10",
    name: "หนองตูม",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "04",
    tumbon_code: "11",
    name: "บ้านใหม่สุขเกษม",
    zipcode: "64170",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "01",
    name: "หาดเสี้ยว",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "02",
    name: "ป่างิ้ว",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "03",
    name: "แม่สำ",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "04",
    name: "แม่สิน",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "05",
    name: "บ้านตึก",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "06",
    name: "หนองอ้อ",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "07",
    name: "ท่าชัย",
    zipcode: "64190",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "08",
    name: "ศรีสัชนาลัย",
    zipcode: "64190",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "09",
    name: "ดงคู่",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "10",
    name: "บ้านแก่ง",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "05",
    tumbon_code: "11",
    name: "สารจิตร",
    zipcode: "64130",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "01",
    name: "คลองตาล",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "02",
    name: "วังลึก",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "03",
    name: "สามเรือน",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "04",
    name: "บ้านนา",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "05",
    name: "วังทอง",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "06",
    name: "นาขุนไกร",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "07",
    name: "เกาะตาเลี้ยง",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "08",
    name: "วัดเกาะ",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "09",
    name: "บ้านไร่",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "10",
    name: "ทับผึ้ง",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "11",
    name: "บ้านซ่าน",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "12",
    name: "วังใหญ่",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "06",
    tumbon_code: "13",
    name: "ราวต้นจันทร์",
    zipcode: "64120",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "01",
    name: "เมืองสวรรคโลก",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "02",
    name: "ในเมือง",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "03",
    name: "คลองกระจง",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "04",
    name: "วังพิณพาทย์",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "05",
    name: "วังไม้ขอน",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "06",
    name: "ย่านยาว",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "07",
    name: "นาทุ่ง",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "08",
    name: "คลองยาง",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "09",
    name: "เมืองบางยม",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "10",
    name: "ท่าทอง",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "11",
    name: "ปากน้ำ",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "12",
    name: "ป่ากุมเกาะ",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "13",
    name: "เมืองบางขลัง",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "07",
    tumbon_code: "14",
    name: "หนองกลับ",
    zipcode: "64110",
  },
  {
    jw_code: "64",
    amph_code: "08",
    tumbon_code: "01",
    name: "ศรีนคร",
    zipcode: "64180",
  },
  {
    jw_code: "64",
    amph_code: "08",
    tumbon_code: "02",
    name: "นครเดิฐ",
    zipcode: "64180",
  },
  {
    jw_code: "64",
    amph_code: "08",
    tumbon_code: "03",
    name: "น้ำขุม",
    zipcode: "64180",
  },
  {
    jw_code: "64",
    amph_code: "08",
    tumbon_code: "04",
    name: "คลองมะพลับ",
    zipcode: "64180",
  },
  {
    jw_code: "64",
    amph_code: "08",
    tumbon_code: "05",
    name: "หนองบัว",
    zipcode: "64180",
  },
  {
    jw_code: "64",
    amph_code: "09",
    tumbon_code: "01",
    name: "บ้านใหม่ไชยมงคล",
    zipcode: "64230",
  },
  {
    jw_code: "64",
    amph_code: "09",
    tumbon_code: "02",
    name: "ไทยชนะศึก",
    zipcode: "64150",
  },
  {
    jw_code: "64",
    amph_code: "09",
    tumbon_code: "03",
    name: "ทุ่งเสลี่ยม",
    zipcode: "64150",
  },
  {
    jw_code: "64",
    amph_code: "09",
    tumbon_code: "04",
    name: "กลางดง",
    zipcode: "64150",
  },
  {
    jw_code: "64",
    amph_code: "09",
    tumbon_code: "05",
    name: "เขาแก้วศรีสมบูรณ์",
    zipcode: "64230",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "02",
    name: "วังน้ำคู้",
    zipcode: "65230",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "03",
    name: "วัดจันทร์",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "04",
    name: "วัดพริก",
    zipcode: "65230",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "05",
    name: "ท่าทอง",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "06",
    name: "ท่าโพธิ์",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "07",
    name: "สมอแข",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "08",
    name: "ดอนทอง",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "09",
    name: "บ้านป่า",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "10",
    name: "ปากโทก",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "11",
    name: "หัวรอ",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "12",
    name: "จอมทอง",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "13",
    name: "บ้านกร่าง",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "14",
    name: "บ้านคลอง",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "15",
    name: "พลายชุมพล",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "16",
    name: "มะขามสูง",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "17",
    name: "อรัญญิก",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "18",
    name: "บึงพระ",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "19",
    name: "ไผ่ขอดอน",
    zipcode: "65000",
  },
  {
    jw_code: "65",
    amph_code: "01",
    tumbon_code: "20",
    name: "งิ้วงาม",
    zipcode: "65230",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "01",
    name: "นครไทย",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "02",
    name: "หนองกะท้าว",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "03",
    name: "บ้านแยง",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "04",
    name: "เนินเพิ่ม",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "05",
    name: "นาบัว",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "06",
    name: "นครชุม",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "07",
    name: "น้ำกุ่ม",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "08",
    name: "ยางโกลน",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "09",
    name: "บ่อโพธิ์",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "10",
    name: "บ้านพร้าว",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "02",
    tumbon_code: "11",
    name: "ห้วยเฮี้ย",
    zipcode: "65120",
  },
  {
    jw_code: "65",
    amph_code: "03",
    tumbon_code: "01",
    name: "ป่าแดง",
    zipcode: "65170",
  },
  {
    jw_code: "65",
    amph_code: "03",
    tumbon_code: "02",
    name: "ชาติตระการ",
    zipcode: "65170",
  },
  {
    jw_code: "65",
    amph_code: "03",
    tumbon_code: "03",
    name: "สวนเมี่ยง",
    zipcode: "65170",
  },
  {
    jw_code: "65",
    amph_code: "03",
    tumbon_code: "04",
    name: "บ้านดง",
    zipcode: "65170",
  },
  {
    jw_code: "65",
    amph_code: "03",
    tumbon_code: "05",
    name: "บ่อภาค",
    zipcode: "65170",
  },
  {
    jw_code: "65",
    amph_code: "03",
    tumbon_code: "06",
    name: "ท่าสะแก",
    zipcode: "65170",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "01",
    name: "บางระกำ",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "02",
    name: "ปลักแรด",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "03",
    name: "พันเสา",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "04",
    name: "วังอิทก",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "05",
    name: "บึงกอก",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "06",
    name: "หนองกุลา",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "07",
    name: "ชุมแสงสงคราม",
    zipcode: "65240",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "08",
    name: "นิคมพัฒนา",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "09",
    name: "บ่อทอง",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "10",
    name: "ท่านางงาม",
    zipcode: "65140",
  },
  {
    jw_code: "65",
    amph_code: "04",
    tumbon_code: "11",
    name: "คุยม่วง",
    zipcode: "65240",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "01",
    name: "บางกระทุ่ม",
    zipcode: "65110",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "02",
    name: "บ้านไร่",
    zipcode: "65110",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "03",
    name: "โคกสลุด",
    zipcode: "65110",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "04",
    name: "สนามคลี",
    zipcode: "65110",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "05",
    name: "ท่าตาล",
    zipcode: "65110",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "06",
    name: "ไผ่ล้อม",
    zipcode: "65110",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "07",
    name: "นครป่าหมาก",
    zipcode: "65110",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "08",
    name: "เนินกุ่ม",
    zipcode: "65210",
  },
  {
    jw_code: "65",
    amph_code: "05",
    tumbon_code: "09",
    name: "วัดตายม",
    zipcode: "65210",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "01",
    name: "พรหมพิราม",
    zipcode: "65150",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "02",
    name: "ท่าช้าง",
    zipcode: "65150",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "03",
    name: "วงฆ้อง",
    zipcode: "65180",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "04",
    name: "มะตูม",
    zipcode: "65150",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "05",
    name: "หอกลอง",
    zipcode: "65150",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "06",
    name: "ศรีภิรมย์",
    zipcode: "65180",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "07",
    name: "ตลุกเทียม",
    zipcode: "65180",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "08",
    name: "วังวน",
    zipcode: "65150",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "09",
    name: "หนองแขม",
    zipcode: "65150",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "10",
    name: "มะต้อง",
    zipcode: "65180",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "11",
    name: "ทับยายเชียง",
    zipcode: "65150",
  },
  {
    jw_code: "65",
    amph_code: "06",
    tumbon_code: "12",
    name: "ดงประคำ",
    zipcode: "65180",
  },
  {
    jw_code: "65",
    amph_code: "07",
    tumbon_code: "01",
    name: "วัดโบสถ์",
    zipcode: "65160",
  },
  {
    jw_code: "65",
    amph_code: "07",
    tumbon_code: "02",
    name: "ท่างาม",
    zipcode: "65160",
  },
  {
    jw_code: "65",
    amph_code: "07",
    tumbon_code: "03",
    name: "ท้อแท้",
    zipcode: "65160",
  },
  {
    jw_code: "65",
    amph_code: "07",
    tumbon_code: "04",
    name: "บ้านยาง",
    zipcode: "65160",
  },
  {
    jw_code: "65",
    amph_code: "07",
    tumbon_code: "05",
    name: "หินลาด",
    zipcode: "65160",
  },
  {
    jw_code: "65",
    amph_code: "07",
    tumbon_code: "06",
    name: "คันโช้ง",
    zipcode: "65160",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "01",
    name: "วังทอง",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "02",
    name: "พันชาลี",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "03",
    name: "แม่ระกา",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "04",
    name: "บ้านกลาง",
    zipcode: "65220",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "05",
    name: "วังพิกุล",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "06",
    name: "แก่งโสภา",
    zipcode: "65220",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "07",
    name: "ท่าหมื่นราม",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "08",
    name: "วังนกแอ่น",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "09",
    name: "หนองพระ",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "10",
    name: "ชัยนาม",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "08",
    tumbon_code: "11",
    name: "ดินทอง",
    zipcode: "65130",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "01",
    name: "ชมพู",
    zipcode: "65190",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "02",
    name: "บ้านมุง",
    zipcode: "65190",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "03",
    name: "ไทรย้อย",
    zipcode: "65190",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "04",
    name: "วังโพรง",
    zipcode: "65190",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "05",
    name: "บ้านน้อยซุ้มขี้เหล็ก",
    zipcode: "65190",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "06",
    name: "เนินมะปราง",
    zipcode: "65190",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "07",
    name: "วังยาง",
    zipcode: "65190",
  },
  {
    jw_code: "65",
    amph_code: "09",
    tumbon_code: "08",
    name: "โคกแหลม",
    zipcode: "65190",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "02",
    name: "ไผ่ขวาง",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "03",
    name: "ย่านยาว",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "04",
    name: "ท่าฬ่อ",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "05",
    name: "ปากทาง",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "06",
    name: "คลองคะเชนทร์",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "07",
    name: "โรงช้าง",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "08",
    name: "เมืองเก่า",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "09",
    name: "ท่าหลวง",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "10",
    name: "บ้านบุ่ง",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "11",
    name: "ฆะมัง",
    zipcode: "66170",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "12",
    name: "ดงป่าคำ",
    zipcode: "66170",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "13",
    name: "หัวดง",
    zipcode: "66170",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "15",
    name: "ป่ามะคาบ",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "19",
    name: "สายคำโห้",
    zipcode: "66000",
  },
  {
    jw_code: "66",
    amph_code: "01",
    tumbon_code: "20",
    name: "ดงกลาง",
    zipcode: "66170",
  },
  {
    jw_code: "66",
    amph_code: "02",
    tumbon_code: "01",
    name: "วังทรายพูน",
    zipcode: "66180",
  },
  {
    jw_code: "66",
    amph_code: "02",
    tumbon_code: "02",
    name: "หนองปลาไหล",
    zipcode: "66180",
  },
  {
    jw_code: "66",
    amph_code: "02",
    tumbon_code: "03",
    name: "หนองพระ",
    zipcode: "66180",
  },
  {
    jw_code: "66",
    amph_code: "02",
    tumbon_code: "04",
    name: "หนองปล้อง",
    zipcode: "66180",
  },
  {
    jw_code: "66",
    amph_code: "03",
    tumbon_code: "01",
    name: "โพธิ์ประทับช้าง",
    zipcode: "66190",
  },
  {
    jw_code: "66",
    amph_code: "03",
    tumbon_code: "02",
    name: "ไผ่ท่าโพ",
    zipcode: "66190",
  },
  {
    jw_code: "66",
    amph_code: "03",
    tumbon_code: "03",
    name: "วังจิก",
    zipcode: "66190",
  },
  {
    jw_code: "66",
    amph_code: "03",
    tumbon_code: "04",
    name: "ไผ่รอบ",
    zipcode: "66190",
  },
  {
    jw_code: "66",
    amph_code: "03",
    tumbon_code: "05",
    name: "ดงเสือเหลือง",
    zipcode: "66190",
  },
  {
    jw_code: "66",
    amph_code: "03",
    tumbon_code: "06",
    name: "เนินสว่าง",
    zipcode: "66190",
  },
  {
    jw_code: "66",
    amph_code: "03",
    tumbon_code: "07",
    name: "ทุ่งใหญ่",
    zipcode: "66190",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "01",
    name: "ตะพานหิน",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "02",
    name: "งิ้วราย",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "03",
    name: "ห้วยเกตุ",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "04",
    name: "ไทรโรงโขน",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "05",
    name: "หนองพยอม",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "06",
    name: "ทุ่งโพธิ์",
    zipcode: "66150",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "07",
    name: "ดงตะขบ",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "08",
    name: "คลองคูณ",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "09",
    name: "วังสำโรง",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "10",
    name: "วังหว้า",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "11",
    name: "วังหลุม",
    zipcode: "66150",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "12",
    name: "ทับหมัน",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "04",
    tumbon_code: "13",
    name: "ไผ่หลวง",
    zipcode: "66110",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "01",
    name: "บางมูลนาก",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "02",
    name: "บางไผ่",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "03",
    name: "หอไกร",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "04",
    name: "เนินมะกอก",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "05",
    name: "วังสำโรง",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "06",
    name: "ภูมิ",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "07",
    name: "วังกรด",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "08",
    name: "ห้วยเขน",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "09",
    name: "วังตะกู",
    zipcode: "66210",
  },
  {
    jw_code: "66",
    amph_code: "05",
    tumbon_code: "14",
    name: "ลำประดา",
    zipcode: "66120",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "01",
    name: "โพทะเล",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "02",
    name: "ท้ายน้ำ",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "03",
    name: "ทะนง",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "04",
    name: "ท่าบัว",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "05",
    name: "ทุ่งน้อย",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "06",
    name: "ท่าขมิ้น",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "07",
    name: "ท่าเสา",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "08",
    name: "บางคลาน",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "11",
    name: "ท่านั่ง",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "12",
    name: "บ้านน้อย",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "06",
    tumbon_code: "13",
    name: "วัดขวาง",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "07",
    tumbon_code: "01",
    name: "สามง่าม",
    zipcode: "66140",
  },
  {
    jw_code: "66",
    amph_code: "07",
    tumbon_code: "02",
    name: "กำแพงดิน",
    zipcode: "66220",
  },
  {
    jw_code: "66",
    amph_code: "07",
    tumbon_code: "03",
    name: "รังนก",
    zipcode: "66140",
  },
  {
    jw_code: "66",
    amph_code: "07",
    tumbon_code: "06",
    name: "เนินปอ",
    zipcode: "66140",
  },
  {
    jw_code: "66",
    amph_code: "07",
    tumbon_code: "07",
    name: "หนองโสน",
    zipcode: "66140",
  },
  {
    jw_code: "66",
    amph_code: "08",
    tumbon_code: "01",
    name: "ทับคล้อ",
    zipcode: "66150",
  },
  {
    jw_code: "66",
    amph_code: "08",
    tumbon_code: "02",
    name: "เขาทราย",
    zipcode: "66230",
  },
  {
    jw_code: "66",
    amph_code: "08",
    tumbon_code: "03",
    name: "เขาเจ็ดลูก",
    zipcode: "66230",
  },
  {
    jw_code: "66",
    amph_code: "08",
    tumbon_code: "04",
    name: "ท้ายทุ่ง",
    zipcode: "66150",
  },
  {
    jw_code: "66",
    amph_code: "09",
    tumbon_code: "01",
    name: "สากเหล็ก",
    zipcode: "66160",
  },
  {
    jw_code: "66",
    amph_code: "09",
    tumbon_code: "02",
    name: "ท่าเยี่ยม",
    zipcode: "66160",
  },
  {
    jw_code: "66",
    amph_code: "09",
    tumbon_code: "03",
    name: "คลองทราย",
    zipcode: "66160",
  },
  {
    jw_code: "66",
    amph_code: "09",
    tumbon_code: "04",
    name: "หนองหญ้าไทร",
    zipcode: "66160",
  },
  {
    jw_code: "66",
    amph_code: "09",
    tumbon_code: "05",
    name: "วังทับไทร",
    zipcode: "66160",
  },
  {
    jw_code: "66",
    amph_code: "10",
    tumbon_code: "01",
    name: "ห้วยแก้ว",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "10",
    tumbon_code: "02",
    name: "โพธิ์ไทรงาม",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "10",
    tumbon_code: "03",
    name: "แหลมรัง",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "10",
    tumbon_code: "04",
    name: "บางลาย",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "10",
    tumbon_code: "05",
    name: "บึงนาราง",
    zipcode: "66130",
  },
  {
    jw_code: "66",
    amph_code: "11",
    tumbon_code: "01",
    name: "วังงิ้วใต้",
    zipcode: "66210",
  },
  {
    jw_code: "66",
    amph_code: "11",
    tumbon_code: "02",
    name: "วังงิ้ว",
    zipcode: "66210",
  },
  {
    jw_code: "66",
    amph_code: "11",
    tumbon_code: "03",
    name: "ห้วยร่วม",
    zipcode: "66210",
  },
  {
    jw_code: "66",
    amph_code: "11",
    tumbon_code: "04",
    name: "ห้วยพุก",
    zipcode: "66210",
  },
  {
    jw_code: "66",
    amph_code: "11",
    tumbon_code: "05",
    name: "สำนักขุนเณร",
    zipcode: "66210",
  },
  {
    jw_code: "66",
    amph_code: "12",
    tumbon_code: "01",
    name: "บ้านนา",
    zipcode: "66140",
  },
  {
    jw_code: "66",
    amph_code: "12",
    tumbon_code: "02",
    name: "บึงบัว",
    zipcode: "66140",
  },
  {
    jw_code: "66",
    amph_code: "12",
    tumbon_code: "03",
    name: "วังโมกข์",
    zipcode: "66140",
  },
  {
    jw_code: "66",
    amph_code: "12",
    tumbon_code: "04",
    name: "หนองหลุม",
    zipcode: "66220",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "02",
    name: "ตะเบาะ",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "03",
    name: "บ้านโตก",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "04",
    name: "สะเดียง",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "05",
    name: "ป่าเลา",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "06",
    name: "นางั่ว",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "07",
    name: "ท่าพล",
    zipcode: "67250",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "08",
    name: "ดงมูลเหล็ก",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "09",
    name: "บ้านโคก",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "10",
    name: "ชอนไพร",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "11",
    name: "นาป่า",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "12",
    name: "นายม",
    zipcode: "67210",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "13",
    name: "วังชมภู",
    zipcode: "67210",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "14",
    name: "น้ำร้อน",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "15",
    name: "ห้วยสะแก",
    zipcode: "67210",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "16",
    name: "ห้วยใหญ่",
    zipcode: "67000",
  },
  {
    jw_code: "67",
    amph_code: "01",
    tumbon_code: "17",
    name: "ระวิง",
    zipcode: "67210",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "01",
    name: "ชนแดน",
    zipcode: "67150",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "02",
    name: "ดงขุย",
    zipcode: "67190",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "03",
    name: "ท่าข้าม",
    zipcode: "67150",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "04",
    name: "พุทธบาท",
    zipcode: "67150",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "05",
    name: "ลาดแค",
    zipcode: "67150",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "06",
    name: "บ้านกล้วย",
    zipcode: "67190",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "08",
    name: "ซับพุทรา",
    zipcode: "67150",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "09",
    name: "ตะกุดไร",
    zipcode: "67190",
  },
  {
    jw_code: "67",
    amph_code: "02",
    tumbon_code: "10",
    name: "ศาลาลาย",
    zipcode: "67150",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "01",
    name: "หล่มสัก",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "02",
    name: "วัดป่า",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "03",
    name: "ตาลเดี่ยว",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "04",
    name: "ฝายนาแซง",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "05",
    name: "หนองสว่าง",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "06",
    name: "น้ำเฮี้ย",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "07",
    name: "สักหลง",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "08",
    name: "ท่าอิบุญ",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "09",
    name: "บ้านโสก",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "10",
    name: "บ้านติ้ว",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "11",
    name: "ห้วยไร่",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "12",
    name: "น้ำก้อ",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "13",
    name: "ปากช่อง",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "14",
    name: "น้ำชุน",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "15",
    name: "หนองไขว่",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "16",
    name: "ลานบ่า",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "17",
    name: "บุ่งคล้า",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "18",
    name: "บุ่งน้ำเต้า",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "19",
    name: "บ้านกลาง",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "20",
    name: "ช้างตะลูด",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "21",
    name: "บ้านไร่",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "22",
    name: "ปากดุก",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "03",
    tumbon_code: "23",
    name: "บ้านหวาย",
    zipcode: "67110",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "01",
    name: "หล่มเก่า",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "02",
    name: "นาซำ",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "03",
    name: "หินฮาว",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "04",
    name: "บ้านเนิน",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "05",
    name: "ศิลา",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "06",
    name: "นาแซง",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "07",
    name: "วังบาล",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "08",
    name: "นาเกาะ",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "04",
    tumbon_code: "09",
    name: "ตาดกลอย",
    zipcode: "67120",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "01",
    name: "ท่าโรง",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "02",
    name: "สระประดู่",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "03",
    name: "สามแยก",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "04",
    name: "โคกปรง",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "05",
    name: "น้ำร้อน",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "06",
    name: "บ่อรัง",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "07",
    name: "พุเตย",
    zipcode: "67180",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "08",
    name: "พุขาม",
    zipcode: "67180",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "09",
    name: "ภูน้ำหยด",
    zipcode: "67180",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "10",
    name: "ซับสมบูรณ์",
    zipcode: "67180",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "11",
    name: "บึงกระจับ",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "12",
    name: "วังใหญ่",
    zipcode: "67180",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "13",
    name: "ยางสาว",
    zipcode: "67130",
  },
  {
    jw_code: "67",
    amph_code: "05",
    tumbon_code: "14",
    name: "ซับน้อย",
    zipcode: "67180",
  },
  {
    jw_code: "67",
    amph_code: "06",
    tumbon_code: "01",
    name: "ศรีเทพ",
    zipcode: "67170",
  },
  {
    jw_code: "67",
    amph_code: "06",
    tumbon_code: "02",
    name: "สระกรวด",
    zipcode: "67170",
  },
  {
    jw_code: "67",
    amph_code: "06",
    tumbon_code: "03",
    name: "คลองกระจัง",
    zipcode: "67170",
  },
  {
    jw_code: "67",
    amph_code: "06",
    tumbon_code: "04",
    name: "นาสนุ่น",
    zipcode: "67170",
  },
  {
    jw_code: "67",
    amph_code: "06",
    tumbon_code: "05",
    name: "โคกสะอาด",
    zipcode: "67170",
  },
  {
    jw_code: "67",
    amph_code: "06",
    tumbon_code: "06",
    name: "หนองย่างทอย",
    zipcode: "67170",
  },
  {
    jw_code: "67",
    amph_code: "06",
    tumbon_code: "07",
    name: "ประดู่งาม",
    zipcode: "67170",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "01",
    name: "กองทูล",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "02",
    name: "นาเฉลียง",
    zipcode: "67220",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "03",
    name: "บ้านโภชน์",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "04",
    name: "ท่าแดง",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "05",
    name: "เพชรละคร",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "06",
    name: "บ่อไทย",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "07",
    name: "ห้วยโป่ง",
    zipcode: "67220",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "08",
    name: "วังท่าดี",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "09",
    name: "บัววัฒนา",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "10",
    name: "หนองไผ่",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "11",
    name: "วังโบสถ์",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "12",
    name: "ยางงาม",
    zipcode: "67220",
  },
  {
    jw_code: "67",
    amph_code: "07",
    tumbon_code: "13",
    name: "ท่าด้วง",
    zipcode: "67140",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "01",
    name: "ซับสมอทอด",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "02",
    name: "ซับไม้แดง",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "03",
    name: "หนองแจง",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "04",
    name: "กันจุ",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "05",
    name: "วังพิกุล",
    zipcode: "67230",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "06",
    name: "พญาวัง",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "07",
    name: "ศรีมงคล",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "08",
    name: "สระแก้ว",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "08",
    tumbon_code: "09",
    name: "บึงสามพัน",
    zipcode: "67160",
  },
  {
    jw_code: "67",
    amph_code: "09",
    tumbon_code: "01",
    name: "น้ำหนาว",
    zipcode: "67260",
  },
  {
    jw_code: "67",
    amph_code: "09",
    tumbon_code: "02",
    name: "หลักด่าน",
    zipcode: "67260",
  },
  {
    jw_code: "67",
    amph_code: "09",
    tumbon_code: "03",
    name: "วังกวาง",
    zipcode: "67260",
  },
  {
    jw_code: "67",
    amph_code: "09",
    tumbon_code: "04",
    name: "โคกมน",
    zipcode: "67260",
  },
  {
    jw_code: "67",
    amph_code: "10",
    tumbon_code: "01",
    name: "วังโป่ง",
    zipcode: "67240",
  },
  {
    jw_code: "67",
    amph_code: "10",
    tumbon_code: "02",
    name: "ท้ายดง",
    zipcode: "67240",
  },
  {
    jw_code: "67",
    amph_code: "10",
    tumbon_code: "03",
    name: "ซับเปิบ",
    zipcode: "67240",
  },
  {
    jw_code: "67",
    amph_code: "10",
    tumbon_code: "04",
    name: "วังหิน",
    zipcode: "67240",
  },
  {
    jw_code: "67",
    amph_code: "10",
    tumbon_code: "05",
    name: "วังศาล",
    zipcode: "67240",
  },
  {
    jw_code: "67",
    amph_code: "11",
    tumbon_code: "01",
    name: "ทุ่งสมอ",
    zipcode: "67270",
  },
  {
    jw_code: "67",
    amph_code: "11",
    tumbon_code: "02",
    name: "แคมป์สน",
    zipcode: "67280",
  },
  {
    jw_code: "67",
    amph_code: "11",
    tumbon_code: "03",
    name: "เขาค้อ",
    zipcode: "67270",
  },
  {
    jw_code: "67",
    amph_code: "11",
    tumbon_code: "04",
    name: "ริมสีม่วง",
    zipcode: "67270",
  },
  {
    jw_code: "67",
    amph_code: "11",
    tumbon_code: "05",
    name: "สะเดาะพง",
    zipcode: "67270",
  },
  {
    jw_code: "67",
    amph_code: "11",
    tumbon_code: "06",
    name: "หนองแม่นา",
    zipcode: "67270",
  },
  {
    jw_code: "67",
    amph_code: "11",
    tumbon_code: "07",
    name: "เข็กน้อย",
    zipcode: "67280",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "01",
    name: "หน้าเมือง",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "02",
    name: "เจดีย์หัก",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "03",
    name: "ดอนตะโก",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "04",
    name: "หนองกลางนา",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "05",
    name: "ห้วยไผ่",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "06",
    name: "คุ้งน้ำวน",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "07",
    name: "คุ้งกระถิน",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "08",
    name: "อ่างทอง",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "09",
    name: "โคกหม้อ",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "10",
    name: "สามเรือน",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "11",
    name: "พิกุลทอง",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "12",
    name: "น้ำพุ",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "13",
    name: "ดอนแร่",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "14",
    name: "หินกอง",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "15",
    name: "เขาแร้ง",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "16",
    name: "เกาะพลับพลา",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "17",
    name: "หลุมดิน",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "18",
    name: "บางป่า",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "19",
    name: "พงสวาย",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "20",
    name: "คูบัว",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "21",
    name: "ท่าราบ",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "01",
    tumbon_code: "22",
    name: "บ้านไร่",
    zipcode: "70000",
  },
  {
    jw_code: "70",
    amph_code: "02",
    tumbon_code: "01",
    name: "จอมบึง",
    zipcode: "70150",
  },
  {
    jw_code: "70",
    amph_code: "02",
    tumbon_code: "02",
    name: "ปากช่อง",
    zipcode: "70150",
  },
  {
    jw_code: "70",
    amph_code: "02",
    tumbon_code: "03",
    name: "เบิกไพร",
    zipcode: "70150",
  },
  {
    jw_code: "70",
    amph_code: "02",
    tumbon_code: "04",
    name: "ด่านทับตะโก",
    zipcode: "70150",
  },
  {
    jw_code: "70",
    amph_code: "02",
    tumbon_code: "05",
    name: "แก้มอ้น",
    zipcode: "70150",
  },
  {
    jw_code: "70",
    amph_code: "02",
    tumbon_code: "06",
    name: "รางบัว",
    zipcode: "70150",
  },
  {
    jw_code: "70",
    amph_code: "03",
    tumbon_code: "01",
    name: "สวนผึ้ง",
    zipcode: "70180",
  },
  {
    jw_code: "70",
    amph_code: "03",
    tumbon_code: "02",
    name: "ป่าหวาย",
    zipcode: "70180",
  },
  {
    jw_code: "70",
    amph_code: "03",
    tumbon_code: "04",
    name: "ท่าเคย",
    zipcode: "70180",
  },
  {
    jw_code: "70",
    amph_code: "03",
    tumbon_code: "07",
    name: "ตะนาวศรี",
    zipcode: "70180",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "01",
    name: "ดำเนินสะดวก",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "02",
    name: "ประสาทสิทธิ์",
    zipcode: "70210",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "03",
    name: "ศรีสุราษฎร์",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "04",
    name: "ตาหลวง",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "05",
    name: "ดอนกรวย",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "06",
    name: "ดอนคลัง",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "07",
    name: "บัวงาม",
    zipcode: "70210",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "08",
    name: "บ้านไร่",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "09",
    name: "แพงพวย",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "10",
    name: "สี่หมื่น",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "11",
    name: "ท่านัด",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "12",
    name: "ขุนพิทักษ์",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "04",
    tumbon_code: "13",
    name: "ดอนไผ่",
    zipcode: "70130",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "01",
    name: "บ้านโป่ง",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "02",
    name: "ท่าผา",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "03",
    name: "กรับใหญ่",
    zipcode: "70190",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "04",
    name: "ปากแรต",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "05",
    name: "หนองกบ",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "06",
    name: "หนองอ้อ",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "07",
    name: "ดอนกระเบื้อง",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "08",
    name: "สวนกล้วย",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "09",
    name: "นครชุมน์",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "10",
    name: "บ้านม่วง",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "11",
    name: "คุ้งพยอม",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "12",
    name: "หนองปลาหมอ",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "13",
    name: "เขาขลุง",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "14",
    name: "เบิกไพร",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "05",
    tumbon_code: "15",
    name: "ลาดบัวขาว",
    zipcode: "70110",
  },
  {
    jw_code: "70",
    amph_code: "06",
    tumbon_code: "01",
    name: "บางแพ",
    zipcode: "70160",
  },
  {
    jw_code: "70",
    amph_code: "06",
    tumbon_code: "02",
    name: "วังเย็น",
    zipcode: "70160",
  },
  {
    jw_code: "70",
    amph_code: "06",
    tumbon_code: "03",
    name: "หัวโพ",
    zipcode: "70160",
  },
  {
    jw_code: "70",
    amph_code: "06",
    tumbon_code: "04",
    name: "วัดแก้ว",
    zipcode: "70160",
  },
  {
    jw_code: "70",
    amph_code: "06",
    tumbon_code: "05",
    name: "ดอนใหญ่",
    zipcode: "70160",
  },
  {
    jw_code: "70",
    amph_code: "06",
    tumbon_code: "06",
    name: "ดอนคา",
    zipcode: "70160",
  },
  {
    jw_code: "70",
    amph_code: "06",
    tumbon_code: "07",
    name: "โพหัก",
    zipcode: "70160",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "01",
    name: "โพธาราม",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "02",
    name: "ดอนกระเบื้อง",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "03",
    name: "หนองโพ",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "04",
    name: "บ้านเลือก",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "05",
    name: "คลองตาคต",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "06",
    name: "บ้านฆ้อง",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "07",
    name: "บ้านสิงห์",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "08",
    name: "ดอนทราย",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "09",
    name: "เจ็ดเสมียน",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "10",
    name: "คลองข่อย",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "11",
    name: "ชำแระ",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "12",
    name: "สร้อยฟ้า",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "13",
    name: "ท่าชุมพล",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "14",
    name: "บางโตนด",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "15",
    name: "เตาปูน",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "16",
    name: "นางแก้ว",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "17",
    name: "ธรรมเสน",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "18",
    name: "เขาชะงุ้ม",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "07",
    tumbon_code: "19",
    name: "หนองกวาง",
    zipcode: "70120",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "01",
    name: "ทุ่งหลวง",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "02",
    name: "วังมะนาว",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "03",
    name: "ดอนทราย",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "04",
    name: "หนองกระทุ่ม",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "05",
    name: "ปากท่อ",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "06",
    name: "ป่าไก่",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "07",
    name: "วัดยางงาม",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "08",
    name: "อ่างหิน",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "09",
    name: "บ่อกระดาน",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "10",
    name: "ยางหัก",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "11",
    name: "วันดาว",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "08",
    tumbon_code: "12",
    name: "ห้วยยางโทน",
    zipcode: "70140",
  },
  {
    jw_code: "70",
    amph_code: "09",
    tumbon_code: "01",
    name: "เกาะศาลพระ",
    zipcode: "70170",
  },
  {
    jw_code: "70",
    amph_code: "09",
    tumbon_code: "02",
    name: "จอมประทัด",
    zipcode: "70170",
  },
  {
    jw_code: "70",
    amph_code: "09",
    tumbon_code: "03",
    name: "วัดเพลง",
    zipcode: "70170",
  },
  {
    jw_code: "70",
    amph_code: "10",
    tumbon_code: "01",
    name: "บ้านคา",
    zipcode: "70180",
  },
  {
    jw_code: "70",
    amph_code: "10",
    tumbon_code: "02",
    name: "บ้านบึง",
    zipcode: "70180",
  },
  {
    jw_code: "70",
    amph_code: "10",
    tumbon_code: "03",
    name: "หนองพันจันทร์",
    zipcode: "70180",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "01",
    name: "บ้านเหนือ",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "02",
    name: "บ้านใต้",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "03",
    name: "ปากแพรก",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "04",
    name: "ท่ามะขาม",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "05",
    name: "แก่งเสี้ยน",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "06",
    name: "หนองบัว",
    zipcode: "71190",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "07",
    name: "ลาดหญ้า",
    zipcode: "71190",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "08",
    name: "วังด้ง",
    zipcode: "71190",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "09",
    name: "ช่องสะเดา",
    zipcode: "71190",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "10",
    name: "หนองหญ้า",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "11",
    name: "เกาะสำโรง",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "13",
    name: "บ้านเก่า",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "01",
    tumbon_code: "16",
    name: "วังเย็น",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "02",
    tumbon_code: "01",
    name: "ลุ่มสุ่ม",
    zipcode: "71150",
  },
  {
    jw_code: "71",
    amph_code: "02",
    tumbon_code: "02",
    name: "ท่าเสา",
    zipcode: "71150",
  },
  {
    jw_code: "71",
    amph_code: "02",
    tumbon_code: "03",
    name: "สิงห์",
    zipcode: "71150",
  },
  {
    jw_code: "71",
    amph_code: "02",
    tumbon_code: "04",
    name: "ไทรโยค",
    zipcode: "71150",
  },
  {
    jw_code: "71",
    amph_code: "02",
    tumbon_code: "05",
    name: "วังกระแจะ",
    zipcode: "71150",
  },
  {
    jw_code: "71",
    amph_code: "02",
    tumbon_code: "06",
    name: "ศรีมงคล",
    zipcode: "71150",
  },
  {
    jw_code: "71",
    amph_code: "02",
    tumbon_code: "07",
    name: "บ้องตี้",
    zipcode: "71150",
  },
  {
    jw_code: "71",
    amph_code: "03",
    tumbon_code: "01",
    name: "บ่อพลอย",
    zipcode: "71160",
  },
  {
    jw_code: "71",
    amph_code: "03",
    tumbon_code: "02",
    name: "หนองกุ่ม",
    zipcode: "71160",
  },
  {
    jw_code: "71",
    amph_code: "03",
    tumbon_code: "03",
    name: "หนองรี",
    zipcode: "71220",
  },
  {
    jw_code: "71",
    amph_code: "03",
    tumbon_code: "05",
    name: "หลุมรัง",
    zipcode: "71160",
  },
  {
    jw_code: "71",
    amph_code: "03",
    tumbon_code: "08",
    name: "ช่องด่าน",
    zipcode: "71160",
  },
  {
    jw_code: "71",
    amph_code: "03",
    tumbon_code: "09",
    name: "หนองกร่าง",
    zipcode: "71220",
  },
  {
    jw_code: "71",
    amph_code: "04",
    tumbon_code: "01",
    name: "นาสวน",
    zipcode: "71250",
  },
  {
    jw_code: "71",
    amph_code: "04",
    tumbon_code: "02",
    name: "ด่านแม่แฉลบ",
    zipcode: "71250",
  },
  {
    jw_code: "71",
    amph_code: "04",
    tumbon_code: "03",
    name: "หนองเป็ด",
    zipcode: "71250",
  },
  {
    jw_code: "71",
    amph_code: "04",
    tumbon_code: "04",
    name: "ท่ากระดาน",
    zipcode: "71250",
  },
  {
    jw_code: "71",
    amph_code: "04",
    tumbon_code: "05",
    name: "เขาโจด",
    zipcode: "71220",
  },
  {
    jw_code: "71",
    amph_code: "04",
    tumbon_code: "06",
    name: "แม่กระบุง",
    zipcode: "71250",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "01",
    name: "พงตึก",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "02",
    name: "ยางม่วง",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "03",
    name: "ดอนชะเอม",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "04",
    name: "ท่าไม้",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "05",
    name: "ตะคร้ำเอน",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "06",
    name: "ท่ามะกา",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "07",
    name: "ท่าเรือ",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "08",
    name: "โคกตะบอง",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "09",
    name: "ดอนขมิ้น",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "10",
    name: "อุโลกสี่หมื่น",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "11",
    name: "เขาสามสิบหาบ",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "12",
    name: "พระแท่น",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "13",
    name: "หวายเหนียว",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "14",
    name: "แสนตอ",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "15",
    name: "สนามแย้",
    zipcode: "70190",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "16",
    name: "ท่าเสา",
    zipcode: "71120",
  },
  {
    jw_code: "71",
    amph_code: "05",
    tumbon_code: "17",
    name: "หนองลาน",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "01",
    name: "ท่าม่วง",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "02",
    name: "วังขนาย",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "03",
    name: "วังศาลา",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "04",
    name: "ท่าล้อ",
    zipcode: "71000",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "05",
    name: "หนองขาว",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "06",
    name: "ทุ่งทอง",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "07",
    name: "เขาน้อย",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "08",
    name: "ม่วงชุม",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "09",
    name: "บ้านใหม่",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "10",
    name: "พังตรุ",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "11",
    name: "ท่าตะคร้อ",
    zipcode: "71130",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "12",
    name: "รางสาลี่",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "06",
    tumbon_code: "13",
    name: "หนองตากยา",
    zipcode: "71110",
  },
  {
    jw_code: "71",
    amph_code: "07",
    tumbon_code: "01",
    name: "ท่าขนุน",
    zipcode: "71180",
  },
  {
    jw_code: "71",
    amph_code: "07",
    tumbon_code: "02",
    name: "ปิล๊อก",
    zipcode: "71180",
  },
  {
    jw_code: "71",
    amph_code: "07",
    tumbon_code: "03",
    name: "หินดาด",
    zipcode: "71180",
  },
  {
    jw_code: "71",
    amph_code: "07",
    tumbon_code: "04",
    name: "ลิ่นถิ่น",
    zipcode: "71180",
  },
  {
    jw_code: "71",
    amph_code: "07",
    tumbon_code: "05",
    name: "ชะแล",
    zipcode: "71180",
  },
  {
    jw_code: "71",
    amph_code: "07",
    tumbon_code: "06",
    name: "ห้วยเขย่ง",
    zipcode: "71180",
  },
  {
    jw_code: "71",
    amph_code: "07",
    tumbon_code: "07",
    name: "สหกรณ์นิคม",
    zipcode: "71180",
  },
  {
    jw_code: "71",
    amph_code: "08",
    tumbon_code: "01",
    name: "หนองลู",
    zipcode: "71240",
  },
  {
    jw_code: "71",
    amph_code: "08",
    tumbon_code: "02",
    name: "ปรังเผล",
    zipcode: "71240",
  },
  {
    jw_code: "71",
    amph_code: "08",
    tumbon_code: "03",
    name: "ไล่โว่",
    zipcode: "71240",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "01",
    name: "พนมทวน",
    zipcode: "71140",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "02",
    name: "หนองโรง",
    zipcode: "71140",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "03",
    name: "ทุ่งสมอ",
    zipcode: "71140",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "04",
    name: "ดอนเจดีย์",
    zipcode: "71140",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "05",
    name: "พังตรุ",
    zipcode: "71140",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "06",
    name: "รางหวาย",
    zipcode: "71170",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "11",
    name: "หนองสาหร่าย",
    zipcode: "71140",
  },
  {
    jw_code: "71",
    amph_code: "09",
    tumbon_code: "12",
    name: "ดอนตาเพชร",
    zipcode: "71140",
  },
  {
    jw_code: "71",
    amph_code: "10",
    tumbon_code: "01",
    name: "เลาขวัญ",
    zipcode: "71210",
  },
  {
    jw_code: "71",
    amph_code: "10",
    tumbon_code: "02",
    name: "หนองโสน",
    zipcode: "71210",
  },
  {
    jw_code: "71",
    amph_code: "10",
    tumbon_code: "03",
    name: "หนองประดู่",
    zipcode: "71210",
  },
  {
    jw_code: "71",
    amph_code: "10",
    tumbon_code: "04",
    name: "หนองปลิง",
    zipcode: "71210",
  },
  {
    jw_code: "71",
    amph_code: "10",
    tumbon_code: "05",
    name: "หนองนกแก้ว",
    zipcode: "71210",
  },
  {
    jw_code: "71",
    amph_code: "10",
    tumbon_code: "06",
    name: "ทุ่งกระบ่ำ",
    zipcode: "71210",
  },
  {
    jw_code: "71",
    amph_code: "10",
    tumbon_code: "07",
    name: "หนองฝ้าย",
    zipcode: "71210",
  },
  {
    jw_code: "71",
    amph_code: "11",
    tumbon_code: "01",
    name: "ด่านมะขามเตี้ย",
    zipcode: "71260",
  },
  {
    jw_code: "71",
    amph_code: "11",
    tumbon_code: "02",
    name: "กลอนโด",
    zipcode: "71260",
  },
  {
    jw_code: "71",
    amph_code: "11",
    tumbon_code: "03",
    name: "จรเข้เผือก",
    zipcode: "71260",
  },
  {
    jw_code: "71",
    amph_code: "11",
    tumbon_code: "04",
    name: "หนองไผ่",
    zipcode: "71260",
  },
  {
    jw_code: "71",
    amph_code: "12",
    tumbon_code: "01",
    name: "หนองปรือ",
    zipcode: "71220",
  },
  {
    jw_code: "71",
    amph_code: "12",
    tumbon_code: "02",
    name: "หนองปลาไหล",
    zipcode: "71220",
  },
  {
    jw_code: "71",
    amph_code: "12",
    tumbon_code: "03",
    name: "สมเด็จเจริญ",
    zipcode: "71220",
  },
  {
    jw_code: "71",
    amph_code: "13",
    tumbon_code: "01",
    name: "ห้วยกระเจา",
    zipcode: "71170",
  },
  {
    jw_code: "71",
    amph_code: "13",
    tumbon_code: "02",
    name: "วังไผ่",
    zipcode: "71170",
  },
  {
    jw_code: "71",
    amph_code: "13",
    tumbon_code: "03",
    name: "ดอนแสลบ",
    zipcode: "71170",
  },
  {
    jw_code: "71",
    amph_code: "13",
    tumbon_code: "04",
    name: "สระลงเรือ",
    zipcode: "71170",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "01",
    name: "ท่าพี่เลี้ยง",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "02",
    name: "รั้วใหญ่",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "03",
    name: "ทับตีเหล็ก",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "04",
    name: "ท่าระหัด",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "05",
    name: "ไผ่ขวาง",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "06",
    name: "โคกโคเฒ่า",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "07",
    name: "ดอนตาล",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "08",
    name: "ดอนมะสังข์",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "09",
    name: "พิหารแดง",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "10",
    name: "ดอนกำยาน",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "11",
    name: "ดอนโพธิ์ทอง",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "12",
    name: "บ้านโพธิ์",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "13",
    name: "สระแก้ว",
    zipcode: "72230",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "14",
    name: "ตลิ่งชัน",
    zipcode: "72230",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "15",
    name: "บางกุ้ง",
    zipcode: "72210",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "16",
    name: "ศาลาขาว",
    zipcode: "72210",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "17",
    name: "สวนแตง",
    zipcode: "72210",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "18",
    name: "สนามชัย",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "19",
    name: "โพธิ์พระยา",
    zipcode: "72000",
  },
  {
    jw_code: "72",
    amph_code: "01",
    tumbon_code: "20",
    name: "สนามคลี",
    zipcode: "72230",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "01",
    name: "เขาพระ",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "02",
    name: "เดิมบาง",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "03",
    name: "นางบวช",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "04",
    name: "เขาดิน",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "05",
    name: "ปากน้ำ",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "06",
    name: "ทุ่งคลี",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "07",
    name: "โคกช้าง",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "08",
    name: "หัวเขา",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "09",
    name: "หัวนา",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "10",
    name: "บ่อกรุ",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "11",
    name: "วังศรีราช",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "12",
    name: "ป่าสะแก",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "13",
    name: "ยางนอน",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "02",
    tumbon_code: "14",
    name: "หนองกระทุ่ม",
    zipcode: "72120",
  },
  {
    jw_code: "72",
    amph_code: "03",
    tumbon_code: "01",
    name: "หนองมะค่าโมง",
    zipcode: "72180",
  },
  {
    jw_code: "72",
    amph_code: "03",
    tumbon_code: "02",
    name: "ด่านช้าง",
    zipcode: "72180",
  },
  {
    jw_code: "72",
    amph_code: "03",
    tumbon_code: "03",
    name: "ห้วยขมิ้น",
    zipcode: "72180",
  },
  {
    jw_code: "72",
    amph_code: "03",
    tumbon_code: "04",
    name: "องค์พระ",
    zipcode: "72180",
  },
  {
    jw_code: "72",
    amph_code: "03",
    tumbon_code: "05",
    name: "วังคัน",
    zipcode: "72180",
  },
  {
    jw_code: "72",
    amph_code: "03",
    tumbon_code: "06",
    name: "นิคมกระเสียว",
    zipcode: "72180",
  },
  {
    jw_code: "72",
    amph_code: "03",
    tumbon_code: "07",
    name: "วังยาว",
    zipcode: "72180",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "01",
    name: "โคกคราม",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "02",
    name: "บางปลาม้า",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "03",
    name: "ตะค่า",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "04",
    name: "บางใหญ่",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "05",
    name: "กฤษณา",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "06",
    name: "สาลี",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "07",
    name: "ไผ่กองดิน",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "08",
    name: "องครักษ์",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "09",
    name: "จรเข้ใหญ่",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "10",
    name: "บ้านแหลม",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "11",
    name: "มะขามล้ม",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "12",
    name: "วังน้ำเย็น",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "13",
    name: "วัดโบสถ์",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "04",
    tumbon_code: "14",
    name: "วัดดาว",
    zipcode: "72150",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "01",
    name: "ศรีประจันต์",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "02",
    name: "บ้านกร่าง",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "03",
    name: "มดแดง",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "04",
    name: "บางงาม",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "05",
    name: "ดอนปรู",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "06",
    name: "ปลายนา",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "07",
    name: "วังหว้า",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "08",
    name: "วังน้ำซับ",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "05",
    tumbon_code: "09",
    name: "วังยาง",
    zipcode: "72140",
  },
  {
    jw_code: "72",
    amph_code: "06",
    tumbon_code: "01",
    name: "ดอนเจดีย์",
    zipcode: "72170",
  },
  {
    jw_code: "72",
    amph_code: "06",
    tumbon_code: "02",
    name: "หนองสาหร่าย",
    zipcode: "72170",
  },
  {
    jw_code: "72",
    amph_code: "06",
    tumbon_code: "03",
    name: "ไร่รถ",
    zipcode: "72170",
  },
  {
    jw_code: "72",
    amph_code: "06",
    tumbon_code: "04",
    name: "สระกระโจม",
    zipcode: "72250",
  },
  {
    jw_code: "72",
    amph_code: "06",
    tumbon_code: "05",
    name: "ทะเลบก",
    zipcode: "72250",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "01",
    name: "สองพี่น้อง",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "02",
    name: "บางเลน",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "03",
    name: "บางตาเถร",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "04",
    name: "บางตะเคียน",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "05",
    name: "บ้านกุ่ม",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "06",
    name: "หัวโพธิ์",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "07",
    name: "บางพลับ",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "08",
    name: "เนินพระปรางค์",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "09",
    name: "บ้านช้าง",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "10",
    name: "ต้นตาล",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "11",
    name: "ศรีสำราญ",
    zipcode: "72190",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "12",
    name: "ทุ่งคอก",
    zipcode: "72190",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "13",
    name: "หนองบ่อ",
    zipcode: "72190",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "14",
    name: "บ่อสุพรรณ",
    zipcode: "72190",
  },
  {
    jw_code: "72",
    amph_code: "07",
    tumbon_code: "15",
    name: "ดอนมะนาว",
    zipcode: "72110",
  },
  {
    jw_code: "72",
    amph_code: "08",
    tumbon_code: "01",
    name: "ย่านยาว",
    zipcode: "72130",
  },
  {
    jw_code: "72",
    amph_code: "08",
    tumbon_code: "02",
    name: "วังลึก",
    zipcode: "72130",
  },
  {
    jw_code: "72",
    amph_code: "08",
    tumbon_code: "03",
    name: "สามชุก",
    zipcode: "72130",
  },
  {
    jw_code: "72",
    amph_code: "08",
    tumbon_code: "04",
    name: "หนองผักนาก",
    zipcode: "72130",
  },
  {
    jw_code: "72",
    amph_code: "08",
    tumbon_code: "05",
    name: "บ้านสระ",
    zipcode: "72130",
  },
  {
    jw_code: "72",
    amph_code: "08",
    tumbon_code: "06",
    name: "หนองสะเดา",
    zipcode: "72130",
  },
  {
    jw_code: "72",
    amph_code: "08",
    tumbon_code: "07",
    name: "กระเสียว",
    zipcode: "72130",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "01",
    name: "อู่ทอง",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "02",
    name: "สระยายโสม",
    zipcode: "72220",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "03",
    name: "จรเข้สามพัน",
    zipcode: "71170",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "04",
    name: "บ้านดอน",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "05",
    name: "ยุ้งทะลาย",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "06",
    name: "ดอนมะเกลือ",
    zipcode: "72220",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "07",
    name: "หนองโอ่ง",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "08",
    name: "ดอนคา",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "09",
    name: "พลับพลาไชย",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "10",
    name: "บ้านโข้ง",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "11",
    name: "เจดีย์",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "12",
    name: "สระพังลาน",
    zipcode: "72220",
  },
  {
    jw_code: "72",
    amph_code: "09",
    tumbon_code: "13",
    name: "กระจัน",
    zipcode: "72160",
  },
  {
    jw_code: "72",
    amph_code: "10",
    tumbon_code: "01",
    name: "หนองหญ้าไซ",
    zipcode: "72240",
  },
  {
    jw_code: "72",
    amph_code: "10",
    tumbon_code: "02",
    name: "หนองราชวัตร",
    zipcode: "72240",
  },
  {
    jw_code: "72",
    amph_code: "10",
    tumbon_code: "03",
    name: "หนองโพธิ์",
    zipcode: "72240",
  },
  {
    jw_code: "72",
    amph_code: "10",
    tumbon_code: "04",
    name: "แจงงาม",
    zipcode: "72240",
  },
  {
    jw_code: "72",
    amph_code: "10",
    tumbon_code: "05",
    name: "หนองขาม",
    zipcode: "72240",
  },
  {
    jw_code: "72",
    amph_code: "10",
    tumbon_code: "06",
    name: "ทัพหลวง",
    zipcode: "72240",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "01",
    name: "พระปฐมเจดีย์",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "02",
    name: "บางแขม",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "03",
    name: "พระประโทน",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "04",
    name: "ธรรมศาลา",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "05",
    name: "ตาก้อง",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "06",
    name: "มาบแค",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "07",
    name: "สนามจันทร์",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "08",
    name: "ดอนยายหอม",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "09",
    name: "ถนนขาด",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "10",
    name: "บ่อพลับ",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "11",
    name: "นครปฐม",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "12",
    name: "วังตะกู",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "13",
    name: "หนองปากโลง",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "14",
    name: "สามควายเผือก",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "15",
    name: "ทุ่งน้อย",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "16",
    name: "หนองดินแดง",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "17",
    name: "วังเย็น",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "18",
    name: "โพรงมะเดื่อ",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "19",
    name: "ลำพยา",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "20",
    name: "สระกะเทียม",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "21",
    name: "สวนป่าน",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "22",
    name: "ห้วยจรเข้",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "23",
    name: "ทัพหลวง",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "24",
    name: "หนองงูเหลือม",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "01",
    tumbon_code: "25",
    name: "บ้านยาง",
    zipcode: "73000",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "01",
    name: "ทุ่งกระพังโหม",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "02",
    name: "กระตีบ",
    zipcode: "73180",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "03",
    name: "ทุ่งลูกนก",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "04",
    name: "ห้วยขวาง",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "05",
    name: "ทุ่งขวาง",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "06",
    name: "สระสี่มุม",
    zipcode: "73180",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "07",
    name: "ทุ่งบัว",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "08",
    name: "ดอนข่อย",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "09",
    name: "สระพัฒนา",
    zipcode: "73180",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "10",
    name: "ห้วยหมอนทอง",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "11",
    name: "ห้วยม่วง",
    zipcode: "73180",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "12",
    name: "กำแพงแสน",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "13",
    name: "รางพิกุล",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "14",
    name: "หนองกระทุ่ม",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "02",
    tumbon_code: "15",
    name: "วังน้ำเขียว",
    zipcode: "73140",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "01",
    name: "นครชัยศรี",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "02",
    name: "บางกระเบา",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "03",
    name: "วัดแค",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "04",
    name: "ท่าตำหนัก",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "05",
    name: "บางแก้ว",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "06",
    name: "ท่ากระชับ",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "07",
    name: "ขุนแก้ว",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "08",
    name: "ท่าพระยา",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "09",
    name: "พะเนียด",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "10",
    name: "บางระกำ",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "11",
    name: "โคกพระเจดีย์",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "12",
    name: "ศรีษะทอง",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "13",
    name: "แหลมบัว",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "14",
    name: "ศรีมหาโพธิ์",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "15",
    name: "สัมปทวน",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "16",
    name: "วัดสำโรง",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "17",
    name: "ดอนแฝก",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "18",
    name: "ห้วยพลู",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "19",
    name: "วัดละมุด",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "20",
    name: "บางพระ",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "21",
    name: "บางแก้วฟ้า",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "22",
    name: "ลานตากฟ้า",
    zipcode: "73170",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "23",
    name: "งิ้วราย",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "03",
    tumbon_code: "24",
    name: "ไทยาวาส",
    zipcode: "73120",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "01",
    name: "สามง่าม",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "02",
    name: "ห้วยพระ",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "03",
    name: "ลำเหย",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "04",
    name: "ดอนพุทรา",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "05",
    name: "บ้านหลวง",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "06",
    name: "ดอนรวก",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "07",
    name: "ห้วยด้วน",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "04",
    tumbon_code: "08",
    name: "ลำลูกบัว",
    zipcode: "73150",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "01",
    name: "บางเลน",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "02",
    name: "บางปลา",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "03",
    name: "บางหลวง",
    zipcode: "73190",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "04",
    name: "บางภาษี",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "05",
    name: "บางระกำ",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "06",
    name: "บางไทรป่า",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "07",
    name: "หินมูล",
    zipcode: "73190",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "08",
    name: "ไทรงาม",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "09",
    name: "ดอนตูม",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "10",
    name: "นิลเพชร",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "11",
    name: "บัวปากท่า",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "12",
    name: "คลองนกกระทุง",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "13",
    name: "นราภิรมย์",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "14",
    name: "ลำพญา",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "05",
    tumbon_code: "15",
    name: "ไผ่หูช้าง",
    zipcode: "73130",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "01",
    name: "ท่าข้าม",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "02",
    name: "ทรงคนอง",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "03",
    name: "หอมเกร็ด",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "04",
    name: "บางกระทึก",
    zipcode: "73210",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "05",
    name: "บางเตย",
    zipcode: "73210",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "06",
    name: "สามพราน",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "07",
    name: "บางช้าง",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "08",
    name: "ไร่ขิง",
    zipcode: "73210",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "09",
    name: "ท่าตลาด",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "10",
    name: "กระทุ่มล้ม",
    zipcode: "73220",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "11",
    name: "คลองใหม่",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "12",
    name: "ตลาดจินดา",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "13",
    name: "คลองจินดา",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "14",
    name: "ยายชา",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "15",
    name: "บ้านใหม่",
    zipcode: "73110",
  },
  {
    jw_code: "73",
    amph_code: "06",
    tumbon_code: "16",
    name: "อ้อมใหญ่",
    zipcode: "73160",
  },
  {
    jw_code: "73",
    amph_code: "07",
    tumbon_code: "01",
    name: "ศาลายา",
    zipcode: "73170",
  },
  {
    jw_code: "73",
    amph_code: "07",
    tumbon_code: "02",
    name: "คลองโยง",
    zipcode: "73170",
  },
  {
    jw_code: "73",
    amph_code: "07",
    tumbon_code: "03",
    name: "มหาสวัสดิ์",
    zipcode: "73170",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "01",
    name: "มหาชัย",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "02",
    name: "ท่าฉลอม",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "03",
    name: "โกรกกราก",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "04",
    name: "บ้านบ่อ",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "05",
    name: "บางโทรัด",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "06",
    name: "กาหลง",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "07",
    name: "นาโคก",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "08",
    name: "ท่าจีน",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "09",
    name: "นาดี",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "10",
    name: "ท่าทราย",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "11",
    name: "คอกกระบือ",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "12",
    name: "บางน้ำจืด",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "13",
    name: "พันท้ายนรสิงห์",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "14",
    name: "โคกขาม",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "15",
    name: "บ้านเกาะ",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "16",
    name: "บางกระเจ้า",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "17",
    name: "บางหญ้าแพรก",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "01",
    tumbon_code: "18",
    name: "ชัยมงคล",
    zipcode: "74000",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "01",
    name: "ตลาดกระทุ่มแบน",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "02",
    name: "อ้อมน้อย",
    zipcode: "74130",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "03",
    name: "ท่าไม้",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "04",
    name: "สวนหลวง",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "05",
    name: "บางยาง",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "06",
    name: "คลองมะเดื่อ",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองนกไข่",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "08",
    name: "ดอนไก่ดี",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "09",
    name: "แคราย",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "02",
    tumbon_code: "10",
    name: "ท่าเสา",
    zipcode: "74110",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "01",
    name: "บ้านแพ้ว",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "02",
    name: "หลักสาม",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "03",
    name: "ยกกระบัตร",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "04",
    name: "โรงเข้",
    zipcode: "70210",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "05",
    name: "หนองสองห้อง",
    zipcode: "70210",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "06",
    name: "หนองบัว",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "07",
    name: "หลักสอง",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "08",
    name: "เจ็ดริ้ว",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "09",
    name: "คลองตัน",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "10",
    name: "อำแพง",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "11",
    name: "สวนส้ม",
    zipcode: "74120",
  },
  {
    jw_code: "74",
    amph_code: "03",
    tumbon_code: "12",
    name: "เกษตรพัฒนา",
    zipcode: "74120",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "01",
    name: "แม่กลอง",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "02",
    name: "บางขันแตก",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "03",
    name: "ลาดใหญ่",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "04",
    name: "บ้านปรก",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "05",
    name: "บางแก้ว",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "06",
    name: "ท้ายหาด",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "07",
    name: "แหลมใหญ่",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "08",
    name: "คลองเขิน",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "09",
    name: "คลองโคน",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "10",
    name: "นางตะเคียน",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "01",
    tumbon_code: "11",
    name: "บางจะเกร็ง",
    zipcode: "75000",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "01",
    name: "กระดังงา",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "02",
    name: "บางสะแก",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางยี่รงค์",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "04",
    name: "โรงหีบ",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "05",
    name: "บางคนที",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "06",
    name: "ดอนมะโนรา",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "07",
    name: "บางพรม",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "08",
    name: "บางกุ้ง",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "09",
    name: "จอมปลวก",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "10",
    name: "บางนกแขวก",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "11",
    name: "ยายแพง",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "12",
    name: "บางกระบือ",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "02",
    tumbon_code: "13",
    name: "บ้านปราโมทย์",
    zipcode: "75120",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "01",
    name: "อัมพวา",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "02",
    name: "สวนหลวง",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "03",
    name: "ท่าคา",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "04",
    name: "วัดประดู่",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "05",
    name: "เหมืองใหม่",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "06",
    name: "บางช้าง",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "07",
    name: "แควอ้อม",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "08",
    name: "ปลายโพงพาง",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "09",
    name: "บางแค",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "10",
    name: "แพรกหนามแดง",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "11",
    name: "ยี่สาร",
    zipcode: "75110",
  },
  {
    jw_code: "75",
    amph_code: "03",
    tumbon_code: "12",
    name: "บางนางลี่",
    zipcode: "75110",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "01",
    name: "ท่าราบ",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "02",
    name: "คลองกระแชง",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "03",
    name: "บางจาน",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "04",
    name: "นาพันสาม",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "05",
    name: "ธงชัย",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "06",
    name: "บ้านกุ่ม",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "07",
    name: "หนองโสน",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "08",
    name: "ไร่ส้ม",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "09",
    name: "เวียงคอย",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "10",
    name: "บางจาก",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "11",
    name: "บ้านหม้อ",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "12",
    name: "ต้นมะม่วง",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "13",
    name: "ช่องสะแก",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "14",
    name: "นาวุ้ง",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "15",
    name: "สำมะโรง",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "16",
    name: "โพพระ",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "17",
    name: "หาดเจ้าสำราญ",
    zipcode: "76100",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "18",
    name: "หัวสะพาน",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "19",
    name: "ต้นมะพร้าว",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "20",
    name: "วังตะโก",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "21",
    name: "โพไร่หวาน",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "22",
    name: "ดอนยาง",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "23",
    name: "หนองขนาน",
    zipcode: "76100",
  },
  {
    jw_code: "76",
    amph_code: "01",
    tumbon_code: "24",
    name: "หนองพลับ",
    zipcode: "76000",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "01",
    name: "เขาย้อย",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "02",
    name: "สระพัง",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางเค็ม",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "04",
    name: "ทับคาง",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "05",
    name: "หนองปลาไหล",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "06",
    name: "หนองปรง",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "07",
    name: "หนองชุมพล",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "08",
    name: "ห้วยโรง",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "09",
    name: "ห้วยท่าช้าง",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "02",
    tumbon_code: "10",
    name: "หนองชุมพลเหนือ",
    zipcode: "76140",
  },
  {
    jw_code: "76",
    amph_code: "03",
    tumbon_code: "01",
    name: "หนองหญ้าปล้อง",
    zipcode: "76160",
  },
  {
    jw_code: "76",
    amph_code: "03",
    tumbon_code: "02",
    name: "ยางน้ำกลัดเหนือ",
    zipcode: "76160",
  },
  {
    jw_code: "76",
    amph_code: "03",
    tumbon_code: "03",
    name: "ยางน้ำกลัดใต้",
    zipcode: "76160",
  },
  {
    jw_code: "76",
    amph_code: "03",
    tumbon_code: "04",
    name: "ท่าตะคร้อ",
    zipcode: "76160",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "01",
    name: "ชะอำ",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "02",
    name: "บางเก่า",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "03",
    name: "นายาง",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "04",
    name: "เขาใหญ่",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "05",
    name: "หนองศาลา",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "06",
    name: "ห้วยทรายเหนือ",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "07",
    name: "ไร่ใหม่พัฒนา",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "08",
    name: "สามพระยา",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "04",
    tumbon_code: "09",
    name: "ดอนขุนห้วย",
    zipcode: "76120",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "01",
    name: "ท่ายาง",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "02",
    name: "ท่าคอย",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "03",
    name: "ยางหย่อง",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "04",
    name: "หนองจอก",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "05",
    name: "มาบปลาเค้า",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "06",
    name: "ท่าไม้รวก",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "07",
    name: "วังไคร้",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "11",
    name: "กลัดหลวง",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "12",
    name: "ปึกเตียน",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "13",
    name: "เขากระปุก",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "14",
    name: "ท่าแลง",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "05",
    tumbon_code: "15",
    name: "บ้านในดง",
    zipcode: "76130",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "01",
    name: "บ้านลาด",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "02",
    name: "บ้านหาด",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "03",
    name: "บ้านทาน",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "04",
    name: "ตำหรุ",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "05",
    name: "สมอพลือ",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "06",
    name: "ไร่มะขาม",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "07",
    name: "ท่าเสน",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "08",
    name: "หนองกระเจ็ด",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "09",
    name: "หนองกะปุ",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "10",
    name: "ลาดโพธิ์",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "11",
    name: "สะพานไกร",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "12",
    name: "ไร่โคก",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "13",
    name: "โรงเข้",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "14",
    name: "ไร่สะท้อน",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "15",
    name: "ห้วยข้อง",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "16",
    name: "ท่าช้าง",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "17",
    name: "ถ้ำรงค์",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "06",
    tumbon_code: "18",
    name: "ห้วยลึก",
    zipcode: "76150",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "01",
    name: "บ้านแหลม",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "02",
    name: "บางขุนไทร",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "03",
    name: "ปากทะเล",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "04",
    name: "บางแก้ว",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "05",
    name: "แหลมผักเบี้ย",
    zipcode: "76100",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "06",
    name: "บางตะบูน",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "07",
    name: "บางตะบูนออก",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "08",
    name: "บางครก",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "09",
    name: "ท่าแร้ง",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "07",
    tumbon_code: "10",
    name: "ท่าแร้งออก",
    zipcode: "76110",
  },
  {
    jw_code: "76",
    amph_code: "08",
    tumbon_code: "01",
    name: "แก่งกระจาน",
    zipcode: "76170",
  },
  {
    jw_code: "76",
    amph_code: "08",
    tumbon_code: "02",
    name: "สองพี่น้อง",
    zipcode: "76170",
  },
  {
    jw_code: "76",
    amph_code: "08",
    tumbon_code: "03",
    name: "วังจันทร์",
    zipcode: "76170",
  },
  {
    jw_code: "76",
    amph_code: "08",
    tumbon_code: "04",
    name: "ป่าเด็ง",
    zipcode: "76170",
  },
  {
    jw_code: "76",
    amph_code: "08",
    tumbon_code: "05",
    name: "พุสวรรค์",
    zipcode: "76170",
  },
  {
    jw_code: "76",
    amph_code: "08",
    tumbon_code: "06",
    name: "ห้วยแม่เพรียง",
    zipcode: "76170",
  },
  {
    jw_code: "77",
    amph_code: "01",
    tumbon_code: "01",
    name: "ประจวบคีรีขันธ์",
    zipcode: "77000",
  },
  {
    jw_code: "77",
    amph_code: "01",
    tumbon_code: "02",
    name: "เกาะหลัก",
    zipcode: "77000",
  },
  {
    jw_code: "77",
    amph_code: "01",
    tumbon_code: "03",
    name: "คลองวาฬ",
    zipcode: "77000",
  },
  {
    jw_code: "77",
    amph_code: "01",
    tumbon_code: "04",
    name: "ห้วยทราย",
    zipcode: "77000",
  },
  {
    jw_code: "77",
    amph_code: "01",
    tumbon_code: "05",
    name: "อ่าวน้อย",
    zipcode: "77210",
  },
  {
    jw_code: "77",
    amph_code: "01",
    tumbon_code: "06",
    name: "บ่อนอก",
    zipcode: "77210",
  },
  {
    jw_code: "77",
    amph_code: "02",
    tumbon_code: "01",
    name: "กุยบุรี",
    zipcode: "77150",
  },
  {
    jw_code: "77",
    amph_code: "02",
    tumbon_code: "02",
    name: "กุยเหนือ",
    zipcode: "77150",
  },
  {
    jw_code: "77",
    amph_code: "02",
    tumbon_code: "03",
    name: "เขาแดง",
    zipcode: "77150",
  },
  {
    jw_code: "77",
    amph_code: "02",
    tumbon_code: "04",
    name: "ดอนยายหนู",
    zipcode: "77150",
  },
  {
    jw_code: "77",
    amph_code: "02",
    tumbon_code: "06",
    name: "สามกระทาย",
    zipcode: "77150",
  },
  {
    jw_code: "77",
    amph_code: "02",
    tumbon_code: "07",
    name: "หาดขาม",
    zipcode: "77150",
  },
  {
    jw_code: "77",
    amph_code: "03",
    tumbon_code: "01",
    name: "ทับสะแก",
    zipcode: "77130",
  },
  {
    jw_code: "77",
    amph_code: "03",
    tumbon_code: "02",
    name: "อ่างทอง",
    zipcode: "77130",
  },
  {
    jw_code: "77",
    amph_code: "03",
    tumbon_code: "03",
    name: "นาหูกวาง",
    zipcode: "77130",
  },
  {
    jw_code: "77",
    amph_code: "03",
    tumbon_code: "04",
    name: "เขาล้าน",
    zipcode: "77130",
  },
  {
    jw_code: "77",
    amph_code: "03",
    tumbon_code: "05",
    name: "ห้วยยาง",
    zipcode: "77130",
  },
  {
    jw_code: "77",
    amph_code: "03",
    tumbon_code: "06",
    name: "แสงอรุณ",
    zipcode: "77130",
  },
  {
    jw_code: "77",
    amph_code: "04",
    tumbon_code: "01",
    name: "กำเนิดนพคุณ",
    zipcode: "77140",
  },
  {
    jw_code: "77",
    amph_code: "04",
    tumbon_code: "02",
    name: "พงศ์ประศาสน์",
    zipcode: "77140",
  },
  {
    jw_code: "77",
    amph_code: "04",
    tumbon_code: "03",
    name: "ร่อนทอง",
    zipcode: "77230",
  },
  {
    jw_code: "77",
    amph_code: "04",
    tumbon_code: "04",
    name: "ธงชัย",
    zipcode: "77190",
  },
  {
    jw_code: "77",
    amph_code: "04",
    tumbon_code: "05",
    name: "ชัยเกษม",
    zipcode: "77190",
  },
  {
    jw_code: "77",
    amph_code: "04",
    tumbon_code: "06",
    name: "ทองมงคล",
    zipcode: "77230",
  },
  {
    jw_code: "77",
    amph_code: "04",
    tumbon_code: "07",
    name: "แม่รำพึง",
    zipcode: "77140",
  },
  {
    jw_code: "77",
    amph_code: "05",
    tumbon_code: "01",
    name: "ปากแพรก",
    zipcode: "77170",
  },
  {
    jw_code: "77",
    amph_code: "05",
    tumbon_code: "02",
    name: "บางสะพาน",
    zipcode: "77170",
  },
  {
    jw_code: "77",
    amph_code: "05",
    tumbon_code: "03",
    name: "ทรายทอง",
    zipcode: "77170",
  },
  {
    jw_code: "77",
    amph_code: "05",
    tumbon_code: "04",
    name: "ช้างแรก",
    zipcode: "77170",
  },
  {
    jw_code: "77",
    amph_code: "05",
    tumbon_code: "05",
    name: "ไชยราช",
    zipcode: "77170",
  },
  {
    jw_code: "77",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปราณบุรี",
    zipcode: "77120",
  },
  {
    jw_code: "77",
    amph_code: "06",
    tumbon_code: "02",
    name: "เขาน้อย",
    zipcode: "77160",
  },
  {
    jw_code: "77",
    amph_code: "06",
    tumbon_code: "04",
    name: "ปากน้ำปราณ",
    zipcode: "77220",
  },
  {
    jw_code: "77",
    amph_code: "06",
    tumbon_code: "07",
    name: "หนองตาแต้ม",
    zipcode: "77120",
  },
  {
    jw_code: "77",
    amph_code: "06",
    tumbon_code: "08",
    name: "วังก์พง",
    zipcode: "77120",
  },
  {
    jw_code: "77",
    amph_code: "06",
    tumbon_code: "09",
    name: "เขาจ้าว",
    zipcode: "77120",
  },
  {
    jw_code: "77",
    amph_code: "07",
    tumbon_code: "01",
    name: "หัวหิน",
    zipcode: "77110",
  },
  {
    jw_code: "77",
    amph_code: "07",
    tumbon_code: "02",
    name: "หนองแก",
    zipcode: "77110",
  },
  {
    jw_code: "77",
    amph_code: "07",
    tumbon_code: "03",
    name: "หินเหล็กไฟ",
    zipcode: "77110",
  },
  {
    jw_code: "77",
    amph_code: "07",
    tumbon_code: "04",
    name: "หนองพลับ",
    zipcode: "77110",
  },
  {
    jw_code: "77",
    amph_code: "07",
    tumbon_code: "05",
    name: "ทับใต้",
    zipcode: "77110",
  },
  {
    jw_code: "77",
    amph_code: "07",
    tumbon_code: "06",
    name: "ห้วยสัตว์ใหญ่",
    zipcode: "77110",
  },
  {
    jw_code: "77",
    amph_code: "07",
    tumbon_code: "07",
    name: "บึงนคร",
    zipcode: "77110",
  },
  {
    jw_code: "77",
    amph_code: "08",
    tumbon_code: "01",
    name: "สามร้อยยอด",
    zipcode: "77180",
  },
  {
    jw_code: "77",
    amph_code: "08",
    tumbon_code: "02",
    name: "ศิลาลอย",
    zipcode: "77180",
  },
  {
    jw_code: "77",
    amph_code: "08",
    tumbon_code: "03",
    name: "ไร่เก่า",
    zipcode: "77180",
  },
  {
    jw_code: "77",
    amph_code: "08",
    tumbon_code: "04",
    name: "ศาลาลัย",
    zipcode: "77180",
  },
  {
    jw_code: "77",
    amph_code: "08",
    tumbon_code: "05",
    name: "ไร่ใหม่",
    zipcode: "77180",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "01",
    name: "ในเมือง",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "02",
    name: "ท่าวัง",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "03",
    name: "คลัง",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "06",
    name: "ท่าไร่",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "07",
    name: "ปากนคร",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "08",
    name: "นาทราย",
    zipcode: "80280",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "12",
    name: "กำแพงเซา",
    zipcode: "80280",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "13",
    name: "ไชยมนตรี",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "14",
    name: "มะม่วงสองต้น",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "15",
    name: "นาเคียน",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "16",
    name: "ท่างิ้ว",
    zipcode: "80280",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "18",
    name: "โพธิ์เสด็จ",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "19",
    name: "บางจาก",
    zipcode: "80330",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "20",
    name: "ปากพูน",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "21",
    name: "ท่าซัก",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "01",
    tumbon_code: "22",
    name: "ท่าเรือ",
    zipcode: "80290",
  },
  {
    jw_code: "80",
    amph_code: "02",
    tumbon_code: "01",
    name: "พรหมโลก",
    zipcode: "80320",
  },
  {
    jw_code: "80",
    amph_code: "02",
    tumbon_code: "02",
    name: "บ้านเกาะ",
    zipcode: "80320",
  },
  {
    jw_code: "80",
    amph_code: "02",
    tumbon_code: "03",
    name: "อินคีรี",
    zipcode: "80320",
  },
  {
    jw_code: "80",
    amph_code: "02",
    tumbon_code: "04",
    name: "ทอนหงส์",
    zipcode: "80320",
  },
  {
    jw_code: "80",
    amph_code: "02",
    tumbon_code: "05",
    name: "นาเรียง",
    zipcode: "80320",
  },
  {
    jw_code: "80",
    amph_code: "03",
    tumbon_code: "01",
    name: "เขาแก้ว",
    zipcode: "80230",
  },
  {
    jw_code: "80",
    amph_code: "03",
    tumbon_code: "02",
    name: "ลานสกา",
    zipcode: "80230",
  },
  {
    jw_code: "80",
    amph_code: "03",
    tumbon_code: "03",
    name: "ท่าดี",
    zipcode: "80230",
  },
  {
    jw_code: "80",
    amph_code: "03",
    tumbon_code: "04",
    name: "กำโลน",
    zipcode: "80230",
  },
  {
    jw_code: "80",
    amph_code: "03",
    tumbon_code: "05",
    name: "ขุนทะเล",
    zipcode: "80230",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "01",
    name: "ฉวาง",
    zipcode: "80250",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "03",
    name: "ละอาย",
    zipcode: "80250",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "04",
    name: "นาแว",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "05",
    name: "ไม้เรียง",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "06",
    name: "กะเปียด",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "07",
    name: "นากะชะ",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "09",
    name: "ห้วยปริก",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "10",
    name: "ไสหร้า",
    zipcode: "80150",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "15",
    name: "นาเขลียง",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "04",
    tumbon_code: "16",
    name: "จันดี",
    zipcode: "80250",
  },
  {
    jw_code: "80",
    amph_code: "05",
    tumbon_code: "01",
    name: "พิปูน",
    zipcode: "80270",
  },
  {
    jw_code: "80",
    amph_code: "05",
    tumbon_code: "02",
    name: "กะทูน",
    zipcode: "80270",
  },
  {
    jw_code: "80",
    amph_code: "05",
    tumbon_code: "03",
    name: "เขาพระ",
    zipcode: "80270",
  },
  {
    jw_code: "80",
    amph_code: "05",
    tumbon_code: "04",
    name: "ยางค้อม",
    zipcode: "80270",
  },
  {
    jw_code: "80",
    amph_code: "05",
    tumbon_code: "05",
    name: "ควนกลาง",
    zipcode: "80270",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "01",
    name: "เชียรใหญ่",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "03",
    name: "ท่าขนาน",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "04",
    name: "บ้านกลาง",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "05",
    name: "บ้านเนิน",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "06",
    name: "ไสหมาก",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "07",
    name: "ท้องลำเจียก",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "10",
    name: "เสือหึง",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "11",
    name: "การะเกด",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "12",
    name: "เขาพระบาท",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "06",
    tumbon_code: "13",
    name: "แม่เจ้าอยู่หัว",
    zipcode: "80190",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "01",
    name: "ชะอวด",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "02",
    name: "ท่าเสม็ด",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "03",
    name: "ท่าประจะ",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "04",
    name: "เคร็ง",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "05",
    name: "วังอ่าง",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "06",
    name: "บ้านตูล",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "07",
    name: "ขอนหาด",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "08",
    name: "เกาะขันธ์",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "09",
    name: "ควนหนองหงษ์",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "10",
    name: "เขาพระทอง",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "07",
    tumbon_code: "11",
    name: "นางหลง",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "01",
    name: "ท่าศาลา",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "02",
    name: "กลาย",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "03",
    name: "ท่าขึ้น",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "04",
    name: "หัวตะพาน",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "06",
    name: "สระแก้ว",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "07",
    name: "โมคลาน",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "09",
    name: "ไทยบุรี",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "10",
    name: "ดอนตะโก",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "11",
    name: "ตลิ่งชัน",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "08",
    tumbon_code: "13",
    name: "โพธิ์ทอง",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "01",
    name: "ปากแพรก",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "02",
    name: "ชะมาย",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "03",
    name: "หนองหงส์",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "04",
    name: "ควนกรด",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "05",
    name: "นาไม้ไผ่",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "06",
    name: "นาหลวงเสน",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "07",
    name: "เขาโร",
    zipcode: "80310",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "08",
    name: "กะปาง",
    zipcode: "80310",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "09",
    name: "ที่วัง",
    zipcode: "80310",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "10",
    name: "น้ำตก",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "11",
    name: "ถ้ำใหญ่",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "12",
    name: "นาโพธิ์",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "09",
    tumbon_code: "13",
    name: "เขาขาว",
    zipcode: "80110",
  },
  {
    jw_code: "80",
    amph_code: "10",
    tumbon_code: "01",
    name: "นาบอน",
    zipcode: "80220",
  },
  {
    jw_code: "80",
    amph_code: "10",
    tumbon_code: "02",
    name: "ทุ่งสง",
    zipcode: "80220",
  },
  {
    jw_code: "80",
    amph_code: "10",
    tumbon_code: "03",
    name: "แก้วแสน",
    zipcode: "80250",
  },
  {
    jw_code: "80",
    amph_code: "11",
    tumbon_code: "01",
    name: "ท่ายาง",
    zipcode: "80240",
  },
  {
    jw_code: "80",
    amph_code: "11",
    tumbon_code: "02",
    name: "ทุ่งสัง",
    zipcode: "80240",
  },
  {
    jw_code: "80",
    amph_code: "11",
    tumbon_code: "03",
    name: "ทุ่งใหญ่",
    zipcode: "80240",
  },
  {
    jw_code: "80",
    amph_code: "11",
    tumbon_code: "04",
    name: "กุแหระ",
    zipcode: "80240",
  },
  {
    jw_code: "80",
    amph_code: "11",
    tumbon_code: "05",
    name: "ปริก",
    zipcode: "80240",
  },
  {
    jw_code: "80",
    amph_code: "11",
    tumbon_code: "06",
    name: "บางรูป",
    zipcode: "80240",
  },
  {
    jw_code: "80",
    amph_code: "11",
    tumbon_code: "07",
    name: "กรุงหยัน",
    zipcode: "80240",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "01",
    name: "ปากพนัง",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "02",
    name: "คลองน้อย",
    zipcode: "80330",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "03",
    name: "ป่าระกำ",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "04",
    name: "ชะเมา",
    zipcode: "80330",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "05",
    name: "คลองกระบือ",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "06",
    name: "เกาะทวด",
    zipcode: "80330",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "07",
    name: "บ้านใหม่",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "08",
    name: "หูล่อง",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "09",
    name: "แหลมตะลุมพุก",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "10",
    name: "ปากพนังฝั่งตะวันตก",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "11",
    name: "บางศาลา",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "12",
    name: "บางพระ",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "13",
    name: "บางตะพง",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "14",
    name: "ปากพนังฝั่งตะวันออก",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "15",
    name: "บ้านเพิง",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "16",
    name: "ท่าพยา",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "17",
    name: "ปากแพรก",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "12",
    tumbon_code: "18",
    name: "ขนาบนาก",
    zipcode: "80140",
  },
  {
    jw_code: "80",
    amph_code: "13",
    tumbon_code: "01",
    name: "ร่อนพิบูลย์",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "13",
    tumbon_code: "02",
    name: "หินตก",
    zipcode: "80350",
  },
  {
    jw_code: "80",
    amph_code: "13",
    tumbon_code: "03",
    name: "เสาธง",
    zipcode: "80350",
  },
  {
    jw_code: "80",
    amph_code: "13",
    tumbon_code: "04",
    name: "ควนเกย",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "13",
    tumbon_code: "05",
    name: "ควนพัง",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "13",
    tumbon_code: "06",
    name: "ควนชุม",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "01",
    name: "สิชล",
    zipcode: "80120",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "02",
    name: "ทุ่งปรัง",
    zipcode: "80120",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "03",
    name: "ฉลอง",
    zipcode: "80120",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "04",
    name: "เสาเภา",
    zipcode: "80340",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "05",
    name: "เปลี่ยน",
    zipcode: "80340",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "06",
    name: "สี่ขีด",
    zipcode: "80120",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "07",
    name: "เทพราช",
    zipcode: "80340",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "08",
    name: "เขาน้อย",
    zipcode: "80120",
  },
  {
    jw_code: "80",
    amph_code: "14",
    tumbon_code: "09",
    name: "ทุ่งใส",
    zipcode: "80120",
  },
  {
    jw_code: "80",
    amph_code: "15",
    tumbon_code: "01",
    name: "ขนอม",
    zipcode: "80210",
  },
  {
    jw_code: "80",
    amph_code: "15",
    tumbon_code: "02",
    name: "ควนทอง",
    zipcode: "80210",
  },
  {
    jw_code: "80",
    amph_code: "15",
    tumbon_code: "03",
    name: "ท้องเนียน",
    zipcode: "80210",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "01",
    name: "หัวไทร",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "02",
    name: "หน้าสตน",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "03",
    name: "ทรายขาว",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "04",
    name: "แหลม",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "05",
    name: "เขาพังไกร",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "06",
    name: "บ้านราม",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "07",
    name: "บางนบ",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "08",
    name: "ท่าซอม",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "09",
    name: "ควนชะลิก",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "10",
    name: "รามแก้ว",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "16",
    tumbon_code: "11",
    name: "เกาะเพชร",
    zipcode: "80170",
  },
  {
    jw_code: "80",
    amph_code: "17",
    tumbon_code: "01",
    name: "บางขัน",
    zipcode: "80360",
  },
  {
    jw_code: "80",
    amph_code: "17",
    tumbon_code: "02",
    name: "บ้านลำนาว",
    zipcode: "80360",
  },
  {
    jw_code: "80",
    amph_code: "17",
    tumbon_code: "03",
    name: "วังหิน",
    zipcode: "80360",
  },
  {
    jw_code: "80",
    amph_code: "17",
    tumbon_code: "04",
    name: "บ้านนิคม",
    zipcode: "80360",
  },
  {
    jw_code: "80",
    amph_code: "18",
    tumbon_code: "01",
    name: "ถ้ำพรรณรา",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "18",
    tumbon_code: "02",
    name: "คลองเส",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "18",
    tumbon_code: "03",
    name: "ดุสิต",
    zipcode: "80260",
  },
  {
    jw_code: "80",
    amph_code: "19",
    tumbon_code: "01",
    name: "บ้านควนมุด",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "19",
    tumbon_code: "02",
    name: "บ้านชะอวด",
    zipcode: "80180",
  },
  {
    jw_code: "80",
    amph_code: "19",
    tumbon_code: "03",
    name: "ควนหนองคว้า",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "19",
    tumbon_code: "04",
    name: "ทุ่งโพธิ์",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "19",
    tumbon_code: "05",
    name: "นาหมอบุญ",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "19",
    tumbon_code: "06",
    name: "สามตำบล",
    zipcode: "80130",
  },
  {
    jw_code: "80",
    amph_code: "20",
    tumbon_code: "01",
    name: "นาพรุ",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "20",
    tumbon_code: "02",
    name: "นาสาร",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "20",
    tumbon_code: "03",
    name: "ท้ายสำเภา",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "20",
    tumbon_code: "04",
    name: "ช้างซ้าย",
    zipcode: "80000",
  },
  {
    jw_code: "80",
    amph_code: "21",
    tumbon_code: "01",
    name: "นบพิตำ",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "21",
    tumbon_code: "02",
    name: "กรุงชิง",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "21",
    tumbon_code: "03",
    name: "กะหรอ",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "21",
    tumbon_code: "04",
    name: "นาเหรง",
    zipcode: "80160",
  },
  {
    jw_code: "80",
    amph_code: "22",
    tumbon_code: "01",
    name: "ช้างกลาง",
    zipcode: "80220",
  },
  {
    jw_code: "80",
    amph_code: "22",
    tumbon_code: "02",
    name: "หลักช้าง",
    zipcode: "80250",
  },
  {
    jw_code: "80",
    amph_code: "22",
    tumbon_code: "03",
    name: "สวนขัน",
    zipcode: "80250",
  },
  {
    jw_code: "80",
    amph_code: "23",
    tumbon_code: "01",
    name: "เชียรเขา",
    zipcode: "30230",
  },
  {
    jw_code: "80",
    amph_code: "23",
    tumbon_code: "02",
    name: "ดอนตรอ",
    zipcode: "80290",
  },
  {
    jw_code: "80",
    amph_code: "23",
    tumbon_code: "03",
    name: "สวนหลวง",
    zipcode: "30230",
  },
  {
    jw_code: "80",
    amph_code: "23",
    tumbon_code: "04",
    name: "ทางพูน",
    zipcode: "80350",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "01",
    name: "ปากน้ำ",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "02",
    name: "กระบี่ใหญ่",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "03",
    name: "กระบี่น้อย",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "05",
    name: "เขาคราม",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "06",
    name: "เขาทอง",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "11",
    name: "ทับปริก",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "15",
    name: "ไสไทย",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "16",
    name: "อ่าวนาง",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "17",
    name: "หนองทะเล",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "01",
    tumbon_code: "18",
    name: "คลองประสงค์",
    zipcode: "81000",
  },
  {
    jw_code: "81",
    amph_code: "02",
    tumbon_code: "01",
    name: "เขาพนม",
    zipcode: "81140",
  },
  {
    jw_code: "81",
    amph_code: "02",
    tumbon_code: "02",
    name: "เขาดิน",
    zipcode: "81140",
  },
  {
    jw_code: "81",
    amph_code: "02",
    tumbon_code: "03",
    name: "สินปุน",
    zipcode: "80240",
  },
  {
    jw_code: "81",
    amph_code: "02",
    tumbon_code: "04",
    name: "พรุเตียว",
    zipcode: "81140",
  },
  {
    jw_code: "81",
    amph_code: "02",
    tumbon_code: "05",
    name: "หน้าเขา",
    zipcode: "81140",
  },
  {
    jw_code: "81",
    amph_code: "02",
    tumbon_code: "06",
    name: "โคกหาร",
    zipcode: "80240",
  },
  {
    jw_code: "81",
    amph_code: "03",
    tumbon_code: "01",
    name: "เกาะลันตาใหญ่",
    zipcode: "81150",
  },
  {
    jw_code: "81",
    amph_code: "03",
    tumbon_code: "02",
    name: "เกาะลันตาน้อย",
    zipcode: "81150",
  },
  {
    jw_code: "81",
    amph_code: "03",
    tumbon_code: "03",
    name: "เกาะกลาง",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "03",
    tumbon_code: "04",
    name: "คลองยาง",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "03",
    tumbon_code: "05",
    name: "ศาลาด่าน",
    zipcode: "81150",
  },
  {
    jw_code: "81",
    amph_code: "04",
    tumbon_code: "01",
    name: "คลองท่อมใต้",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "04",
    tumbon_code: "02",
    name: "คลองท่อมเหนือ",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "04",
    tumbon_code: "03",
    name: "คลองพน",
    zipcode: "81170",
  },
  {
    jw_code: "81",
    amph_code: "04",
    tumbon_code: "04",
    name: "ทรายขาว",
    zipcode: "81170",
  },
  {
    jw_code: "81",
    amph_code: "04",
    tumbon_code: "05",
    name: "ห้วยน้ำขาว",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "04",
    tumbon_code: "06",
    name: "พรุดินนา",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "04",
    tumbon_code: "07",
    name: "เพหลา",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "01",
    name: "อ่าวลึกใต้",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "02",
    name: "แหลมสัก",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "03",
    name: "นาเหนือ",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "04",
    name: "คลองหิน",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "05",
    name: "อ่าวลึกน้อย",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "06",
    name: "อ่าวลึกเหนือ",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "07",
    name: "เขาใหญ่",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "08",
    name: "คลองยา",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "05",
    tumbon_code: "09",
    name: "บ้านกลาง",
    zipcode: "81110",
  },
  {
    jw_code: "81",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปลายพระยา",
    zipcode: "81160",
  },
  {
    jw_code: "81",
    amph_code: "06",
    tumbon_code: "02",
    name: "เขาเขน",
    zipcode: "81160",
  },
  {
    jw_code: "81",
    amph_code: "06",
    tumbon_code: "03",
    name: "เขาต่อ",
    zipcode: "81160",
  },
  {
    jw_code: "81",
    amph_code: "06",
    tumbon_code: "04",
    name: "คีรีวง",
    zipcode: "81160",
  },
  {
    jw_code: "81",
    amph_code: "07",
    tumbon_code: "01",
    name: "ลำทับ",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "07",
    tumbon_code: "02",
    name: "ดินอุดม",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "07",
    tumbon_code: "03",
    name: "ทุ่งไทรทอง",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "07",
    tumbon_code: "04",
    name: "ดินแดง",
    zipcode: "81120",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "01",
    name: "เหนือคลอง",
    zipcode: "81130",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "02",
    name: "เกาะศรีบอยา",
    zipcode: "81130",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "03",
    name: "คลองขนาน",
    zipcode: "81130",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "04",
    name: "คลองเขม้า",
    zipcode: "81130",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "05",
    name: "โคกยาง",
    zipcode: "81130",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "06",
    name: "ตลิ่งชัน",
    zipcode: "81130",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "07",
    name: "ปกาสัย",
    zipcode: "81130",
  },
  {
    jw_code: "81",
    amph_code: "08",
    tumbon_code: "08",
    name: "ห้วยยูง",
    zipcode: "81130",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "01",
    name: "ท้ายช้าง",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "02",
    name: "นบปริง",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "03",
    name: "ถ้ำน้ำผุด",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "04",
    name: "บางเตย",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "05",
    name: "ตากแดด",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "06",
    name: "สองแพรก",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "07",
    name: "ทุ่งคาโงก",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "08",
    name: "เกาะปันหยี",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "01",
    tumbon_code: "09",
    name: "ป่ากอ",
    zipcode: "82000",
  },
  {
    jw_code: "82",
    amph_code: "02",
    tumbon_code: "01",
    name: "เกาะยาวน้อย",
    zipcode: "82160",
  },
  {
    jw_code: "82",
    amph_code: "02",
    tumbon_code: "02",
    name: "เกาะยาวใหญ่",
    zipcode: "82160",
  },
  {
    jw_code: "82",
    amph_code: "02",
    tumbon_code: "03",
    name: "พรุใน",
    zipcode: "82160",
  },
  {
    jw_code: "82",
    amph_code: "03",
    tumbon_code: "01",
    name: "กะปง",
    zipcode: "82170",
  },
  {
    jw_code: "82",
    amph_code: "03",
    tumbon_code: "02",
    name: "ท่านา",
    zipcode: "82170",
  },
  {
    jw_code: "82",
    amph_code: "03",
    tumbon_code: "03",
    name: "เหมาะ",
    zipcode: "82170",
  },
  {
    jw_code: "82",
    amph_code: "03",
    tumbon_code: "04",
    name: "เหล",
    zipcode: "82170",
  },
  {
    jw_code: "82",
    amph_code: "03",
    tumbon_code: "05",
    name: "รมณีย์",
    zipcode: "82170",
  },
  {
    jw_code: "82",
    amph_code: "04",
    tumbon_code: "01",
    name: "ถ้ำ",
    zipcode: "82130",
  },
  {
    jw_code: "82",
    amph_code: "04",
    tumbon_code: "02",
    name: "กระโสม",
    zipcode: "82130",
  },
  {
    jw_code: "82",
    amph_code: "04",
    tumbon_code: "03",
    name: "กะไหล",
    zipcode: "82130",
  },
  {
    jw_code: "82",
    amph_code: "04",
    tumbon_code: "04",
    name: "ท่าอยู่",
    zipcode: "82130",
  },
  {
    jw_code: "82",
    amph_code: "04",
    tumbon_code: "05",
    name: "หล่อยูง",
    zipcode: "82140",
  },
  {
    jw_code: "82",
    amph_code: "04",
    tumbon_code: "06",
    name: "โคกกลอย",
    zipcode: "82140",
  },
  {
    jw_code: "82",
    amph_code: "04",
    tumbon_code: "07",
    name: "คลองเคียน",
    zipcode: "82130",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "01",
    name: "ตะกั่วป่า",
    zipcode: "82110",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "02",
    name: "บางนายสี",
    zipcode: "82110",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "03",
    name: "บางไทร",
    zipcode: "82110",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "04",
    name: "บางม่วง",
    zipcode: "82190",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "05",
    name: "ตำตัว",
    zipcode: "82110",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "06",
    name: "โคกเคียน",
    zipcode: "82110",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "07",
    name: "คึกคัก",
    zipcode: "82190",
  },
  {
    jw_code: "82",
    amph_code: "05",
    tumbon_code: "08",
    name: "เกาะคอเขา",
    zipcode: "82190",
  },
  {
    jw_code: "82",
    amph_code: "06",
    tumbon_code: "01",
    name: "คุระ",
    zipcode: "82150",
  },
  {
    jw_code: "82",
    amph_code: "06",
    tumbon_code: "02",
    name: "บางวัน",
    zipcode: "82150",
  },
  {
    jw_code: "82",
    amph_code: "06",
    tumbon_code: "03",
    name: "เกาะพระทอง",
    zipcode: "82150",
  },
  {
    jw_code: "82",
    amph_code: "06",
    tumbon_code: "05",
    name: "แม่นางขาว",
    zipcode: "82150",
  },
  {
    jw_code: "82",
    amph_code: "07",
    tumbon_code: "01",
    name: "ทับปุด",
    zipcode: "82180",
  },
  {
    jw_code: "82",
    amph_code: "07",
    tumbon_code: "02",
    name: "มะรุ่ย",
    zipcode: "82180",
  },
  {
    jw_code: "82",
    amph_code: "07",
    tumbon_code: "03",
    name: "บ่อแสน",
    zipcode: "82180",
  },
  {
    jw_code: "82",
    amph_code: "07",
    tumbon_code: "04",
    name: "ถ้ำทองหลาง",
    zipcode: "82180",
  },
  {
    jw_code: "82",
    amph_code: "07",
    tumbon_code: "05",
    name: "โคกเจริญ",
    zipcode: "82180",
  },
  {
    jw_code: "82",
    amph_code: "07",
    tumbon_code: "06",
    name: "บางเหรียง",
    zipcode: "82180",
  },
  {
    jw_code: "82",
    amph_code: "08",
    tumbon_code: "01",
    name: "ท้ายเหมือง",
    zipcode: "82120",
  },
  {
    jw_code: "82",
    amph_code: "08",
    tumbon_code: "02",
    name: "นาเตย",
    zipcode: "82120",
  },
  {
    jw_code: "82",
    amph_code: "08",
    tumbon_code: "03",
    name: "บางทอง",
    zipcode: "82120",
  },
  {
    jw_code: "82",
    amph_code: "08",
    tumbon_code: "04",
    name: "ทุ่งมะพร้าว",
    zipcode: "82120",
  },
  {
    jw_code: "82",
    amph_code: "08",
    tumbon_code: "05",
    name: "ลำภี",
    zipcode: "82120",
  },
  {
    jw_code: "82",
    amph_code: "08",
    tumbon_code: "06",
    name: "ลำแก่น",
    zipcode: "82210",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "01",
    name: "ตลาดใหญ่",
    zipcode: "83000",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "02",
    name: "ตลาดเหนือ",
    zipcode: "83000",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "03",
    name: "เกาะแก้ว",
    zipcode: "83200",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "04",
    name: "รัษฎา",
    zipcode: "83000",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "05",
    name: "วิชิต",
    zipcode: "83000",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "06",
    name: "ฉลอง",
    zipcode: "83130",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "07",
    name: "ราไวย์",
    zipcode: "83130",
  },
  {
    jw_code: "83",
    amph_code: "01",
    tumbon_code: "08",
    name: "กะรน",
    zipcode: "83100",
  },
  {
    jw_code: "83",
    amph_code: "02",
    tumbon_code: "01",
    name: "กะทู้",
    zipcode: "83120",
  },
  {
    jw_code: "83",
    amph_code: "02",
    tumbon_code: "02",
    name: "ป่าตอง",
    zipcode: "83150",
  },
  {
    jw_code: "83",
    amph_code: "02",
    tumbon_code: "03",
    name: "กมลา",
    zipcode: "83150",
  },
  {
    jw_code: "83",
    amph_code: "03",
    tumbon_code: "01",
    name: "เทพกระษัตรี",
    zipcode: "83110",
  },
  {
    jw_code: "83",
    amph_code: "03",
    tumbon_code: "02",
    name: "ศรีสุนทร",
    zipcode: "83110",
  },
  {
    jw_code: "83",
    amph_code: "03",
    tumbon_code: "03",
    name: "เชิงทะเล",
    zipcode: "83110",
  },
  {
    jw_code: "83",
    amph_code: "03",
    tumbon_code: "04",
    name: "ป่าคลอก",
    zipcode: "83110",
  },
  {
    jw_code: "83",
    amph_code: "03",
    tumbon_code: "05",
    name: "ไม้ขาว",
    zipcode: "83140",
  },
  {
    jw_code: "83",
    amph_code: "03",
    tumbon_code: "06",
    name: "สาคู",
    zipcode: "83140",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "01",
    name: "ตลาด",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "02",
    name: "มะขามเตี้ย",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "03",
    name: "วัดประดู่",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "04",
    name: "ขุนทะเล",
    zipcode: "84100",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "05",
    name: "บางใบไม้",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "06",
    name: "บางชนะ",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "07",
    name: "คลองน้อย",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางไทร",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "09",
    name: "บางโพธิ์",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "10",
    name: "บางกุ้ง",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "01",
    tumbon_code: "11",
    name: "คลองฉนาก",
    zipcode: "84000",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "01",
    name: "ท่าทองใหม่",
    zipcode: "84290",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "02",
    name: "ท่าทอง",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "03",
    name: "กะแดะ",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "04",
    name: "ทุ่งกง",
    zipcode: "84290",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "05",
    name: "กรูด",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "06",
    name: "ช้างซ้าย",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "07",
    name: "พลายวาส",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "08",
    name: "ป่าร่อน",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "09",
    name: "ตะเคียนทอง",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "10",
    name: "ช้างขวา",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "11",
    name: "ท่าอุแท",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "12",
    name: "ทุ่งรัง",
    zipcode: "84290",
  },
  {
    jw_code: "84",
    amph_code: "02",
    tumbon_code: "13",
    name: "คลองสระ",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "03",
    tumbon_code: "01",
    name: "ดอนสัก",
    zipcode: "84220",
  },
  {
    jw_code: "84",
    amph_code: "03",
    tumbon_code: "02",
    name: "ชลคราม",
    zipcode: "84160",
  },
  {
    jw_code: "84",
    amph_code: "03",
    tumbon_code: "03",
    name: "ไชยคราม",
    zipcode: "84220",
  },
  {
    jw_code: "84",
    amph_code: "03",
    tumbon_code: "04",
    name: "ปากแพรก",
    zipcode: "84340",
  },
  {
    jw_code: "84",
    amph_code: "04",
    tumbon_code: "01",
    name: "อ่างทอง",
    zipcode: "84220",
  },
  {
    jw_code: "84",
    amph_code: "04",
    tumbon_code: "02",
    name: "ลิปะน้อย",
    zipcode: "84140",
  },
  {
    jw_code: "84",
    amph_code: "04",
    tumbon_code: "03",
    name: "ตลิ่งงาม",
    zipcode: "84140",
  },
  {
    jw_code: "84",
    amph_code: "04",
    tumbon_code: "04",
    name: "หน้าเมือง",
    zipcode: "84140",
  },
  {
    jw_code: "84",
    amph_code: "04",
    tumbon_code: "05",
    name: "มะเร็ต",
    zipcode: "84310",
  },
  {
    jw_code: "84",
    amph_code: "04",
    tumbon_code: "06",
    name: "บ่อผุด",
    zipcode: "84320",
  },
  {
    jw_code: "84",
    amph_code: "04",
    tumbon_code: "07",
    name: "แม่น้ำ",
    zipcode: "84330",
  },
  {
    jw_code: "84",
    amph_code: "05",
    tumbon_code: "01",
    name: "เกาะพะงัน",
    zipcode: "84280",
  },
  {
    jw_code: "84",
    amph_code: "05",
    tumbon_code: "02",
    name: "บ้านใต้",
    zipcode: "84280",
  },
  {
    jw_code: "84",
    amph_code: "05",
    tumbon_code: "03",
    name: "เกาะเต่า",
    zipcode: "84360",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "01",
    name: "ตลาดไชยา",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "02",
    name: "พุมเรียง",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "03",
    name: "เลม็ด",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "04",
    name: "เวียง",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "05",
    name: "ทุ่ง",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "06",
    name: "ป่าเว",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "07",
    name: "ตะกรบ",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "08",
    name: "โมถ่าย",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "06",
    tumbon_code: "09",
    name: "ปากหมาก",
    zipcode: "84110",
  },
  {
    jw_code: "84",
    amph_code: "07",
    tumbon_code: "01",
    name: "ท่าชนะ",
    zipcode: "84170",
  },
  {
    jw_code: "84",
    amph_code: "07",
    tumbon_code: "02",
    name: "สมอทอง",
    zipcode: "84170",
  },
  {
    jw_code: "84",
    amph_code: "07",
    tumbon_code: "03",
    name: "ประสงค์",
    zipcode: "84170",
  },
  {
    jw_code: "84",
    amph_code: "07",
    tumbon_code: "04",
    name: "คันธุลี",
    zipcode: "84170",
  },
  {
    jw_code: "84",
    amph_code: "07",
    tumbon_code: "05",
    name: "วัง",
    zipcode: "84170",
  },
  {
    jw_code: "84",
    amph_code: "07",
    tumbon_code: "06",
    name: "คลองพา",
    zipcode: "84170",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "01",
    name: "ท่าขนอน",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "02",
    name: "บ้านยาง",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "03",
    name: "น้ำหัก",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "06",
    name: "กะเปา",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "07",
    name: "ท่ากระดาน",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "08",
    name: "ย่านยาว",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "09",
    name: "ถ้ำสิงขร",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "08",
    tumbon_code: "10",
    name: "บ้านทำเนียบ",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "09",
    tumbon_code: "01",
    name: "เขาวง",
    zipcode: "84230",
  },
  {
    jw_code: "84",
    amph_code: "09",
    tumbon_code: "02",
    name: "พะแสง",
    zipcode: "84230",
  },
  {
    jw_code: "84",
    amph_code: "09",
    tumbon_code: "03",
    name: "พรุไทย",
    zipcode: "84230",
  },
  {
    jw_code: "84",
    amph_code: "09",
    tumbon_code: "04",
    name: "เขาพัง",
    zipcode: "84230",
  },
  {
    jw_code: "84",
    amph_code: "10",
    tumbon_code: "01",
    name: "พนม",
    zipcode: "84250",
  },
  {
    jw_code: "84",
    amph_code: "10",
    tumbon_code: "02",
    name: "ต้นยวน",
    zipcode: "84250",
  },
  {
    jw_code: "84",
    amph_code: "10",
    tumbon_code: "03",
    name: "คลองศก",
    zipcode: "84250",
  },
  {
    jw_code: "84",
    amph_code: "10",
    tumbon_code: "04",
    name: "พลูเถื่อน",
    zipcode: "84250",
  },
  {
    jw_code: "84",
    amph_code: "10",
    tumbon_code: "05",
    name: "พังกาญจน์",
    zipcode: "84250",
  },
  {
    jw_code: "84",
    amph_code: "10",
    tumbon_code: "06",
    name: "คลองชะอุ่น",
    zipcode: "84250",
  },
  {
    jw_code: "84",
    amph_code: "11",
    tumbon_code: "01",
    name: "ท่าฉาง",
    zipcode: "84150",
  },
  {
    jw_code: "84",
    amph_code: "11",
    tumbon_code: "02",
    name: "ท่าเคย",
    zipcode: "84150",
  },
  {
    jw_code: "84",
    amph_code: "11",
    tumbon_code: "03",
    name: "คลองไทร",
    zipcode: "84150",
  },
  {
    jw_code: "84",
    amph_code: "11",
    tumbon_code: "04",
    name: "เขาถ่าน",
    zipcode: "84150",
  },
  {
    jw_code: "84",
    amph_code: "11",
    tumbon_code: "05",
    name: "เสวียด",
    zipcode: "84150",
  },
  {
    jw_code: "84",
    amph_code: "11",
    tumbon_code: "06",
    name: "ปากฉลุย",
    zipcode: "84150",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "01",
    name: "นาสาร",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "02",
    name: "พรุพี",
    zipcode: "84270",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "03",
    name: "ทุ่งเตา",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "04",
    name: "ลำพูน",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "05",
    name: "ท่าชี",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "06",
    name: "ควนศรี",
    zipcode: "84270",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "07",
    name: "ควนสุบรรณ",
    zipcode: "84240",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "08",
    name: "คลองปราบ",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "09",
    name: "น้ำพุ",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "10",
    name: "ทุ่งเตาใหม่",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "12",
    tumbon_code: "11",
    name: "เพิ่มพูนทรัพย์",
    zipcode: "84120",
  },
  {
    jw_code: "84",
    amph_code: "13",
    tumbon_code: "01",
    name: "บ้านนา",
    zipcode: "84240",
  },
  {
    jw_code: "84",
    amph_code: "13",
    tumbon_code: "02",
    name: "ท่าเรือ",
    zipcode: "84240",
  },
  {
    jw_code: "84",
    amph_code: "13",
    tumbon_code: "03",
    name: "ทรัพย์ทวี",
    zipcode: "84240",
  },
  {
    jw_code: "84",
    amph_code: "13",
    tumbon_code: "04",
    name: "นาใต้",
    zipcode: "84240",
  },
  {
    jw_code: "84",
    amph_code: "14",
    tumbon_code: "01",
    name: "เคียนซา",
    zipcode: "84260",
  },
  {
    jw_code: "84",
    amph_code: "14",
    tumbon_code: "02",
    name: "พ่วงพรมคร",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "14",
    tumbon_code: "03",
    name: "เขาตอก",
    zipcode: "84260",
  },
  {
    jw_code: "84",
    amph_code: "14",
    tumbon_code: "04",
    name: "อรัญคามวารี",
    zipcode: "84260",
  },
  {
    jw_code: "84",
    amph_code: "14",
    tumbon_code: "05",
    name: "บ้านเสด็จ",
    zipcode: "84260",
  },
  {
    jw_code: "84",
    amph_code: "15",
    tumbon_code: "01",
    name: "เวียงสระ",
    zipcode: "84190",
  },
  {
    jw_code: "84",
    amph_code: "15",
    tumbon_code: "02",
    name: "บ้านส้อง",
    zipcode: "84190",
  },
  {
    jw_code: "84",
    amph_code: "15",
    tumbon_code: "03",
    name: "คลองฉนวน",
    zipcode: "84190",
  },
  {
    jw_code: "84",
    amph_code: "15",
    tumbon_code: "04",
    name: "ทุ่งหลวง",
    zipcode: "84190",
  },
  {
    jw_code: "84",
    amph_code: "15",
    tumbon_code: "05",
    name: "เขานิพันธ์",
    zipcode: "84190",
  },
  {
    jw_code: "84",
    amph_code: "16",
    tumbon_code: "01",
    name: "อิปัน",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "16",
    tumbon_code: "02",
    name: "สินปุน",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "16",
    tumbon_code: "03",
    name: "บางสวรรค์",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "16",
    tumbon_code: "04",
    name: "ไทรขึง",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "16",
    tumbon_code: "05",
    name: "สินเจริญ",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "16",
    tumbon_code: "06",
    name: "ไทรโสภา",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "16",
    tumbon_code: "07",
    name: "สาคู",
    zipcode: "84210",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "01",
    name: "ท่าข้าม",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "02",
    name: "ท่าสะท้อน",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "03",
    name: "ลีเล็ด",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "04",
    name: "บางมะเดื่อ",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "05",
    name: "บางเดือน",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "06",
    name: "ท่าโรงช้าง",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "07",
    name: "กรูด",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "08",
    name: "พุนพิน",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "09",
    name: "บางงอน",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "10",
    name: "ศรีวิชัย",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "11",
    name: "น้ำรอบ",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "12",
    name: "มะลวน",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "13",
    name: "หัวเตย",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "14",
    name: "หนองไทร",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "15",
    name: "เขาหัวควาย",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "17",
    tumbon_code: "16",
    name: "ตะปาน",
    zipcode: "84130",
  },
  {
    jw_code: "84",
    amph_code: "18",
    tumbon_code: "01",
    name: "สองแพรก",
    zipcode: "84350",
  },
  {
    jw_code: "84",
    amph_code: "18",
    tumbon_code: "02",
    name: "ชัยบุรี",
    zipcode: "84350",
  },
  {
    jw_code: "84",
    amph_code: "18",
    tumbon_code: "03",
    name: "คลองน้อย",
    zipcode: "84350",
  },
  {
    jw_code: "84",
    amph_code: "18",
    tumbon_code: "04",
    name: "ไทรทอง",
    zipcode: "84350",
  },
  {
    jw_code: "84",
    amph_code: "19",
    tumbon_code: "01",
    name: "ตะกุกใต้",
    zipcode: "84180",
  },
  {
    jw_code: "84",
    amph_code: "19",
    tumbon_code: "02",
    name: "ตะกุกเหนือ",
    zipcode: "84180",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "01",
    name: "เขานิเวศน์",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "02",
    name: "ราชกรูด",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "03",
    name: "หงาว",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "04",
    name: "บางริ้น",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "05",
    name: "ปากน้ำ",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "06",
    name: "บางนอน",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "07",
    name: "หาดส้มแป้น",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "08",
    name: "ทรายแดง",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "01",
    tumbon_code: "09",
    name: "เกาะพยาม",
    zipcode: "85000",
  },
  {
    jw_code: "85",
    amph_code: "02",
    tumbon_code: "01",
    name: "ละอุ่นใต้",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "02",
    tumbon_code: "02",
    name: "ละอุ่นเหนือ",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางพระใต้",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "02",
    tumbon_code: "04",
    name: "บางพระเหนือ",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "02",
    tumbon_code: "05",
    name: "บางแก้ว",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "02",
    tumbon_code: "06",
    name: "ในวงเหนือ",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "02",
    tumbon_code: "07",
    name: "ในวงใต้",
    zipcode: "85130",
  },
  {
    jw_code: "85",
    amph_code: "03",
    tumbon_code: "01",
    name: "ม่วงกลวง",
    zipcode: "85120",
  },
  {
    jw_code: "85",
    amph_code: "03",
    tumbon_code: "02",
    name: "กะเปอร์",
    zipcode: "85120",
  },
  {
    jw_code: "85",
    amph_code: "03",
    tumbon_code: "03",
    name: "เชี่ยวเหลียง",
    zipcode: "85120",
  },
  {
    jw_code: "85",
    amph_code: "03",
    tumbon_code: "04",
    name: "บ้านนา",
    zipcode: "85120",
  },
  {
    jw_code: "85",
    amph_code: "03",
    tumbon_code: "05",
    name: "บางหิน",
    zipcode: "85120",
  },
  {
    jw_code: "85",
    amph_code: "04",
    tumbon_code: "01",
    name: "น้ำจืด",
    zipcode: "85110",
  },
  {
    jw_code: "85",
    amph_code: "04",
    tumbon_code: "02",
    name: "น้ำจืดน้อย",
    zipcode: "85110",
  },
  {
    jw_code: "85",
    amph_code: "04",
    tumbon_code: "03",
    name: "มะมุ",
    zipcode: "85110",
  },
  {
    jw_code: "85",
    amph_code: "04",
    tumbon_code: "04",
    name: "ปากจั่น",
    zipcode: "85110",
  },
  {
    jw_code: "85",
    amph_code: "04",
    tumbon_code: "05",
    name: "ลำเลียง",
    zipcode: "85110",
  },
  {
    jw_code: "85",
    amph_code: "04",
    tumbon_code: "06",
    name: "จ.ป.ร.",
    zipcode: "85110",
  },
  {
    jw_code: "85",
    amph_code: "04",
    tumbon_code: "07",
    name: "บางใหญ่",
    zipcode: "85110",
  },
  {
    jw_code: "85",
    amph_code: "05",
    tumbon_code: "01",
    name: "นาคา",
    zipcode: "85120",
  },
  {
    jw_code: "85",
    amph_code: "05",
    tumbon_code: "02",
    name: "กำพวน",
    zipcode: "85120",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "01",
    name: "ท่าตะเภา",
    zipcode: "86000",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "02",
    name: "ปากน้ำ",
    zipcode: "86120",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "03",
    name: "ท่ายาง",
    zipcode: "86120",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "04",
    name: "บางหมาก",
    zipcode: "86000",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "05",
    name: "นาทุ่ง",
    zipcode: "86000",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "06",
    name: "นาชะอัง",
    zipcode: "86000",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "07",
    name: "ตากแดด",
    zipcode: "86190",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "08",
    name: "บางลึก",
    zipcode: "86000",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "09",
    name: "หาดพันไกร",
    zipcode: "86000",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "10",
    name: "วังไผ่",
    zipcode: "86190",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "11",
    name: "วังใหม่",
    zipcode: "86190",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "12",
    name: "บ้านนา",
    zipcode: "86190",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "13",
    name: "ขุนกระทิง",
    zipcode: "86190",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "14",
    name: "ทุ่งคา",
    zipcode: "86100",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "15",
    name: "วิสัยเหนือ",
    zipcode: "86100",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "16",
    name: "หาดทรายรี",
    zipcode: "86120",
  },
  {
    jw_code: "86",
    amph_code: "01",
    tumbon_code: "17",
    name: "ถ้ำสิงห์",
    zipcode: "86100",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "01",
    name: "ท่าแซะ",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "02",
    name: "คุริง",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "03",
    name: "สลุย",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "04",
    name: "นากระตาม",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "05",
    name: "รับร่อ",
    zipcode: "86190",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "06",
    name: "ท่าข้าม",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "07",
    name: "หงษ์เจริญ",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "08",
    name: "หินแก้ว",
    zipcode: "86190",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "09",
    name: "ทรัพย์อนันต์",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "02",
    tumbon_code: "10",
    name: "สองพี่น้อง",
    zipcode: "86140",
  },
  {
    jw_code: "86",
    amph_code: "03",
    tumbon_code: "01",
    name: "บางสน",
    zipcode: "86160",
  },
  {
    jw_code: "86",
    amph_code: "03",
    tumbon_code: "02",
    name: "ทะเลทรัพย์",
    zipcode: "86160",
  },
  {
    jw_code: "86",
    amph_code: "03",
    tumbon_code: "03",
    name: "สะพลี",
    zipcode: "86230",
  },
  {
    jw_code: "86",
    amph_code: "03",
    tumbon_code: "04",
    name: "ชุมโค",
    zipcode: "86160",
  },
  {
    jw_code: "86",
    amph_code: "03",
    tumbon_code: "05",
    name: "ดอนยาง",
    zipcode: "86210",
  },
  {
    jw_code: "86",
    amph_code: "03",
    tumbon_code: "06",
    name: "ปากคลอง",
    zipcode: "86210",
  },
  {
    jw_code: "86",
    amph_code: "03",
    tumbon_code: "07",
    name: "เขาไชยราช",
    zipcode: "86210",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "01",
    name: "หลังสวน",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "02",
    name: "ขันเงิน",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "03",
    name: "ท่ามะพลา",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "04",
    name: "นาขา",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "05",
    name: "นาพญา",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "06",
    name: "บ้านควน",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "07",
    name: "บางมะพร้าว",
    zipcode: "86150",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "08",
    name: "บางน้ำจืด",
    zipcode: "86150",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "09",
    name: "ปากน้ำ",
    zipcode: "86150",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "10",
    name: "พ้อแดง",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "11",
    name: "แหลมทราย",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "12",
    name: "วังตะกอ",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "04",
    tumbon_code: "13",
    name: "หาดยาย",
    zipcode: "86110",
  },
  {
    jw_code: "86",
    amph_code: "05",
    tumbon_code: "01",
    name: "ละแม",
    zipcode: "86170",
  },
  {
    jw_code: "86",
    amph_code: "05",
    tumbon_code: "02",
    name: "ทุ่งหลวง",
    zipcode: "86170",
  },
  {
    jw_code: "86",
    amph_code: "05",
    tumbon_code: "03",
    name: "สวนแตง",
    zipcode: "86170",
  },
  {
    jw_code: "86",
    amph_code: "05",
    tumbon_code: "04",
    name: "ทุ่งคาวัด",
    zipcode: "86170",
  },
  {
    jw_code: "86",
    amph_code: "06",
    tumbon_code: "01",
    name: "พะโต๊ะ",
    zipcode: "86180",
  },
  {
    jw_code: "86",
    amph_code: "06",
    tumbon_code: "02",
    name: "ปากทรง",
    zipcode: "86180",
  },
  {
    jw_code: "86",
    amph_code: "06",
    tumbon_code: "03",
    name: "ปังหวาน",
    zipcode: "86180",
  },
  {
    jw_code: "86",
    amph_code: "06",
    tumbon_code: "04",
    name: "พระรักษ์",
    zipcode: "86180",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "01",
    name: "นาโพธิ์",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "02",
    name: "สวี",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "03",
    name: "ทุ่งระยะ",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "04",
    name: "ท่าหิน",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "05",
    name: "ปากแพรก",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "06",
    name: "ด่านสวี",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "07",
    name: "ครน",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "08",
    name: "วิสัยใต้",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "09",
    name: "นาสัก",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "10",
    name: "เขาทะลุ",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "07",
    tumbon_code: "11",
    name: "เขาค่าย",
    zipcode: "86130",
  },
  {
    jw_code: "86",
    amph_code: "08",
    tumbon_code: "01",
    name: "ปากตะโก",
    zipcode: "86220",
  },
  {
    jw_code: "86",
    amph_code: "08",
    tumbon_code: "02",
    name: "ทุ่งตะไคร",
    zipcode: "86220",
  },
  {
    jw_code: "86",
    amph_code: "08",
    tumbon_code: "03",
    name: "ตะโก",
    zipcode: "86220",
  },
  {
    jw_code: "86",
    amph_code: "08",
    tumbon_code: "04",
    name: "ช่องไม้แก้ว",
    zipcode: "86220",
  },
  {
    jw_code: "90",
    amph_code: "01",
    tumbon_code: "01",
    name: "บ่อยาง",
    zipcode: "90000",
  },
  {
    jw_code: "90",
    amph_code: "01",
    tumbon_code: "02",
    name: "เขารูปช้าง",
    zipcode: "90000",
  },
  {
    jw_code: "90",
    amph_code: "01",
    tumbon_code: "03",
    name: "เกาะแต้ว",
    zipcode: "90000",
  },
  {
    jw_code: "90",
    amph_code: "01",
    tumbon_code: "04",
    name: "พะวง",
    zipcode: "90100",
  },
  {
    jw_code: "90",
    amph_code: "01",
    tumbon_code: "05",
    name: "ทุ่งหวัง",
    zipcode: "90000",
  },
  {
    jw_code: "90",
    amph_code: "01",
    tumbon_code: "06",
    name: "เกาะยอ",
    zipcode: "90100",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "01",
    name: "จะทิ้งพระ",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "02",
    name: "กระดังงา",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "03",
    name: "สนามชัย",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "04",
    name: "ดีหลวง",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "05",
    name: "ชุมพล",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "06",
    name: "คลองรี",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "07",
    name: "คูขุด",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "08",
    name: "ท่าหิน",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "09",
    name: "วัดจันทร์",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "10",
    name: "บ่อแดง",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "02",
    tumbon_code: "11",
    name: "บ่อดาน",
    zipcode: "90190",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "01",
    name: "บ้านนา",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "02",
    name: "ป่าชิง",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "03",
    name: "สะพานไม้แก่น",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "04",
    name: "สะกอม",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "05",
    name: "นาหว้า",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "06",
    name: "นาทับ",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "07",
    name: "น้ำขาว",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "08",
    name: "ขุนตัดหวาย",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "09",
    name: "ท่าหมอไทร",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "10",
    name: "จะโหนง",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "11",
    name: "คู",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "12",
    name: "แค",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "13",
    name: "คลองเปียะ",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "03",
    tumbon_code: "14",
    name: "ตลิ่งชัน",
    zipcode: "90130",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "01",
    name: "นาทวี",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "02",
    name: "ฉาง",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "03",
    name: "นาหมอศรี",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "04",
    name: "คลองทราย",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "05",
    name: "ปลักหนู",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "06",
    name: "ท่าประดู่",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "07",
    name: "สะท้อน",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "08",
    name: "ทับช้าง",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "09",
    name: "ประกอบ",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "04",
    tumbon_code: "10",
    name: "คลองกวาง",
    zipcode: "90160",
  },
  {
    jw_code: "90",
    amph_code: "05",
    tumbon_code: "01",
    name: "เทพา",
    zipcode: "90150",
  },
  {
    jw_code: "90",
    amph_code: "05",
    tumbon_code: "02",
    name: "ปากบาง",
    zipcode: "90150",
  },
  {
    jw_code: "90",
    amph_code: "05",
    tumbon_code: "03",
    name: "เกาะสะบ้า",
    zipcode: "90150",
  },
  {
    jw_code: "90",
    amph_code: "05",
    tumbon_code: "04",
    name: "ลำไพล",
    zipcode: "90260",
  },
  {
    jw_code: "90",
    amph_code: "05",
    tumbon_code: "05",
    name: "ท่าม่วง",
    zipcode: "90260",
  },
  {
    jw_code: "90",
    amph_code: "05",
    tumbon_code: "06",
    name: "วังใหญ่",
    zipcode: "90260",
  },
  {
    jw_code: "90",
    amph_code: "05",
    tumbon_code: "07",
    name: "สะกอม",
    zipcode: "90150",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "01",
    name: "สะบ้าย้อย",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "02",
    name: "ทุ่งพอ",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "03",
    name: "เปียน",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "04",
    name: "บ้านโหนด",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "05",
    name: "จะแหน",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "06",
    name: "คูหา",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "07",
    name: "เขาแดง",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "08",
    name: "บาโหย",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "06",
    tumbon_code: "09",
    name: "ธารคีรี",
    zipcode: "90210",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "01",
    name: "ระโนด",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "02",
    name: "คลองแดน",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "03",
    name: "ตะเครียะ",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "04",
    name: "ท่าบอน",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "05",
    name: "บ้านใหม่",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "06",
    name: "บ่อตรุ",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "07",
    name: "ปากแตระ",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "08",
    name: "พังยาง",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "09",
    name: "ระวะ",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "10",
    name: "วัดสน",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "11",
    name: "บ้านขาว",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "07",
    tumbon_code: "12",
    name: "แดนสงวน",
    zipcode: "90140",
  },
  {
    jw_code: "90",
    amph_code: "08",
    tumbon_code: "01",
    name: "เกาะใหญ่",
    zipcode: "90270",
  },
  {
    jw_code: "90",
    amph_code: "08",
    tumbon_code: "02",
    name: "โรง",
    zipcode: "90270",
  },
  {
    jw_code: "90",
    amph_code: "08",
    tumbon_code: "03",
    name: "เชิงแส",
    zipcode: "90270",
  },
  {
    jw_code: "90",
    amph_code: "08",
    tumbon_code: "04",
    name: "กระแสสินธุ์",
    zipcode: "90270",
  },
  {
    jw_code: "90",
    amph_code: "09",
    tumbon_code: "01",
    name: "กำแพงเพชร",
    zipcode: "90180",
  },
  {
    jw_code: "90",
    amph_code: "09",
    tumbon_code: "02",
    name: "ท่าชะมวง",
    zipcode: "90180",
  },
  {
    jw_code: "90",
    amph_code: "09",
    tumbon_code: "03",
    name: "คูหาใต้",
    zipcode: "90180",
  },
  {
    jw_code: "90",
    amph_code: "09",
    tumbon_code: "04",
    name: "ควนรู",
    zipcode: "90220",
  },
  {
    jw_code: "90",
    amph_code: "09",
    tumbon_code: "09",
    name: "เขาพระ",
    zipcode: "90180",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "01",
    name: "สะเดา",
    zipcode: "90120",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "02",
    name: "ปริก",
    zipcode: "90120",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "03",
    name: "พังลา",
    zipcode: "90170",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "04",
    name: "สำนักแต้ว",
    zipcode: "90120",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "05",
    name: "ทุ่งหมอ",
    zipcode: "90240",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "06",
    name: "ท่าโพธิ์",
    zipcode: "90170",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "07",
    name: "ปาดังเบซาร์",
    zipcode: "90240",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "08",
    name: "สำนักขาม",
    zipcode: "90320",
  },
  {
    jw_code: "90",
    amph_code: "10",
    tumbon_code: "09",
    name: "เขามีเกียรติ",
    zipcode: "90170",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "01",
    name: "หาดใหญ่",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "02",
    name: "ควนลัง",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "03",
    name: "คูเต่า",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "04",
    name: "คอหงส์",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "05",
    name: "คลองแห",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "07",
    name: "คลองอู่ตะเภา",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "08",
    name: "ฉลุง",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "11",
    name: "ทุ่งใหญ่",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "12",
    name: "ทุ่งตำเสา",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "13",
    name: "ท่าข้าม",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "14",
    name: "น้ำน้อย",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "16",
    name: "บ้านพรุ",
    zipcode: "90250",
  },
  {
    jw_code: "90",
    amph_code: "11",
    tumbon_code: "18",
    name: "พะตง",
    zipcode: "90230",
  },
  {
    jw_code: "90",
    amph_code: "12",
    tumbon_code: "01",
    name: "นาหม่อม",
    zipcode: "90310",
  },
  {
    jw_code: "90",
    amph_code: "12",
    tumbon_code: "02",
    name: "พิจิตร",
    zipcode: "90310",
  },
  {
    jw_code: "90",
    amph_code: "12",
    tumbon_code: "03",
    name: "ทุ่งขมิ้น",
    zipcode: "90310",
  },
  {
    jw_code: "90",
    amph_code: "12",
    tumbon_code: "04",
    name: "คลองหรัง",
    zipcode: "90310",
  },
  {
    jw_code: "90",
    amph_code: "13",
    tumbon_code: "01",
    name: "รัตภูมิ",
    zipcode: "90220",
  },
  {
    jw_code: "90",
    amph_code: "13",
    tumbon_code: "02",
    name: "ควนโส",
    zipcode: "90220",
  },
  {
    jw_code: "90",
    amph_code: "13",
    tumbon_code: "03",
    name: "ห้วยลึก",
    zipcode: "90220",
  },
  {
    jw_code: "90",
    amph_code: "13",
    tumbon_code: "04",
    name: "บางเหรียง",
    zipcode: "90220",
  },
  {
    jw_code: "90",
    amph_code: "14",
    tumbon_code: "01",
    name: "บางกล่ำ",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "14",
    tumbon_code: "02",
    name: "ท่าช้าง",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "14",
    tumbon_code: "03",
    name: "แม่ทอม",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "14",
    tumbon_code: "04",
    name: "บ้านหาร",
    zipcode: "90110",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "01",
    name: "ชิงโค",
    zipcode: "90280",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "02",
    name: "สทิงหม้อ",
    zipcode: "90280",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "03",
    name: "ทำนบ",
    zipcode: "90280",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "04",
    name: "รำแดง",
    zipcode: "90330",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "05",
    name: "วัดขนุน",
    zipcode: "90330",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "06",
    name: "ชะแล้",
    zipcode: "90330",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "07",
    name: "ปากรอ",
    zipcode: "90330",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "08",
    name: "ป่าขาด",
    zipcode: "90330",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "09",
    name: "หัวเขา",
    zipcode: "90280",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "10",
    name: "บางเขียด",
    zipcode: "90330",
  },
  {
    jw_code: "90",
    amph_code: "15",
    tumbon_code: "11",
    name: "ม่วงงาม",
    zipcode: "90330",
  },
  {
    jw_code: "90",
    amph_code: "16",
    tumbon_code: "01",
    name: "คลองหอยโข่ง",
    zipcode: "90230",
  },
  {
    jw_code: "90",
    amph_code: "16",
    tumbon_code: "02",
    name: "ทุ่งลาน",
    zipcode: "90230",
  },
  {
    jw_code: "90",
    amph_code: "16",
    tumbon_code: "03",
    name: "โคกม่วง",
    zipcode: "90115",
  },
  {
    jw_code: "90",
    amph_code: "16",
    tumbon_code: "04",
    name: "คลองหลา",
    zipcode: "90115",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "01",
    name: "พิมาน",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "02",
    name: "คลองขุด",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "03",
    name: "ควนขัน",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "04",
    name: "บ้านควน",
    zipcode: "91140",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "05",
    name: "ฉลุง",
    zipcode: "91140",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "06",
    name: "เกาะสาหร่าย",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "07",
    name: "ตันหยงโป",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "08",
    name: "เจ๊ะบิลัง",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "09",
    name: "ตำมะลัง",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "10",
    name: "ปูยู",
    zipcode: "91000",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "11",
    name: "ควนโพธิ์",
    zipcode: "91140",
  },
  {
    jw_code: "91",
    amph_code: "01",
    tumbon_code: "12",
    name: "เกตรี",
    zipcode: "91140",
  },
  {
    jw_code: "91",
    amph_code: "02",
    tumbon_code: "01",
    name: "ควนโดน",
    zipcode: "91160",
  },
  {
    jw_code: "91",
    amph_code: "02",
    tumbon_code: "02",
    name: "ควนสตอ",
    zipcode: "91160",
  },
  {
    jw_code: "91",
    amph_code: "02",
    tumbon_code: "03",
    name: "ย่านซื่อ",
    zipcode: "91160",
  },
  {
    jw_code: "91",
    amph_code: "02",
    tumbon_code: "04",
    name: "วังประจัน",
    zipcode: "91160",
  },
  {
    jw_code: "91",
    amph_code: "03",
    tumbon_code: "01",
    name: "ทุ่งนุ้ย",
    zipcode: "91130",
  },
  {
    jw_code: "91",
    amph_code: "03",
    tumbon_code: "02",
    name: "ควนกาหลง",
    zipcode: "91130",
  },
  {
    jw_code: "91",
    amph_code: "03",
    tumbon_code: "03",
    name: "อุใดเจริญ",
    zipcode: "91130",
  },
  {
    jw_code: "91",
    amph_code: "04",
    tumbon_code: "01",
    name: "ท่าแพ",
    zipcode: "91150",
  },
  {
    jw_code: "91",
    amph_code: "04",
    tumbon_code: "02",
    name: "แป-ระ",
    zipcode: "91150",
  },
  {
    jw_code: "91",
    amph_code: "04",
    tumbon_code: "03",
    name: "สาคร",
    zipcode: "91150",
  },
  {
    jw_code: "91",
    amph_code: "04",
    tumbon_code: "04",
    name: "ท่าเรือ",
    zipcode: "91150",
  },
  {
    jw_code: "91",
    amph_code: "05",
    tumbon_code: "01",
    name: "กำแพง",
    zipcode: "91110",
  },
  {
    jw_code: "91",
    amph_code: "05",
    tumbon_code: "02",
    name: "ละงู",
    zipcode: "91110",
  },
  {
    jw_code: "91",
    amph_code: "05",
    tumbon_code: "03",
    name: "เขาขาว",
    zipcode: "91110",
  },
  {
    jw_code: "91",
    amph_code: "05",
    tumbon_code: "04",
    name: "ปากน้ำ",
    zipcode: "91110",
  },
  {
    jw_code: "91",
    amph_code: "05",
    tumbon_code: "05",
    name: "น้ำผุด",
    zipcode: "91110",
  },
  {
    jw_code: "91",
    amph_code: "05",
    tumbon_code: "06",
    name: "แหลมสน",
    zipcode: "91110",
  },
  {
    jw_code: "91",
    amph_code: "06",
    tumbon_code: "01",
    name: "ทุ่งหว้า",
    zipcode: "91120",
  },
  {
    jw_code: "91",
    amph_code: "06",
    tumbon_code: "02",
    name: "นาทอน",
    zipcode: "91120",
  },
  {
    jw_code: "91",
    amph_code: "06",
    tumbon_code: "03",
    name: "ขอนคลาน",
    zipcode: "91120",
  },
  {
    jw_code: "91",
    amph_code: "06",
    tumbon_code: "04",
    name: "ทุ่งบุหลัง",
    zipcode: "91120",
  },
  {
    jw_code: "91",
    amph_code: "06",
    tumbon_code: "05",
    name: "ป่าแก่บ่อหิน",
    zipcode: "91120",
  },
  {
    jw_code: "91",
    amph_code: "07",
    tumbon_code: "01",
    name: "ปาล์มพัฒนา",
    zipcode: "91130",
  },
  {
    jw_code: "91",
    amph_code: "07",
    tumbon_code: "02",
    name: "นิคมพัฒนา",
    zipcode: "91130",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "01",
    name: "ทับเที่ยง",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "04",
    name: "นาพละ",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "05",
    name: "บ้านควน",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "06",
    name: "นาบินหลา",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "07",
    name: "ควนปริง",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "08",
    name: "นาโยงใต้",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "09",
    name: "บางรัก",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "10",
    name: "โคกหล่อ",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "13",
    name: "นาโต๊ะหมิง",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "14",
    name: "หนองตรุด",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "15",
    name: "น้ำผุด",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "17",
    name: "นาตาล่วง",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "18",
    name: "บ้านโพธิ์",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "19",
    name: "นาท่ามเหนือ",
    zipcode: "92190",
  },
  {
    jw_code: "92",
    amph_code: "01",
    tumbon_code: "20",
    name: "นาท่ามใต้",
    zipcode: "92190",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "01",
    name: "กันตัง",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "02",
    name: "ควนธานี",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางหมาก",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "04",
    name: "บางเป้า",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "05",
    name: "วังวน",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "06",
    name: "กันตังใต้",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "07",
    name: "โคกยาง",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "08",
    name: "คลองลุ",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "09",
    name: "ย่านซื่อ",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "10",
    name: "บ่อน้ำร้อน",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "11",
    name: "บางสัก",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "12",
    name: "นาเกลือ",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "13",
    name: "เกาะลิบง",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "02",
    tumbon_code: "14",
    name: "คลองชีล้อม",
    zipcode: "92110",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "01",
    name: "ย่านตาขาว",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "02",
    name: "หนองบ่อ",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "03",
    name: "นาชุมเห็ด",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "04",
    name: "ในควน",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "05",
    name: "โพรงจระเข้",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "06",
    name: "ทุ่งกระบือ",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "07",
    name: "ทุ่งค่าย",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "03",
    tumbon_code: "08",
    name: "เกาะเปียะ",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "01",
    name: "ท่าข้าม",
    zipcode: "92120",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "02",
    name: "ทุ่งยาว",
    zipcode: "92180",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "03",
    name: "ปะเหลียน",
    zipcode: "92180",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "04",
    name: "บางด้วน",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "07",
    name: "บ้านนา",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "09",
    name: "สุโสะ",
    zipcode: "92180",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "10",
    name: "ลิพัง",
    zipcode: "92180",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "11",
    name: "เกาะสุกร",
    zipcode: "92120",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "12",
    name: "ท่าพญา",
    zipcode: "92140",
  },
  {
    jw_code: "92",
    amph_code: "04",
    tumbon_code: "13",
    name: "แหลมสอม",
    zipcode: "92180",
  },
  {
    jw_code: "92",
    amph_code: "05",
    tumbon_code: "01",
    name: "บ่อหิน",
    zipcode: "92150",
  },
  {
    jw_code: "92",
    amph_code: "05",
    tumbon_code: "02",
    name: "เขาไม้แก้ว",
    zipcode: "92150",
  },
  {
    jw_code: "92",
    amph_code: "05",
    tumbon_code: "03",
    name: "กะลาเส",
    zipcode: "92150",
  },
  {
    jw_code: "92",
    amph_code: "05",
    tumbon_code: "04",
    name: "ไม้ฝาด",
    zipcode: "92150",
  },
  {
    jw_code: "92",
    amph_code: "05",
    tumbon_code: "05",
    name: "นาเมืองเพชร",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "01",
    name: "ห้วยยอด",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "02",
    name: "หนองช้างแล่น",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "05",
    name: "บางดี",
    zipcode: "92210",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "06",
    name: "บางกุ้ง",
    zipcode: "92210",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "07",
    name: "เขากอบ",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "08",
    name: "เขาขาว",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "09",
    name: "เขาปูน",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "10",
    name: "ปากแจ่ม",
    zipcode: "92190",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "11",
    name: "ปากคม",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "14",
    name: "ท่างิ้ว",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "15",
    name: "ลำภูรา",
    zipcode: "92190",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "16",
    name: "นาวง",
    zipcode: "92210",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "17",
    name: "ห้วยนาง",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "19",
    name: "ในเตา",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "20",
    name: "ทุ่งต่อ",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "06",
    tumbon_code: "21",
    name: "วังคีรี",
    zipcode: "92210",
  },
  {
    jw_code: "92",
    amph_code: "07",
    tumbon_code: "01",
    name: "เขาวิเศษ",
    zipcode: "92220",
  },
  {
    jw_code: "92",
    amph_code: "07",
    tumbon_code: "02",
    name: "วังมะปราง",
    zipcode: "92220",
  },
  {
    jw_code: "92",
    amph_code: "07",
    tumbon_code: "03",
    name: "อ่าวตง",
    zipcode: "92220",
  },
  {
    jw_code: "92",
    amph_code: "07",
    tumbon_code: "04",
    name: "ท่าสะบ้า",
    zipcode: "92000",
  },
  {
    jw_code: "92",
    amph_code: "07",
    tumbon_code: "05",
    name: "วังมะปรางเหนือ",
    zipcode: "92220",
  },
  {
    jw_code: "92",
    amph_code: "08",
    tumbon_code: "01",
    name: "นาโยงเหนือ",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "08",
    tumbon_code: "02",
    name: "ช่อง",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "08",
    tumbon_code: "03",
    name: "ละมอ",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "08",
    tumbon_code: "04",
    name: "โคกสะบ้า",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "08",
    tumbon_code: "05",
    name: "นาหมื่นศรี",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "08",
    tumbon_code: "06",
    name: "นาข้าวเสีย",
    zipcode: "92170",
  },
  {
    jw_code: "92",
    amph_code: "09",
    tumbon_code: "01",
    name: "ควนเมา",
    zipcode: "92160",
  },
  {
    jw_code: "92",
    amph_code: "09",
    tumbon_code: "02",
    name: "คลองปาง",
    zipcode: "92160",
  },
  {
    jw_code: "92",
    amph_code: "09",
    tumbon_code: "03",
    name: "หนองบัว",
    zipcode: "92160",
  },
  {
    jw_code: "92",
    amph_code: "09",
    tumbon_code: "04",
    name: "หนองปรือ",
    zipcode: "92130",
  },
  {
    jw_code: "92",
    amph_code: "09",
    tumbon_code: "05",
    name: "เขาไพร",
    zipcode: "92160",
  },
  {
    jw_code: "92",
    amph_code: "10",
    tumbon_code: "01",
    name: "หาดสำราญ",
    zipcode: "92120",
  },
  {
    jw_code: "92",
    amph_code: "10",
    tumbon_code: "02",
    name: "บ้าหวี",
    zipcode: "92120",
  },
  {
    jw_code: "92",
    amph_code: "10",
    tumbon_code: "03",
    name: "ตะเสะ",
    zipcode: "92120",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "01",
    name: "คูหาสวรรค์",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "03",
    name: "เขาเจียก",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "04",
    name: "ท่ามิหรำ",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "05",
    name: "โคกชะงาย",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "06",
    name: "นาท่อม",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "07",
    name: "ปรางหมู่",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "08",
    name: "ท่าแค",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "09",
    name: "ลำปำ",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "10",
    name: "ตำนาน",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "11",
    name: "ควนมะพร้าว",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "12",
    name: "ร่มเมือง",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "13",
    name: "ชัยบุรี",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "14",
    name: "นาโหนด",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "01",
    tumbon_code: "15",
    name: "พญาขัน",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "02",
    tumbon_code: "01",
    name: "กงหรา",
    zipcode: "93180",
  },
  {
    jw_code: "93",
    amph_code: "02",
    tumbon_code: "02",
    name: "ชะรัด",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "02",
    tumbon_code: "03",
    name: "คลองเฉลิม",
    zipcode: "93180",
  },
  {
    jw_code: "93",
    amph_code: "02",
    tumbon_code: "04",
    name: "คลองทรายขาว",
    zipcode: "93180",
  },
  {
    jw_code: "93",
    amph_code: "02",
    tumbon_code: "05",
    name: "สมหวัง",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "03",
    tumbon_code: "01",
    name: "เขาชัยสน",
    zipcode: "93130",
  },
  {
    jw_code: "93",
    amph_code: "03",
    tumbon_code: "02",
    name: "ควนขนุน",
    zipcode: "93130",
  },
  {
    jw_code: "93",
    amph_code: "03",
    tumbon_code: "05",
    name: "จองถนน",
    zipcode: "93130",
  },
  {
    jw_code: "93",
    amph_code: "03",
    tumbon_code: "06",
    name: "หานโพธิ์",
    zipcode: "93130",
  },
  {
    jw_code: "93",
    amph_code: "03",
    tumbon_code: "07",
    name: "โคกม่วง",
    zipcode: "93130",
  },
  {
    jw_code: "93",
    amph_code: "04",
    tumbon_code: "01",
    name: "แม่ขรี",
    zipcode: "93160",
  },
  {
    jw_code: "93",
    amph_code: "04",
    tumbon_code: "02",
    name: "ตะโหมด",
    zipcode: "93160",
  },
  {
    jw_code: "93",
    amph_code: "04",
    tumbon_code: "03",
    name: "คลองใหญ่",
    zipcode: "93160",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "01",
    name: "ควนขนุน",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "02",
    name: "ทะเลน้อย",
    zipcode: "93150",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "04",
    name: "นาขยาด",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "05",
    name: "พนมวังก์",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "06",
    name: "แหลมโตนด",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "08",
    name: "ปันแต",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "09",
    name: "โตนดด้วน",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "10",
    name: "ดอนทราย",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "11",
    name: "มะกอกเหนือ",
    zipcode: "93150",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "12",
    name: "พนางตุง",
    zipcode: "93150",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "13",
    name: "ชะมวง",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "05",
    tumbon_code: "16",
    name: "แพรกหา",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "06",
    tumbon_code: "01",
    name: "ปากพะยูน",
    zipcode: "93120",
  },
  {
    jw_code: "93",
    amph_code: "06",
    tumbon_code: "02",
    name: "ดอนประดู่",
    zipcode: "93120",
  },
  {
    jw_code: "93",
    amph_code: "06",
    tumbon_code: "03",
    name: "เกาะนางคำ",
    zipcode: "93120",
  },
  {
    jw_code: "93",
    amph_code: "06",
    tumbon_code: "04",
    name: "เกาะหมาก",
    zipcode: "93120",
  },
  {
    jw_code: "93",
    amph_code: "06",
    tumbon_code: "05",
    name: "ฝาละมี",
    zipcode: "93120",
  },
  {
    jw_code: "93",
    amph_code: "06",
    tumbon_code: "06",
    name: "หารเทา",
    zipcode: "93120",
  },
  {
    jw_code: "93",
    amph_code: "06",
    tumbon_code: "07",
    name: "ดอนทราย",
    zipcode: "93120",
  },
  {
    jw_code: "93",
    amph_code: "07",
    tumbon_code: "01",
    name: "เขาย่า",
    zipcode: "93190",
  },
  {
    jw_code: "93",
    amph_code: "07",
    tumbon_code: "02",
    name: "เขาปู่",
    zipcode: "93190",
  },
  {
    jw_code: "93",
    amph_code: "07",
    tumbon_code: "03",
    name: "ตะแพน",
    zipcode: "93190",
  },
  {
    jw_code: "93",
    amph_code: "08",
    tumbon_code: "01",
    name: "ป่าบอน",
    zipcode: "93170",
  },
  {
    jw_code: "93",
    amph_code: "08",
    tumbon_code: "02",
    name: "โคกทราย",
    zipcode: "93170",
  },
  {
    jw_code: "93",
    amph_code: "08",
    tumbon_code: "03",
    name: "หนองธง",
    zipcode: "93170",
  },
  {
    jw_code: "93",
    amph_code: "08",
    tumbon_code: "04",
    name: "ทุ่งนารี",
    zipcode: "93170",
  },
  {
    jw_code: "93",
    amph_code: "08",
    tumbon_code: "06",
    name: "วังใหม่",
    zipcode: "93170",
  },
  {
    jw_code: "93",
    amph_code: "09",
    tumbon_code: "01",
    name: "ท่ามะเดื่อ",
    zipcode: "93140",
  },
  {
    jw_code: "93",
    amph_code: "09",
    tumbon_code: "02",
    name: "นาปะขอ",
    zipcode: "93140",
  },
  {
    jw_code: "93",
    amph_code: "09",
    tumbon_code: "03",
    name: "โคกสัก",
    zipcode: "93160",
  },
  {
    jw_code: "93",
    amph_code: "10",
    tumbon_code: "01",
    name: "ป่าพะยอม",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "10",
    tumbon_code: "02",
    name: "ลานข่อย",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "10",
    tumbon_code: "03",
    name: "เกาะเต่า",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "10",
    tumbon_code: "04",
    name: "บ้านพร้าว",
    zipcode: "93110",
  },
  {
    jw_code: "93",
    amph_code: "11",
    tumbon_code: "01",
    name: "ชุมพล",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "11",
    tumbon_code: "02",
    name: "บ้านนา",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "11",
    tumbon_code: "03",
    name: "อ่างทอง",
    zipcode: "93000",
  },
  {
    jw_code: "93",
    amph_code: "11",
    tumbon_code: "04",
    name: "ลำสินธุ์",
    zipcode: "93000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "01",
    name: "สะบารัง",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "02",
    name: "อาเนาะรู",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "03",
    name: "จะบังติกอ",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "04",
    name: "บานา",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "05",
    name: "ตันหยงลุโละ",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "06",
    name: "คลองมานิง",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "07",
    name: "กะมิยอ",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "08",
    name: "บาราโหม",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "09",
    name: "ปะกาฮะรัง",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "10",
    name: "รูสะมิแล",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "11",
    name: "ตะลุโบะ",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "12",
    name: "บาราเฮาะ",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "01",
    tumbon_code: "13",
    name: "ปุยุด",
    zipcode: "94000",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "01",
    name: "โคกโพธิ์",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "02",
    name: "มะกรูด",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "03",
    name: "บางโกระ",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "04",
    name: "ป่าบอน",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "05",
    name: "ทรายขาว",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "06",
    name: "นาประดู่",
    zipcode: "94180",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "07",
    name: "ปากล่อ",
    zipcode: "94180",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "08",
    name: "ทุ่งพลา",
    zipcode: "94180",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "11",
    name: "ท่าเรือ",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "13",
    name: "นาเกตุ",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "14",
    name: "ควนโนรี",
    zipcode: "94180",
  },
  {
    jw_code: "94",
    amph_code: "02",
    tumbon_code: "15",
    name: "ช้างให้ตก",
    zipcode: "94120",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "01",
    name: "เกาะเปาะ",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "02",
    name: "คอลอตันหยง",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "03",
    name: "ดอนรัก",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "04",
    name: "ดาโต๊ะ",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "05",
    name: "ตุยง",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "06",
    name: "ท่ากำชำ",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "07",
    name: "บ่อทอง",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "08",
    name: "บางเขา",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "09",
    name: "บางตาวา",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "10",
    name: "ปุโละปุโย",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "11",
    name: "ยาบี",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "03",
    tumbon_code: "12",
    name: "ลิปะสะโง",
    zipcode: "94170",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "01",
    name: "ปะนาเระ",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "02",
    name: "ท่าข้าม",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "03",
    name: "บ้านนอก",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "04",
    name: "ดอน",
    zipcode: "94190",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "05",
    name: "ควน",
    zipcode: "94190",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "06",
    name: "ท่าน้ำ",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "07",
    name: "คอกกระบือ",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "08",
    name: "พ่อมิ่ง",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "09",
    name: "บ้านกลาง",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "04",
    tumbon_code: "10",
    name: "บ้านน้ำบ่อ",
    zipcode: "94130",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "01",
    name: "มายอ",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "02",
    name: "ถนน",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "03",
    name: "ตรัง",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "04",
    name: "กระหวะ",
    zipcode: "94190",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "05",
    name: "ลุโบะยิไร",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "06",
    name: "ลางา",
    zipcode: "94190",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "07",
    name: "กระเสาะ",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "08",
    name: "เกาะจัน",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "09",
    name: "ปะโด",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "10",
    name: "สาคอบน",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "11",
    name: "สาคอใต้",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "12",
    name: "สะกำ",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "05",
    tumbon_code: "13",
    name: "ปานัน",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "06",
    tumbon_code: "01",
    name: "ตะโละแมะนา",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "06",
    tumbon_code: "02",
    name: "พิเทน",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "06",
    tumbon_code: "03",
    name: "น้ำดำ",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "06",
    tumbon_code: "04",
    name: "ปากู",
    zipcode: "94140",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "01",
    name: "ตะลุบัน",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "02",
    name: "ตะบิ้ง",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "03",
    name: "ปะเสยะวอ",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "04",
    name: "บางเก่า",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "05",
    name: "บือเระ",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "06",
    name: "เตราะบอน",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "07",
    name: "กะดุนง",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "08",
    name: "ละหาร",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "09",
    name: "มะนังดาลำ",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "10",
    name: "แป้น",
    zipcode: "94110",
  },
  {
    jw_code: "94",
    amph_code: "07",
    tumbon_code: "11",
    name: "ทุ่งคล้า",
    zipcode: "94190",
  },
  {
    jw_code: "94",
    amph_code: "08",
    tumbon_code: "01",
    name: "ไทรทอง",
    zipcode: "94220",
  },
  {
    jw_code: "94",
    amph_code: "08",
    tumbon_code: "02",
    name: "ไม้แก่น",
    zipcode: "94220",
  },
  {
    jw_code: "94",
    amph_code: "08",
    tumbon_code: "03",
    name: "ตะโละไกรทอง",
    zipcode: "94220",
  },
  {
    jw_code: "94",
    amph_code: "08",
    tumbon_code: "04",
    name: "ดอนทราย",
    zipcode: "94220",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "01",
    name: "ตะโละ",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "02",
    name: "ตะโละกาโปร์",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "03",
    name: "ตันหยงดาลอ",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "04",
    name: "ตันหยงจึงงา",
    zipcode: "94190",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "05",
    name: "ตอหลัง",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "06",
    name: "ตาแกะ",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "07",
    name: "ตาลีอายร์",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "08",
    name: "ยามู",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "09",
    name: "บางปู",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "10",
    name: "หนองแรต",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "11",
    name: "ปิยามุมัง",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "12",
    name: "ปุลากง",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "13",
    name: "บาโลย",
    zipcode: "94190",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "14",
    name: "สาบัน",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "15",
    name: "มะนังยง",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "16",
    name: "ราตาปันยัง",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "17",
    name: "จะรัง",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "09",
    tumbon_code: "18",
    name: "แหลมโพธิ์",
    zipcode: "94150",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "01",
    name: "ยะรัง",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "02",
    name: "สะดาวา",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "03",
    name: "ประจัน",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "04",
    name: "สะนอ",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "05",
    name: "ระแว้ง",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "06",
    name: "ปิตูมุดี",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "07",
    name: "วัด",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "08",
    name: "กระโด",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "09",
    name: "คลองใหม่",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "10",
    name: "เมาะมาวี",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "11",
    name: "กอลำ",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "10",
    tumbon_code: "12",
    name: "เขาตูม",
    zipcode: "94160",
  },
  {
    jw_code: "94",
    amph_code: "11",
    tumbon_code: "01",
    name: "กะรุบี",
    zipcode: "94230",
  },
  {
    jw_code: "94",
    amph_code: "11",
    tumbon_code: "02",
    name: "ตะโละดือรามัน",
    zipcode: "94230",
  },
  {
    jw_code: "94",
    amph_code: "11",
    tumbon_code: "03",
    name: "ปล่องหอย",
    zipcode: "94230",
  },
  {
    jw_code: "94",
    amph_code: "12",
    tumbon_code: "01",
    name: "แม่ลาน",
    zipcode: "94180",
  },
  {
    jw_code: "94",
    amph_code: "12",
    tumbon_code: "02",
    name: "ม่วงเตี้ย",
    zipcode: "94180",
  },
  {
    jw_code: "94",
    amph_code: "12",
    tumbon_code: "03",
    name: "ป่าไร่",
    zipcode: "94180",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "01",
    name: "สะเตง",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "02",
    name: "บุดี",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "03",
    name: "ยุโป",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "04",
    name: "ลิดล",
    zipcode: "95160",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "06",
    name: "ยะลา",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "08",
    name: "ท่าสาป",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "09",
    name: "ลำใหม่",
    zipcode: "95160",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "10",
    name: "หน้าถ้ำ",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "11",
    name: "ลำพะยา",
    zipcode: "95160",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "12",
    name: "เปาะเส้ง",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "14",
    name: "พร่อน",
    zipcode: "95160",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "15",
    name: "บันนังสาเรง",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "16",
    name: "สะเตงนอก",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "01",
    tumbon_code: "18",
    name: "ตาเซะ",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "02",
    tumbon_code: "01",
    name: "เบตง",
    zipcode: "95110",
  },
  {
    jw_code: "95",
    amph_code: "02",
    tumbon_code: "02",
    name: "ยะรม",
    zipcode: "95110",
  },
  {
    jw_code: "95",
    amph_code: "02",
    tumbon_code: "03",
    name: "ตาเนาะแมเราะ",
    zipcode: "95110",
  },
  {
    jw_code: "95",
    amph_code: "02",
    tumbon_code: "04",
    name: "อัยเยอร์เวง",
    zipcode: "95110",
  },
  {
    jw_code: "95",
    amph_code: "02",
    tumbon_code: "05",
    name: "ธารน้ำทิพย์",
    zipcode: "95110",
  },
  {
    jw_code: "95",
    amph_code: "03",
    tumbon_code: "01",
    name: "บันนังสตา",
    zipcode: "95130",
  },
  {
    jw_code: "95",
    amph_code: "03",
    tumbon_code: "02",
    name: "บาเจาะ",
    zipcode: "95130",
  },
  {
    jw_code: "95",
    amph_code: "03",
    tumbon_code: "03",
    name: "ตาเนาะปูเต๊ะ",
    zipcode: "95130",
  },
  {
    jw_code: "95",
    amph_code: "03",
    tumbon_code: "04",
    name: "ถ้ำทะลุ",
    zipcode: "95130",
  },
  {
    jw_code: "95",
    amph_code: "03",
    tumbon_code: "05",
    name: "ตลิ่งชัน",
    zipcode: "95130",
  },
  {
    jw_code: "95",
    amph_code: "03",
    tumbon_code: "06",
    name: "เขื่อนบางลาง",
    zipcode: "95130",
  },
  {
    jw_code: "95",
    amph_code: "04",
    tumbon_code: "01",
    name: "ธารโต",
    zipcode: "95150",
  },
  {
    jw_code: "95",
    amph_code: "04",
    tumbon_code: "02",
    name: "บ้านแหร",
    zipcode: "95150",
  },
  {
    jw_code: "95",
    amph_code: "04",
    tumbon_code: "03",
    name: "แม่หวาด",
    zipcode: "95170",
  },
  {
    jw_code: "95",
    amph_code: "04",
    tumbon_code: "04",
    name: "คีรีเขต",
    zipcode: "95150",
  },
  {
    jw_code: "95",
    amph_code: "05",
    tumbon_code: "01",
    name: "ยะหา",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "05",
    tumbon_code: "02",
    name: "ละแอ",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "05",
    tumbon_code: "03",
    name: "ปะแต",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "05",
    tumbon_code: "04",
    name: "บาโร๊ะ",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "05",
    tumbon_code: "06",
    name: "ตาชี",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "05",
    tumbon_code: "07",
    name: "บาโงยซิแน",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "05",
    tumbon_code: "08",
    name: "กาตอง",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "01",
    name: "กายูบอเกาะ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "02",
    name: "กาลูปัง",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "03",
    name: "กาลอ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "04",
    name: "กอตอตือร๊ะ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "05",
    name: "โกตาบารู",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "06",
    name: "เกะรอ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "07",
    name: "จะกว๊ะ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "08",
    name: "ท่าธง",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "09",
    name: "เนินงาม",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "10",
    name: "บาลอ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "11",
    name: "บาโงย",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "12",
    name: "บือมัง",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "13",
    name: "ยะต๊ะ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "14",
    name: "วังพญา",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "15",
    name: "อาซ่อง",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "06",
    tumbon_code: "16",
    name: "ตะโล๊ะหะลอ",
    zipcode: "95140",
  },
  {
    jw_code: "95",
    amph_code: "07",
    tumbon_code: "01",
    name: "กาบัง",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "07",
    tumbon_code: "02",
    name: "บาละ",
    zipcode: "95120",
  },
  {
    jw_code: "95",
    amph_code: "08",
    tumbon_code: "01",
    name: "กรงปินัง",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "08",
    tumbon_code: "02",
    name: "สะเอะ",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "08",
    tumbon_code: "03",
    name: "ห้วยกระทิง",
    zipcode: "95000",
  },
  {
    jw_code: "95",
    amph_code: "08",
    tumbon_code: "04",
    name: "ปุโรง",
    zipcode: "95000",
  },
  {
    jw_code: "96",
    amph_code: "01",
    tumbon_code: "01",
    name: "บางนาค",
    zipcode: "96000",
  },
  {
    jw_code: "96",
    amph_code: "01",
    tumbon_code: "02",
    name: "ลำภู",
    zipcode: "96000",
  },
  {
    jw_code: "96",
    amph_code: "01",
    tumbon_code: "03",
    name: "มะนังตายอ",
    zipcode: "96000",
  },
  {
    jw_code: "96",
    amph_code: "01",
    tumbon_code: "04",
    name: "บางปอ",
    zipcode: "96000",
  },
  {
    jw_code: "96",
    amph_code: "01",
    tumbon_code: "05",
    name: "กะลุวอ",
    zipcode: "96000",
  },
  {
    jw_code: "96",
    amph_code: "01",
    tumbon_code: "06",
    name: "กะลุวอเหนือ",
    zipcode: "96000",
  },
  {
    jw_code: "96",
    amph_code: "01",
    tumbon_code: "07",
    name: "โคกเคียน",
    zipcode: "96000",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "01",
    name: "เจ๊ะเห",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "02",
    name: "ไพรวัน",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "03",
    name: "พร่อน",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "04",
    name: "ศาลาใหม่",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "05",
    name: "บางขุนทอง",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "06",
    name: "เกาะสะท้อน",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "07",
    name: "นานาค",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "02",
    tumbon_code: "08",
    name: "โฆษิต",
    zipcode: "96110",
  },
  {
    jw_code: "96",
    amph_code: "03",
    tumbon_code: "01",
    name: "บาเจาะ",
    zipcode: "96170",
  },
  {
    jw_code: "96",
    amph_code: "03",
    tumbon_code: "02",
    name: "ลุโบะสาวอ",
    zipcode: "96170",
  },
  {
    jw_code: "96",
    amph_code: "03",
    tumbon_code: "03",
    name: "กาเยาะมาตี",
    zipcode: "96170",
  },
  {
    jw_code: "96",
    amph_code: "03",
    tumbon_code: "04",
    name: "ปะลุกาสาเมาะ",
    zipcode: "96170",
  },
  {
    jw_code: "96",
    amph_code: "03",
    tumbon_code: "05",
    name: "บาเระเหนือ",
    zipcode: "96170",
  },
  {
    jw_code: "96",
    amph_code: "03",
    tumbon_code: "06",
    name: "บาเระใต้",
    zipcode: "96170",
  },
  {
    jw_code: "96",
    amph_code: "04",
    tumbon_code: "01",
    name: "ยี่งอ",
    zipcode: "96180",
  },
  {
    jw_code: "96",
    amph_code: "04",
    tumbon_code: "02",
    name: "ละหาร",
    zipcode: "96180",
  },
  {
    jw_code: "96",
    amph_code: "04",
    tumbon_code: "03",
    name: "จอเบาะ",
    zipcode: "96180",
  },
  {
    jw_code: "96",
    amph_code: "04",
    tumbon_code: "04",
    name: "ลุโบะบายะ",
    zipcode: "96180",
  },
  {
    jw_code: "96",
    amph_code: "04",
    tumbon_code: "05",
    name: "ลุโบะบือซา",
    zipcode: "96180",
  },
  {
    jw_code: "96",
    amph_code: "04",
    tumbon_code: "06",
    name: "ตะปอเยาะ",
    zipcode: "96180",
  },
  {
    jw_code: "96",
    amph_code: "05",
    tumbon_code: "01",
    name: "ตันหยงมัส",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "05",
    tumbon_code: "02",
    name: "ตันหยงลิมอ",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "05",
    tumbon_code: "06",
    name: "บองอ",
    zipcode: "96220",
  },
  {
    jw_code: "96",
    amph_code: "05",
    tumbon_code: "07",
    name: "กาลิซา",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "05",
    tumbon_code: "08",
    name: "บาโงสะโต",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "05",
    tumbon_code: "09",
    name: "เฉลิม",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "05",
    tumbon_code: "10",
    name: "มะรือโบตก",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "01",
    name: "รือเสาะ",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "02",
    name: "สาวอ",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "03",
    name: "เรียง",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "04",
    name: "สามัคคี",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "05",
    name: "บาตง",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "06",
    name: "ลาโละ",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "07",
    name: "รือเสาะออก",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "08",
    name: "โคกสะตอ",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "06",
    tumbon_code: "09",
    name: "สุวารี",
    zipcode: "96150",
  },
  {
    jw_code: "96",
    amph_code: "07",
    tumbon_code: "01",
    name: "ซากอ",
    zipcode: "96210",
  },
  {
    jw_code: "96",
    amph_code: "07",
    tumbon_code: "02",
    name: "ตะมะยูง",
    zipcode: "96210",
  },
  {
    jw_code: "96",
    amph_code: "07",
    tumbon_code: "03",
    name: "ศรีสาคร",
    zipcode: "96210",
  },
  {
    jw_code: "96",
    amph_code: "07",
    tumbon_code: "04",
    name: "เชิงคีรี",
    zipcode: "96210",
  },
  {
    jw_code: "96",
    amph_code: "07",
    tumbon_code: "05",
    name: "กาหลง",
    zipcode: "96210",
  },
  {
    jw_code: "96",
    amph_code: "07",
    tumbon_code: "06",
    name: "ศรีบรรพต",
    zipcode: "96210",
  },
  {
    jw_code: "96",
    amph_code: "08",
    tumbon_code: "01",
    name: "แว้ง",
    zipcode: "96160",
  },
  {
    jw_code: "96",
    amph_code: "08",
    tumbon_code: "02",
    name: "กายูคละ",
    zipcode: "96160",
  },
  {
    jw_code: "96",
    amph_code: "08",
    tumbon_code: "03",
    name: "ฆอเลาะ",
    zipcode: "96160",
  },
  {
    jw_code: "96",
    amph_code: "08",
    tumbon_code: "04",
    name: "โละจูด",
    zipcode: "96160",
  },
  {
    jw_code: "96",
    amph_code: "08",
    tumbon_code: "05",
    name: "แม่ดง",
    zipcode: "96160",
  },
  {
    jw_code: "96",
    amph_code: "08",
    tumbon_code: "06",
    name: "เอราวัณ",
    zipcode: "96160",
  },
  {
    jw_code: "96",
    amph_code: "09",
    tumbon_code: "01",
    name: "มาโมง",
    zipcode: "96190",
  },
  {
    jw_code: "96",
    amph_code: "09",
    tumbon_code: "02",
    name: "สุคิริน",
    zipcode: "96190",
  },
  {
    jw_code: "96",
    amph_code: "09",
    tumbon_code: "03",
    name: "เกียร์",
    zipcode: "96190",
  },
  {
    jw_code: "96",
    amph_code: "09",
    tumbon_code: "04",
    name: "ภูเขาทอง",
    zipcode: "96190",
  },
  {
    jw_code: "96",
    amph_code: "09",
    tumbon_code: "05",
    name: "ร่มไทร",
    zipcode: "96190",
  },
  {
    jw_code: "96",
    amph_code: "10",
    tumbon_code: "01",
    name: "สุไหงโก-ลก",
    zipcode: "96120",
  },
  {
    jw_code: "96",
    amph_code: "10",
    tumbon_code: "02",
    name: "ปาเสมัส",
    zipcode: "96120",
  },
  {
    jw_code: "96",
    amph_code: "10",
    tumbon_code: "03",
    name: "มูโนะ",
    zipcode: "96120",
  },
  {
    jw_code: "96",
    amph_code: "10",
    tumbon_code: "04",
    name: "ปูโยะ",
    zipcode: "96120",
  },
  {
    jw_code: "96",
    amph_code: "11",
    tumbon_code: "01",
    name: "ปะลุรู",
    zipcode: "96140",
  },
  {
    jw_code: "96",
    amph_code: "11",
    tumbon_code: "02",
    name: "สุไหงปาดี",
    zipcode: "96140",
  },
  {
    jw_code: "96",
    amph_code: "11",
    tumbon_code: "03",
    name: "โต๊ะเด็ง",
    zipcode: "96140",
  },
  {
    jw_code: "96",
    amph_code: "11",
    tumbon_code: "04",
    name: "สากอ",
    zipcode: "96140",
  },
  {
    jw_code: "96",
    amph_code: "11",
    tumbon_code: "05",
    name: "ริโก๋",
    zipcode: "96140",
  },
  {
    jw_code: "96",
    amph_code: "11",
    tumbon_code: "06",
    name: "กาวะ",
    zipcode: "96140",
  },
  {
    jw_code: "96",
    amph_code: "12",
    tumbon_code: "01",
    name: "จะแนะ",
    zipcode: "96220",
  },
  {
    jw_code: "96",
    amph_code: "12",
    tumbon_code: "02",
    name: "ดุซงญอ",
    zipcode: "96220",
  },
  {
    jw_code: "96",
    amph_code: "12",
    tumbon_code: "03",
    name: "ผดุงมาตร",
    zipcode: "96220",
  },
  {
    jw_code: "96",
    amph_code: "12",
    tumbon_code: "04",
    name: "ช้างเผือก",
    zipcode: "96220",
  },
  {
    jw_code: "96",
    amph_code: "13",
    tumbon_code: "01",
    name: "จวบ",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "13",
    tumbon_code: "02",
    name: "บูกิต",
    zipcode: "96130",
  },
  {
    jw_code: "96",
    amph_code: "13",
    tumbon_code: "03",
    name: "มะรือโบออก",
    zipcode: "96130",
  },
]

const groupBy = _.chain(subdistricts)
  .groupBy(item => `${item.jw_code}-${item.amph_code}`)
  .mapValues(function(v, i) {
    return v;
  })
  .value();
export default groupBy;
